export * from '../models/AccessCondition.js';
export * from '../models/AccessConditionEffect.js';
export * from '../models/AccessConditionalExpression.js';
export * from '../models/AccessibleOrganizationAccount.js';
export * from '../models/Account.js';
export * from '../models/AccountConfigInput.js';
export * from '../models/AccountDisplayNameFilters.js';
export * from '../models/AccountIdCondition.js';
export * from '../models/AccountIdFilters.js';
export * from '../models/AccountInstallationMethod.js';
export * from '../models/AccountMetricsDestination.js';
export * from '../models/AccountModuleVersion.js';
export * from '../models/AccountNameFilters.js';
export * from '../models/AccountState.js';
export * from '../models/AccountStatusFilters.js';
export * from '../models/AccountStatusReason.js';
export * from '../models/AccountUpdateInput.js';
export * from '../models/AccountVersion.js';
export * from '../models/ActionApprovalOperationType.js';
export * from '../models/ActionApprovalRule.js';
export * from '../models/ActionApprovalRuleExpression.js';
export * from '../models/ActionApprovalRuleGroupCondition.js';
export * from '../models/ActionApprovalRuleResourceSelector.js';
export * from '../models/ActionFilters.js';
export * from '../models/ActivateAtlasOrganizationResponse.js';
export * from '../models/ActivateGcpFolderResponse.js';
export * from '../models/ActivateGcpOrganizationResponse.js';
export * from '../models/AddRestoreAtlasPrivateLinkRequest.js';
export * from '../models/AdeRestoreEncryptionConfig.js';
export * from '../models/AgreementWithCredits.js';
export * from '../models/Ami.js';
export * from '../models/AmiBlockDevice.js';
export * from '../models/AnnuallyConfig.js';
export * from '../models/AnomalyDataPoint.js';
export * from '../models/AnomalyGraphData.js';
export * from '../models/ApiCredentials.js';
export * from '../models/ApiCredentialsProperties.js';
export * from '../models/App.js';
export * from '../models/AppFilters.js';
export * from '../models/ApplicationOverride.js';
export * from '../models/AppsCondition.js';
export * from '../models/AppsDetails.js';
export * from '../models/AtlasCluster.js';
export * from '../models/AtlasClusters.js';
export * from '../models/AtlasOrganization.js';
export * from '../models/AtlasProject.js';
export * from '../models/AtlasProjects.js';
export * from '../models/AuditLog.js';
export * from '../models/AuditLogAction.js';
export * from '../models/AuditLogAuthMethod.js';
export * from '../models/AuditLogAuthStatus.js';
export * from '../models/AuditLogChangeSource.js';
export * from '../models/AuditLogCloudContext.js';
export * from '../models/AuditLogEnrichmentStatus.js';
export * from '../models/AuditLogEntitiesInner.js';
export * from '../models/AuditLogExtendedData.js';
export * from '../models/AuditLogExtendedDataAuth.js';
export * from '../models/AuditLogExtendedDataMpa.js';
export * from '../models/AuditLogFilterConditions.js';
export * from '../models/AuditLogInitiatorType.js';
export * from '../models/AuditLogMfaMethod.js';
export * from '../models/AuditLogSecurityContext.js';
export * from '../models/AuditLogStateSnapshot.js';
export * from '../models/AuthResponse.js';
export * from '../models/AuthV2AssociateSoftwareTokenRequest.js';
export * from '../models/AuthV2AssociateSoftwareTokenResponse.js';
export * from '../models/AuthV2ConfirmForgotPasswordRequest.js';
export * from '../models/AuthV2ForgotPasswordRequest.js';
export * from '../models/AuthV2ForgotPasswordResponse.js';
export * from '../models/AuthV2LoginRequest.js';
export * from '../models/AuthV2RespondChallengeRequest.js';
export * from '../models/AuthV2VerifySoftwareTokenRequest.js';
export * from '../models/AuthV2VerifySoftwareTokenResponse.js';
export * from '../models/AwsAccountConfigInput.js';
export * from '../models/AwsAccountMetricsDestination.js';
export * from '../models/AwsCassandraClusterRestoreDestination.js';
export * from '../models/AwsCassandraClusterRestoreTarget.js';
export * from '../models/AwsDatabaseDestination.js';
export * from '../models/AwsDynamoDBDestination.js';
export * from '../models/AwsDynamoDbResource.js';
export * from '../models/AwsDynamoDbSnapshotProperties.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection.js';
export * from '../models/AwsEbsSnapshotConvertResult.js';
export * from '../models/AwsEbsVolumeResource.js';
export * from '../models/AwsEbsVolumeRestoreData.js';
export * from '../models/AwsEbsVolumeRestoreResult.js';
export * from '../models/AwsEbsVolumeSnapshotProperties.js';
export * from '../models/AwsEc2AmiConvertResult.js';
export * from '../models/AwsEc2InstanceRestoreDestination.js';
export * from '../models/AwsEc2InstanceRestoreResult.js';
export * from '../models/AwsEc2InstanceRestoreTarget.js';
export * from '../models/AwsEc2Resource.js';
export * from '../models/AwsEc2SnapshotProperties.js';
export * from '../models/AwsEksClusterResource.js';
export * from '../models/AwsEksNamespaceResource.js';
export * from '../models/AwsEksNamespaceSnapshotProperties.js';
export * from '../models/AwsFsxResource.js';
export * from '../models/AwsKeyspacesDestination.js';
export * from '../models/AwsKeyspacesResource.js';
export * from '../models/AwsNativePitrBackupPolicyPlan.js';
export * from '../models/AwsNativePitrBackupResourceType.js';
export * from '../models/AwsNativePitrConfig.js';
export * from '../models/AwsNativeStandardBackupPolicyPlan.js';
export * from '../models/AwsNativeStandardBackupScheduleConfig.js';
export * from '../models/AwsNativeStandardBackupSchedules.js';
export * from '../models/AwsNativeStandardIntervalConfig.js';
export * from '../models/AwsNeptuneResource.js';
export * from '../models/AwsOpenSearchDomainRestoreDestination.js';
export * from '../models/AwsOpenSearchDomainRestoreTarget.js';
export * from '../models/AwsOpenSearchIndexSelection.js';
export * from '../models/AwsRdsEngine.js';
export * from '../models/AwsRdsResource.js';
export * from '../models/AwsRdsResourceAurora.js';
export * from '../models/AwsRdsResourceStorageSettings.js';
export * from '../models/AwsRdsSnapshotProperties.js';
export * from '../models/AwsRestoreAccountAttributes.js';
export * from '../models/AwsRestoreAccountAttributesInput.js';
export * from '../models/AwsRestoreAccountConnectivityConfig.js';
export * from '../models/AwsRestoreServerNetworkParams.js';
export * from '../models/AwsSourceAccountAttributes.js';
export * from '../models/AwsSourceAccountAttributesInput.js';
export * from '../models/AwsVaultConfig.js';
export * from '../models/AwsVaultConfigInput.js';
export * from '../models/AwsVpcConnectivityConfig.js';
export * from '../models/AzureAccountConfigInput.js';
export * from '../models/AzureAksNamespaceResource.js';
export * from '../models/AzureAppRegistrationOption.js';
export * from '../models/AzureBackupApplicationsResponse.js';
export * from '../models/AzureCmkEligibleApp.js';
export * from '../models/AzureConsentUrlResponse.js';
export * from '../models/AzureDisk.js';
export * from '../models/AzureDiskEncryptionSet.js';
export * from '../models/AzureDiskEncryptionSetAccessProblem.js';
export * from '../models/AzureDiskEncryptionSetEncryptionType.js';
export * from '../models/AzureDiskRestoreData.js';
export * from '../models/AzureDiskRestoreDestination.js';
export * from '../models/AzureDiskRestoreResult.js';
export * from '../models/AzureDiskSettings.js';
export * from '../models/AzureDiskTarget.js';
export * from '../models/AzureEntraIdPolicyConfig.js';
export * from '../models/AzureEntraIdResource.js';
export * from '../models/AzureEntraIdRestoreConsent.js';
export * from '../models/AzureEntraIdRestoreEntity.js';
export * from '../models/AzureEonApplication.js';
export * from '../models/AzureFileShareRestoreFileSpec.js';
export * from '../models/AzureFilesBackupPolicyPlan.js';
export * from '../models/AzureFilesBackupSchedules.js';
export * from '../models/AzureFilesStorageAccountSelection.js';
export * from '../models/AzureKeyVaultKey.js';
export * from '../models/AzureListResourceGroupsResponse.js';
export * from '../models/AzureListSubscriptionsResponse.js';
export * from '../models/AzureManagementGroup.js';
export * from '../models/AzureManagementGroups.js';
export * from '../models/AzureMarketplaceWebhookInput.js';
export * from '../models/AzureMarketplaceWebhookInputSubscription.js';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionBeneficiary.js';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionPurchaser.js';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionTerm.js';
export * from '../models/AzureMssqlSnapshotProperties.js';
export * from '../models/AzureOnboardedTenantsResponse.js';
export * from '../models/AzureOnboardingStatus.js';
export * from '../models/AzureOptionalCapabilities.js';
export * from '../models/AzurePostgresDatabaseRestoreDestination.js';
export * from '../models/AzurePostgresDatabaseRestoreTarget.js';
export * from '../models/AzureResourceGroup.js';
export * from '../models/AzureResourceGroups.js';
export * from '../models/AzureRestoreAccountAttributes.js';
export * from '../models/AzureRestoreAccountAttributesInput.js';
export * from '../models/AzureRestoreAccountConnectivityConfig.js';
export * from '../models/AzureRestorePointData.js';
export * from '../models/AzureRestorePointDisk.js';
export * from '../models/AzureRestorePointSpec.js';
export * from '../models/AzureSapHanaResource.js';
export * from '../models/AzureScanningAccountSetupStatus200Response.js';
export * from '../models/AzureSourceAccountAttributes.js';
export * from '../models/AzureSourceAccountAttributesInput.js';
export * from '../models/AzureSqlDatabaseNativePitrBackupPolicyPlan.js';
export * from '../models/AzureSqlDatabaseNativePitrBackupResourceType.js';
export * from '../models/AzureSqlDatabaseNativePitrConfig.js';
export * from '../models/AzureSqlDatabaseRestoreDestination.js';
export * from '../models/AzureSqlDatabaseRestoreTarget.js';
export * from '../models/AzureSqlRestoreTargetServers.js';
export * from '../models/AzureSqlServer.js';
export * from '../models/AzureSqlTdeRestoreConfig.js';
export * from '../models/AzureStorageAccount.js';
export * from '../models/AzureStorageAccounts.js';
export * from '../models/AzureSubscription.js';
export * from '../models/AzureTenant.js';
export * from '../models/AzureVaultConfig.js';
export * from '../models/AzureVaultConfigInput.js';
export * from '../models/AzureVaultType.js';
export * from '../models/AzureVmInstanceRestoreDestination.js';
export * from '../models/AzureVmInstanceRestoreResult.js';
export * from '../models/AzureVmInstanceRestoreTarget.js';
export * from '../models/AzureVmNativeRestoreTarget.js';
export * from '../models/AzureVmResource.js';
export * from '../models/AzureVmSnapshotProperties.js';
export * from '../models/AzureVnetConnectivityConfig.js';
export * from '../models/BackedByCategory.js';
export * from '../models/BackedUpByResourceType.js';
export * from '../models/BackedUpByResourceTypeDataInner.js';
export * from '../models/BackedUpStorageDateHistogram.js';
export * from '../models/BackupControlViolations.js';
export * from '../models/BackupJob.js';
export * from '../models/BackupJobResponse.js';
export * from '../models/BackupJobSortField.js';
export * from '../models/BackupJobType.js';
export * from '../models/BackupJobTypeFilters.js';
export * from '../models/BackupJobsFilterConditions.js';
export * from '../models/BackupPoliciesFilters.js';
export * from '../models/BackupPoliciesLimits.js';
export * from '../models/BackupPoliciesSecurityConfig.js';
export * from '../models/BackupPolicy.js';
export * from '../models/BackupPolicyAppliesNotificationArguments.js';
export * from '../models/BackupPolicyConfig.js';
export * from '../models/BackupPolicyConfigResponse.js';
export * from '../models/BackupPolicyExpression.js';
export * from '../models/BackupPolicyGroupCondition.js';
export * from '../models/BackupPolicyNotificationArguments.js';
export * from '../models/BackupPolicyPlan.js';
export * from '../models/BackupPolicyResourceSelector.js';
export * from '../models/BackupPolicySecurityConfig.js';
export * from '../models/BackupPolicyType.js';
export * from '../models/BackupPostureControl.js';
export * from '../models/BackupPostureControlExpression.js';
export * from '../models/BackupPostureControlGroupCondition.js';
export * from '../models/BackupPostureControlResourceSelector.js';
export * from '../models/BackupPostureControlRules.js';
export * from '../models/BackupPostureControlSort.js';
export * from '../models/BackupPostureControlSortField.js';
export * from '../models/BackupRegionsFilters.js';
export * from '../models/BackupSchedule.js';
export * from '../models/BackupScope.js';
export * from '../models/BackupScopeResourcesLosingBackupCountResponse.js';
export * from '../models/BackupScopeSummary.js';
export * from '../models/BackupStatus.js';
export * from '../models/BackupStatusFilters.js';
export * from '../models/BackupVault.js';
export * from '../models/BackupZeroEtlAccessConfiguration.js';
export * from '../models/BackupZeroEtlAwsAccessConfiguration.js';
export * from '../models/BackupZeroEtlAwsGlueCatalogConfiguration.js';
export * from '../models/BackupZeroEtlCatalogConfiguration.js';
export * from '../models/BackupZeroEtlColumnDefinition.js';
export * from '../models/BackupZeroEtlColumnDefinitions.js';
export * from '../models/BackupZeroEtlColumnExtract.js';
export * from '../models/BackupZeroEtlExtendedJsonMode.js';
export * from '../models/BackupZeroEtlFilters.js';
export * from '../models/BackupZeroEtlGlueCatalogLocation.js';
export * from '../models/BackupZeroEtlIcebergPartitionSpec.js';
export * from '../models/BackupZeroEtlIcebergPartitionTransform.js';
export * from '../models/BackupZeroEtlIcebergTransformType.js';
export * from '../models/BackupZeroEtlIdentityColumnField.js';
export * from '../models/BackupZeroEtlIdentityColumnSpec.js';
export * from '../models/BackupZeroEtlLakeStorageLocation.js';
export * from '../models/BackupZeroEtlMultiResourceRoutingPolicy.js';
export * from '../models/BackupZeroEtlOrderingSpec.js';
export * from '../models/BackupZeroEtlOrderingStrategy.js';
export * from '../models/BackupZeroEtlPolicy.js';
export * from '../models/BackupZeroEtlPolicyScope.js';
export * from '../models/BackupZeroEtlResourceSelector.js';
export * from '../models/BackupZeroEtlRoutingMode.js';
export * from '../models/BackupZeroEtlSingleResourceColumnDefinitionConfig.js';
export * from '../models/BackupZeroEtlSingleResourceDatabaseNameAffixes.js';
export * from '../models/BackupZeroEtlSingleResourcePartitionConfig.js';
export * from '../models/BackupZeroEtlSingleResourceRoutingPolicy.js';
export * from '../models/BackupZeroEtlSingleResourceTableMappingMergeDatabasesParams.js';
export * from '../models/BackupZeroEtlSingleResourceTableMappingMode.js';
export * from '../models/BackupZeroEtlStorageConfiguration.js';
export * from '../models/BackupZeroEtlTableFilter.js';
export * from '../models/BackupZeroEtlTableSelection.js';
export * from '../models/BackupZeroEtlTableSelectionMode.js';
export * from '../models/BatchApplicationOverrides.js';
export * from '../models/BatchOperationResponse.js';
export * from '../models/BatchResourceValidationResult.js';
export * from '../models/BatchUpdateLlgPoliciesRequest.js';
export * from '../models/BatchUpdateLlgPolicyItem.js';
export * from '../models/BatchValidateResourceConfigurationRequest.js';
export * from '../models/BatchValidateResourceConfigurationResponse.js';
export * from '../models/BigQueryDatasetDestination.js';
export * from '../models/BigQueryIntegrationConfig.js';
export * from '../models/BigQueryNativePitrBackupPolicyPlan.js';
export * from '../models/BigQueryNativePitrBackupResourceType.js';
export * from '../models/BigQueryNativePitrConfig.js';
export * from '../models/BigQueryNativePitrDestination.js';
export * from '../models/BillingPeriod.js';
export * from '../models/BillingProvider.js';
export * from '../models/BillingTransactionHistory.js';
export * from '../models/BooleanFilters.js';
export * from '../models/BulkAttachRestoreTemplateRequest.js';
export * from '../models/BulkDetachRestoreTemplateRequest.js';
export * from '../models/BulkRestoreItem.js';
export * from '../models/BulkRestoreItemStatus.js';
export * from '../models/BulkRestoreRequest.js';
export * from '../models/BulkRestoreResponse.js';
export * from '../models/BulkRestoreResponseItemsInner.js';
export * from '../models/BulkRestoreResponseJobsInner.js';
export * from '../models/BulkRestoreValidateRequest.js';
export * from '../models/BulkRestoreValidateResponse.js';
export * from '../models/BulkRestoreValidateResponseItemsInner.js';
export * from '../models/BulkSelectSnapshotStatus.js';
export * from '../models/BulkSelectSnapshotsForResourcesRequest.js';
export * from '../models/BulkSelectSnapshotsForResourcesResponse.js';
export * from '../models/BulkSelectSnapshotsForResourcesResponseItemsInner.js';
export * from '../models/CancelExclusionFromBackupResponse.js';
export * from '../models/CancelMyMPARequestResponse.js';
export * from '../models/CassandraClusterResource.js';
export * from '../models/Catalog.js';
export * from '../models/CdcBackupModeCheckResult.js';
export * from '../models/CheckAzureDiskEncryptionSetAccessRequest.js';
export * from '../models/CheckAzureDiskEncryptionSetAccessResponse.js';
export * from '../models/CheckAzureVMNameExists200Response.js';
export * from '../models/CheckAzureVMNameExistsRequest.js';
export * from '../models/CheckCdcPrerequisitesResponse.js';
export * from '../models/CheckIngestionPipelineAccessRequest.js';
export * from '../models/CheckIngestionPipelineAccessResponse.js';
export * from '../models/ClassificationCategory.js';
export * from '../models/ClassificationPolicy.js';
export * from '../models/ClassificationPolicySchedule.js';
export * from '../models/ClassificationScheduleConfig.js';
export * from '../models/ClassificationScheduleFrequency.js';
export * from '../models/Classifications.js';
export * from '../models/CloudAccountIdFilters.js';
export * from '../models/CloudAccountNotificationArguments.js';
export * from '../models/CloudAccountType.js';
export * from '../models/CloudProviderCondition.js';
export * from '../models/CloudProviderFilters.js';
export * from '../models/CloudRegion.js';
export * from '../models/CloudResourceAttachmentEvent.js';
export * from '../models/CloudResourceAttachmentEventType.js';
export * from '../models/CloudResourceConfiguration.js';
export * from '../models/CloudResourceConfigurationCdcBackup.js';
export * from '../models/CloudResourceConfigurationInventoryBackup.js';
export * from '../models/CloudResourceSecurityProperties.js';
export * from '../models/CloudSnapshotsPerVolume.js';
export * from '../models/ClusterNameFilters.js';
export * from '../models/CognitoExchangeRequest.js';
export * from '../models/CognitoExchangeResponse.js';
export * from '../models/Column.js';
export * from '../models/ColumnMetadata.js';
export * from '../models/ColumnValueDistribution.js';
export * from '../models/CompanyContact.js';
export * from '../models/ComplianceControlTrends.js';
export * from '../models/ComplianceStatus.js';
export * from '../models/ComplianceStatusFilters.js';
export * from '../models/ComplianceSummary.js';
export * from '../models/ComplianceTrend.js';
export * from '../models/Condition.js';
export * from '../models/ConditionOperatorEnum.js';
export * from '../models/ConfigurationStatus.js';
export * from '../models/ConfigurationStatusFilters.js';
export * from '../models/ConnectAtlasOrganizationRequest.js';
export * from '../models/ConnectAtlasOrganizationResponse.js';
export * from '../models/ConnectAzureBackupAccountRequest.js';
export * from '../models/ConnectAzureBackupApplicationsRequest.js';
export * from '../models/ConnectAzureRestoreAccountRequest.js';
export * from '../models/ConnectAzureSourceAccountRequest.js';
export * from '../models/ConnectAzureVaultAccountRequest.js';
export * from '../models/ConnectBYOApps200Response.js';
export * from '../models/ConnectBYOAppsRequest.js';
export * from '../models/ConnectBYOAzureBackupApplicationsRequest.js';
export * from '../models/ConnectCustomerVaultAccountRequest.js';
export * from '../models/ConnectCustomerVaultAccountResponse.js';
export * from '../models/ConnectGcpFolderRequest.js';
export * from '../models/ConnectGcpFolderResponse.js';
export * from '../models/ConnectGcpOrganizationRequest.js';
export * from '../models/ConnectGcpOrganizationResponse.js';
export * from '../models/ConnectRestoreAccountRequest.js';
export * from '../models/ConnectRestoreAccountResponse.js';
export * from '../models/ConnectRestoreAwsOrganizationalUnitRequest.js';
export * from '../models/ConnectRestoreAwsOrganizationalUnitResponse.js';
export * from '../models/ConnectSourceAccountRequest.js';
export * from '../models/ConnectSourceAccountResponse.js';
export * from '../models/ConnectSourceAwsOrganizationalUnitRequest.js';
export * from '../models/ConnectSourceAwsOrganizationalUnitResponse.js';
export * from '../models/ControlComplianceEntry.js';
export * from '../models/ControlFailureCount.js';
export * from '../models/ControlPlaneConfig.js';
export * from '../models/ControlTrendEntry.js';
export * from '../models/ControlViolation.js';
export * from '../models/ControlViolations.js';
export * from '../models/ControlViolationsPerSeverity.js';
export * from '../models/ControlViolationsPerSeverityViolatedControlsInner.js';
export * from '../models/ControlsFilters.js';
export * from '../models/ConvertEbsSnapshotConfig.js';
export * from '../models/ConvertEc2ImageConfig.js';
export * from '../models/ConvertOtherSnapshotsOnDemandRequest.js';
export * from '../models/ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner.js';
export * from '../models/ConvertResourceSnapshotsRequest.js';
export * from '../models/ConvertResourceSnapshotsResponse.js';
export * from '../models/Cost.js';
export * from '../models/CostDataFilters.js';
export * from '../models/CostDataGroupBy.js';
export * from '../models/CostDataRecord.js';
export * from '../models/CostDataRecordCost.js';
export * from '../models/CostDataRecordDimensions.js';
export * from '../models/CostGranularity.js';
export * from '../models/CostProduct.js';
export * from '../models/CostProductFilters.js';
export * from '../models/CostRecordMetadata.js';
export * from '../models/CostRecordMetadataDataTransfer.js';
export * from '../models/CostRecordMetadataType.js';
export * from '../models/CostUnit.js';
export * from '../models/CreateAccessGrantRequest.js';
export * from '../models/CreateAccessPolicyRequest.js';
export * from '../models/CreateAccountInput.js';
export * from '../models/CreateActionApprovalRuleRequest.js';
export * from '../models/CreateActionApprovalRuleResponse.js';
export * from '../models/CreateApiCredentialsRequest.js';
export * from '../models/CreateApiCredentialsResponse.js';
export * from '../models/CreateBackupPolicyRequest.js';
export * from '../models/CreateBackupPolicyResponse.js';
export * from '../models/CreateBackupPostureControlRequest.js';
export * from '../models/CreateBackupZeroEtlPolicyInput.js';
export * from '../models/CreateClassificationPolicyRequest.js';
export * from '../models/CreateClassificationPolicyResponse.js';
export * from '../models/CreateDataCatalogPipelineRequest.js';
export * from '../models/CreateDlsgPolicyRequest.js';
export * from '../models/CreateDlsgPolicyResponse.js';
export * from '../models/CreateFabricTableShortcutDemoRequest.js';
export * from '../models/CreateFabricTableShortcutDemoRequestShortcutsInner.js';
export * from '../models/CreateFabricTableShortcutDemoResponse.js';
export * from '../models/CreateFabricTableShortcutDemoResponseResultsInner.js';
export * from '../models/CreateFindingExclusionRequest.js';
export * from '../models/CreateFindingExclusionResponse.js';
export * from '../models/CreateGdsgInventoryReportConfigurationRequest.js';
export * from '../models/CreateGdsgInventoryReportConfigurationResponse.js';
export * from '../models/CreateIdpGroupRequest.js';
export * from '../models/CreateIdpGroupResponse.js';
export * from '../models/CreateIntegrationRequest.js';
export * from '../models/CreateIntegrationResponse.js';
export * from '../models/CreateMPARequestReviewRequest.js';
export * from '../models/CreateMPARequestReviewResponse.js';
export * from '../models/CreateOAuthAppRequest.js';
export * from '../models/CreateOAuthAppResponse.js';
export * from '../models/CreateOrganizationIdpGroupRequest.js';
export * from '../models/CreateOrganizationIdpGroupResponse.js';
export * from '../models/CreateOrganizationIdpRequest.js';
export * from '../models/CreateOrganizationIdpResponse.js';
export * from '../models/CreateOrganizationUserRequest.js';
export * from '../models/CreateOrganizationUserResponse.js';
export * from '../models/CreatePolicyInput.js';
export * from '../models/CreatePolicyScheduleInput.js';
export * from '../models/CreateProjectInput.js';
export * from '../models/CreatePulumiConfigurationRequest.js';
export * from '../models/CreateRestoreTemplateRequest.js';
export * from '../models/CreateRestoreTemplateResponse.js';
export * from '../models/CreateRoleRequest.js';
export * from '../models/CreateRoleResponse.js';
export * from '../models/CreateSamlIdentityProviderConfigInput.js';
export * from '../models/CreateScanJobInput.js';
export * from '../models/CreateScanJobResponse.js';
export * from '../models/CreateSessionRequest.js';
export * from '../models/CreateSnapshotRecipeRequest.js';
export * from '../models/CreateSnapshotRecipeResponse.js';
export * from '../models/CreateTagDefinitionRequest.js';
export * from '../models/CreateThreatHuntingScanRequestRequest.js';
export * from '../models/CreateThreatHuntingScanRequestResponse.js';
export * from '../models/CreateUserInput.js';
export * from '../models/CreateVaultRequest.js';
export * from '../models/CreateVaultResponse.js';
export * from '../models/CredentialFinding.js';
export * from '../models/CreditsMonthlyUsageNotificationArguments.js';
export * from '../models/CreditsNotificationArguments.js';
export * from '../models/CrossResourceQueryRequest.js';
export * from '../models/CrossResourceQueryRequestResourcesInner.js';
export * from '../models/CustomTagsInner.js';
export * from '../models/CustomerVaultAccount.js';
export * from '../models/DBResourceMetadata.js';
export * from '../models/DBServerRecord.js';
export * from '../models/DBSnapshotMetadata.js';
export * from '../models/DBSnapshotType.js';
export * from '../models/DBValueDistributionResponse.js';
export * from '../models/DailyConfig.js';
export * from '../models/DailySnapshotData.js';
export * from '../models/DailyStorageSummaries.js';
export * from '../models/DailyStorageSummary.js';
export * from '../models/Dashboard.js';
export * from '../models/Dashboards.js';
export * from '../models/DataCatalogAccessGrant.js';
export * from '../models/DataCatalogAccessPolicy.js';
export * from '../models/DataCatalogColumnType.js';
export * from '../models/DataCatalogDataset.js';
export * from '../models/DataCatalogDatasetAccessControlMode.js';
export * from '../models/DataCatalogDatasetAvailability.js';
export * from '../models/DataCatalogDatasetEvent.js';
export * from '../models/DataCatalogDatasetEventKind.js';
export * from '../models/DataCatalogDatasetHealth.js';
export * from '../models/DataCatalogDatasetHealthIssue.js';
export * from '../models/DataCatalogDatasetHealthIssueKind.js';
export * from '../models/DataCatalogDatasetHealthStatus.js';
export * from '../models/DataCatalogDatasetSchema.js';
export * from '../models/DataCatalogDatasetSchemaColumnsInner.js';
export * from '../models/DataCatalogDatasetType.js';
export * from '../models/DataCatalogDiscoveryProperties.js';
export * from '../models/DataCatalogEffectiveTag.js';
export * from '../models/DataCatalogGrantScope.js';
export * from '../models/DataCatalogGrantStatus.js';
export * from '../models/DataCatalogIssueSeverity.js';
export * from '../models/DataCatalogJoinabilityEntry.js';
export * from '../models/DataCatalogJoinabilitySide.js';
export * from '../models/DataCatalogMaskTransform.js';
export * from '../models/DataCatalogMaskTransformKind.js';
export * from '../models/DataCatalogMaskingPolicyBody.js';
export * from '../models/DataCatalogNamespace.js';
export * from '../models/DataCatalogPipeline.js';
export * from '../models/DataCatalogPipelineAddressPart.js';
export * from '../models/DataCatalogPipelineAddressPartPattern.js';
export * from '../models/DataCatalogPipelineDefinition.js';
export * from '../models/DataCatalogPipelineEngine.js';
export * from '../models/DataCatalogPipelineOutput.js';
export * from '../models/DataCatalogPipelineOutputPartitionSpecInner.js';
export * from '../models/DataCatalogPipelineResolvedDataset.js';
export * from '../models/DataCatalogPipelineResolvedGroup.js';
export * from '../models/DataCatalogPipelineResolvedGroupKeyInner.js';
export * from '../models/DataCatalogPipelineRunMode.js';
export * from '../models/DataCatalogPipelineSchedule.js';
export * from '../models/DataCatalogPipelineSource.js';
export * from '../models/DataCatalogPipelineState.js';
export * from '../models/DataCatalogPipelineViolation.js';
export * from '../models/DataCatalogPipelineWriteMode.js';
export * from '../models/DataCatalogPolicyKind.js';
export * from '../models/DataCatalogPolicyResourceType.js';
export * from '../models/DataCatalogPolicyScope.js';
export * from '../models/DataCatalogPrivilege.js';
export * from '../models/DataCatalogRowExpression.js';
export * from '../models/DataCatalogRowFilterPolicyBody.js';
export * from '../models/DataCatalogRowLiteral.js';
export * from '../models/DataCatalogRowOperator.js';
export * from '../models/DataCatalogRowPredicate.js';
export * from '../models/DataCatalogSemanticLayerRun.js';
export * from '../models/DataCatalogSubjectRef.js';
export * from '../models/DataCatalogSubjectSet.js';
export * from '../models/DataCatalogSubjectType.js';
export * from '../models/DataCatalogTagAssignment.js';
export * from '../models/DataCatalogTagConjunction.js';
export * from '../models/DataCatalogTagDefinition.js';
export * from '../models/DataCatalogTagExpression.js';
export * from '../models/DataCatalogTagInheritance.js';
export * from '../models/DataCatalogTagKind.js';
export * from '../models/DataCatalogTagOperator.js';
export * from '../models/DataCatalogTagPredicate.js';
export * from '../models/DataCatalogTagResourceRef.js';
export * from '../models/DataCatalogTagResourceType.js';
export * from '../models/DataCatalogTagSource.js';
export * from '../models/DataCatalogTreeItem.js';
export * from '../models/DataCatalogTreeItemType.js';
export * from '../models/DataCatalogValidationIssue.js';
export * from '../models/DataCatalogViewAiProperties.js';
export * from '../models/DataCatalogViewProperties.js';
export * from '../models/DataCatalogViewQuery.js';
export * from '../models/DataClassEntitiesFilters.js';
export * from '../models/DataClassesCondition.js';
export * from '../models/DataClassesDetails.js';
export * from '../models/DataClassesFilters.js';
export * from '../models/DataClassificationEntity.js';
export * from '../models/DataClassificationEntityOption.js';
export * from '../models/DataShareIntegrationConfig.js';
export * from '../models/DataTransferOperationType.js';
export * from '../models/Database.js';
export * from '../models/DatabaseDestination.js';
export * from '../models/DatabaseRecord.js';
export * from '../models/DatabricksIntegrationConfig.js';
export * from '../models/DayOfWeek.js';
export * from '../models/DeactivateAccountRequest.js';
export * from '../models/DeactivateAccountResponse.js';
export * from '../models/DeactivateAtlasOrganizationResponse.js';
export * from '../models/DeactivateGcpFolderResponse.js';
export * from '../models/DeactivateGcpOrganizationResponse.js';
export * from '../models/DeleteGdsgObjectsRequest.js';
export * from '../models/DeleteGdsgObjectsResponse.js';
export * from '../models/DeleteResourceTagRequest.js';
export * from '../models/DestinationDetails.js';
export * from '../models/DestinationProviderAttributes.js';
export * from '../models/DestinationProviderAttributesAzure.js';
export * from '../models/DestinationRestoreTypeAttributes.js';
export * from '../models/DetectorSummary.js';
export * from '../models/DetectorType.js';
export * from '../models/DetectorTypeFilters.js';
export * from '../models/DirectoryApplicationSummary.js';
export * from '../models/DirectoryEdgeRecord.js';
export * from '../models/DirectoryEdgeType.js';
export * from '../models/DirectoryEntityRecord.js';
export * from '../models/DirectoryEntityType.js';
export * from '../models/DirectoryEntityTypeCount.js';
export * from '../models/DirectoryScopeKind.js';
export * from '../models/DirectorySearchFilter.js';
export * from '../models/DisableResourceOverrideLimitsResponse.js';
export * from '../models/DisconnectCustomerVaultAccountResponse.js';
export * from '../models/DisconnectRestoreAccountResponse.js';
export * from '../models/DisconnectRestoreAwsOrganizationalUnitResponse.js';
export * from '../models/DisconnectSourceAccountResponse.js';
export * from '../models/DisconnectSourceAwsOrganizationalUnitResponse.js';
export * from '../models/DiscoveryInvokeParams.js';
export * from '../models/DiscoveryJob.js';
export * from '../models/DiscoveryStatusResponse.js';
export * from '../models/DlsgPolicy.js';
export * from '../models/DlsgPolicyConfig.js';
export * from '../models/DlsgPolicyFilters.js';
export * from '../models/DlsgPolicyPlan.js';
export * from '../models/DlsgSettings.js';
export * from '../models/DocumentDBRestoreDestination.js';
export * from '../models/DocumentDbClusterParameterGroup.js';
export * from '../models/DocumentDbClusterParameterGroups.js';
export * from '../models/DocumentDbSnapshotProperties.js';
export * from '../models/DownloadGdsgObjectsRequest.js';
export * from '../models/DriftProtectionPolicy.js';
export * from '../models/DriftProtectionSummary.js';
export * from '../models/DriftProtectionTimePoint.js';
export * from '../models/DsgBucketFilters.js';
export * from '../models/DsgEnvironmentFilters.js';
export * from '../models/DsgRegionFilters.js';
export * from '../models/DsgRequestType.js';
export * from '../models/DsgRequestTypeFilters.js';
export * from '../models/DsgStorageTier.js';
export * from '../models/DsgStorageTierFilters.js';
export * from '../models/DynamoDBAdvancedIndexConfig.js';
export * from '../models/DynamoDBRestoreMethodAvailabilityRequest.js';
export * from '../models/DynamoDBRestoreMethodAvailabilityResponse.js';
export * from '../models/DynamoDBRestoreToS3OutputFormat.js';
export * from '../models/DynamoDbBackupConfig.js';
export * from '../models/DynamoDbBackupConfigApplication.js';
export * from '../models/DynamoDbBillingMode.js';
export * from '../models/DynamoDbGlobalSecondaryIndex.js';
export * from '../models/DynamoDbIndexKeySchemaElement.js';
export * from '../models/DynamoDbIndexProjection.js';
export * from '../models/DynamoDbIndexThroughput.js';
export * from '../models/DynamoDbKeyType.js';
export * from '../models/DynamoDbLocalSecondaryIndex.js';
export * from '../models/DynamoDbProjectionType.js';
export * from '../models/DynamodbTableRestoreDestination.js';
export * from '../models/EFSRestoreDestination.js';
export * from '../models/EbsRestoreDestination.js';
export * from '../models/EbsSnapshotRestoreDestination.js';
export * from '../models/EbsSnapshotTarget.js';
export * from '../models/EbsTarget.js';
export * from '../models/Ec2TemplateParams.js';
export * from '../models/Ec2TemplateParamsAdditionalTagsInner.js';
export * from '../models/EfsSnapshotProperties.js';
export * from '../models/EksBackupNamespaces.js';
export * from '../models/EksCluster.js';
export * from '../models/EksClusterRestoreDestination.js';
export * from '../models/EksClusterRestoreDestinationType.js';
export * from '../models/EksClusterSnapshotProperties.js';
export * from '../models/EksClusterStatus.js';
export * from '../models/EksNamespaceRestoreDestination.js';
export * from '../models/EksNamespaceRestoreResult.js';
export * from '../models/EksRestoreTargetClusters.js';
export * from '../models/EksVolumeRestoreResult.js';
export * from '../models/EmailSearchFilter.js';
export * from '../models/EmrIntegrationConfig.js';
export * from '../models/EnableFromLimitExceededResponse.js';
export * from '../models/EnableResourceOverrideLimitsResponse.js';
export * from '../models/EnableRestoreAccountMetricsConfigRequest.js';
export * from '../models/EnableRestoreAccountMetricsConfigResponse.js';
export * from '../models/EnableSourceAccountMetricsConfigRequest.js';
export * from '../models/EnableSourceAccountMetricsConfigResponse.js';
export * from '../models/EncryptionKey.js';
export * from '../models/EncryptionKeys.js';
export * from '../models/EncryptionType.js';
export * from '../models/EncryptionTypeCondition.js';
export * from '../models/EncryptionTypeFilters.js';
export * from '../models/EndTimeDateFilters.js';
export * from '../models/EntraIdConnectionInfo.js';
export * from '../models/EntraIdEntitySelection.js';
export * from '../models/EntraIdRestoreAccountAttributes.js';
export * from '../models/EntraIdRestoreAccountAttributesInput.js';
export * from '../models/EntraIdSelectionMode.js';
export * from '../models/EntraIdSourceAccountAttributesInput.js';
export * from '../models/EntraRestoreReport.js';
export * from '../models/EntraRestoreReportEntity.js';
export * from '../models/EntraRestoreReportEntityRelationships.js';
export * from '../models/EntraRestoreReportEntityRequiredActionsInner.js';
export * from '../models/EntraRestoreReportJob.js';
export * from '../models/EntraRestoreReportSummary.js';
export * from '../models/EntraRestoreReportSummaryByMethod.js';
export * from '../models/EntraRestoreReportSummaryByTypeValue.js';
export * from '../models/Environment.js';
export * from '../models/EnvironmentCondition.js';
export * from '../models/EnvironmentDetails.js';
export * from '../models/EnvironmentFilters.js';
export * from '../models/EonAccount.js';
export * from '../models/EonAccountIdFilters.js';
export * from '../models/EonAccountStatus.js';
export * from '../models/EonAccountType.js';
export * from '../models/EonOrganization.js';
export * from '../models/EonOrganizationSummary.js';
export * from '../models/ErrorCode.js';
export * from '../models/EvaluateRestoreTemplateResponse.js';
export * from '../models/EvidenceTypeFilters.js';
export * from '../models/ExcludeFromBackupResponse.js';
export * from '../models/ExportAccessDeniedItemsRequest.js';
export * from '../models/ExportComplianceReportRequest.js';
export * from '../models/ExportComplianceReportResponse.js';
export * from '../models/ExportCostDataRequest.js';
export * from '../models/ExportOrganizationCostData400Response.js';
export * from '../models/ExportOrganizationCostDataRequest.js';
export * from '../models/FSxRestoreDestination.js';
export * from '../models/FSxRestoreDestinationOntapRestoreOptions.js';
export * from '../models/FeatureFlagOverrideGet200Response.js';
export * from '../models/FieldStatus.js';
export * from '../models/FileExplorerCountPathFilesResponse.js';
export * from '../models/FileExplorerCountSecurityAlertsInResourceResponse.js';
export * from '../models/FileExplorerCountWorkspaceEntitiesResponse.js';
export * from '../models/FileExplorerResponse.js';
export * from '../models/FilePath.js';
export * from '../models/FileRestoreData.js';
export * from '../models/FileSearchRecord.js';
export * from '../models/FileSnapshot.js';
export * from '../models/FilterQueryRequest.js';
export * from '../models/FindingCountEntry.js';
export * from '../models/FindingEntry.js';
export * from '../models/FindingExclusion.js';
export * from '../models/FindingExclusionDetectorFilters.js';
export * from '../models/FindingExclusionDetectorType.js';
export * from '../models/FindingExclusionFilterConditions.js';
export * from '../models/FindingExclusionResourceFilter.js';
export * from '../models/FindingExclusionScope.js';
export * from '../models/FindingExclusionScopeFilters.js';
export * from '../models/FindingExclusionTypeFilters.js';
export * from '../models/FindingExclusionValueFilters.js';
export * from '../models/FindingObjectType.js';
export * from '../models/FindingObjectTypeFilters.js';
export * from '../models/FindingResourceFilters.js';
export * from '../models/FindingSensitiveDataLocation.js';
export * from '../models/FindingStatus.js';
export * from '../models/FindingStatusFilters.js';
export * from '../models/ForceDeleteSnapshotsRequest.js';
export * from '../models/FreeTextFilters.js';
export * from '../models/FsxOntapVolume.js';
export * from '../models/FsxSnapshotProperties.js';
export * from '../models/FsxVolumeBackupInfo.js';
export * from '../models/GCSBucket.js';
export * from '../models/GCSBuckets.js';
export * from '../models/GCSRestoreDestination.js';
export * from '../models/GCSRestoreTarget.js';
export * from '../models/GcpAccountConfigInput.js';
export * from '../models/GcpBigQueryDatasetRestoreResult.js';
export * from '../models/GcpBigQueryResource.js';
export * from '../models/GcpBigQueryResourceMaterializedViewsInner.js';
export * from '../models/GcpBigQueryResourceRoutinesInner.js';
export * from '../models/GcpBigQueryResourceTablesInner.js';
export * from '../models/GcpBigQueryResourceViewsInner.js';
export * from '../models/GcpCloudSqlResource.js';
export * from '../models/GcpCloudSqlResourceStorageSettings.js';
export * from '../models/GcpCloudSqlRestoreDestination.js';
export * from '../models/GcpCloudSqlSnapshotProperties.js';
export * from '../models/GcpCloudSqlTarget.js';
export * from '../models/GcpDiskResource.js';
export * from '../models/GcpDiskRestoreData.js';
export * from '../models/GcpDiskRestoreDestination.js';
export * from '../models/GcpDiskSettings.js';
export * from '../models/GcpDiskSnapshotProperties.js';
export * from '../models/GcpDiskTarget.js';
export * from '../models/GcpDiskTypesResponse.js';
export * from '../models/GcpEncryptionKey.js';
export * from '../models/GcpEncryptionKeys.js';
export * from '../models/GcpGcsResource.js';
export * from '../models/GcpGkeNamespaceResource.js';
export * from '../models/GcpGrantedServices.js';
export * from '../models/GcpLabelFilter.js';
export * from '../models/GcpMachineTypesResponse.js';
export * from '../models/GcpNetworkConnectivityConfig.js';
export * from '../models/GcpNetworkType.js';
export * from '../models/GcpOptionalCapabilities.js';
export * from '../models/GcpOrganization.js';
export * from '../models/GcpRestoreAccountAttributes.js';
export * from '../models/GcpRestoreAccountAttributesInput.js';
export * from '../models/GcpRestoreAccountConnectivityConfig.js';
export * from '../models/GcpRestoreGrantedServices.js';
export * from '../models/GcpSapHanaResource.js';
export * from '../models/GcpSourceAccountAttributes.js';
export * from '../models/GcpSourceAccountAttributesInput.js';
export * from '../models/GcpSourceServices.js';
export * from '../models/GcpSqlVmBackupHealth.js';
export * from '../models/GcpSqlVmSetup.js';
export * from '../models/GcpSqlVmSetupPath.js';
export * from '../models/GcpSubnet.js';
export * from '../models/GcpSubnetPerRegion.js';
export * from '../models/GcpTagFilter.js';
export * from '../models/GcpVaultConfig.js';
export * from '../models/GcpVaultConfigInput.js';
export * from '../models/GcpVmInstanceRestoreDestination.js';
export * from '../models/GcpVmInstanceRestoreResult.js';
export * from '../models/GcpVmInstanceRestoreTarget.js';
export * from '../models/GcpVmResource.js';
export * from '../models/GcpVmSnapshotProperties.js';
export * from '../models/GcsLocationType.js';
export * from '../models/GdsgActiveBatchJobs.js';
export * from '../models/GdsgBigtableClusterStats.js';
export * from '../models/GdsgBigtableStorageTypeBytes.js';
export * from '../models/GdsgBigtableTableCpu.js';
export * from '../models/GdsgBigtableTableStorage.js';
export * from '../models/GdsgBucketStats.js';
export * from '../models/GdsgDeleteResult.js';
export * from '../models/GdsgDevStats.js';
export * from '../models/GdsgEnvironment.js';
export * from '../models/GdsgEnvironmentRegion.js';
export * from '../models/GdsgInventoryReportConfiguration.js';
export * from '../models/GdsgInventoryReportConfigurationInput.js';
export * from '../models/GdsgInventoryReportCsvOptions.js';
export * from '../models/GdsgInventoryReportCsvRecordSeparator.js';
export * from '../models/GdsgInventoryReportFormat.js';
export * from '../models/GdsgInventoryReportFrequency.js';
export * from '../models/GdsgInventoryReportFrequencyOptions.js';
export * from '../models/GdsgInventoryReportMetadataField.js';
export * from '../models/GdsgInventoryReportRun.js';
export * from '../models/GdsgInventoryReportRunStatus.js';
export * from '../models/GdsgObjectEntry.js';
export * from '../models/GdsgOperationalNotificationArguments.js';
export * from '../models/GdsgOperationalWarning.js';
export * from '../models/GdsgQueueLagStats.js';
export * from '../models/GdsgQueueScanSummary.js';
export * from '../models/GdsgRegionStats.js';
export * from '../models/GdsgRegionStatsPoint.js';
export * from '../models/GdsgStorageBreakdownEntry.js';
export * from '../models/GdsgStorageByBucketEntry.js';
export * from '../models/GdsgStorageByTierEntry.js';
export * from '../models/GdsgWorkerHeartbeatStats.js';
export * from '../models/GdsgWorkerHeartbeats.js';
export * from '../models/GenericSnapshotData.js';
export * from '../models/GetAWSStackDetailsResponse.js';
export * from '../models/GetActionApprovalRuleResponse.js';
export * from '../models/GetActionApprovalSummaryResponse.js';
export * from '../models/GetAdditionalAzureAppsOnboardingStatus200Response.js';
export * from '../models/GetAgreementsResponse.js';
export * from '../models/GetAwsPrivateLinkStatusResponse.js';
export * from '../models/GetAzureQueryExportStorage200Response.js';
export * from '../models/GetBackupJobResponse.js';
export * from '../models/GetBackupPolicyResponse.js';
export * from '../models/GetBackupZeroEtlPolicyConnectionInfoResponse.js';
export * from '../models/GetBillingPeriodsResponse.js';
export * from '../models/GetBulkRestoreSnapshotHistogramRequest.js';
export * from '../models/GetBulkRestoreSnapshotHistogramResponse.js';
export * from '../models/GetCdcSqlSetupCheckResponse.js';
export * from '../models/GetClassificationPolicyResponse.js';
export * from '../models/GetCloudResourceSecurityPropertiesResponse.js';
export * from '../models/GetCredits400Response.js';
export * from '../models/GetCreditsResponse.js';
export * from '../models/GetDataCatalogDatasetResponse.js';
export * from '../models/GetDataCatalogNamespaceResponse.js';
export * from '../models/GetDataCatalogPipelineCapabilitiesResponse.js';
export * from '../models/GetDataCatalogPipelineCapabilitiesResponseEngineAvailabilityInner.js';
export * from '../models/GetDataCatalogSemanticLayerArtifactResponse.js';
export * from '../models/GetDataCatalogSemanticLayerScheduleResponse.js';
export * from '../models/GetDataCatalogSemanticLayerSeedArtifactResponse.js';
export * from '../models/GetDirectoryEntityRequest.js';
export * from '../models/GetDirectoryEntityResponse.js';
export * from '../models/GetDlsgPolicyResponse.js';
export * from '../models/GetFindingExclusionResponse.js';
export * from '../models/GetGcsServiceAgentResponse.js';
export * from '../models/GetGdsgDevStatsResponse.js';
export * from '../models/GetGdsgInventoryReportConfigurationResponse.js';
export * from '../models/GetGdsgRegionStatsResponse.js';
export * from '../models/GetIdpGroupResponse.js';
export * from '../models/GetIntegrationResponse.js';
export * from '../models/GetJobProgressStepsResponse.js';
export * from '../models/GetLimitsResponseValue.js';
export * from '../models/GetMPARequestResponse.js';
export * from '../models/GetMicrosoft365BackupScopeRequest.js';
export * from '../models/GetObjectStoreScanMethodResponse.js';
export * from '../models/GetProjectConfigurationKeyResponse.js';
export * from '../models/GetProjectConfigurationKeysResponse.js';
export * from '../models/GetQueryExecutionResultResponse.js';
export * from '../models/GetResourceResponse.js';
export * from '../models/GetRestoreAccountCanDelete200Response.js';
export * from '../models/GetRestoreAccountConnectivityConfigResponse.js';
export * from '../models/GetRestoreAccountMetricsConfigResponse.js';
export * from '../models/GetRestoreAccountResponse.js';
export * from '../models/GetRestoreJobResponse.js';
export * from '../models/GetRestoreTemplateResponse.js';
export * from '../models/GetRoleResponse.js';
export * from '../models/GetSaasEntityIdByExternalIdRequest.js';
export * from '../models/GetSaasEntityIdByExternalIdResponse.js';
export * from '../models/GetScanJobResponse.js';
export * from '../models/GetSnapshotRecipeResponse.js';
export * from '../models/GetSnapshotResponse.js';
export * from '../models/GetSourceAccountCanDelete200Response.js';
export * from '../models/GetSourceAccountMetricsConfigResponse.js';
export * from '../models/GetSourceAccountResponse.js';
export * from '../models/GetSqlVmNetworkInfoRequest.js';
export * from '../models/GetSqlVmNetworkInfoResponse.js';
export * from '../models/GetTestShadowConsistencyStatus200Response.js';
export * from '../models/GetTestSnapshot200Response.js';
export * from '../models/GetVaultResponse.js';
export * from '../models/GlobalClusterIdentifierCondition.js';
export * from '../models/GlobalClusterIdentifierFilters.js';
export * from '../models/GoogleWorkspaceBackupPolicyPlan.js';
export * from '../models/GoogleWorkspaceConnectionInfo.js';
export * from '../models/GoogleWorkspaceDriveRestoreOptions.js';
export * from '../models/GoogleWorkspaceGmailRestoreOptions.js';
export * from '../models/GoogleWorkspaceGroup.js';
export * from '../models/GoogleWorkspaceGroupMessageMailboxTarget.js';
export * from '../models/GoogleWorkspaceGroupMessageTarget.js';
export * from '../models/GoogleWorkspaceGroupMessageTargetType.js';
export * from '../models/GoogleWorkspaceGroupRestoreWorkload.js';
export * from '../models/GoogleWorkspaceGroupRestoreWorkloadType.js';
export * from '../models/GoogleWorkspaceOrgUnit.js';
export * from '../models/GoogleWorkspaceResource.js';
export * from '../models/GoogleWorkspaceRestoreAccountAttributes.js';
export * from '../models/GoogleWorkspaceRestoreAccountAttributesInput.js';
export * from '../models/GoogleWorkspaceRestoreWorkload.js';
export * from '../models/GoogleWorkspaceServiceAccountInfo.js';
export * from '../models/GoogleWorkspaceSharedDriveEntireDriveOptions.js';
export * from '../models/GoogleWorkspaceSharedDriveRestoreScope.js';
export * from '../models/GoogleWorkspaceSharedDriveSelectedItemsOptions.js';
export * from '../models/GoogleWorkspaceSnapshotProperties.js';
export * from '../models/GoogleWorkspaceSourceAccountAttributes.js';
export * from '../models/GoogleWorkspaceSourceAccountAttributesInput.js';
export * from '../models/GoogleWorkspaceUserDriveEntireDriveOptions.js';
export * from '../models/GoogleWorkspaceUserDriveRestoreScope.js';
export * from '../models/GoogleWorkspaceUserDriveSelectedItemsOptions.js';
export * from '../models/GoogleWorkspaceUserMailEntireMailboxOptions.js';
export * from '../models/GoogleWorkspaceUserMailRestoreScope.js';
export * from '../models/GoogleWorkspaceUserMailSelectedItemsOptions.js';
export * from '../models/GoogleWorkspaceUserRestoreData.js';
export * from '../models/GoogleWorkspaceUserRestoreWorkload.js';
export * from '../models/GoogleWorkspaceUserRestoreWorkloadType.js';
export * from '../models/GoogleWorkspaceWithPolicyStatus.js';
export * from '../models/GroupBreakdown.js';
export * from '../models/GroupBreakdownEntry.js';
export * from '../models/HighFrequencyBackupPolicyPlan.js';
export * from '../models/HighFrequencyBackupResourceType.js';
export * from '../models/HighFrequencyBackupScheduleConfig.js';
export * from '../models/HighFrequencyBackupScheduleFrequency.js';
export * from '../models/HighFrequencyBackupSchedules.js';
export * from '../models/HighFrequencyIntervalConfig.js';
export * from '../models/HoldSnapshotRequest.js';
export * from '../models/IDs.js';
export * from '../models/IdFilters.js';
export * from '../models/IdentityProvidersNames.js';
export * from '../models/Idp.js';
export * from '../models/IdpGroup.js';
export * from '../models/IdpGroupUser.js';
export * from '../models/ImportDlsgCertificateRequest.js';
export * from '../models/IndexRestoreMode.js';
export * from '../models/InfectedDataByClassification.js';
export * from '../models/InfectedDataClassificationSize.js';
export * from '../models/InfectedDataOverTime.js';
export * from '../models/InfectedDateSize.js';
export * from '../models/InfectedResourcesCountResponse.js';
export * from '../models/IngestionPipelineAccess.js';
export * from '../models/IngestionPipelineAccessSubject.js';
export * from '../models/InitAuthInput.js';
export * from '../models/InitiateAccountSwitch403Response.js';
export * from '../models/InitiateAccountSwitchRequest.js';
export * from '../models/InitiateAccountSwitchResponse.js';
export * from '../models/Initiator.js';
export * from '../models/InitiatorIdentity.js';
export * from '../models/InitiatorNameFilters.js';
export * from '../models/InitiatorType.js';
export * from '../models/IntegConfig.js';
export * from '../models/IntegType.js';
export * from '../models/IntegrationConfig.js';
export * from '../models/IntrospectRequest.js';
export * from '../models/IntrospectResponse.js';
export * from '../models/InventoryAzureDisk.js';
export * from '../models/InventoryBackupPolicy.js';
export * from '../models/InventoryClassificationPolicy.js';
export * from '../models/InventoryDetail.js';
export * from '../models/InventoryFilterConditions.js';
export * from '../models/InventoryGcpDisk.js';
export * from '../models/InventoryResource.js';
export * from '../models/InventoryResourceMetadata.js';
export * from '../models/InventorySnapshotVolume.js';
export * from '../models/InventoryVault.js';
export * from '../models/InventoryVolume.js';
export * from '../models/IsVaultDeletableResponse.js';
export * from '../models/IssueMutedNotificationArguments.js';
export * from '../models/IssueType.js';
export * from '../models/IssuesFilters.js';
export * from '../models/JobExecutionDetails.js';
export * from '../models/JobFailedNotificationArguments.js';
export * from '../models/JobIdFilters.js';
export * from '../models/JobInitiationResponse.js';
export * from '../models/JobMetricsReportFailedArguments.js';
export * from '../models/JobProgressStep.js';
export * from '../models/JobProgressStepBucketDataBackupData.js';
export * from '../models/JobProgressStepBucketDataBackupDataCoverage.js';
export * from '../models/JobProgressStepBucketDataBackupDataCoverageNotBackedUpInner.js';
export * from '../models/JobProgressStepBucketDataRestorationData.js';
export * from '../models/JobProgressStepConnectingToRestoreServerData.js';
export * from '../models/JobProgressStepCreateInstanceData.js';
export * from '../models/JobProgressStepDatabaseClusterCreationData.js';
export * from '../models/JobProgressStepDatabaseConfigurationData.js';
export * from '../models/JobProgressStepDatabaseCopyCreationData.js';
export * from '../models/JobProgressStepDatabaseCreationData.js';
export * from '../models/JobProgressStepDatabaseDataBackupData.js';
export * from '../models/JobProgressStepDatabaseDataRestorationData.js';
export * from '../models/JobProgressStepGroupDirectoryRestorationData.js';
export * from '../models/JobProgressStepGroupMessageRestorationData.js';
export * from '../models/JobProgressStepIdentityRestorationData.js';
export * from '../models/JobProgressStepKind.js';
export * from '../models/JobProgressStepNetworkInterfaceCreationData.js';
export * from '../models/JobProgressStepRestoreVolumeData.js';
export * from '../models/JobProgressStepRestoreWorkerData.js';
export * from '../models/JobProgressStepScanningBucketData.js';
export * from '../models/JobProgressStepScanningBucketDataTierByClassInner.js';
export * from '../models/JobProgressStepSnapshotCreationData.js';
export * from '../models/JobProgressStepSnapshotCreationDataVolumesInner.js';
export * from '../models/JobProgressStepStatus.js';
export * from '../models/JobProgressStepTableConfigurationData.js';
export * from '../models/JobProgressStepTableCreationData.js';
export * from '../models/JobProgressStepThreatDetectionData.js';
export * from '../models/JobProgressStepUserDataRestorationData.js';
export * from '../models/JobProgressStepUserWorkloadRestorationData.js';
export * from '../models/JobProgressStepVolumeCreationData.js';
export * from '../models/JobProgressStepVolumeDataBackupData.js';
export * from '../models/JobSnapshotDetails.js';
export * from '../models/JobStatus.js';
export * from '../models/JobStatusFilters.js';
export * from '../models/JobStep.js';
export * from '../models/JobStepName.js';
export * from '../models/JobStepStatus.js';
export * from '../models/JobSucceededNotificationArguments.js';
export * from '../models/KeyspacesBackupConfig.js';
export * from '../models/KeyspacesBackupConfigApplication.js';
export * from '../models/KeyspacesTableRestoreDestination.js';
export * from '../models/KubeAccessStatus.js';
export * from '../models/KubernetesAccessMode.js';
export * from '../models/LimitData.js';
export * from '../models/ListAccessGrantsResponse.js';
export * from '../models/ListAccessPoliciesResponse.js';
export * from '../models/ListAccessibleAccountsResponse.js';
export * from '../models/ListAccountsResponse.js';
export * from '../models/ListActionApprovalRulesResponse.js';
export * from '../models/ListAiAssistantSessions502Response.js';
export * from '../models/ListAllRegionsResponse.js';
export * from '../models/ListAllRegionsResponseRegions.js';
export * from '../models/ListApiCredentialsResponse.js';
export * from '../models/ListApplicationOverrideResponse.js';
export * from '../models/ListAtlasOrganizationsResponse.js';
export * from '../models/ListAuditLogRequest.js';
export * from '../models/ListAuditLogResponse.js';
export * from '../models/ListAuditLogsResponse.js';
export * from '../models/ListAwsVpcsResponse.js';
export * from '../models/ListAwsVpcsResponseVpcsInner.js';
export * from '../models/ListAzureAppRegistrationsResponse.js';
export * from '../models/ListAzureCmkEligibleAppsResponse.js';
export * from '../models/ListAzureDiskEncryptionSetsRequest.js';
export * from '../models/ListAzureDiskEncryptionSetsResponse.js';
export * from '../models/ListAzureFileShares200Response.js';
export * from '../models/ListAzureFileShares200ResponseFileSharesInner.js';
export * from '../models/ListAzureFileSharesRequest.js';
export * from '../models/ListAzureKeyVaultKeysRequest.js';
export * from '../models/ListAzureKeyVaultKeysResponse.js';
export * from '../models/ListAzureRegions200Response.js';
export * from '../models/ListAzureSKUs200Response.js';
export * from '../models/ListAzureSKUs200ResponseSkusInner.js';
export * from '../models/ListAzureSKUsRequest.js';
export * from '../models/ListAzureStorageAccountContainers200Response.js';
export * from '../models/ListAzureStorageAccountContainersRequest.js';
export * from '../models/ListAzureSubnets200Response.js';
export * from '../models/ListAzureSubnets200ResponseSubnetsInner.js';
export * from '../models/ListAzureSubnetsRequest.js';
export * from '../models/ListAzureUnassignedNetworkInterfaces200Response.js';
export * from '../models/ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner.js';
export * from '../models/ListAzureUnassignedNetworkInterfacesRequest.js';
export * from '../models/ListAzureVirtualNetworks200Response.js';
export * from '../models/ListAzureVirtualNetworks200ResponseVirtualNetworksInner.js';
export * from '../models/ListAzureVirtualNetworksRequest.js';
export * from '../models/ListBackupJobTypesResponse.js';
export * from '../models/ListBackupJobsInternal200Response.js';
export * from '../models/ListBackupJobsRequest.js';
export * from '../models/ListBackupJobsResponse.js';
export * from '../models/ListBackupPoliciesResponse.js';
export * from '../models/ListBackupPolicyResponse.js';
export * from '../models/ListBackupPostureControlsRequest.js';
export * from '../models/ListBackupPostureControlsResponse.js';
export * from '../models/ListBackupVaultResponse.js';
export * from '../models/ListBackupZeroEtlPoliciesResponse.js';
export * from '../models/ListBillingTransactionHistoryRequest.js';
export * from '../models/ListBillingTransactionHistoryResponse.js';
export * from '../models/ListCatalogDatabasesResponse.js';
export * from '../models/ListCatalogTablesResponse.js';
export * from '../models/ListCatalogsResponse.js';
export * from '../models/ListClassificationCategoriesResponse.js';
export * from '../models/ListClassificationPoliciesResponse.js';
export * from '../models/ListCloudSnapshotsResponse.js';
export * from '../models/ListComplianceResourcesResponse.js';
export * from '../models/ListControlViolationsResponse.js';
export * from '../models/ListCredentialFindingsResponse.js';
export * from '../models/ListDailySnapshotsResponse.js';
export * from '../models/ListDataCatalogChildrenRequest.js';
export * from '../models/ListDataCatalogChildrenResponse.js';
export * from '../models/ListDataCatalogDatasetEventsRequest.js';
export * from '../models/ListDataCatalogDatasetEventsResponse.js';
export * from '../models/ListDataCatalogDatasetsFlatRequest.js';
export * from '../models/ListDataCatalogDatasetsFlatResponse.js';
export * from '../models/ListDataCatalogDatasetsRequest.js';
export * from '../models/ListDataCatalogDatasetsResponse.js';
export * from '../models/ListDataCatalogJoinabilityRequest.js';
export * from '../models/ListDataCatalogJoinabilityResponse.js';
export * from '../models/ListDataCatalogNamespacesRequest.js';
export * from '../models/ListDataCatalogNamespacesResponse.js';
export * from '../models/ListDataCatalogPipelineVersionsResponse.js';
export * from '../models/ListDataCatalogPipelinesRequest.js';
export * from '../models/ListDataCatalogPipelinesResponse.js';
export * from '../models/ListDataCatalogSemanticLayerRunsResponse.js';
export * from '../models/ListDataClassificationEntitiesResponse.js';
export * from '../models/ListDatabaseSnapshotsResponse.js';
export * from '../models/ListDirectoryEdgesRequest.js';
export * from '../models/ListDirectoryEdgesResponse.js';
export * from '../models/ListDlsgPoliciesResponse.js';
export * from '../models/ListDynamoDbBackupConfigsResponse.js';
export * from '../models/ListEffectivePoliciesRequest.js';
export * from '../models/ListEffectivePoliciesResponse.js';
export * from '../models/ListEffectiveTagsRequest.js';
export * from '../models/ListEffectiveTagsResponse.js';
export * from '../models/ListEksClustersResponse.js';
export * from '../models/ListExclusionPatternResourcesResponse.js';
export * from '../models/ListFindingExclusionsRequest.js';
export * from '../models/ListFindingExclusionsResponse.js';
export * from '../models/ListFindingsResponse.js';
export * from '../models/ListGcpFoldersResponse.js';
export * from '../models/ListGcpNetworksResponse.js';
export * from '../models/ListGcpNetworksResponseNetworksInner.js';
export * from '../models/ListGcpOrganizationsResponse.js';
export * from '../models/ListGcpSubnetsResponse.js';
export * from '../models/ListGdsgEnvironmentsResponse.js';
export * from '../models/ListGdsgInventoryReportConfigurationsResponse.js';
export * from '../models/ListGdsgInventoryReportRunsResponse.js';
export * from '../models/ListGdsgObjectsResponse.js';
export * from '../models/ListGoogleWorkspaceGroups200Response.js';
export * from '../models/ListGoogleWorkspaceGroupsRequest.js';
export * from '../models/ListGoogleWorkspaceOrgUnits200Response.js';
export * from '../models/ListGoogleWorkspaceOrgUnitsRequest.js';
export * from '../models/ListGoogleWorkspacesWithPolicyStatusResponse.js';
export * from '../models/ListGrantedOrganizationGroupAccessResponse.js';
export * from '../models/ListGroupConversationsRequest.js';
export * from '../models/ListIdpGroupsResponse.js';
export * from '../models/ListIdpsResponse.js';
export * from '../models/ListInfectedSnapshotsResponse.js';
export * from '../models/ListInitiatorsResponse.js';
export * from '../models/ListInstanceProfilesResponse.js';
export * from '../models/ListInstanceTypesResponse.js';
export * from '../models/ListIntegrationsResponse.js';
export * from '../models/ListInventoryAppsResponse.js';
export * from '../models/ListInventoryBackupRegionsResponse.js';
export * from '../models/ListInventoryClassificationEntitiesResponse.js';
export * from '../models/ListInventoryEnvironmentsResponse.js';
export * from '../models/ListInventoryGlobalDatabasesResponse.js';
export * from '../models/ListInventoryItemSnapshotsResponse.js';
export * from '../models/ListInventoryNetworksResponse.js';
export * from '../models/ListInventoryRequest.js';
export * from '../models/ListInventoryResourceGroupsResponse.js';
export * from '../models/ListInventoryResourceIdentifiersResponse.js';
export * from '../models/ListInventoryResourceTypesResponse.js';
export * from '../models/ListInventoryResourcesResponse.js';
export * from '../models/ListInventorySensitivityAnnotationValuesResponse.js';
export * from '../models/ListInventorySnapshotsRequest.js';
export * from '../models/ListInventorySnapshotsResponse.js';
export * from '../models/ListInventorySourceRegionsResponse.js';
export * from '../models/ListInventorySubnetsResponse.js';
export * from '../models/ListInventoryTagsResponse.js';
export * from '../models/ListJobErrorCodesResponse.js';
export * from '../models/ListKeyspacesBackupConfigsResponse.js';
export * from '../models/ListKnownAppsResponse.js';
export * from '../models/ListLogSourcesPoliciesResponse.js';
export * from '../models/ListLogSourcesResponse.js';
export * from '../models/ListMPAOperationsResponse.js';
export * from '../models/ListMPARequestsRequest.js';
export * from '../models/ListMPARequestsRequestFilters.js';
export * from '../models/ListMPARequestsResponse.js';
export * from '../models/ListMPARequestsSort.js';
export * from '../models/ListMappableRolesRequest.js';
export * from '../models/ListMappableRolesResponse.js';
export * from '../models/ListMicrosoft365GroupMembers200Response.js';
export * from '../models/ListMicrosoft365GroupMembersRequest.js';
export * from '../models/ListMicrosoft365GroupMembersSort.js';
export * from '../models/ListMicrosoft365Groups200Response.js';
export * from '../models/ListMicrosoft365GroupsRequest.js';
export * from '../models/ListMicrosoft365SharePointSites200Response.js';
export * from '../models/ListMicrosoft365SharePointSitesRequest.js';
export * from '../models/ListMicrosoft365Users200Response.js';
export * from '../models/ListMicrosoft365UsersRequest.js';
export * from '../models/ListMongoAtlasPrivateLinks200Response.js';
export * from '../models/ListMongoDbBackupConfigsResponse.js';
export * from '../models/ListMyMPARequestsRequest.js';
export * from '../models/ListMyMPARequestsRequestFilters.js';
export * from '../models/ListMyMPARequestsResponse.js';
export * from '../models/ListNotificationPoliciesResponse.js';
export * from '../models/ListNotificationsResponse.js';
export * from '../models/ListOAuthAppsResponse.js';
export * from '../models/ListObjectStoreExclusionRulesResponse.js';
export * from '../models/ListOperators.js';
export * from '../models/ListOrganizationAccountsResponse.js';
export * from '../models/ListOrganizationIdpGroupsRequest.js';
export * from '../models/ListOrganizationIdpGroupsResponse.js';
export * from '../models/ListOrganizationIdpsResponse.js';
export * from '../models/ListOrganizationUsersResponse.js';
export * from '../models/ListPermissionsResponse.js';
export * from '../models/ListProjectsResponse.js';
export * from '../models/ListQueryExecutionsRequest.js';
export * from '../models/ListQueryExecutionsRequestFilters.js';
export * from '../models/ListQueryExecutionsRequestFiltersCreatedAt.js';
export * from '../models/ListQueryExecutionsRequestFiltersId.js';
export * from '../models/ListQueryExecutionsRequestFiltersStatus.js';
export * from '../models/ListQueryExecutionsRequestSortsInner.js';
export * from '../models/ListQueryExecutionsResponse.js';
export * from '../models/ListResourceAttachmentEventsResponse.js';
export * from '../models/ListResourcesResponse.js';
export * from '../models/ListRestoreAccountsRequest.js';
export * from '../models/ListRestoreAccountsResponse.js';
export * from '../models/ListRestoreAwsOrganizationalUnitsResponse.js';
export * from '../models/ListRestoreJobTypesResponse.js';
export * from '../models/ListRestoreJobsInternal200Response.js';
export * from '../models/ListRestoreJobsRequest.js';
export * from '../models/ListRestoreJobsResponse.js';
export * from '../models/ListRestoreTemplatesRequest.js';
export * from '../models/ListRestoreTemplatesResponse.js';
export * from '../models/ListRestoreTemplatesResponsePagination.js';
export * from '../models/ListRolesResponse.js';
export * from '../models/ListSaasEntitiesRequest.js';
export * from '../models/ListSaasEntitiesRequestFilters.js';
export * from '../models/ListSaasEntitiesResponse.js';
export * from '../models/ListSaasEntitySnapshotsResponse.js';
export * from '../models/ListScanJobTypesResponse.js';
export * from '../models/ListScanJobsInternal200Response.js';
export * from '../models/ListScanJobsRequest.js';
export * from '../models/ListScanJobsResponse.js';
export * from '../models/ListSecurityFindingsRequest.js';
export * from '../models/ListSensitivityAnnotationsResponse.js';
export * from '../models/ListSnapshotRecipeEntriesRequest.js';
export * from '../models/ListSnapshotRecipeEntriesResponse.js';
export * from '../models/ListSnapshotRecipesResponse.js';
export * from '../models/ListSourceAccountsRequest.js';
export * from '../models/ListSourceAccountsResponse.js';
export * from '../models/ListSourceAwsOrganizationalUnitsResponse.js';
export * from '../models/ListStagingBucketsResponse.js';
export * from '../models/ListStorageGatewaysResponse.js';
export * from '../models/ListSubnetsResponse.js';
export * from '../models/ListSubnetsResponseV2.js';
export * from '../models/ListSubnetsResponseV2SubnetsInner.js';
export * from '../models/ListTagDefinitionsResponse.js';
export * from '../models/ListTestResourceSnapshots200Response.js';
export * from '../models/ListTestResourceSnapshots200ResponseSnapshotsInner.js';
export * from '../models/ListThreatHuntingResultsRequest.js';
export * from '../models/ListThreatHuntingResultsResponse.js';
export * from '../models/ListThreatHuntingScanRequestsRequest.js';
export * from '../models/ListThreatHuntingScanRequestsResponse.js';
export * from '../models/ListUsersResponse.js';
export * from '../models/ListVaultBlockedRegionsResponse.js';
export * from '../models/ListVaultsRequest.js';
export * from '../models/ListZeroEtlJobSyncsRequest.js';
export * from '../models/ListZeroEtlJobSyncsResponse.js';
export * from '../models/ListZeroEtlJobsRequest.js';
export * from '../models/ListZeroEtlJobsResponse.js';
export * from '../models/ListZeroEtlTargetTablesRequest.js';
export * from '../models/ListZeroEtlTargetTablesResponse.js';
export * from '../models/LlgLocationResource.js';
export * from '../models/LlgLocationWithResources.js';
export * from '../models/LlgResourcePolicy.js';
export * from '../models/LogRecord.js';
export * from '../models/LogSource.js';
export * from '../models/LogSourceLocation.js';
export * from '../models/LogSourceLocationCloudTrail.js';
export * from '../models/LogSourceLocationCloudWatchLogs.js';
export * from '../models/LogSourceLocationDatadog.js';
export * from '../models/LogSourceLocationGcpCloudLogging.js';
export * from '../models/LogSourceLocationSplunkDdss.js';
export * from '../models/LogSourceWithPolicy.js';
export * from '../models/LogicalOperator.js';
export * from '../models/LogsHistogramDataPoint.js';
export * from '../models/LogsSchema.js';
export * from '../models/LogsSchemaColumn.js';
export * from '../models/LogsSchemaEntry.js';
export * from '../models/LogsSchemasResponse.js';
export * from '../models/LuceneQueryInput.js';
export * from '../models/MPADecision.js';
export * from '../models/MPAEntityType.js';
export * from '../models/MPAInterceptedResponse.js';
export * from '../models/MPAListRequestSortField.js';
export * from '../models/MPAOperationInfo.js';
export * from '../models/MPAOperationScope.js';
export * from '../models/MPAOperationType.js';
export * from '../models/MPAPoliciesInfo.js';
export * from '../models/MPAPrincipal.js';
export * from '../models/MPARequest.js';
export * from '../models/MPARequestDetail.js';
export * from '../models/MPARequestListPerspective.js';
export * from '../models/MPARequestNotificationArguments.js';
export * from '../models/MPARequestPolicyDetail.js';
export * from '../models/MPARequestStatus.js';
export * from '../models/MPAReview.js';
export * from '../models/MPAReviewNotificationArguments.js';
export * from '../models/MPAReviewSubmitDecision.js';
export * from '../models/MPASubmitAction.js';
export * from '../models/MaxRetentionDaysLimit.js';
export * from '../models/MaxRetentionRule.js';
export * from '../models/Message.js';
export * from '../models/MeteringDimension.js';
export * from '../models/Microsoft365BackupScope.js';
export * from '../models/Microsoft365ConnectionInfo.js';
export * from '../models/Microsoft365EntityFilters.js';
export * from '../models/Microsoft365EntitySelection.js';
export * from '../models/Microsoft365FilterSelectionRef.js';
export * from '../models/Microsoft365Group.js';
export * from '../models/Microsoft365GroupMemberSortField.js';
export * from '../models/Microsoft365Permission.js';
export * from '../models/Microsoft365PolicyConfig.js';
export * from '../models/Microsoft365Resource.js';
export * from '../models/Microsoft365RestoreAccountAttributes.js';
export * from '../models/Microsoft365RestoreAccountAttributesInput.js';
export * from '../models/Microsoft365RestoreWorkload.js';
export * from '../models/Microsoft365SelectionMode.js';
export * from '../models/Microsoft365SharePointSite.js';
export * from '../models/Microsoft365SharePointSiteRestoreScope.js';
export * from '../models/Microsoft365SharePointSiteSelectedItemsOptions.js';
export * from '../models/Microsoft365SourceAccountAttributesInput.js';
export * from '../models/Microsoft365TeamRestoreScope.js';
export * from '../models/Microsoft365TeamSelectedItemsOptions.js';
export * from '../models/Microsoft365TeamsRestoreDestination.js';
export * from '../models/Microsoft365User.js';
export * from '../models/Microsoft365UserChatsRestoreScope.js';
export * from '../models/Microsoft365UserChatsSelectedItemsOptions.js';
export * from '../models/Microsoft365UserDriveRestoreScope.js';
export * from '../models/Microsoft365UserDriveSelectedItemsOptions.js';
export * from '../models/Microsoft365UserExclusions.js';
export * from '../models/Microsoft365UserLicenseStatus.js';
export * from '../models/Microsoft365UserMailRestoreScope.js';
export * from '../models/Microsoft365UserMailSelectedItemsOptions.js';
export * from '../models/Microsoft365UserRestoreData.js';
export * from '../models/Microsoft365UserRestoreSelection.js';
export * from '../models/Microsoft365UserRestoreWorkload.js';
export * from '../models/Microsoft365UserRestoreWorkloadType.js';
export * from '../models/Microsoft365WholeUserRestore.js';
export * from '../models/MicrosoftFabricIntegrationConfig.js';
export * from '../models/MinRetentionRule.js';
export * from '../models/ModelError.js';
export * from '../models/MongoAtlasClusterResource.js';
export * from '../models/MongoAtlasOidc.js';
export * from '../models/MongoAtlasPrivateLinkEntry.js';
export * from '../models/MongoAtlasPrivateLinkProvider.js';
export * from '../models/MongoAtlasRegionPlacement.js';
export * from '../models/MongoAtlasRequiredPrivateLink.js';
export * from '../models/MongoAtlasRestoreAccountAttributes.js';
export * from '../models/MongoAtlasRestoreAccountAttributesInput.js';
export * from '../models/MongoAtlasRestoreDestination.js';
export * from '../models/MongoAtlasSourceAccountAttributes.js';
export * from '../models/MongoAtlasSourceAccountAttributesInput.js';
export * from '../models/MongoDbBackupConfig.js';
export * from '../models/MonthlyConfig.js';
export * from '../models/MonthlySnapshotData.js';
export * from '../models/MsaAcceptanceResponse.js';
export * from '../models/MultiResourceBackupZeroEtlConfiguration.js';
export * from '../models/NativePasswordAccounts.js';
export * from '../models/NativeStandardConfig.js';
export * from '../models/NeptuneClusterParameterGroup.js';
export * from '../models/NeptuneClusterParameterGroups.js';
export * from '../models/NeptuneRestoreDestination.js';
export * from '../models/NeptuneSnapshotProperties.js';
export * from '../models/NetworkClassification.js';
export * from '../models/NetworkClassificationCondition.js';
export * from '../models/NetworkClassificationDetails.js';
export * from '../models/NetworkClassificationFilters.js';
export * from '../models/NetworkInterfaceConfig.js';
export * from '../models/Notification.js';
export * from '../models/NotificationArguments.js';
export * from '../models/NotificationPolicy.js';
export * from '../models/NotificationPolicyConfig.js';
export * from '../models/NotificationPolicyConfigDatadog.js';
export * from '../models/NotificationPolicyConfigEmail.js';
export * from '../models/NotificationPolicyConfigServiceNow.js';
export * from '../models/NotificationPolicyConfigSlack.js';
export * from '../models/NotificationPolicyConfigSns.js';
export * from '../models/NotificationPolicyConfigSplunk.js';
export * from '../models/NotificationPolicyConfigWebhook.js';
export * from '../models/NotificationStatus.js';
export * from '../models/NotificationType.js';
export * from '../models/NumberOfCopiesRule.js';
export * from '../models/NumericOperators.js';
export * from '../models/OAuthApp.js';
export * from '../models/Oauth2TokenResponse.js';
export * from '../models/ObjectStorageDestination.js';
export * from '../models/ObjectStoreCoverageBreakdown.js';
export * from '../models/ObjectStoreCoverageReason.js';
export * from '../models/ObjectStoreCoverageReasonEntry.js';
export * from '../models/ObjectStoreExclusionRule.js';
export * from '../models/ObjectStoreScanMethod.js';
export * from '../models/ObjectStoreScanMethodSetting.js';
export * from '../models/ObjectStoreTierClass.js';
export * from '../models/OnboardAdditionalAzureApps200Response.js';
export * from '../models/OnboardAdditionalAzureAppsRequest.js';
export * from '../models/OnboardRdsCdcRequest.js';
export * from '../models/OnboardRdsCdcResponse.js';
export * from '../models/OnboardingAzureResourceGroup.js';
export * from '../models/OperatingSystem.js';
export * from '../models/OperationIdFilters.js';
export * from '../models/OrgCostDataFilters.js';
export * from '../models/OrgCostDataGroupBy.js';
export * from '../models/OrgSaasAccountCost.js';
export * from '../models/OrganizationAccount.js';
export * from '../models/OrganizationGroupAccess.js';
export * from '../models/OrganizationIdp.js';
export * from '../models/OrganizationIdpGroup.js';
export * from '../models/OrganizationRoleGrant.js';
export * from '../models/OrganizationRoleGrantTargetKind.js';
export * from '../models/OrganizationSamlServiceProviderDetails.js';
export * from '../models/OrganizationUser.js';
export * from '../models/OrganizationUserRole.js';
export * from '../models/OrganizationUserStatus.js';
export * from '../models/OverrideDataClassificationsRequest.js';
export * from '../models/OverrideDataClassificationsResponse.js';
export * from '../models/OverrideEnvironmentRequest.js';
export * from '../models/OverrideEnvironmentResponse.js';
export * from '../models/OverrideNetworkClassificationRequest.js';
export * from '../models/OverrideNetworkClassificationResponse.js';
export * from '../models/OverrideSensitivityAnnotationsRequest.js';
export * from '../models/Pagination.js';
export * from '../models/ParameterCheckResult.js';
export * from '../models/ParentIdFilters.js';
export * from '../models/PartialRestoreData.js';
export * from '../models/PartialRestoreType.js';
export * from '../models/Path.js';
export * from '../models/PathSnapshotsRequest.js';
export * from '../models/PathSnapshotsResponse.js';
export * from '../models/PathType.js';
export * from '../models/Permission.js';
export * from '../models/PermissionActionCategory.js';
export * from '../models/PermissionArea.js';
export * from '../models/PermissionGrant.js';
export * from '../models/PermissionGrantInput.js';
export * from '../models/PermissionType.js';
export * from '../models/PersistentVolumeClaimProperties.js';
export * from '../models/PitrBackupPolicyPlan.js';
export * from '../models/PitrBackupResourceType.js';
export * from '../models/PitrBackupSchedules.js';
export * from '../models/PitrIntervalConfig.js';
export * from '../models/PitrRestoreVaultWindows.js';
export * from '../models/PitrRestoreWindow.js';
export * from '../models/PitrRestoreWindowsResponse.js';
export * from '../models/Preferences.js';
export * from '../models/PreviewBackupPolicyResourcesRequest.js';
export * from '../models/PreviewBackupPolicyResourcesResponse.js';
export * from '../models/PrivateLinkCheckResult.js';
export * from '../models/PrivateLinkFormatInstructions.js';
export * from '../models/PrivateLinkInstructionStep.js';
export * from '../models/Project.js';
export * from '../models/ProjectConfigurationKeyEnum.js';
export * from '../models/ProjectIdFilters.js';
export * from '../models/Provider.js';
export * from '../models/ProviderAccountIdFilters.js';
export * from '../models/ProviderCategory.js';
export * from '../models/ProviderCategoryFilters.js';
export * from '../models/ProviderParentIdFilters.js';
export * from '../models/ProviderRestoreAccountConnectivityConfig.js';
export * from '../models/PulumiConfiguration.js';
export * from '../models/PulumiConfigurations.js';
export * from '../models/PulumiConfigurationsFilterConditions.js';
export * from '../models/PulumiConfigurationsRequest.js';
export * from '../models/PutDashboardRequest.js';
export * from '../models/PutDataCatalogExternalContextDocumentRequest.js';
export * from '../models/PutDataCatalogExternalContextDocumentResponse.js';
export * from '../models/QueryCostDataRequest.js';
export * from '../models/QueryCostDataResponse.js';
export * from '../models/QueryDBRequest.js';
export * from '../models/QueryDBResponse.js';
export * from '../models/QueryDBRestoreDestination.js';
export * from '../models/QueryDBRestoreDestinationType.js';
export * from '../models/QueryDBResultResponse.js';
export * from '../models/QueryDBStatus.js';
export * from '../models/QueryDBStatusResponse.js';
export * from '../models/QueryEngine.js';
export * from '../models/QueryExecution.js';
export * from '../models/QueryExecutionResultColumn.js';
export * from '../models/QueryExecutionStatus.js';
export * from '../models/QueryOrganizationCostData400Response.js';
export * from '../models/QueryOrganizationCostDataRequest.js';
export * from '../models/QueryOrganizationCostDataResponse.js';
export * from '../models/QuotaStatus.js';
export * from '../models/QuotaStatusFilters.js';
export * from '../models/RamShareCheckResult.js';
export * from '../models/RansomwareResourceNotificationArguments.js';
export * from '../models/RdsCdcCheckScope.js';
export * from '../models/RdsNativePitrAdvancedConfig.js';
export * from '../models/RdsNativePitrClusterAdvancedConfig.js';
export * from '../models/RdsNativePitrNetworkConfig.js';
export * from '../models/RdsNativePitrWindow.js';
export * from '../models/RdsPasswordConfig.js';
export * from '../models/RdsSecurityGroup.js';
export * from '../models/ReactivateAccountRequest.js';
export * from '../models/ReassessActionRequiredRequest.js';
export * from '../models/ReassessActionRequiredResponse.js';
export * from '../models/ReconnectCustomerVaultAccountResponse.js';
export * from '../models/ReconnectRestoreAccountResponse.js';
export * from '../models/ReconnectRestoreAwsOrganizationalUnitResponse.js';
export * from '../models/ReconnectSourceAccountResponse.js';
export * from '../models/ReconnectSourceAwsOrganizationalUnitResponse.js';
export * from '../models/RecordRestoreResult.js';
export * from '../models/RecoveryPointData.js';
export * from '../models/RegionCondition.js';
export * from '../models/RegisterInput.js';
export * from '../models/RegisterInputBillingToken.js';
export * from '../models/RegisterResponse.js';
export * from '../models/RelatedGlobalDbCluster.js';
export * from '../models/RemoteCatalogType.js';
export * from '../models/RequestDetails.js';
export * from '../models/ResourceBackupSettings.js';
export * from '../models/ResourceBlockerDetail.js';
export * from '../models/ResourceBlockerGroup.js';
export * from '../models/ResourceBlockerType.js';
export * from '../models/ResourceComplianceRow.js';
export * from '../models/ResourceDetails.js';
export * from '../models/ResourceGroupNameCondition.js';
export * from '../models/ResourceGroupNameFilters.js';
export * from '../models/ResourceIdCondition.js';
export * from '../models/ResourceIdFilters.js';
export * from '../models/ResourceIdentifiers.js';
export * from '../models/ResourceNameCondition.js';
export * from '../models/ResourceNameFilters.js';
export * from '../models/ResourceProperties.js';
export * from '../models/ResourceQuota.js';
export * from '../models/ResourceReference.js';
export * from '../models/ResourceSelectorMode.js';
export * from '../models/ResourceSnapshot.js';
export * from '../models/ResourceSnapshotProperties.js';
export * from '../models/ResourceSortField.js';
export * from '../models/ResourceTag.js';
export * from '../models/ResourceType.js';
export * from '../models/ResourceTypeCondition.js';
export * from '../models/ResourceTypeFilters.js';
export * from '../models/ResourceTypeToSecurityGroup.js';
export * from '../models/ResourceValidationError.js';
export * from '../models/RestoreAccount.js';
export * from '../models/RestoreAccountAttributesInput.js';
export * from '../models/RestoreAccountCloudAttributes.js';
export * from '../models/RestoreAccountConnectivityConfig.js';
export * from '../models/RestoreAccountMetricsConfig.js';
export * from '../models/RestoreAccountRegions.js';
export * from '../models/RestoreAccountSortField.js';
export * from '../models/RestoreAccountTagOperator.js';
export * from '../models/RestoreAccountTagSubject.js';
export * from '../models/RestoreAccountsFilterConditions.js';
export * from '../models/RestoreAtlasClusterInput.js';
export * from '../models/RestoreAvailabilityZones.js';
export * from '../models/RestoreAwsCassandraClusterRequest.js';
export * from '../models/RestoreAwsEc2InstanceRequest.js';
export * from '../models/RestoreAwsOpenSearchDomainRequest.js';
export * from '../models/RestoreAwsOrganizationalUnit.js';
export * from '../models/RestoreAzureDiskConfig.js';
export * from '../models/RestoreAzureDiskRequest.js';
export * from '../models/RestoreAzureEntraIdRequest.js';
export * from '../models/RestoreAzureFileShareRequest.js';
export * from '../models/RestoreAzureInstanceDiskInput.js';
export * from '../models/RestoreAzurePostgresDatabaseRequest.js';
export * from '../models/RestoreAzureSqlDatabaseNativePitrRequest.js';
export * from '../models/RestoreAzureSqlDatabaseRequest.js';
export * from '../models/RestoreAzureSqlVmPitrRequest.js';
export * from '../models/RestoreAzureVMInstanceConfig.js';
export * from '../models/RestoreAzureVmInstanceRequest.js';
export * from '../models/RestoreAzureVmNativeRequest.js';
export * from '../models/RestoreBigQueryDatasetRequest.js';
export * from '../models/RestoreBigQueryNativePitrRequest.js';
export * from '../models/RestoreBucketRequest.js';
export * from '../models/RestoreDbToRdsInstanceRequest.js';
export * from '../models/RestoreDbToRdsSnapshotRequest.js';
export * from '../models/RestoreDestinationLimits.js';
export * from '../models/RestoreDestinationTagLimits.js';
export * from '../models/RestoreDocumentDBRequest.js';
export * from '../models/RestoreDynamoDBTableRequest.js';
export * from '../models/RestoreDynamoDBToExistingTableRequest.js';
export * from '../models/RestoreDynamoDBToS3Request.js';
export * from '../models/RestoreDynamoDbTableConfig.js';
export * from '../models/RestoreEFSRequest.js';
export * from '../models/RestoreEbsVolumeConfig.js';
export * from '../models/RestoreEc2InstanceConfig.js';
export * from '../models/RestoreEksClusterRequest.js';
export * from '../models/RestoreEksNamespaceConfig.js';
export * from '../models/RestoreEksNamespaceInput.js';
export * from '../models/RestoreEksNamespaceVolumeInput.js';
export * from '../models/RestoreEntraIdWithMicrosoft365Request.js';
export * from '../models/RestoreFSxRequest.js';
export * from '../models/RestoreFilesRequest.js';
export * from '../models/RestoreGceDiskConfig.js';
export * from '../models/RestoreGceInstanceConfig.js';
export * from '../models/RestoreGcpCloudSqlDatabaseConfig.js';
export * from '../models/RestoreGcpCloudSqlRequest.js';
export * from '../models/RestoreGcpDiskRequest.js';
export * from '../models/RestoreGcpInstanceDiskInput.js';
export * from '../models/RestoreGcpVmInstanceRequest.js';
export * from '../models/RestoreGoogleWorkspaceGroupMessagesRequest.js';
export * from '../models/RestoreGoogleWorkspaceGroupRequest.js';
export * from '../models/RestoreGoogleWorkspaceSharedDriveRequest.js';
export * from '../models/RestoreGoogleWorkspaceUserDriveRequest.js';
export * from '../models/RestoreGoogleWorkspaceUserMailRequest.js';
export * from '../models/RestoreGoogleWorkspaceUserRequest.js';
export * from '../models/RestoreImageImageDeviceInput.js';
export * from '../models/RestoreImageImageInput.js';
export * from '../models/RestoreImageInput.js';
export * from '../models/RestoreImageVolumeInput.js';
export * from '../models/RestoreInstanceImageDeviceInput.js';
export * from '../models/RestoreInstanceImageInput.js';
export * from '../models/RestoreInstanceVolumeInput.js';
export * from '../models/RestoreJob.js';
export * from '../models/RestoreJobConfiguration.js';
export * from '../models/RestoreJobInitiationResponse.js';
export * from '../models/RestoreJobSortField.js';
export * from '../models/RestoreJobType.js';
export * from '../models/RestoreJobTypeFilters.js';
export * from '../models/RestoreJobsFilterConditions.js';
export * from '../models/RestoreKeyspacesTableRequest.js';
export * from '../models/RestoreMethod.js';
export * from '../models/RestoreMethodAvailabilityReason.js';
export * from '../models/RestoreMicrosoft365ItemsRequest.js';
export * from '../models/RestoreMicrosoft365Request.js';
export * from '../models/RestoreMicrosoft365SharePointSiteByEntityRequest.js';
export * from '../models/RestoreMicrosoft365TeamByEntityRequest.js';
export * from '../models/RestoreMicrosoft365UserByEntityRequest.js';
export * from '../models/RestoreMicrosoft365UserChatsByEntityRequest.js';
export * from '../models/RestoreMicrosoft365UserDriveByEntityRequest.js';
export * from '../models/RestoreMicrosoft365UserMailByEntityRequest.js';
export * from '../models/RestoreMicrosoft365UserRequest.js';
export * from '../models/RestoreNeptuneRequest.js';
export * from '../models/RestoreObfuscationConfig.js';
export * from '../models/RestoreRdsInstanceClasses.js';
export * from '../models/RestoreRdsInstanceConfig.js';
export * from '../models/RestoreRdsNativePitrRequest.js';
export * from '../models/RestoreRdsSubnetGroups.js';
export * from '../models/RestoreRdsSubnetGroupsRdsSubnetGroupsInner.js';
export * from '../models/RestoreRecipeRef.js';
export * from '../models/RestoreResult.js';
export * from '../models/RestoreSecurityGroups.js';
export * from '../models/RestoreSecurityGroupsSecurityGroupsInner.js';
export * from '../models/RestoreTemplate.js';
export * from '../models/RestoreTemplateFilterConditions.js';
export * from '../models/RestoreTemplateIdFilters.js';
export * from '../models/RestoreTemplateResourceType.js';
export * from '../models/RestoreTemplateResourceTypeFilters.js';
export * from '../models/RestoreVolumeToEbsRequest.js';
export * from '../models/RestoreVolumeToEbsSnapshotRequest.js';
export * from '../models/RevalidateRestoreTemplateRequest.js';
export * from '../models/RevalidateRestoreTemplateResponse.js';
export * from '../models/RevalidationReport.js';
export * from '../models/RevalidationStatus.js';
export * from '../models/RiskLevel.js';
export * from '../models/RiskLevelFilters.js';
export * from '../models/Role.js';
export * from '../models/RoleAccessGroupCondition.js';
export * from '../models/RoleInstallationMethod.js';
export * from '../models/RoleSummary.js';
export * from '../models/RoleUsage.js';
export * from '../models/RuleComponent.js';
export * from '../models/RuleOutcome.js';
export * from '../models/RuleOutcomeList.js';
export * from '../models/RunAgentRequest.js';
export * from '../models/S3Bucket.js';
export * from '../models/S3Buckets.js';
export * from '../models/S3RestoreDestination.js';
export * from '../models/S3RestoreTarget.js';
export * from '../models/S3TemplateParams.js';
export * from '../models/SAMLCallback400Response.js';
export * from '../models/SAMLCallback401Response.js';
export * from '../models/SAMLCallback500Response.js';
export * from '../models/SaasAppCost.js';
export * from '../models/SaasBackupStatus.js';
export * from '../models/SaasCommitmentWindowCost.js';
export * from '../models/SaasEmailSearchFilter.js';
export * from '../models/SaasEntity.js';
export * from '../models/SaasEntityExternalIdFilters.js';
export * from '../models/SaasEntityProperties.js';
export * from '../models/SaasEntitySnapshot.js';
export * from '../models/SaasEntityType.js';
export * from '../models/SaasEntityTypeFilters.js';
export * from '../models/SaasGoogleWorkspaceUserProperties.js';
export * from '../models/SaasGroupProperties.js';
export * from '../models/SaasItemSearchRequest.js';
export * from '../models/SaasItemSearchResponse.js';
export * from '../models/SaasMailDetails.js';
export * from '../models/SaasMicrosoft365UserProperties.js';
export * from '../models/SaasProtectionStatus.js';
export * from '../models/SaasProtectionStatusFilters.js';
export * from '../models/SaasRestoreItem.js';
export * from '../models/SaasRestoreMode.js';
export * from '../models/SaasSharePointSiteProperties.js';
export * from '../models/SaasSnapshotItem.js';
export * from '../models/SaasTeamProperties.js';
export * from '../models/SaasWorkload.js';
export * from '../models/SaasWorkloadStatus.js';
export * from '../models/SameSourceAccountRestoreLimits.js';
export * from '../models/SamlIdentityProvider.js';
export * from '../models/SamlIdentityProviderConfigsResponse.js';
export * from '../models/SapHanaInstance.js';
export * from '../models/SapHanaRestoreProperties.js';
export * from '../models/SaveCloudResourceSecurityPropertiesRequest.js';
export * from '../models/ScalarOperators.js';
export * from '../models/ScanJob.js';
export * from '../models/ScanJobType.js';
export * from '../models/ScheduleMode.js';
export * from '../models/ScheduleTimezone.js';
export * from '../models/ScheduleType.js';
export * from '../models/SchemaRecord.js';
export * from '../models/SearchAllEvent.js';
export * from '../models/SearchAllPlan.js';
export * from '../models/SearchAllRequest.js';
export * from '../models/SearchAllSection.js';
export * from '../models/SearchAllSectionQuery.js';
export * from '../models/SearchAllSectionRef.js';
export * from '../models/SearchAllSectionResult.js';
export * from '../models/SearchAllSectionStatus.js';
export * from '../models/SearchAllType.js';
export * from '../models/SearchDBResponse.js';
export * from '../models/SearchDirectoryEntitiesRequest.js';
export * from '../models/SearchDirectoryEntitiesResponse.js';
export * from '../models/SearchFilesResponse.js';
export * from '../models/SearchInput.js';
export * from '../models/SearchLogsHistogramInput.js';
export * from '../models/SearchLogsHistogramResponse.js';
export * from '../models/SearchLogsInput.js';
export * from '../models/SearchLogsResponse.js';
export * from '../models/SearchWorkspaceDirectoryRequest.js';
export * from '../models/SearchWorkspaceFilesRequest.js';
export * from '../models/SearchWorkspaceMailRequest.js';
export * from '../models/SecurityAssignmentStatus.js';
export * from '../models/SecurityFindingsFilterConditions.js';
export * from '../models/SecurityInformation.js';
export * from '../models/SecurityPlan.js';
export * from '../models/SecurityPlanEnabledResponse.js';
export * from '../models/SecurityResourceNotificationArguments.js';
export * from '../models/SecurityScan.js';
export * from '../models/SecurityScanConclusion.js';
export * from '../models/SecurityScanConclusionCondition.js';
export * from '../models/SecurityScanConclusionFilters.js';
export * from '../models/SecurityScanNotificationData.js';
export * from '../models/SecurityScanResult.js';
export * from '../models/SecurityScansSummaryResponse.js';
export * from '../models/SecuritySnapshotNotificationArguments.js';
export * from '../models/SecuritySummary.js';
export * from '../models/SendA2AMessageRequest.js';
export * from '../models/SensitivityAnnotation.js';
export * from '../models/SensitivityAnnotationsCondition.js';
export * from '../models/SensitivityLabelsDetails.js';
export * from '../models/SensitivityLabelsFilters.js';
export * from '../models/SensitivityLevel.js';
export * from '../models/ServiceProviderDetails.js';
export * from '../models/Session.js';
export * from '../models/SessionScope.js';
export * from '../models/SetDataCatalogDatasetAccessControlModeRequest.js';
export * from '../models/SetDataCatalogDatasetAccessControlModeResponse.js';
export * from '../models/SetResourceTagRequest.js';
export * from '../models/SetupAwsPrivateLinkRequest.js';
export * from '../models/SetupAwsPrivateLinkResponse.js';
export * from '../models/SetupMongoAtlasPrivateLinkRequest.js';
export * from '../models/SetupMongoAtlasPrivateLinkResponse.js';
export * from '../models/Severity.js';
export * from '../models/SeverityFilterValue.js';
export * from '../models/SeverityFilters.js';
export * from '../models/ShadowSnapshotType.js';
export * from '../models/ShovalAgentInstallCommand.js';
export * from '../models/ShovalAgentInstallPlatform.js';
export * from '../models/SingleResourceBackupZeroEtlConfiguration.js';
export * from '../models/Snapshot.js';
export * from '../models/SnapshotAccessDeniedNotificationArguments.js';
export * from '../models/SnapshotCoverage.js';
export * from '../models/SnapshotCoverageAvailability.js';
export * from '../models/SnapshotDateFilters.js';
export * from '../models/SnapshotFilterConditions.js';
export * from '../models/SnapshotFindingCountsResponse.js';
export * from '../models/SnapshotHistogramBucket.js';
export * from '../models/SnapshotHoldReason.js';
export * from '../models/SnapshotIdFilters.js';
export * from '../models/SnapshotLocation.js';
export * from '../models/SnapshotRangePick.js';
export * from '../models/SnapshotRecipe.js';
export * from '../models/SnapshotRecipeDirectorySummary.js';
export * from '../models/SnapshotRecipeEntry.js';
export * from '../models/SnapshotRecipeEntryAction.js';
export * from '../models/SnapshotRecipeEntryReason.js';
export * from '../models/SnapshotRecipeInvalidReason.js';
export * from '../models/SnapshotRecipeInvalidSnapshot.js';
export * from '../models/SnapshotRecipeProposal.js';
export * from '../models/SnapshotRecipeProposalMode.js';
export * from '../models/SnapshotRecipeRule.js';
export * from '../models/SnapshotRecipeRuleError.js';
export * from '../models/SnapshotRecipeRuleOp.js';
export * from '../models/SnapshotRecipeSourceSummary.js';
export * from '../models/SnapshotRecipeStatus.js';
export * from '../models/SnapshotRecipeSummary.js';
export * from '../models/SnapshotRecipeValidity.js';
export * from '../models/SnapshotReference.js';
export * from '../models/SnapshotSortField.js';
export * from '../models/SnapshotStatus.js';
export * from '../models/SnapshotStorage.js';
export * from '../models/SnapshotTimeFilters.js';
export * from '../models/SnapshotsSummaryResponse.js';
export * from '../models/SnowflakeIntegrationConfig.js';
export * from '../models/SortBackupJobBy.js';
export * from '../models/SortLogsBy.js';
export * from '../models/SortOrder.js';
export * from '../models/SortResourceBy.js';
export * from '../models/SortRestoreAccountsBy.js';
export * from '../models/SortRestoreJobBy.js';
export * from '../models/SortSnapshotsBy.js';
export * from '../models/SortSourceAccountsBy.js';
export * from '../models/SourceAccount.js';
export * from '../models/SourceAccountAttributesInput.js';
export * from '../models/SourceAccountCloudAttributes.js';
export * from '../models/SourceAccountMetricsConfig.js';
export * from '../models/SourceAccountProviderIdFilters.js';
export * from '../models/SourceAccountSortField.js';
export * from '../models/SourceAccountTagKeyValuesCondition.js';
export * from '../models/SourceAccountTagKeysCondition.js';
export * from '../models/SourceAccountsFilterConditions.js';
export * from '../models/SourceAwsOrganizationalUnit.js';
export * from '../models/SourceRegionFilters.js';
export * from '../models/SourceSizeCheckResult.js';
export * from '../models/SourceStorage.js';
export * from '../models/SourceStorageBackupStatus.js';
export * from '../models/SourceStorageSizeCondition.js';
export * from '../models/SqlInstructions.js';
export * from '../models/SqlSetupCheckResult.js';
export * from '../models/SqlSetupCheckStatus.js';
export * from '../models/SqlVmNetworkInfo.js';
export * from '../models/SqlVmPitrRestoreProperties.js';
export * from '../models/SsoIntegrationSettings.js';
export * from '../models/StackNameFilters.js';
export * from '../models/StagingAccount.js';
export * from '../models/StagingAccountConfig.js';
export * from '../models/StagingBucket.js';
export * from '../models/StagingBucketConfig.js';
export * from '../models/StandardBackupPolicyPlan.js';
export * from '../models/StandardBackupScheduleConfig.js';
export * from '../models/StandardBackupScheduleFrequency.js';
export * from '../models/StandardBackupSchedules.js';
export * from '../models/StandardIntervalConfig.js';
export * from '../models/StartQueryExecutionRequest.js';
export * from '../models/StartTimeDateFilters.js';
export * from '../models/StatusCodeFilters.js';
export * from '../models/StatusProperties.js';
export * from '../models/StepProgressMetric.js';
export * from '../models/StepProgressUnit.js';
export * from '../models/StepProgressView.js';
export * from '../models/StorageAccountContainerRestoreDestination.js';
export * from '../models/StorageAccountRestoreTarget.js';
export * from '../models/StorageGateway.js';
export * from '../models/StorageGatewayDetails.js';
export * from '../models/StorageGatewayStatus.js';
export * from '../models/StringOperators.js';
export * from '../models/SubmitMyMPARequestRequest.js';
export * from '../models/SubmitMyMPARequestResponse.js';
export * from '../models/SubnetConfig.js';
export * from '../models/SubnetFilters.js';
export * from '../models/SubnetPerAvailabilityZone.js';
export * from '../models/SubnetsCondition.js';
export * from '../models/SupportedProviders.js';
export * from '../models/Table.js';
export * from '../models/TableRecord.js';
export * from '../models/TagKeyValue.js';
export * from '../models/TagKeyValuesCondition.js';
export * from '../models/TagKeyValuesFilters.js';
export * from '../models/TagKeysCondition.js';
export * from '../models/TagKeysFilters.js';
export * from '../models/TakeNativeSnapshotRequest.js';
export * from '../models/TakeSnapshotRequest.js';
export * from '../models/TakeSnapshotResponse.js';
export * from '../models/TeardownAwsPrivateLinkResponse.js';
export * from '../models/TeardownMongoAtlasPrivateLinkResponse.js';
export * from '../models/ThreatDetectionFilters.js';
export * from '../models/ThreatHuntingResult.js';
export * from '../models/ThreatHuntingScanRequest.js';
export * from '../models/ThreatHuntingStatus.js';
export * from '../models/TimeFrame.js';
export * from '../models/TimeOfDay.js';
export * from '../models/TimeOfYear.js';
export * from '../models/TokenResponse.js';
export * from '../models/TotalSourceStorageSizeRequest.js';
export * from '../models/TotalSourceStorageSizeResponse.js';
export * from '../models/TrendPoint.js';
export * from '../models/TriggerKeyspacesScheduledDump200Response.js';
export * from '../models/UnifiedDBRecord.js';
export * from '../models/UnifiedDBServerRecord.js';
export * from '../models/UnifiedDatabaseRecord.js';
export * from '../models/UnifiedRestoreDirectoryPresence.js';
export * from '../models/UnifiedRestoreEntity.js';
export * from '../models/UnifiedRestoreEntityMicrosoft365.js';
export * from '../models/UnifiedRestoreEntityRelationships.js';
export * from '../models/UnifiedRestoreEntityType.js';
export * from '../models/UnifiedRestoreMicrosoft365Request.js';
export * from '../models/UnifiedRestoreMicrosoft365Snapshot.js';
export * from '../models/UnifiedRestoreMicrosoft365User.js';
export * from '../models/UnifiedRestorePlan.js';
export * from '../models/UnifiedRestoreWorkload.js';
export * from '../models/UnifiedSchemaRecord.js';
export * from '../models/UnifiedTableRecord.js';
export * from '../models/UpPulumiStacksResponse.js';
export * from '../models/UpdateAccessGrantRequest.js';
export * from '../models/UpdateAccessPolicyRequest.js';
export * from '../models/UpdateAccountCompanyContactsRequest.js';
export * from '../models/UpdateAccountLabelsRequest.js';
export * from '../models/UpdateAccountProfileResponse.js';
export * from '../models/UpdateActionApprovalRuleRequest.js';
export * from '../models/UpdateActionApprovalRuleResponse.js';
export * from '../models/UpdateApiCredentialsRequest.js';
export * from '../models/UpdateAwsRestoreAccountAttributes.js';
export * from '../models/UpdateAwsSourceAccountAttributes.js';
export * from '../models/UpdateAzureSourceAccountAttributes.js';
export * from '../models/UpdateBackupPolicyRequest.js';
export * from '../models/UpdateBackupPolicyResponse.js';
export * from '../models/UpdateBackupPostureControlRequest.js';
export * from '../models/UpdateBackupZeroEtlPolicyInput.js';
export * from '../models/UpdateClassificationPolicyRequest.js';
export * from '../models/UpdateClassificationPolicyResponse.js';
export * from '../models/UpdateCloudResourceConfigurationRequest.js';
export * from '../models/UpdateCloudResourceConfigurationRequestCdcBackup.js';
export * from '../models/UpdateCloudResourceConfigurationRequestInventoryBackup.js';
export * from '../models/UpdateControlViolationInput.js';
export * from '../models/UpdateDataCatalogPipelineRequest.js';
export * from '../models/UpdateDlsgPolicyRequest.js';
export * from '../models/UpdateDlsgPolicyResponse.js';
export * from '../models/UpdateFindingExclusionRequest.js';
export * from '../models/UpdateFindingExclusionResponse.js';
export * from '../models/UpdateGcpRestoreAccountAttributes.js';
export * from '../models/UpdateGcpSourceAccountAttributes.js';
export * from '../models/UpdateGdsgInventoryReportConfigurationRequest.js';
export * from '../models/UpdateGdsgInventoryReportConfigurationResponse.js';
export * from '../models/UpdateGwsBackupFilterRequest.js';
export * from '../models/UpdateIdpGroupRequest.js';
export * from '../models/UpdateIdpGroupResponse.js';
export * from '../models/UpdateIntegrationRequest.js';
export * from '../models/UpdateIntegrationResponse.js';
export * from '../models/UpdateObjectStoreScanMethodRequest.js';
export * from '../models/UpdateObjectStoreScanMethodResponse.js';
export * from '../models/UpdateObjectStoreScanMethodSetting.js';
export * from '../models/UpdateOrganizationIdpGroupRequest.js';
export * from '../models/UpdateOrganizationIdpGroupResponse.js';
export * from '../models/UpdateOrganizationIdpRequest.js';
export * from '../models/UpdateOrganizationIdpResponse.js';
export * from '../models/UpdateOrganizationUserRequest.js';
export * from '../models/UpdateOrganizationUserResponse.js';
export * from '../models/UpdateProjectConfigurationKeyRequest.js';
export * from '../models/UpdatePulumiConfigurationRequest.js';
export * from '../models/UpdateResourceSecurityScansExclusionRequest.js';
export * from '../models/UpdateRestoreAccountAttributesInput.js';
export * from '../models/UpdateRestoreAccountConnectivityConfigRequest.js';
export * from '../models/UpdateRestoreAccountConnectivityConfigResponse.js';
export * from '../models/UpdateRestoreAccountRequest.js';
export * from '../models/UpdateRestoreAccountResponse.js';
export * from '../models/UpdateRestoreTemplateRequest.js';
export * from '../models/UpdateRestoreTemplateResponse.js';
export * from '../models/UpdateRoleRequest.js';
export * from '../models/UpdateRoleResponse.js';
export * from '../models/UpdateSamlIdentityProviderInput.js';
export * from '../models/UpdateSessionRequest.js';
export * from '../models/UpdateShouldFullBackupResourceRequest.js';
export * from '../models/UpdateSnapshotRecipeRequest.js';
export * from '../models/UpdateSnapshotRecipeResponse.js';
export * from '../models/UpdateSourceAccountAttributesInput.js';
export * from '../models/UpdateSourceAccountRequest.js';
export * from '../models/UpdateSourceAccountResponse.js';
export * from '../models/UpdateTagDefinitionRequest.js';
export * from '../models/UpdateThreatHuntingScanRequestRequest.js';
export * from '../models/UpdateUserInput.js';
export * from '../models/UpdateVaultRequest.js';
export * from '../models/UpdateVaultResponse.js';
export * from '../models/UpdateViewerRoleRequest.js';
export * from '../models/Usage.js';
export * from '../models/UsageType.js';
export * from '../models/UsageTypeFilters.js';
export * from '../models/UsageUnit.js';
export * from '../models/User.js';
export * from '../models/UserIdFilters.js';
export * from '../models/UserType.js';
export * from '../models/VNetConfig.js';
export * from '../models/ValidateAccessGrantRequest.js';
export * from '../models/ValidateAccessGrantResponse.js';
export * from '../models/ValidateAccessPolicyRequest.js';
export * from '../models/ValidateAccessPolicyResponse.js';
export * from '../models/ValidateDataCatalogPipelineRequest.js';
export * from '../models/ValidateDataCatalogPipelineResponse.js';
export * from '../models/ValidateResourceConfigurationRequest.js';
export * from '../models/ValidateResourceConfigurationResponse.js';
export * from '../models/VaultEncryptionType.js';
export * from '../models/VaultEncryptionTypeFilters.js';
export * from '../models/VaultFilters.js';
export * from '../models/VaultMetadataReplicationConfig.js';
export * from '../models/VaultNotificationArguments.js';
export * from '../models/VaultProtectionMode.js';
export * from '../models/VaultProviderAttributes.js';
export * from '../models/VaultProviderAttributesInput.js';
export * from '../models/VaultRegionFilters.js';
export * from '../models/VaultSnapshotCount.js';
export * from '../models/VaultStatus.js';
export * from '../models/VaultStatusFilters.js';
export * from '../models/VaultStorageTier.js';
export * from '../models/VaultTagFilters.js';
export * from '../models/VaultTieringPolicy.js';
export * from '../models/VaultTieringPolicyType.js';
export * from '../models/VaultType.js';
export * from '../models/VaultTypeFilters.js';
export * from '../models/VaultsFilterConditions.js';
export * from '../models/VerifyMongoAtlasPrivateLinkResponse.js';
export * from '../models/VerifyRdsCdcSqlSetupResponse.js';
export * from '../models/Viewer.js';
export * from '../models/ViolationsDetectionNotificationArguments.js';
export * from '../models/VirtualMachineRestoreDestination.js';
export * from '../models/VisualizationHistogramSeries.js';
export * from '../models/VisualizationHistogramTimePoint.js';
export * from '../models/VisualizationLabel.js';
export * from '../models/VolumeSettings.js';
export * from '../models/VpcCondition.js';
export * from '../models/VpcPropertyFilters.js';
export * from '../models/WebhookV1AnomalyDataPoint.js';
export * from '../models/WebhookV1AnomalyGraphData.js';
export * from '../models/WebhookV1AuditEvent.js';
export * from '../models/WebhookV1AuditPayload.js';
export * from '../models/WebhookV1BackupJobDetails.js';
export * from '../models/WebhookV1BackupJobFailedArguments.js';
export * from '../models/WebhookV1BackupJobPartialArguments.js';
export * from '../models/WebhookV1BackupJobRejectedArguments.js';
export * from '../models/WebhookV1BackupJobSkippedArguments.js';
export * from '../models/WebhookV1BackupJobSucceededArguments.js';
export * from '../models/WebhookV1BackupPolicyNotificationArguments.js';
export * from '../models/WebhookV1ClassificationJobFailedArguments.js';
export * from '../models/WebhookV1ClassificationJobRejectedArguments.js';
export * from '../models/WebhookV1ClassificationJobSkippedArguments.js';
export * from '../models/WebhookV1CloudAccountArguments.js';
export * from '../models/WebhookV1ConclusionTypes.js';
export * from '../models/WebhookV1CreditsMonthlyUsageNotificationArguments.js';
export * from '../models/WebhookV1CreditsNotificationArguments.js';
export * from '../models/WebhookV1DetectorType.js';
export * from '../models/WebhookV1FindingObjectType.js';
export * from '../models/WebhookV1GdsgOperationalNotificationArguments.js';
export * from '../models/WebhookV1InitiatorArguments.js';
export * from '../models/WebhookV1IssueMutedNotificationArguments.js';
export * from '../models/WebhookV1JobMetricsReportFailedArguments.js';
export * from '../models/WebhookV1MPARequestNotificationArguments.js';
export * from '../models/WebhookV1MPAReviewNotificationArguments.js';
export * from '../models/WebhookV1NotificationTargetChangeArguments.js';
export * from '../models/WebhookV1OnboardingPayload.js';
export * from '../models/WebhookV1Payload.js';
export * from '../models/WebhookV1PolicyArguments.js';
export * from '../models/WebhookV1ProtobufDuration.js';
export * from '../models/WebhookV1ProtobufTimestamp.js';
export * from '../models/WebhookV1ResourceArguments.js';
export * from '../models/WebhookV1RestoreJobFailedArguments.js';
export * from '../models/WebhookV1RestoreJobRejectedArguments.js';
export * from '../models/WebhookV1RestoreJobSucceededArguments.js';
export * from '../models/WebhookV1ReviewerType.js';
export * from '../models/WebhookV1RiskLevel.js';
export * from '../models/WebhookV1SecurityEvidence.js';
export * from '../models/WebhookV1SecurityScan.js';
export * from '../models/WebhookV1SecurityScanApproval.js';
export * from '../models/WebhookV1SecurityScanResult.js';
export * from '../models/WebhookV1SnapshotAccessDeniedArguments.js';
export * from '../models/WebhookV1SnapshotArguments.js';
export * from '../models/WebhookV1StandardPayload.js';
export * from '../models/WebhookV1StandardPayloadBackupJobFailed.js';
export * from '../models/WebhookV1StandardPayloadBackupJobFailedArguments.js';
export * from '../models/WebhookV1StandardPayloadBackupJobPartial.js';
export * from '../models/WebhookV1StandardPayloadBackupJobPartialArguments.js';
export * from '../models/WebhookV1StandardPayloadBackupJobRejected.js';
export * from '../models/WebhookV1StandardPayloadBackupJobRejectedArguments.js';
export * from '../models/WebhookV1StandardPayloadBackupJobSkipped.js';
export * from '../models/WebhookV1StandardPayloadBackupJobSkippedArguments.js';
export * from '../models/WebhookV1StandardPayloadBackupJobSucceeded.js';
export * from '../models/WebhookV1StandardPayloadBackupJobSucceededArguments.js';
export * from '../models/WebhookV1StandardPayloadBackupVault.js';
export * from '../models/WebhookV1StandardPayloadBackupVaultArguments.js';
export * from '../models/WebhookV1StandardPayloadClassificationJobFailed.js';
export * from '../models/WebhookV1StandardPayloadClassificationJobFailedArguments.js';
export * from '../models/WebhookV1StandardPayloadClassificationJobRejected.js';
export * from '../models/WebhookV1StandardPayloadClassificationJobRejectedArguments.js';
export * from '../models/WebhookV1StandardPayloadClassificationJobSkipped.js';
export * from '../models/WebhookV1StandardPayloadClassificationJobSkippedArguments.js';
export * from '../models/WebhookV1StandardPayloadCloudAccount.js';
export * from '../models/WebhookV1StandardPayloadCloudAccountArguments.js';
export * from '../models/WebhookV1StandardPayloadCreditsMonthlyUsage.js';
export * from '../models/WebhookV1StandardPayloadCreditsMonthlyUsageArguments.js';
export * from '../models/WebhookV1StandardPayloadCreditsUsage.js';
export * from '../models/WebhookV1StandardPayloadCreditsUsageArguments.js';
export * from '../models/WebhookV1StandardPayloadGdsgOperational.js';
export * from '../models/WebhookV1StandardPayloadGdsgOperationalArguments.js';
export * from '../models/WebhookV1StandardPayloadIssueMuted.js';
export * from '../models/WebhookV1StandardPayloadIssueMutedArguments.js';
export * from '../models/WebhookV1StandardPayloadJobMetricsReportFailed.js';
export * from '../models/WebhookV1StandardPayloadJobMetricsReportFailedArguments.js';
export * from '../models/WebhookV1StandardPayloadMpaRequest.js';
export * from '../models/WebhookV1StandardPayloadMpaRequestArguments.js';
export * from '../models/WebhookV1StandardPayloadMpaReview.js';
export * from '../models/WebhookV1StandardPayloadMpaReviewArguments.js';
export * from '../models/WebhookV1StandardPayloadNotificationTargetChange.js';
export * from '../models/WebhookV1StandardPayloadNotificationTargetChangeArguments.js';
export * from '../models/WebhookV1StandardPayloadPolicyAssignment.js';
export * from '../models/WebhookV1StandardPayloadPolicyAssignmentArguments.js';
export * from '../models/WebhookV1StandardPayloadPolicyChange.js';
export * from '../models/WebhookV1StandardPayloadPolicyChangeArguments.js';
export * from '../models/WebhookV1StandardPayloadResource.js';
export * from '../models/WebhookV1StandardPayloadResourceArguments.js';
export * from '../models/WebhookV1StandardPayloadRestoreJobFailed.js';
export * from '../models/WebhookV1StandardPayloadRestoreJobFailedArguments.js';
export * from '../models/WebhookV1StandardPayloadRestoreJobRejected.js';
export * from '../models/WebhookV1StandardPayloadRestoreJobRejectedArguments.js';
export * from '../models/WebhookV1StandardPayloadRestoreJobSucceeded.js';
export * from '../models/WebhookV1StandardPayloadRestoreJobSucceededArguments.js';
export * from '../models/WebhookV1StandardPayloadSnapshot.js';
export * from '../models/WebhookV1StandardPayloadSnapshotAccessDenied.js';
export * from '../models/WebhookV1StandardPayloadSnapshotAccessDeniedArguments.js';
export * from '../models/WebhookV1StandardPayloadSnapshotArguments.js';
export * from '../models/WebhookV1StandardPayloadSnapshotUserProtection.js';
export * from '../models/WebhookV1StandardPayloadSnapshotUserProtectionArguments.js';
export * from '../models/WebhookV1StandardPayloadViolations.js';
export * from '../models/WebhookV1StandardPayloadViolationsArguments.js';
export * from '../models/WebhookV1VaultArguments.js';
export * from '../models/WebhookV1ViolationsDetectionNotificationArguments.js';
export * from '../models/WeeklyConfig.js';
export * from '../models/WorkspaceRestoreMode.js';
export * from '../models/YearlySnapshotDistribution.js';
export * from '../models/ZeroEtlJob.js';
export * from '../models/ZeroEtlJobSync.js';
export * from '../models/ZeroEtlJobSyncStatus.js';
export * from '../models/ZeroEtlJobSyncsFilters.js';
export * from '../models/ZeroEtlJobTableCounts.js';
export * from '../models/ZeroEtlJobType.js';
export * from '../models/ZeroEtlJobsFilters.js';
export * from '../models/ZeroEtlJobsSort.js';
export * from '../models/ZeroEtlJobsSortField.js';
export * from '../models/ZeroEtlTableFormat.js';
export * from '../models/ZeroEtlTargetTable.js';
export * from '../models/ZeroEtlTargetTableStatus.js';
export * from '../models/ZeroEtlTargetTablesFilters.js';
export * from '../models/ZeroEtlTargetTablesSort.js';
export * from '../models/ZeroEtlTargetTablesSortField.js';
import { AccessCondition } from '../models/AccessCondition.js';
import { AccessConditionalExpression } from '../models/AccessConditionalExpression.js';
import { AccessibleOrganizationAccount } from '../models/AccessibleOrganizationAccount.js';
import { Account } from '../models/Account.js';
import { AccountConfigInput } from '../models/AccountConfigInput.js';
import { AccountDisplayNameFilters } from '../models/AccountDisplayNameFilters.js';
import { AccountIdCondition } from '../models/AccountIdCondition.js';
import { AccountIdFilters } from '../models/AccountIdFilters.js';
import { AccountMetricsDestination } from '../models/AccountMetricsDestination.js';
import { AccountModuleVersion } from '../models/AccountModuleVersion.js';
import { AccountNameFilters } from '../models/AccountNameFilters.js';
import { AccountStatusFilters } from '../models/AccountStatusFilters.js';
import { AccountUpdateInput } from '../models/AccountUpdateInput.js';
import { AccountVersion } from '../models/AccountVersion.js';
import { ActionApprovalRule } from '../models/ActionApprovalRule.js';
import { ActionApprovalRuleExpression } from '../models/ActionApprovalRuleExpression.js';
import { ActionApprovalRuleGroupCondition } from '../models/ActionApprovalRuleGroupCondition.js';
import { ActionApprovalRuleResourceSelector } from '../models/ActionApprovalRuleResourceSelector.js';
import { ActionFilters } from '../models/ActionFilters.js';
import { ActivateAtlasOrganizationResponse } from '../models/ActivateAtlasOrganizationResponse.js';
import { ActivateGcpFolderResponse } from '../models/ActivateGcpFolderResponse.js';
import { ActivateGcpOrganizationResponse } from '../models/ActivateGcpOrganizationResponse.js';
import { AddRestoreAtlasPrivateLinkRequest } from '../models/AddRestoreAtlasPrivateLinkRequest.js';
import { AdeRestoreEncryptionConfig } from '../models/AdeRestoreEncryptionConfig.js';
import { AgreementWithCredits } from '../models/AgreementWithCredits.js';
import { Ami } from '../models/Ami.js';
import { AmiBlockDevice } from '../models/AmiBlockDevice.js';
import { AnnuallyConfig } from '../models/AnnuallyConfig.js';
import { AnomalyDataPoint } from '../models/AnomalyDataPoint.js';
import { AnomalyGraphData } from '../models/AnomalyGraphData.js';
import { ApiCredentials } from '../models/ApiCredentials.js';
import { ApiCredentialsProperties } from '../models/ApiCredentialsProperties.js';
import { App } from '../models/App.js';
import { AppFilters } from '../models/AppFilters.js';
import { ApplicationOverride } from '../models/ApplicationOverride.js';
import { AppsCondition } from '../models/AppsCondition.js';
import { AppsDetails } from '../models/AppsDetails.js';
import { AtlasCluster } from '../models/AtlasCluster.js';
import { AtlasClusters } from '../models/AtlasClusters.js';
import { AtlasOrganization } from '../models/AtlasOrganization.js';
import { AtlasProject } from '../models/AtlasProject.js';
import { AtlasProjects } from '../models/AtlasProjects.js';
import { AuditLog } from '../models/AuditLog.js';
import { AuditLogCloudContext } from '../models/AuditLogCloudContext.js';
import { AuditLogEntitiesInner } from '../models/AuditLogEntitiesInner.js';
import { AuditLogExtendedData } from '../models/AuditLogExtendedData.js';
import { AuditLogExtendedDataAuth } from '../models/AuditLogExtendedDataAuth.js';
import { AuditLogExtendedDataMpa } from '../models/AuditLogExtendedDataMpa.js';
import { AuditLogFilterConditions } from '../models/AuditLogFilterConditions.js';
import { AuditLogSecurityContext } from '../models/AuditLogSecurityContext.js';
import { AuditLogStateSnapshot } from '../models/AuditLogStateSnapshot.js';
import { AuthResponse } from '../models/AuthResponse.js';
import { AuthV2AssociateSoftwareTokenRequest } from '../models/AuthV2AssociateSoftwareTokenRequest.js';
import { AuthV2AssociateSoftwareTokenResponse } from '../models/AuthV2AssociateSoftwareTokenResponse.js';
import { AuthV2ConfirmForgotPasswordRequest } from '../models/AuthV2ConfirmForgotPasswordRequest.js';
import { AuthV2ForgotPasswordRequest } from '../models/AuthV2ForgotPasswordRequest.js';
import { AuthV2ForgotPasswordResponse } from '../models/AuthV2ForgotPasswordResponse.js';
import { AuthV2LoginRequest } from '../models/AuthV2LoginRequest.js';
import { AuthV2RespondChallengeRequest } from '../models/AuthV2RespondChallengeRequest.js';
import { AuthV2VerifySoftwareTokenRequest } from '../models/AuthV2VerifySoftwareTokenRequest.js';
import { AuthV2VerifySoftwareTokenResponse } from '../models/AuthV2VerifySoftwareTokenResponse.js';
import { AwsAccountConfigInput } from '../models/AwsAccountConfigInput.js';
import { AwsAccountMetricsDestination } from '../models/AwsAccountMetricsDestination.js';
import { AwsCassandraClusterRestoreDestination } from '../models/AwsCassandraClusterRestoreDestination.js';
import { AwsCassandraClusterRestoreTarget } from '../models/AwsCassandraClusterRestoreTarget.js';
import { AwsDatabaseDestination } from '../models/AwsDatabaseDestination.js';
import { AwsDynamoDBDestination } from '../models/AwsDynamoDBDestination.js';
import { AwsDynamoDbResource } from '../models/AwsDynamoDbResource.js';
import { AwsDynamoDbSnapshotProperties } from '../models/AwsDynamoDbSnapshotProperties.js';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner.js';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput.js';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection.js';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput.js';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput.js';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner.js';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner.js';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection.js';
import { AwsEbsSnapshotConvertResult } from '../models/AwsEbsSnapshotConvertResult.js';
import { AwsEbsVolumeResource } from '../models/AwsEbsVolumeResource.js';
import { AwsEbsVolumeRestoreData } from '../models/AwsEbsVolumeRestoreData.js';
import { AwsEbsVolumeRestoreResult } from '../models/AwsEbsVolumeRestoreResult.js';
import { AwsEbsVolumeSnapshotProperties } from '../models/AwsEbsVolumeSnapshotProperties.js';
import { AwsEc2AmiConvertResult } from '../models/AwsEc2AmiConvertResult.js';
import { AwsEc2InstanceRestoreDestination } from '../models/AwsEc2InstanceRestoreDestination.js';
import { AwsEc2InstanceRestoreResult } from '../models/AwsEc2InstanceRestoreResult.js';
import { AwsEc2InstanceRestoreTarget } from '../models/AwsEc2InstanceRestoreTarget.js';
import { AwsEc2Resource } from '../models/AwsEc2Resource.js';
import { AwsEc2SnapshotProperties } from '../models/AwsEc2SnapshotProperties.js';
import { AwsEksClusterResource } from '../models/AwsEksClusterResource.js';
import { AwsEksNamespaceResource } from '../models/AwsEksNamespaceResource.js';
import { AwsEksNamespaceSnapshotProperties } from '../models/AwsEksNamespaceSnapshotProperties.js';
import { AwsFsxResource } from '../models/AwsFsxResource.js';
import { AwsKeyspacesDestination } from '../models/AwsKeyspacesDestination.js';
import { AwsKeyspacesResource } from '../models/AwsKeyspacesResource.js';
import { AwsNativePitrBackupPolicyPlan } from '../models/AwsNativePitrBackupPolicyPlan.js';
import { AwsNativePitrBackupResourceType } from '../models/AwsNativePitrBackupResourceType.js';
import { AwsNativePitrConfig } from '../models/AwsNativePitrConfig.js';
import { AwsNativeStandardBackupPolicyPlan } from '../models/AwsNativeStandardBackupPolicyPlan.js';
import { AwsNativeStandardBackupScheduleConfig } from '../models/AwsNativeStandardBackupScheduleConfig.js';
import { AwsNativeStandardBackupSchedules } from '../models/AwsNativeStandardBackupSchedules.js';
import { AwsNativeStandardIntervalConfig } from '../models/AwsNativeStandardIntervalConfig.js';
import { AwsNeptuneResource } from '../models/AwsNeptuneResource.js';
import { AwsOpenSearchDomainRestoreDestination } from '../models/AwsOpenSearchDomainRestoreDestination.js';
import { AwsOpenSearchDomainRestoreTarget } from '../models/AwsOpenSearchDomainRestoreTarget.js';
import { AwsOpenSearchIndexSelection } from '../models/AwsOpenSearchIndexSelection.js';
import { AwsRdsResource } from '../models/AwsRdsResource.js';
import { AwsRdsResourceAurora } from '../models/AwsRdsResourceAurora.js';
import { AwsRdsResourceStorageSettings } from '../models/AwsRdsResourceStorageSettings.js';
import { AwsRdsSnapshotProperties } from '../models/AwsRdsSnapshotProperties.js';
import { AwsRestoreAccountAttributes } from '../models/AwsRestoreAccountAttributes.js';
import { AwsRestoreAccountAttributesInput } from '../models/AwsRestoreAccountAttributesInput.js';
import { AwsRestoreAccountConnectivityConfig } from '../models/AwsRestoreAccountConnectivityConfig.js';
import { AwsRestoreServerNetworkParams } from '../models/AwsRestoreServerNetworkParams.js';
import { AwsSourceAccountAttributes } from '../models/AwsSourceAccountAttributes.js';
import { AwsSourceAccountAttributesInput } from '../models/AwsSourceAccountAttributesInput.js';
import { AwsVaultConfig } from '../models/AwsVaultConfig.js';
import { AwsVaultConfigInput } from '../models/AwsVaultConfigInput.js';
import { AwsVpcConnectivityConfig } from '../models/AwsVpcConnectivityConfig.js';
import { AzureAccountConfigInput } from '../models/AzureAccountConfigInput.js';
import { AzureAksNamespaceResource } from '../models/AzureAksNamespaceResource.js';
import { AzureAppRegistrationOption } from '../models/AzureAppRegistrationOption.js';
import { AzureBackupApplicationsResponse } from '../models/AzureBackupApplicationsResponse.js';
import { AzureCmkEligibleApp } from '../models/AzureCmkEligibleApp.js';
import { AzureConsentUrlResponse } from '../models/AzureConsentUrlResponse.js';
import { AzureDisk } from '../models/AzureDisk.js';
import { AzureDiskEncryptionSet } from '../models/AzureDiskEncryptionSet.js';
import { AzureDiskRestoreData } from '../models/AzureDiskRestoreData.js';
import { AzureDiskRestoreDestination } from '../models/AzureDiskRestoreDestination.js';
import { AzureDiskRestoreResult } from '../models/AzureDiskRestoreResult.js';
import { AzureDiskSettings } from '../models/AzureDiskSettings.js';
import { AzureDiskTarget } from '../models/AzureDiskTarget.js';
import { AzureEntraIdPolicyConfig } from '../models/AzureEntraIdPolicyConfig.js';
import { AzureEntraIdResource } from '../models/AzureEntraIdResource.js';
import { AzureEntraIdRestoreConsent } from '../models/AzureEntraIdRestoreConsent.js';
import { AzureEntraIdRestoreEntity } from '../models/AzureEntraIdRestoreEntity.js';
import { AzureEonApplication } from '../models/AzureEonApplication.js';
import { AzureFileShareRestoreFileSpec } from '../models/AzureFileShareRestoreFileSpec.js';
import { AzureFilesBackupPolicyPlan } from '../models/AzureFilesBackupPolicyPlan.js';
import { AzureFilesBackupSchedules } from '../models/AzureFilesBackupSchedules.js';
import { AzureFilesStorageAccountSelection } from '../models/AzureFilesStorageAccountSelection.js';
import { AzureKeyVaultKey } from '../models/AzureKeyVaultKey.js';
import { AzureListResourceGroupsResponse } from '../models/AzureListResourceGroupsResponse.js';
import { AzureListSubscriptionsResponse } from '../models/AzureListSubscriptionsResponse.js';
import { AzureManagementGroup } from '../models/AzureManagementGroup.js';
import { AzureManagementGroups } from '../models/AzureManagementGroups.js';
import { AzureMarketplaceWebhookInput } from '../models/AzureMarketplaceWebhookInput.js';
import { AzureMarketplaceWebhookInputSubscription } from '../models/AzureMarketplaceWebhookInputSubscription.js';
import { AzureMarketplaceWebhookInputSubscriptionBeneficiary } from '../models/AzureMarketplaceWebhookInputSubscriptionBeneficiary.js';
import { AzureMarketplaceWebhookInputSubscriptionPurchaser } from '../models/AzureMarketplaceWebhookInputSubscriptionPurchaser.js';
import { AzureMarketplaceWebhookInputSubscriptionTerm } from '../models/AzureMarketplaceWebhookInputSubscriptionTerm.js';
import { AzureMssqlSnapshotProperties } from '../models/AzureMssqlSnapshotProperties.js';
import { AzureOnboardedTenantsResponse } from '../models/AzureOnboardedTenantsResponse.js';
import { AzureOnboardingStatus } from '../models/AzureOnboardingStatus.js';
import { AzureOptionalCapabilities } from '../models/AzureOptionalCapabilities.js';
import { AzurePostgresDatabaseRestoreDestination } from '../models/AzurePostgresDatabaseRestoreDestination.js';
import { AzurePostgresDatabaseRestoreTarget } from '../models/AzurePostgresDatabaseRestoreTarget.js';
import { AzureResourceGroup } from '../models/AzureResourceGroup.js';
import { AzureResourceGroups } from '../models/AzureResourceGroups.js';
import { AzureRestoreAccountAttributes } from '../models/AzureRestoreAccountAttributes.js';
import { AzureRestoreAccountAttributesInput } from '../models/AzureRestoreAccountAttributesInput.js';
import { AzureRestoreAccountConnectivityConfig } from '../models/AzureRestoreAccountConnectivityConfig.js';
import { AzureRestorePointData } from '../models/AzureRestorePointData.js';
import { AzureRestorePointDisk } from '../models/AzureRestorePointDisk.js';
import { AzureRestorePointSpec } from '../models/AzureRestorePointSpec.js';
import { AzureSapHanaResource } from '../models/AzureSapHanaResource.js';
import { AzureScanningAccountSetupStatus200Response } from '../models/AzureScanningAccountSetupStatus200Response.js';
import { AzureSourceAccountAttributes } from '../models/AzureSourceAccountAttributes.js';
import { AzureSourceAccountAttributesInput } from '../models/AzureSourceAccountAttributesInput.js';
import { AzureSqlDatabaseNativePitrBackupPolicyPlan } from '../models/AzureSqlDatabaseNativePitrBackupPolicyPlan.js';
import { AzureSqlDatabaseNativePitrBackupResourceType } from '../models/AzureSqlDatabaseNativePitrBackupResourceType.js';
import { AzureSqlDatabaseNativePitrConfig } from '../models/AzureSqlDatabaseNativePitrConfig.js';
import { AzureSqlDatabaseRestoreDestination } from '../models/AzureSqlDatabaseRestoreDestination.js';
import { AzureSqlDatabaseRestoreTarget } from '../models/AzureSqlDatabaseRestoreTarget.js';
import { AzureSqlRestoreTargetServers } from '../models/AzureSqlRestoreTargetServers.js';
import { AzureSqlServer } from '../models/AzureSqlServer.js';
import { AzureSqlTdeRestoreConfig } from '../models/AzureSqlTdeRestoreConfig.js';
import { AzureStorageAccount } from '../models/AzureStorageAccount.js';
import { AzureStorageAccounts } from '../models/AzureStorageAccounts.js';
import { AzureSubscription } from '../models/AzureSubscription.js';
import { AzureTenant } from '../models/AzureTenant.js';
import { AzureVaultConfig } from '../models/AzureVaultConfig.js';
import { AzureVaultConfigInput } from '../models/AzureVaultConfigInput.js';
import { AzureVmInstanceRestoreDestination } from '../models/AzureVmInstanceRestoreDestination.js';
import { AzureVmInstanceRestoreResult } from '../models/AzureVmInstanceRestoreResult.js';
import { AzureVmInstanceRestoreTarget } from '../models/AzureVmInstanceRestoreTarget.js';
import { AzureVmNativeRestoreTarget } from '../models/AzureVmNativeRestoreTarget.js';
import { AzureVmResource } from '../models/AzureVmResource.js';
import { AzureVmSnapshotProperties } from '../models/AzureVmSnapshotProperties.js';
import { AzureVnetConnectivityConfig } from '../models/AzureVnetConnectivityConfig.js';
import { BackedUpByResourceType } from '../models/BackedUpByResourceType.js';
import { BackedUpByResourceTypeDataInner } from '../models/BackedUpByResourceTypeDataInner.js';
import { BackedUpStorageDateHistogram } from '../models/BackedUpStorageDateHistogram.js';
import { BackupControlViolations } from '../models/BackupControlViolations.js';
import { BackupJob } from '../models/BackupJob.js';
import { BackupJobResponse } from '../models/BackupJobResponse.js';
import { BackupJobTypeFilters } from '../models/BackupJobTypeFilters.js';
import { BackupJobsFilterConditions } from '../models/BackupJobsFilterConditions.js';
import { BackupPoliciesFilters } from '../models/BackupPoliciesFilters.js';
import { BackupPoliciesLimits } from '../models/BackupPoliciesLimits.js';
import { BackupPoliciesSecurityConfig } from '../models/BackupPoliciesSecurityConfig.js';
import { BackupPolicy } from '../models/BackupPolicy.js';
import { BackupPolicyAppliesNotificationArguments } from '../models/BackupPolicyAppliesNotificationArguments.js';
import { BackupPolicyConfig } from '../models/BackupPolicyConfig.js';
import { BackupPolicyConfigResponse } from '../models/BackupPolicyConfigResponse.js';
import { BackupPolicyExpression } from '../models/BackupPolicyExpression.js';
import { BackupPolicyGroupCondition } from '../models/BackupPolicyGroupCondition.js';
import { BackupPolicyNotificationArguments } from '../models/BackupPolicyNotificationArguments.js';
import { BackupPolicyPlan } from '../models/BackupPolicyPlan.js';
import { BackupPolicyResourceSelector } from '../models/BackupPolicyResourceSelector.js';
import { BackupPolicySecurityConfig } from '../models/BackupPolicySecurityConfig.js';
import { BackupPostureControl } from '../models/BackupPostureControl.js';
import { BackupPostureControlExpression } from '../models/BackupPostureControlExpression.js';
import { BackupPostureControlGroupCondition } from '../models/BackupPostureControlGroupCondition.js';
import { BackupPostureControlResourceSelector } from '../models/BackupPostureControlResourceSelector.js';
import { BackupPostureControlRules } from '../models/BackupPostureControlRules.js';
import { BackupPostureControlSort } from '../models/BackupPostureControlSort.js';
import { BackupRegionsFilters } from '../models/BackupRegionsFilters.js';
import { BackupSchedule } from '../models/BackupSchedule.js';
import { BackupScope } from '../models/BackupScope.js';
import { BackupScopeResourcesLosingBackupCountResponse } from '../models/BackupScopeResourcesLosingBackupCountResponse.js';
import { BackupScopeSummary } from '../models/BackupScopeSummary.js';
import { BackupStatusFilters } from '../models/BackupStatusFilters.js';
import { BackupVault } from '../models/BackupVault.js';
import { BackupZeroEtlAccessConfiguration } from '../models/BackupZeroEtlAccessConfiguration.js';
import { BackupZeroEtlAwsAccessConfiguration } from '../models/BackupZeroEtlAwsAccessConfiguration.js';
import { BackupZeroEtlAwsGlueCatalogConfiguration } from '../models/BackupZeroEtlAwsGlueCatalogConfiguration.js';
import { BackupZeroEtlCatalogConfiguration } from '../models/BackupZeroEtlCatalogConfiguration.js';
import { BackupZeroEtlColumnDefinition } from '../models/BackupZeroEtlColumnDefinition.js';
import { BackupZeroEtlColumnDefinitions } from '../models/BackupZeroEtlColumnDefinitions.js';
import { BackupZeroEtlColumnExtract } from '../models/BackupZeroEtlColumnExtract.js';
import { BackupZeroEtlFilters } from '../models/BackupZeroEtlFilters.js';
import { BackupZeroEtlGlueCatalogLocation } from '../models/BackupZeroEtlGlueCatalogLocation.js';
import { BackupZeroEtlIcebergPartitionSpec } from '../models/BackupZeroEtlIcebergPartitionSpec.js';
import { BackupZeroEtlIcebergPartitionTransform } from '../models/BackupZeroEtlIcebergPartitionTransform.js';
import { BackupZeroEtlIdentityColumnSpec } from '../models/BackupZeroEtlIdentityColumnSpec.js';
import { BackupZeroEtlLakeStorageLocation } from '../models/BackupZeroEtlLakeStorageLocation.js';
import { BackupZeroEtlMultiResourceRoutingPolicy } from '../models/BackupZeroEtlMultiResourceRoutingPolicy.js';
import { BackupZeroEtlOrderingSpec } from '../models/BackupZeroEtlOrderingSpec.js';
import { BackupZeroEtlPolicy } from '../models/BackupZeroEtlPolicy.js';
import { BackupZeroEtlResourceSelector } from '../models/BackupZeroEtlResourceSelector.js';
import { BackupZeroEtlSingleResourceColumnDefinitionConfig } from '../models/BackupZeroEtlSingleResourceColumnDefinitionConfig.js';
import { BackupZeroEtlSingleResourceDatabaseNameAffixes } from '../models/BackupZeroEtlSingleResourceDatabaseNameAffixes.js';
import { BackupZeroEtlSingleResourcePartitionConfig } from '../models/BackupZeroEtlSingleResourcePartitionConfig.js';
import { BackupZeroEtlSingleResourceRoutingPolicy } from '../models/BackupZeroEtlSingleResourceRoutingPolicy.js';
import { BackupZeroEtlSingleResourceTableMappingMergeDatabasesParams } from '../models/BackupZeroEtlSingleResourceTableMappingMergeDatabasesParams.js';
import { BackupZeroEtlStorageConfiguration } from '../models/BackupZeroEtlStorageConfiguration.js';
import { BackupZeroEtlTableFilter } from '../models/BackupZeroEtlTableFilter.js';
import { BackupZeroEtlTableSelection } from '../models/BackupZeroEtlTableSelection.js';
import { BatchApplicationOverrides } from '../models/BatchApplicationOverrides.js';
import { BatchOperationResponse } from '../models/BatchOperationResponse.js';
import { BatchResourceValidationResult } from '../models/BatchResourceValidationResult.js';
import { BatchUpdateLlgPoliciesRequest } from '../models/BatchUpdateLlgPoliciesRequest.js';
import { BatchUpdateLlgPolicyItem } from '../models/BatchUpdateLlgPolicyItem.js';
import { BatchValidateResourceConfigurationRequest } from '../models/BatchValidateResourceConfigurationRequest.js';
import { BatchValidateResourceConfigurationResponse } from '../models/BatchValidateResourceConfigurationResponse.js';
import { BigQueryDatasetDestination } from '../models/BigQueryDatasetDestination.js';
import { BigQueryIntegrationConfig } from '../models/BigQueryIntegrationConfig.js';
import { BigQueryNativePitrBackupPolicyPlan } from '../models/BigQueryNativePitrBackupPolicyPlan.js';
import { BigQueryNativePitrBackupResourceType } from '../models/BigQueryNativePitrBackupResourceType.js';
import { BigQueryNativePitrConfig } from '../models/BigQueryNativePitrConfig.js';
import { BigQueryNativePitrDestination } from '../models/BigQueryNativePitrDestination.js';
import { BillingPeriod } from '../models/BillingPeriod.js';
import { BillingTransactionHistory } from '../models/BillingTransactionHistory.js';
import { BooleanFilters } from '../models/BooleanFilters.js';
import { BulkAttachRestoreTemplateRequest } from '../models/BulkAttachRestoreTemplateRequest.js';
import { BulkDetachRestoreTemplateRequest } from '../models/BulkDetachRestoreTemplateRequest.js';
import { BulkRestoreItem } from '../models/BulkRestoreItem.js';
import { BulkRestoreRequest } from '../models/BulkRestoreRequest.js';
import { BulkRestoreResponse } from '../models/BulkRestoreResponse.js';
import { BulkRestoreResponseItemsInner } from '../models/BulkRestoreResponseItemsInner.js';
import { BulkRestoreResponseJobsInner } from '../models/BulkRestoreResponseJobsInner.js';
import { BulkRestoreValidateRequest } from '../models/BulkRestoreValidateRequest.js';
import { BulkRestoreValidateResponse } from '../models/BulkRestoreValidateResponse.js';
import { BulkRestoreValidateResponseItemsInner } from '../models/BulkRestoreValidateResponseItemsInner.js';
import { BulkSelectSnapshotsForResourcesRequest } from '../models/BulkSelectSnapshotsForResourcesRequest.js';
import { BulkSelectSnapshotsForResourcesResponse } from '../models/BulkSelectSnapshotsForResourcesResponse.js';
import { BulkSelectSnapshotsForResourcesResponseItemsInner } from '../models/BulkSelectSnapshotsForResourcesResponseItemsInner.js';
import { CancelExclusionFromBackupResponse } from '../models/CancelExclusionFromBackupResponse.js';
import { CancelMyMPARequestResponse } from '../models/CancelMyMPARequestResponse.js';
import { CassandraClusterResource } from '../models/CassandraClusterResource.js';
import { Catalog } from '../models/Catalog.js';
import { CdcBackupModeCheckResult } from '../models/CdcBackupModeCheckResult.js';
import { CheckAzureDiskEncryptionSetAccessRequest } from '../models/CheckAzureDiskEncryptionSetAccessRequest.js';
import { CheckAzureDiskEncryptionSetAccessResponse } from '../models/CheckAzureDiskEncryptionSetAccessResponse.js';
import { CheckAzureVMNameExists200Response } from '../models/CheckAzureVMNameExists200Response.js';
import { CheckAzureVMNameExistsRequest } from '../models/CheckAzureVMNameExistsRequest.js';
import { CheckCdcPrerequisitesResponse } from '../models/CheckCdcPrerequisitesResponse.js';
import { CheckIngestionPipelineAccessRequest } from '../models/CheckIngestionPipelineAccessRequest.js';
import { CheckIngestionPipelineAccessResponse } from '../models/CheckIngestionPipelineAccessResponse.js';
import { ClassificationCategory } from '../models/ClassificationCategory.js';
import { ClassificationPolicy } from '../models/ClassificationPolicy.js';
import { ClassificationPolicySchedule } from '../models/ClassificationPolicySchedule.js';
import { ClassificationScheduleConfig } from '../models/ClassificationScheduleConfig.js';
import { Classifications } from '../models/Classifications.js';
import { CloudAccountIdFilters } from '../models/CloudAccountIdFilters.js';
import { CloudAccountNotificationArguments } from '../models/CloudAccountNotificationArguments.js';
import { CloudProviderCondition } from '../models/CloudProviderCondition.js';
import { CloudProviderFilters } from '../models/CloudProviderFilters.js';
import { CloudRegion } from '../models/CloudRegion.js';
import { CloudResourceAttachmentEvent } from '../models/CloudResourceAttachmentEvent.js';
import { CloudResourceConfiguration } from '../models/CloudResourceConfiguration.js';
import { CloudResourceConfigurationCdcBackup } from '../models/CloudResourceConfigurationCdcBackup.js';
import { CloudResourceConfigurationInventoryBackup } from '../models/CloudResourceConfigurationInventoryBackup.js';
import { CloudResourceSecurityProperties } from '../models/CloudResourceSecurityProperties.js';
import { CloudSnapshotsPerVolume } from '../models/CloudSnapshotsPerVolume.js';
import { ClusterNameFilters } from '../models/ClusterNameFilters.js';
import { CognitoExchangeRequest } from '../models/CognitoExchangeRequest.js';
import { CognitoExchangeResponse } from '../models/CognitoExchangeResponse.js';
import { Column } from '../models/Column.js';
import { ColumnMetadata } from '../models/ColumnMetadata.js';
import { ColumnValueDistribution } from '../models/ColumnValueDistribution.js';
import { CompanyContact } from '../models/CompanyContact.js';
import { ComplianceControlTrends } from '../models/ComplianceControlTrends.js';
import { ComplianceStatusFilters } from '../models/ComplianceStatusFilters.js';
import { ComplianceSummary } from '../models/ComplianceSummary.js';
import { ComplianceTrend } from '../models/ComplianceTrend.js';
import { Condition } from '../models/Condition.js';
import { ConfigurationStatusFilters } from '../models/ConfigurationStatusFilters.js';
import { ConnectAtlasOrganizationRequest } from '../models/ConnectAtlasOrganizationRequest.js';
import { ConnectAtlasOrganizationResponse } from '../models/ConnectAtlasOrganizationResponse.js';
import { ConnectAzureBackupAccountRequest } from '../models/ConnectAzureBackupAccountRequest.js';
import { ConnectAzureBackupApplicationsRequest } from '../models/ConnectAzureBackupApplicationsRequest.js';
import { ConnectAzureRestoreAccountRequest } from '../models/ConnectAzureRestoreAccountRequest.js';
import { ConnectAzureSourceAccountRequest } from '../models/ConnectAzureSourceAccountRequest.js';
import { ConnectAzureVaultAccountRequest } from '../models/ConnectAzureVaultAccountRequest.js';
import { ConnectBYOApps200Response } from '../models/ConnectBYOApps200Response.js';
import { ConnectBYOAppsRequest } from '../models/ConnectBYOAppsRequest.js';
import { ConnectBYOAzureBackupApplicationsRequest } from '../models/ConnectBYOAzureBackupApplicationsRequest.js';
import { ConnectCustomerVaultAccountRequest } from '../models/ConnectCustomerVaultAccountRequest.js';
import { ConnectCustomerVaultAccountResponse } from '../models/ConnectCustomerVaultAccountResponse.js';
import { ConnectGcpFolderRequest } from '../models/ConnectGcpFolderRequest.js';
import { ConnectGcpFolderResponse } from '../models/ConnectGcpFolderResponse.js';
import { ConnectGcpOrganizationRequest } from '../models/ConnectGcpOrganizationRequest.js';
import { ConnectGcpOrganizationResponse } from '../models/ConnectGcpOrganizationResponse.js';
import { ConnectRestoreAccountRequest } from '../models/ConnectRestoreAccountRequest.js';
import { ConnectRestoreAccountResponse } from '../models/ConnectRestoreAccountResponse.js';
import { ConnectRestoreAwsOrganizationalUnitRequest } from '../models/ConnectRestoreAwsOrganizationalUnitRequest.js';
import { ConnectRestoreAwsOrganizationalUnitResponse } from '../models/ConnectRestoreAwsOrganizationalUnitResponse.js';
import { ConnectSourceAccountRequest } from '../models/ConnectSourceAccountRequest.js';
import { ConnectSourceAccountResponse } from '../models/ConnectSourceAccountResponse.js';
import { ConnectSourceAwsOrganizationalUnitRequest } from '../models/ConnectSourceAwsOrganizationalUnitRequest.js';
import { ConnectSourceAwsOrganizationalUnitResponse } from '../models/ConnectSourceAwsOrganizationalUnitResponse.js';
import { ControlComplianceEntry } from '../models/ControlComplianceEntry.js';
import { ControlFailureCount } from '../models/ControlFailureCount.js';
import { ControlPlaneConfig } from '../models/ControlPlaneConfig.js';
import { ControlTrendEntry } from '../models/ControlTrendEntry.js';
import { ControlViolation } from '../models/ControlViolation.js';
import { ControlViolations } from '../models/ControlViolations.js';
import { ControlViolationsPerSeverity } from '../models/ControlViolationsPerSeverity.js';
import { ControlViolationsPerSeverityViolatedControlsInner } from '../models/ControlViolationsPerSeverityViolatedControlsInner.js';
import { ControlsFilters } from '../models/ControlsFilters.js';
import { ConvertEbsSnapshotConfig } from '../models/ConvertEbsSnapshotConfig.js';
import { ConvertEc2ImageConfig } from '../models/ConvertEc2ImageConfig.js';
import { ConvertOtherSnapshotsOnDemandRequest } from '../models/ConvertOtherSnapshotsOnDemandRequest.js';
import { ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner } from '../models/ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner.js';
import { ConvertResourceSnapshotsRequest } from '../models/ConvertResourceSnapshotsRequest.js';
import { ConvertResourceSnapshotsResponse } from '../models/ConvertResourceSnapshotsResponse.js';
import { Cost } from '../models/Cost.js';
import { CostDataFilters } from '../models/CostDataFilters.js';
import { CostDataRecord } from '../models/CostDataRecord.js';
import { CostDataRecordCost } from '../models/CostDataRecordCost.js';
import { CostDataRecordDimensions } from '../models/CostDataRecordDimensions.js';
import { CostProductFilters } from '../models/CostProductFilters.js';
import { CostRecordMetadata } from '../models/CostRecordMetadata.js';
import { CostRecordMetadataDataTransfer } from '../models/CostRecordMetadataDataTransfer.js';
import { CreateAccessGrantRequest } from '../models/CreateAccessGrantRequest.js';
import { CreateAccessPolicyRequest } from '../models/CreateAccessPolicyRequest.js';
import { CreateAccountInput } from '../models/CreateAccountInput.js';
import { CreateActionApprovalRuleRequest } from '../models/CreateActionApprovalRuleRequest.js';
import { CreateActionApprovalRuleResponse } from '../models/CreateActionApprovalRuleResponse.js';
import { CreateApiCredentialsRequest } from '../models/CreateApiCredentialsRequest.js';
import { CreateApiCredentialsResponse } from '../models/CreateApiCredentialsResponse.js';
import { CreateBackupPolicyRequest } from '../models/CreateBackupPolicyRequest.js';
import { CreateBackupPolicyResponse } from '../models/CreateBackupPolicyResponse.js';
import { CreateBackupPostureControlRequest } from '../models/CreateBackupPostureControlRequest.js';
import { CreateBackupZeroEtlPolicyInput } from '../models/CreateBackupZeroEtlPolicyInput.js';
import { CreateClassificationPolicyRequest } from '../models/CreateClassificationPolicyRequest.js';
import { CreateClassificationPolicyResponse } from '../models/CreateClassificationPolicyResponse.js';
import { CreateDataCatalogPipelineRequest } from '../models/CreateDataCatalogPipelineRequest.js';
import { CreateDlsgPolicyRequest } from '../models/CreateDlsgPolicyRequest.js';
import { CreateDlsgPolicyResponse } from '../models/CreateDlsgPolicyResponse.js';
import { CreateFabricTableShortcutDemoRequest } from '../models/CreateFabricTableShortcutDemoRequest.js';
import { CreateFabricTableShortcutDemoRequestShortcutsInner } from '../models/CreateFabricTableShortcutDemoRequestShortcutsInner.js';
import { CreateFabricTableShortcutDemoResponse } from '../models/CreateFabricTableShortcutDemoResponse.js';
import { CreateFabricTableShortcutDemoResponseResultsInner } from '../models/CreateFabricTableShortcutDemoResponseResultsInner.js';
import { CreateFindingExclusionRequest } from '../models/CreateFindingExclusionRequest.js';
import { CreateFindingExclusionResponse } from '../models/CreateFindingExclusionResponse.js';
import { CreateGdsgInventoryReportConfigurationRequest } from '../models/CreateGdsgInventoryReportConfigurationRequest.js';
import { CreateGdsgInventoryReportConfigurationResponse } from '../models/CreateGdsgInventoryReportConfigurationResponse.js';
import { CreateIdpGroupRequest } from '../models/CreateIdpGroupRequest.js';
import { CreateIdpGroupResponse } from '../models/CreateIdpGroupResponse.js';
import { CreateIntegrationRequest } from '../models/CreateIntegrationRequest.js';
import { CreateIntegrationResponse } from '../models/CreateIntegrationResponse.js';
import { CreateMPARequestReviewRequest } from '../models/CreateMPARequestReviewRequest.js';
import { CreateMPARequestReviewResponse } from '../models/CreateMPARequestReviewResponse.js';
import { CreateOAuthAppRequest } from '../models/CreateOAuthAppRequest.js';
import { CreateOAuthAppResponse } from '../models/CreateOAuthAppResponse.js';
import { CreateOrganizationIdpGroupRequest } from '../models/CreateOrganizationIdpGroupRequest.js';
import { CreateOrganizationIdpGroupResponse } from '../models/CreateOrganizationIdpGroupResponse.js';
import { CreateOrganizationIdpRequest } from '../models/CreateOrganizationIdpRequest.js';
import { CreateOrganizationIdpResponse } from '../models/CreateOrganizationIdpResponse.js';
import { CreateOrganizationUserRequest } from '../models/CreateOrganizationUserRequest.js';
import { CreateOrganizationUserResponse } from '../models/CreateOrganizationUserResponse.js';
import { CreatePolicyInput } from '../models/CreatePolicyInput.js';
import { CreatePolicyScheduleInput } from '../models/CreatePolicyScheduleInput.js';
import { CreateProjectInput } from '../models/CreateProjectInput.js';
import { CreatePulumiConfigurationRequest } from '../models/CreatePulumiConfigurationRequest.js';
import { CreateRestoreTemplateRequest } from '../models/CreateRestoreTemplateRequest.js';
import { CreateRestoreTemplateResponse } from '../models/CreateRestoreTemplateResponse.js';
import { CreateRoleRequest } from '../models/CreateRoleRequest.js';
import { CreateRoleResponse } from '../models/CreateRoleResponse.js';
import { CreateSamlIdentityProviderConfigInput } from '../models/CreateSamlIdentityProviderConfigInput.js';
import { CreateScanJobInput } from '../models/CreateScanJobInput.js';
import { CreateScanJobResponse } from '../models/CreateScanJobResponse.js';
import { CreateSessionRequest } from '../models/CreateSessionRequest.js';
import { CreateSnapshotRecipeRequest } from '../models/CreateSnapshotRecipeRequest.js';
import { CreateSnapshotRecipeResponse } from '../models/CreateSnapshotRecipeResponse.js';
import { CreateTagDefinitionRequest } from '../models/CreateTagDefinitionRequest.js';
import { CreateThreatHuntingScanRequestRequest } from '../models/CreateThreatHuntingScanRequestRequest.js';
import { CreateThreatHuntingScanRequestResponse } from '../models/CreateThreatHuntingScanRequestResponse.js';
import { CreateUserInput } from '../models/CreateUserInput.js';
import { CreateVaultRequest } from '../models/CreateVaultRequest.js';
import { CreateVaultResponse } from '../models/CreateVaultResponse.js';
import { CredentialFinding } from '../models/CredentialFinding.js';
import { CreditsMonthlyUsageNotificationArguments } from '../models/CreditsMonthlyUsageNotificationArguments.js';
import { CreditsNotificationArguments } from '../models/CreditsNotificationArguments.js';
import { CrossResourceQueryRequest } from '../models/CrossResourceQueryRequest.js';
import { CrossResourceQueryRequestResourcesInner } from '../models/CrossResourceQueryRequestResourcesInner.js';
import { CustomTagsInner } from '../models/CustomTagsInner.js';
import { CustomerVaultAccount } from '../models/CustomerVaultAccount.js';
import { DBResourceMetadata } from '../models/DBResourceMetadata.js';
import { DBServerRecord } from '../models/DBServerRecord.js';
import { DBSnapshotMetadata } from '../models/DBSnapshotMetadata.js';
import { DBValueDistributionResponse } from '../models/DBValueDistributionResponse.js';
import { DailyConfig } from '../models/DailyConfig.js';
import { DailySnapshotData } from '../models/DailySnapshotData.js';
import { DailyStorageSummaries } from '../models/DailyStorageSummaries.js';
import { DailyStorageSummary } from '../models/DailyStorageSummary.js';
import { Dashboard } from '../models/Dashboard.js';
import { Dashboards } from '../models/Dashboards.js';
import { DataCatalogAccessGrant } from '../models/DataCatalogAccessGrant.js';
import { DataCatalogAccessPolicy } from '../models/DataCatalogAccessPolicy.js';
import { DataCatalogDataset } from '../models/DataCatalogDataset.js';
import { DataCatalogDatasetEvent } from '../models/DataCatalogDatasetEvent.js';
import { DataCatalogDatasetHealth } from '../models/DataCatalogDatasetHealth.js';
import { DataCatalogDatasetHealthIssue } from '../models/DataCatalogDatasetHealthIssue.js';
import { DataCatalogDatasetSchema } from '../models/DataCatalogDatasetSchema.js';
import { DataCatalogDatasetSchemaColumnsInner } from '../models/DataCatalogDatasetSchemaColumnsInner.js';
import { DataCatalogDiscoveryProperties } from '../models/DataCatalogDiscoveryProperties.js';
import { DataCatalogEffectiveTag } from '../models/DataCatalogEffectiveTag.js';
import { DataCatalogGrantScope } from '../models/DataCatalogGrantScope.js';
import { DataCatalogJoinabilityEntry } from '../models/DataCatalogJoinabilityEntry.js';
import { DataCatalogJoinabilitySide } from '../models/DataCatalogJoinabilitySide.js';
import { DataCatalogMaskTransform } from '../models/DataCatalogMaskTransform.js';
import { DataCatalogMaskingPolicyBody } from '../models/DataCatalogMaskingPolicyBody.js';
import { DataCatalogNamespace } from '../models/DataCatalogNamespace.js';
import { DataCatalogPipeline } from '../models/DataCatalogPipeline.js';
import { DataCatalogPipelineAddressPart } from '../models/DataCatalogPipelineAddressPart.js';
import { DataCatalogPipelineAddressPartPattern } from '../models/DataCatalogPipelineAddressPartPattern.js';
import { DataCatalogPipelineDefinition } from '../models/DataCatalogPipelineDefinition.js';
import { DataCatalogPipelineOutput } from '../models/DataCatalogPipelineOutput.js';
import { DataCatalogPipelineOutputPartitionSpecInner } from '../models/DataCatalogPipelineOutputPartitionSpecInner.js';
import { DataCatalogPipelineResolvedDataset } from '../models/DataCatalogPipelineResolvedDataset.js';
import { DataCatalogPipelineResolvedGroup } from '../models/DataCatalogPipelineResolvedGroup.js';
import { DataCatalogPipelineResolvedGroupKeyInner } from '../models/DataCatalogPipelineResolvedGroupKeyInner.js';
import { DataCatalogPipelineSchedule } from '../models/DataCatalogPipelineSchedule.js';
import { DataCatalogPipelineSource } from '../models/DataCatalogPipelineSource.js';
import { DataCatalogPipelineViolation } from '../models/DataCatalogPipelineViolation.js';
import { DataCatalogPolicyScope } from '../models/DataCatalogPolicyScope.js';
import { DataCatalogRowExpression } from '../models/DataCatalogRowExpression.js';
import { DataCatalogRowFilterPolicyBody } from '../models/DataCatalogRowFilterPolicyBody.js';
import { DataCatalogRowLiteral } from '../models/DataCatalogRowLiteral.js';
import { DataCatalogRowPredicate } from '../models/DataCatalogRowPredicate.js';
import { DataCatalogSemanticLayerRun } from '../models/DataCatalogSemanticLayerRun.js';
import { DataCatalogSubjectRef } from '../models/DataCatalogSubjectRef.js';
import { DataCatalogSubjectSet } from '../models/DataCatalogSubjectSet.js';
import { DataCatalogTagAssignment } from '../models/DataCatalogTagAssignment.js';
import { DataCatalogTagConjunction } from '../models/DataCatalogTagConjunction.js';
import { DataCatalogTagDefinition } from '../models/DataCatalogTagDefinition.js';
import { DataCatalogTagExpression } from '../models/DataCatalogTagExpression.js';
import { DataCatalogTagPredicate } from '../models/DataCatalogTagPredicate.js';
import { DataCatalogTagResourceRef } from '../models/DataCatalogTagResourceRef.js';
import { DataCatalogTreeItem } from '../models/DataCatalogTreeItem.js';
import { DataCatalogValidationIssue } from '../models/DataCatalogValidationIssue.js';
import { DataCatalogViewAiProperties } from '../models/DataCatalogViewAiProperties.js';
import { DataCatalogViewProperties } from '../models/DataCatalogViewProperties.js';
import { DataCatalogViewQuery } from '../models/DataCatalogViewQuery.js';
import { DataClassEntitiesFilters } from '../models/DataClassEntitiesFilters.js';
import { DataClassesCondition } from '../models/DataClassesCondition.js';
import { DataClassesDetails } from '../models/DataClassesDetails.js';
import { DataClassesFilters } from '../models/DataClassesFilters.js';
import { DataClassificationEntity } from '../models/DataClassificationEntity.js';
import { DataClassificationEntityOption } from '../models/DataClassificationEntityOption.js';
import { DataShareIntegrationConfig } from '../models/DataShareIntegrationConfig.js';
import { Database } from '../models/Database.js';
import { DatabaseDestination } from '../models/DatabaseDestination.js';
import { DatabaseRecord } from '../models/DatabaseRecord.js';
import { DatabricksIntegrationConfig } from '../models/DatabricksIntegrationConfig.js';
import { DeactivateAccountRequest } from '../models/DeactivateAccountRequest.js';
import { DeactivateAccountResponse } from '../models/DeactivateAccountResponse.js';
import { DeactivateAtlasOrganizationResponse } from '../models/DeactivateAtlasOrganizationResponse.js';
import { DeactivateGcpFolderResponse } from '../models/DeactivateGcpFolderResponse.js';
import { DeactivateGcpOrganizationResponse } from '../models/DeactivateGcpOrganizationResponse.js';
import { DeleteGdsgObjectsRequest } from '../models/DeleteGdsgObjectsRequest.js';
import { DeleteGdsgObjectsResponse } from '../models/DeleteGdsgObjectsResponse.js';
import { DeleteResourceTagRequest } from '../models/DeleteResourceTagRequest.js';
import { DestinationDetails } from '../models/DestinationDetails.js';
import { DestinationProviderAttributes } from '../models/DestinationProviderAttributes.js';
import { DestinationProviderAttributesAzure } from '../models/DestinationProviderAttributesAzure.js';
import { DestinationRestoreTypeAttributes } from '../models/DestinationRestoreTypeAttributes.js';
import { DetectorSummary } from '../models/DetectorSummary.js';
import { DetectorTypeFilters } from '../models/DetectorTypeFilters.js';
import { DirectoryApplicationSummary } from '../models/DirectoryApplicationSummary.js';
import { DirectoryEdgeRecord } from '../models/DirectoryEdgeRecord.js';
import { DirectoryEntityRecord } from '../models/DirectoryEntityRecord.js';
import { DirectoryEntityTypeCount } from '../models/DirectoryEntityTypeCount.js';
import { DirectorySearchFilter } from '../models/DirectorySearchFilter.js';
import { DisableResourceOverrideLimitsResponse } from '../models/DisableResourceOverrideLimitsResponse.js';
import { DisconnectCustomerVaultAccountResponse } from '../models/DisconnectCustomerVaultAccountResponse.js';
import { DisconnectRestoreAccountResponse } from '../models/DisconnectRestoreAccountResponse.js';
import { DisconnectRestoreAwsOrganizationalUnitResponse } from '../models/DisconnectRestoreAwsOrganizationalUnitResponse.js';
import { DisconnectSourceAccountResponse } from '../models/DisconnectSourceAccountResponse.js';
import { DisconnectSourceAwsOrganizationalUnitResponse } from '../models/DisconnectSourceAwsOrganizationalUnitResponse.js';
import { DiscoveryInvokeParams } from '../models/DiscoveryInvokeParams.js';
import { DiscoveryJob } from '../models/DiscoveryJob.js';
import { DiscoveryStatusResponse } from '../models/DiscoveryStatusResponse.js';
import { DlsgPolicy } from '../models/DlsgPolicy.js';
import { DlsgPolicyConfig } from '../models/DlsgPolicyConfig.js';
import { DlsgPolicyFilters } from '../models/DlsgPolicyFilters.js';
import { DlsgPolicyPlan } from '../models/DlsgPolicyPlan.js';
import { DlsgSettings } from '../models/DlsgSettings.js';
import { DocumentDBRestoreDestination } from '../models/DocumentDBRestoreDestination.js';
import { DocumentDbClusterParameterGroup } from '../models/DocumentDbClusterParameterGroup.js';
import { DocumentDbClusterParameterGroups } from '../models/DocumentDbClusterParameterGroups.js';
import { DocumentDbSnapshotProperties } from '../models/DocumentDbSnapshotProperties.js';
import { DownloadGdsgObjectsRequest } from '../models/DownloadGdsgObjectsRequest.js';
import { DriftProtectionPolicy } from '../models/DriftProtectionPolicy.js';
import { DriftProtectionSummary } from '../models/DriftProtectionSummary.js';
import { DriftProtectionTimePoint } from '../models/DriftProtectionTimePoint.js';
import { DsgBucketFilters } from '../models/DsgBucketFilters.js';
import { DsgEnvironmentFilters } from '../models/DsgEnvironmentFilters.js';
import { DsgRegionFilters } from '../models/DsgRegionFilters.js';
import { DsgRequestTypeFilters } from '../models/DsgRequestTypeFilters.js';
import { DsgStorageTierFilters } from '../models/DsgStorageTierFilters.js';
import { DynamoDBAdvancedIndexConfig } from '../models/DynamoDBAdvancedIndexConfig.js';
import { DynamoDBRestoreMethodAvailabilityRequest } from '../models/DynamoDBRestoreMethodAvailabilityRequest.js';
import { DynamoDBRestoreMethodAvailabilityResponse } from '../models/DynamoDBRestoreMethodAvailabilityResponse.js';
import { DynamoDbBackupConfig } from '../models/DynamoDbBackupConfig.js';
import { DynamoDbBackupConfigApplication } from '../models/DynamoDbBackupConfigApplication.js';
import { DynamoDbGlobalSecondaryIndex } from '../models/DynamoDbGlobalSecondaryIndex.js';
import { DynamoDbIndexKeySchemaElement } from '../models/DynamoDbIndexKeySchemaElement.js';
import { DynamoDbIndexProjection } from '../models/DynamoDbIndexProjection.js';
import { DynamoDbIndexThroughput } from '../models/DynamoDbIndexThroughput.js';
import { DynamoDbLocalSecondaryIndex } from '../models/DynamoDbLocalSecondaryIndex.js';
import { DynamodbTableRestoreDestination } from '../models/DynamodbTableRestoreDestination.js';
import { EFSRestoreDestination } from '../models/EFSRestoreDestination.js';
import { EbsRestoreDestination } from '../models/EbsRestoreDestination.js';
import { EbsSnapshotRestoreDestination } from '../models/EbsSnapshotRestoreDestination.js';
import { EbsSnapshotTarget } from '../models/EbsSnapshotTarget.js';
import { EbsTarget } from '../models/EbsTarget.js';
import { Ec2TemplateParams } from '../models/Ec2TemplateParams.js';
import { Ec2TemplateParamsAdditionalTagsInner } from '../models/Ec2TemplateParamsAdditionalTagsInner.js';
import { EfsSnapshotProperties } from '../models/EfsSnapshotProperties.js';
import { EksBackupNamespaces } from '../models/EksBackupNamespaces.js';
import { EksCluster } from '../models/EksCluster.js';
import { EksClusterRestoreDestination } from '../models/EksClusterRestoreDestination.js';
import { EksClusterSnapshotProperties } from '../models/EksClusterSnapshotProperties.js';
import { EksNamespaceRestoreDestination } from '../models/EksNamespaceRestoreDestination.js';
import { EksNamespaceRestoreResult } from '../models/EksNamespaceRestoreResult.js';
import { EksRestoreTargetClusters } from '../models/EksRestoreTargetClusters.js';
import { EksVolumeRestoreResult } from '../models/EksVolumeRestoreResult.js';
import { EmailSearchFilter } from '../models/EmailSearchFilter.js';
import { EmrIntegrationConfig } from '../models/EmrIntegrationConfig.js';
import { EnableFromLimitExceededResponse } from '../models/EnableFromLimitExceededResponse.js';
import { EnableResourceOverrideLimitsResponse } from '../models/EnableResourceOverrideLimitsResponse.js';
import { EnableRestoreAccountMetricsConfigRequest } from '../models/EnableRestoreAccountMetricsConfigRequest.js';
import { EnableRestoreAccountMetricsConfigResponse } from '../models/EnableRestoreAccountMetricsConfigResponse.js';
import { EnableSourceAccountMetricsConfigRequest } from '../models/EnableSourceAccountMetricsConfigRequest.js';
import { EnableSourceAccountMetricsConfigResponse } from '../models/EnableSourceAccountMetricsConfigResponse.js';
import { EncryptionKey } from '../models/EncryptionKey.js';
import { EncryptionKeys } from '../models/EncryptionKeys.js';
import { EncryptionTypeCondition } from '../models/EncryptionTypeCondition.js';
import { EncryptionTypeFilters } from '../models/EncryptionTypeFilters.js';
import { EndTimeDateFilters } from '../models/EndTimeDateFilters.js';
import { EntraIdConnectionInfo } from '../models/EntraIdConnectionInfo.js';
import { EntraIdEntitySelection } from '../models/EntraIdEntitySelection.js';
import { EntraIdRestoreAccountAttributes } from '../models/EntraIdRestoreAccountAttributes.js';
import { EntraIdRestoreAccountAttributesInput } from '../models/EntraIdRestoreAccountAttributesInput.js';
import { EntraIdSourceAccountAttributesInput } from '../models/EntraIdSourceAccountAttributesInput.js';
import { EntraRestoreReport } from '../models/EntraRestoreReport.js';
import { EntraRestoreReportEntity } from '../models/EntraRestoreReportEntity.js';
import { EntraRestoreReportEntityRelationships } from '../models/EntraRestoreReportEntityRelationships.js';
import { EntraRestoreReportEntityRequiredActionsInner } from '../models/EntraRestoreReportEntityRequiredActionsInner.js';
import { EntraRestoreReportJob } from '../models/EntraRestoreReportJob.js';
import { EntraRestoreReportSummary } from '../models/EntraRestoreReportSummary.js';
import { EntraRestoreReportSummaryByMethod } from '../models/EntraRestoreReportSummaryByMethod.js';
import { EntraRestoreReportSummaryByTypeValue } from '../models/EntraRestoreReportSummaryByTypeValue.js';
import { EnvironmentCondition } from '../models/EnvironmentCondition.js';
import { EnvironmentDetails } from '../models/EnvironmentDetails.js';
import { EnvironmentFilters } from '../models/EnvironmentFilters.js';
import { EonAccount } from '../models/EonAccount.js';
import { EonAccountIdFilters } from '../models/EonAccountIdFilters.js';
import { EonOrganization } from '../models/EonOrganization.js';
import { EonOrganizationSummary } from '../models/EonOrganizationSummary.js';
import { EvaluateRestoreTemplateResponse } from '../models/EvaluateRestoreTemplateResponse.js';
import { EvidenceTypeFilters } from '../models/EvidenceTypeFilters.js';
import { ExcludeFromBackupResponse } from '../models/ExcludeFromBackupResponse.js';
import { ExportAccessDeniedItemsRequest } from '../models/ExportAccessDeniedItemsRequest.js';
import { ExportComplianceReportRequest } from '../models/ExportComplianceReportRequest.js';
import { ExportComplianceReportResponse } from '../models/ExportComplianceReportResponse.js';
import { ExportCostDataRequest } from '../models/ExportCostDataRequest.js';
import { ExportOrganizationCostData400Response } from '../models/ExportOrganizationCostData400Response.js';
import { ExportOrganizationCostDataRequest } from '../models/ExportOrganizationCostDataRequest.js';
import { FSxRestoreDestination } from '../models/FSxRestoreDestination.js';
import { FSxRestoreDestinationOntapRestoreOptions } from '../models/FSxRestoreDestinationOntapRestoreOptions.js';
import { FeatureFlagOverrideGet200Response } from '../models/FeatureFlagOverrideGet200Response.js';
import { FieldStatus } from '../models/FieldStatus.js';
import { FileExplorerCountPathFilesResponse } from '../models/FileExplorerCountPathFilesResponse.js';
import { FileExplorerCountSecurityAlertsInResourceResponse } from '../models/FileExplorerCountSecurityAlertsInResourceResponse.js';
import { FileExplorerCountWorkspaceEntitiesResponse } from '../models/FileExplorerCountWorkspaceEntitiesResponse.js';
import { FileExplorerResponse } from '../models/FileExplorerResponse.js';
import { FilePath } from '../models/FilePath.js';
import { FileRestoreData } from '../models/FileRestoreData.js';
import { FileSearchRecord } from '../models/FileSearchRecord.js';
import { FileSnapshot } from '../models/FileSnapshot.js';
import { FilterQueryRequest } from '../models/FilterQueryRequest.js';
import { FindingCountEntry } from '../models/FindingCountEntry.js';
import { FindingEntry } from '../models/FindingEntry.js';
import { FindingExclusion } from '../models/FindingExclusion.js';
import { FindingExclusionDetectorFilters } from '../models/FindingExclusionDetectorFilters.js';
import { FindingExclusionFilterConditions } from '../models/FindingExclusionFilterConditions.js';
import { FindingExclusionResourceFilter } from '../models/FindingExclusionResourceFilter.js';
import { FindingExclusionScopeFilters } from '../models/FindingExclusionScopeFilters.js';
import { FindingExclusionTypeFilters } from '../models/FindingExclusionTypeFilters.js';
import { FindingExclusionValueFilters } from '../models/FindingExclusionValueFilters.js';
import { FindingObjectTypeFilters } from '../models/FindingObjectTypeFilters.js';
import { FindingResourceFilters } from '../models/FindingResourceFilters.js';
import { FindingSensitiveDataLocation } from '../models/FindingSensitiveDataLocation.js';
import { FindingStatusFilters } from '../models/FindingStatusFilters.js';
import { ForceDeleteSnapshotsRequest } from '../models/ForceDeleteSnapshotsRequest.js';
import { FreeTextFilters } from '../models/FreeTextFilters.js';
import { FsxOntapVolume } from '../models/FsxOntapVolume.js';
import { FsxSnapshotProperties } from '../models/FsxSnapshotProperties.js';
import { FsxVolumeBackupInfo } from '../models/FsxVolumeBackupInfo.js';
import { GCSBucket } from '../models/GCSBucket.js';
import { GCSBuckets } from '../models/GCSBuckets.js';
import { GCSRestoreDestination } from '../models/GCSRestoreDestination.js';
import { GCSRestoreTarget } from '../models/GCSRestoreTarget.js';
import { GcpAccountConfigInput } from '../models/GcpAccountConfigInput.js';
import { GcpBigQueryDatasetRestoreResult } from '../models/GcpBigQueryDatasetRestoreResult.js';
import { GcpBigQueryResource } from '../models/GcpBigQueryResource.js';
import { GcpBigQueryResourceMaterializedViewsInner } from '../models/GcpBigQueryResourceMaterializedViewsInner.js';
import { GcpBigQueryResourceRoutinesInner } from '../models/GcpBigQueryResourceRoutinesInner.js';
import { GcpBigQueryResourceTablesInner } from '../models/GcpBigQueryResourceTablesInner.js';
import { GcpBigQueryResourceViewsInner } from '../models/GcpBigQueryResourceViewsInner.js';
import { GcpCloudSqlResource } from '../models/GcpCloudSqlResource.js';
import { GcpCloudSqlResourceStorageSettings } from '../models/GcpCloudSqlResourceStorageSettings.js';
import { GcpCloudSqlRestoreDestination } from '../models/GcpCloudSqlRestoreDestination.js';
import { GcpCloudSqlSnapshotProperties } from '../models/GcpCloudSqlSnapshotProperties.js';
import { GcpCloudSqlTarget } from '../models/GcpCloudSqlTarget.js';
import { GcpDiskResource } from '../models/GcpDiskResource.js';
import { GcpDiskRestoreData } from '../models/GcpDiskRestoreData.js';
import { GcpDiskRestoreDestination } from '../models/GcpDiskRestoreDestination.js';
import { GcpDiskSettings } from '../models/GcpDiskSettings.js';
import { GcpDiskSnapshotProperties } from '../models/GcpDiskSnapshotProperties.js';
import { GcpDiskTarget } from '../models/GcpDiskTarget.js';
import { GcpDiskTypesResponse } from '../models/GcpDiskTypesResponse.js';
import { GcpEncryptionKey } from '../models/GcpEncryptionKey.js';
import { GcpEncryptionKeys } from '../models/GcpEncryptionKeys.js';
import { GcpGcsResource } from '../models/GcpGcsResource.js';
import { GcpGkeNamespaceResource } from '../models/GcpGkeNamespaceResource.js';
import { GcpGrantedServices } from '../models/GcpGrantedServices.js';
import { GcpLabelFilter } from '../models/GcpLabelFilter.js';
import { GcpMachineTypesResponse } from '../models/GcpMachineTypesResponse.js';
import { GcpNetworkConnectivityConfig } from '../models/GcpNetworkConnectivityConfig.js';
import { GcpOptionalCapabilities } from '../models/GcpOptionalCapabilities.js';
import { GcpOrganization } from '../models/GcpOrganization.js';
import { GcpRestoreAccountAttributes } from '../models/GcpRestoreAccountAttributes.js';
import { GcpRestoreAccountAttributesInput } from '../models/GcpRestoreAccountAttributesInput.js';
import { GcpRestoreAccountConnectivityConfig } from '../models/GcpRestoreAccountConnectivityConfig.js';
import { GcpRestoreGrantedServices } from '../models/GcpRestoreGrantedServices.js';
import { GcpSapHanaResource } from '../models/GcpSapHanaResource.js';
import { GcpSourceAccountAttributes } from '../models/GcpSourceAccountAttributes.js';
import { GcpSourceAccountAttributesInput } from '../models/GcpSourceAccountAttributesInput.js';
import { GcpSourceServices } from '../models/GcpSourceServices.js';
import { GcpSqlVmSetup } from '../models/GcpSqlVmSetup.js';
import { GcpSubnet } from '../models/GcpSubnet.js';
import { GcpSubnetPerRegion } from '../models/GcpSubnetPerRegion.js';
import { GcpTagFilter } from '../models/GcpTagFilter.js';
import { GcpVaultConfig } from '../models/GcpVaultConfig.js';
import { GcpVaultConfigInput } from '../models/GcpVaultConfigInput.js';
import { GcpVmInstanceRestoreDestination } from '../models/GcpVmInstanceRestoreDestination.js';
import { GcpVmInstanceRestoreResult } from '../models/GcpVmInstanceRestoreResult.js';
import { GcpVmInstanceRestoreTarget } from '../models/GcpVmInstanceRestoreTarget.js';
import { GcpVmResource } from '../models/GcpVmResource.js';
import { GcpVmSnapshotProperties } from '../models/GcpVmSnapshotProperties.js';
import { GdsgActiveBatchJobs } from '../models/GdsgActiveBatchJobs.js';
import { GdsgBigtableClusterStats } from '../models/GdsgBigtableClusterStats.js';
import { GdsgBigtableStorageTypeBytes } from '../models/GdsgBigtableStorageTypeBytes.js';
import { GdsgBigtableTableCpu } from '../models/GdsgBigtableTableCpu.js';
import { GdsgBigtableTableStorage } from '../models/GdsgBigtableTableStorage.js';
import { GdsgBucketStats } from '../models/GdsgBucketStats.js';
import { GdsgDeleteResult } from '../models/GdsgDeleteResult.js';
import { GdsgDevStats } from '../models/GdsgDevStats.js';
import { GdsgEnvironment } from '../models/GdsgEnvironment.js';
import { GdsgEnvironmentRegion } from '../models/GdsgEnvironmentRegion.js';
import { GdsgInventoryReportConfiguration } from '../models/GdsgInventoryReportConfiguration.js';
import { GdsgInventoryReportConfigurationInput } from '../models/GdsgInventoryReportConfigurationInput.js';
import { GdsgInventoryReportCsvOptions } from '../models/GdsgInventoryReportCsvOptions.js';
import { GdsgInventoryReportFrequencyOptions } from '../models/GdsgInventoryReportFrequencyOptions.js';
import { GdsgInventoryReportRun } from '../models/GdsgInventoryReportRun.js';
import { GdsgObjectEntry } from '../models/GdsgObjectEntry.js';
import { GdsgOperationalNotificationArguments } from '../models/GdsgOperationalNotificationArguments.js';
import { GdsgOperationalWarning } from '../models/GdsgOperationalWarning.js';
import { GdsgQueueLagStats } from '../models/GdsgQueueLagStats.js';
import { GdsgQueueScanSummary } from '../models/GdsgQueueScanSummary.js';
import { GdsgRegionStats } from '../models/GdsgRegionStats.js';
import { GdsgRegionStatsPoint } from '../models/GdsgRegionStatsPoint.js';
import { GdsgStorageBreakdownEntry } from '../models/GdsgStorageBreakdownEntry.js';
import { GdsgStorageByBucketEntry } from '../models/GdsgStorageByBucketEntry.js';
import { GdsgStorageByTierEntry } from '../models/GdsgStorageByTierEntry.js';
import { GdsgWorkerHeartbeatStats } from '../models/GdsgWorkerHeartbeatStats.js';
import { GdsgWorkerHeartbeats } from '../models/GdsgWorkerHeartbeats.js';
import { GenericSnapshotData } from '../models/GenericSnapshotData.js';
import { GetAWSStackDetailsResponse } from '../models/GetAWSStackDetailsResponse.js';
import { GetActionApprovalRuleResponse } from '../models/GetActionApprovalRuleResponse.js';
import { GetActionApprovalSummaryResponse } from '../models/GetActionApprovalSummaryResponse.js';
import { GetAdditionalAzureAppsOnboardingStatus200Response } from '../models/GetAdditionalAzureAppsOnboardingStatus200Response.js';
import { GetAgreementsResponse } from '../models/GetAgreementsResponse.js';
import { GetAwsPrivateLinkStatusResponse } from '../models/GetAwsPrivateLinkStatusResponse.js';
import { GetAzureQueryExportStorage200Response } from '../models/GetAzureQueryExportStorage200Response.js';
import { GetBackupJobResponse } from '../models/GetBackupJobResponse.js';
import { GetBackupPolicyResponse } from '../models/GetBackupPolicyResponse.js';
import { GetBackupZeroEtlPolicyConnectionInfoResponse } from '../models/GetBackupZeroEtlPolicyConnectionInfoResponse.js';
import { GetBillingPeriodsResponse } from '../models/GetBillingPeriodsResponse.js';
import { GetBulkRestoreSnapshotHistogramRequest } from '../models/GetBulkRestoreSnapshotHistogramRequest.js';
import { GetBulkRestoreSnapshotHistogramResponse } from '../models/GetBulkRestoreSnapshotHistogramResponse.js';
import { GetCdcSqlSetupCheckResponse } from '../models/GetCdcSqlSetupCheckResponse.js';
import { GetClassificationPolicyResponse } from '../models/GetClassificationPolicyResponse.js';
import { GetCloudResourceSecurityPropertiesResponse } from '../models/GetCloudResourceSecurityPropertiesResponse.js';
import { GetCredits400Response } from '../models/GetCredits400Response.js';
import { GetCreditsResponse } from '../models/GetCreditsResponse.js';
import { GetDataCatalogDatasetResponse } from '../models/GetDataCatalogDatasetResponse.js';
import { GetDataCatalogNamespaceResponse } from '../models/GetDataCatalogNamespaceResponse.js';
import { GetDataCatalogPipelineCapabilitiesResponse } from '../models/GetDataCatalogPipelineCapabilitiesResponse.js';
import { GetDataCatalogPipelineCapabilitiesResponseEngineAvailabilityInner } from '../models/GetDataCatalogPipelineCapabilitiesResponseEngineAvailabilityInner.js';
import { GetDataCatalogSemanticLayerArtifactResponse } from '../models/GetDataCatalogSemanticLayerArtifactResponse.js';
import { GetDataCatalogSemanticLayerScheduleResponse } from '../models/GetDataCatalogSemanticLayerScheduleResponse.js';
import { GetDataCatalogSemanticLayerSeedArtifactResponse } from '../models/GetDataCatalogSemanticLayerSeedArtifactResponse.js';
import { GetDirectoryEntityRequest } from '../models/GetDirectoryEntityRequest.js';
import { GetDirectoryEntityResponse } from '../models/GetDirectoryEntityResponse.js';
import { GetDlsgPolicyResponse } from '../models/GetDlsgPolicyResponse.js';
import { GetFindingExclusionResponse } from '../models/GetFindingExclusionResponse.js';
import { GetGcsServiceAgentResponse } from '../models/GetGcsServiceAgentResponse.js';
import { GetGdsgDevStatsResponse } from '../models/GetGdsgDevStatsResponse.js';
import { GetGdsgInventoryReportConfigurationResponse } from '../models/GetGdsgInventoryReportConfigurationResponse.js';
import { GetGdsgRegionStatsResponse } from '../models/GetGdsgRegionStatsResponse.js';
import { GetIdpGroupResponse } from '../models/GetIdpGroupResponse.js';
import { GetIntegrationResponse } from '../models/GetIntegrationResponse.js';
import { GetJobProgressStepsResponse } from '../models/GetJobProgressStepsResponse.js';
import { GetLimitsResponseValue } from '../models/GetLimitsResponseValue.js';
import { GetMPARequestResponse } from '../models/GetMPARequestResponse.js';
import { GetMicrosoft365BackupScopeRequest } from '../models/GetMicrosoft365BackupScopeRequest.js';
import { GetObjectStoreScanMethodResponse } from '../models/GetObjectStoreScanMethodResponse.js';
import { GetProjectConfigurationKeyResponse } from '../models/GetProjectConfigurationKeyResponse.js';
import { GetProjectConfigurationKeysResponse } from '../models/GetProjectConfigurationKeysResponse.js';
import { GetQueryExecutionResultResponse } from '../models/GetQueryExecutionResultResponse.js';
import { GetResourceResponse } from '../models/GetResourceResponse.js';
import { GetRestoreAccountCanDelete200Response } from '../models/GetRestoreAccountCanDelete200Response.js';
import { GetRestoreAccountConnectivityConfigResponse } from '../models/GetRestoreAccountConnectivityConfigResponse.js';
import { GetRestoreAccountMetricsConfigResponse } from '../models/GetRestoreAccountMetricsConfigResponse.js';
import { GetRestoreAccountResponse } from '../models/GetRestoreAccountResponse.js';
import { GetRestoreJobResponse } from '../models/GetRestoreJobResponse.js';
import { GetRestoreTemplateResponse } from '../models/GetRestoreTemplateResponse.js';
import { GetRoleResponse } from '../models/GetRoleResponse.js';
import { GetSaasEntityIdByExternalIdRequest } from '../models/GetSaasEntityIdByExternalIdRequest.js';
import { GetSaasEntityIdByExternalIdResponse } from '../models/GetSaasEntityIdByExternalIdResponse.js';
import { GetScanJobResponse } from '../models/GetScanJobResponse.js';
import { GetSnapshotRecipeResponse } from '../models/GetSnapshotRecipeResponse.js';
import { GetSnapshotResponse } from '../models/GetSnapshotResponse.js';
import { GetSourceAccountCanDelete200Response } from '../models/GetSourceAccountCanDelete200Response.js';
import { GetSourceAccountMetricsConfigResponse } from '../models/GetSourceAccountMetricsConfigResponse.js';
import { GetSourceAccountResponse } from '../models/GetSourceAccountResponse.js';
import { GetSqlVmNetworkInfoRequest } from '../models/GetSqlVmNetworkInfoRequest.js';
import { GetSqlVmNetworkInfoResponse } from '../models/GetSqlVmNetworkInfoResponse.js';
import { GetTestShadowConsistencyStatus200Response } from '../models/GetTestShadowConsistencyStatus200Response.js';
import { GetTestSnapshot200Response } from '../models/GetTestSnapshot200Response.js';
import { GetVaultResponse } from '../models/GetVaultResponse.js';
import { GlobalClusterIdentifierCondition } from '../models/GlobalClusterIdentifierCondition.js';
import { GlobalClusterIdentifierFilters } from '../models/GlobalClusterIdentifierFilters.js';
import { GoogleWorkspaceBackupPolicyPlan } from '../models/GoogleWorkspaceBackupPolicyPlan.js';
import { GoogleWorkspaceConnectionInfo } from '../models/GoogleWorkspaceConnectionInfo.js';
import { GoogleWorkspaceDriveRestoreOptions } from '../models/GoogleWorkspaceDriveRestoreOptions.js';
import { GoogleWorkspaceGmailRestoreOptions } from '../models/GoogleWorkspaceGmailRestoreOptions.js';
import { GoogleWorkspaceGroup } from '../models/GoogleWorkspaceGroup.js';
import { GoogleWorkspaceGroupMessageMailboxTarget } from '../models/GoogleWorkspaceGroupMessageMailboxTarget.js';
import { GoogleWorkspaceGroupMessageTarget } from '../models/GoogleWorkspaceGroupMessageTarget.js';
import { GoogleWorkspaceGroupRestoreWorkload } from '../models/GoogleWorkspaceGroupRestoreWorkload.js';
import { GoogleWorkspaceOrgUnit } from '../models/GoogleWorkspaceOrgUnit.js';
import { GoogleWorkspaceResource } from '../models/GoogleWorkspaceResource.js';
import { GoogleWorkspaceRestoreAccountAttributes } from '../models/GoogleWorkspaceRestoreAccountAttributes.js';
import { GoogleWorkspaceRestoreAccountAttributesInput } from '../models/GoogleWorkspaceRestoreAccountAttributesInput.js';
import { GoogleWorkspaceServiceAccountInfo } from '../models/GoogleWorkspaceServiceAccountInfo.js';
import { GoogleWorkspaceSharedDriveEntireDriveOptions } from '../models/GoogleWorkspaceSharedDriveEntireDriveOptions.js';
import { GoogleWorkspaceSharedDriveSelectedItemsOptions } from '../models/GoogleWorkspaceSharedDriveSelectedItemsOptions.js';
import { GoogleWorkspaceSnapshotProperties } from '../models/GoogleWorkspaceSnapshotProperties.js';
import { GoogleWorkspaceSourceAccountAttributes } from '../models/GoogleWorkspaceSourceAccountAttributes.js';
import { GoogleWorkspaceSourceAccountAttributesInput } from '../models/GoogleWorkspaceSourceAccountAttributesInput.js';
import { GoogleWorkspaceUserDriveEntireDriveOptions } from '../models/GoogleWorkspaceUserDriveEntireDriveOptions.js';
import { GoogleWorkspaceUserDriveSelectedItemsOptions } from '../models/GoogleWorkspaceUserDriveSelectedItemsOptions.js';
import { GoogleWorkspaceUserMailEntireMailboxOptions } from '../models/GoogleWorkspaceUserMailEntireMailboxOptions.js';
import { GoogleWorkspaceUserMailSelectedItemsOptions } from '../models/GoogleWorkspaceUserMailSelectedItemsOptions.js';
import { GoogleWorkspaceUserRestoreData } from '../models/GoogleWorkspaceUserRestoreData.js';
import { GoogleWorkspaceUserRestoreWorkload } from '../models/GoogleWorkspaceUserRestoreWorkload.js';
import { GoogleWorkspaceWithPolicyStatus } from '../models/GoogleWorkspaceWithPolicyStatus.js';
import { GroupBreakdown } from '../models/GroupBreakdown.js';
import { GroupBreakdownEntry } from '../models/GroupBreakdownEntry.js';
import { HighFrequencyBackupPolicyPlan } from '../models/HighFrequencyBackupPolicyPlan.js';
import { HighFrequencyBackupResourceType } from '../models/HighFrequencyBackupResourceType.js';
import { HighFrequencyBackupScheduleConfig } from '../models/HighFrequencyBackupScheduleConfig.js';
import { HighFrequencyBackupSchedules } from '../models/HighFrequencyBackupSchedules.js';
import { HighFrequencyIntervalConfig } from '../models/HighFrequencyIntervalConfig.js';
import { HoldSnapshotRequest } from '../models/HoldSnapshotRequest.js';
import { IDs } from '../models/IDs.js';
import { IdFilters } from '../models/IdFilters.js';
import { IdentityProvidersNames } from '../models/IdentityProvidersNames.js';
import { Idp } from '../models/Idp.js';
import { IdpGroup } from '../models/IdpGroup.js';
import { IdpGroupUser } from '../models/IdpGroupUser.js';
import { ImportDlsgCertificateRequest } from '../models/ImportDlsgCertificateRequest.js';
import { InfectedDataByClassification } from '../models/InfectedDataByClassification.js';
import { InfectedDataClassificationSize } from '../models/InfectedDataClassificationSize.js';
import { InfectedDataOverTime } from '../models/InfectedDataOverTime.js';
import { InfectedDateSize } from '../models/InfectedDateSize.js';
import { InfectedResourcesCountResponse } from '../models/InfectedResourcesCountResponse.js';
import { IngestionPipelineAccess } from '../models/IngestionPipelineAccess.js';
import { IngestionPipelineAccessSubject } from '../models/IngestionPipelineAccessSubject.js';
import { InitAuthInput } from '../models/InitAuthInput.js';
import { InitiateAccountSwitch403Response } from '../models/InitiateAccountSwitch403Response.js';
import { InitiateAccountSwitchRequest } from '../models/InitiateAccountSwitchRequest.js';
import { InitiateAccountSwitchResponse } from '../models/InitiateAccountSwitchResponse.js';
import { Initiator } from '../models/Initiator.js';
import { InitiatorIdentity } from '../models/InitiatorIdentity.js';
import { InitiatorNameFilters } from '../models/InitiatorNameFilters.js';
import { IntegConfig } from '../models/IntegConfig.js';
import { IntegrationConfig } from '../models/IntegrationConfig.js';
import { IntrospectRequest } from '../models/IntrospectRequest.js';
import { IntrospectResponse } from '../models/IntrospectResponse.js';
import { InventoryAzureDisk } from '../models/InventoryAzureDisk.js';
import { InventoryBackupPolicy } from '../models/InventoryBackupPolicy.js';
import { InventoryClassificationPolicy } from '../models/InventoryClassificationPolicy.js';
import { InventoryFilterConditions } from '../models/InventoryFilterConditions.js';
import { InventoryGcpDisk } from '../models/InventoryGcpDisk.js';
import { InventoryResource } from '../models/InventoryResource.js';
import { InventoryResourceMetadata } from '../models/InventoryResourceMetadata.js';
import { InventorySnapshotVolume } from '../models/InventorySnapshotVolume.js';
import { InventoryVault } from '../models/InventoryVault.js';
import { InventoryVolume } from '../models/InventoryVolume.js';
import { IsVaultDeletableResponse } from '../models/IsVaultDeletableResponse.js';
import { IssueMutedNotificationArguments } from '../models/IssueMutedNotificationArguments.js';
import { IssuesFilters } from '../models/IssuesFilters.js';
import { JobExecutionDetails } from '../models/JobExecutionDetails.js';
import { JobFailedNotificationArguments } from '../models/JobFailedNotificationArguments.js';
import { JobIdFilters } from '../models/JobIdFilters.js';
import { JobInitiationResponse } from '../models/JobInitiationResponse.js';
import { JobMetricsReportFailedArguments } from '../models/JobMetricsReportFailedArguments.js';
import { JobProgressStep } from '../models/JobProgressStep.js';
import { JobProgressStepBucketDataBackupData } from '../models/JobProgressStepBucketDataBackupData.js';
import { JobProgressStepBucketDataBackupDataCoverage } from '../models/JobProgressStepBucketDataBackupDataCoverage.js';
import { JobProgressStepBucketDataBackupDataCoverageNotBackedUpInner } from '../models/JobProgressStepBucketDataBackupDataCoverageNotBackedUpInner.js';
import { JobProgressStepBucketDataRestorationData } from '../models/JobProgressStepBucketDataRestorationData.js';
import { JobProgressStepConnectingToRestoreServerData } from '../models/JobProgressStepConnectingToRestoreServerData.js';
import { JobProgressStepCreateInstanceData } from '../models/JobProgressStepCreateInstanceData.js';
import { JobProgressStepDatabaseClusterCreationData } from '../models/JobProgressStepDatabaseClusterCreationData.js';
import { JobProgressStepDatabaseConfigurationData } from '../models/JobProgressStepDatabaseConfigurationData.js';
import { JobProgressStepDatabaseCopyCreationData } from '../models/JobProgressStepDatabaseCopyCreationData.js';
import { JobProgressStepDatabaseCreationData } from '../models/JobProgressStepDatabaseCreationData.js';
import { JobProgressStepDatabaseDataBackupData } from '../models/JobProgressStepDatabaseDataBackupData.js';
import { JobProgressStepDatabaseDataRestorationData } from '../models/JobProgressStepDatabaseDataRestorationData.js';
import { JobProgressStepGroupDirectoryRestorationData } from '../models/JobProgressStepGroupDirectoryRestorationData.js';
import { JobProgressStepGroupMessageRestorationData } from '../models/JobProgressStepGroupMessageRestorationData.js';
import { JobProgressStepIdentityRestorationData } from '../models/JobProgressStepIdentityRestorationData.js';
import { JobProgressStepNetworkInterfaceCreationData } from '../models/JobProgressStepNetworkInterfaceCreationData.js';
import { JobProgressStepRestoreVolumeData } from '../models/JobProgressStepRestoreVolumeData.js';
import { JobProgressStepRestoreWorkerData } from '../models/JobProgressStepRestoreWorkerData.js';
import { JobProgressStepScanningBucketData } from '../models/JobProgressStepScanningBucketData.js';
import { JobProgressStepScanningBucketDataTierByClassInner } from '../models/JobProgressStepScanningBucketDataTierByClassInner.js';
import { JobProgressStepSnapshotCreationData } from '../models/JobProgressStepSnapshotCreationData.js';
import { JobProgressStepSnapshotCreationDataVolumesInner } from '../models/JobProgressStepSnapshotCreationDataVolumesInner.js';
import { JobProgressStepTableConfigurationData } from '../models/JobProgressStepTableConfigurationData.js';
import { JobProgressStepTableCreationData } from '../models/JobProgressStepTableCreationData.js';
import { JobProgressStepThreatDetectionData } from '../models/JobProgressStepThreatDetectionData.js';
import { JobProgressStepUserDataRestorationData } from '../models/JobProgressStepUserDataRestorationData.js';
import { JobProgressStepUserWorkloadRestorationData } from '../models/JobProgressStepUserWorkloadRestorationData.js';
import { JobProgressStepVolumeCreationData } from '../models/JobProgressStepVolumeCreationData.js';
import { JobProgressStepVolumeDataBackupData } from '../models/JobProgressStepVolumeDataBackupData.js';
import { JobSnapshotDetails } from '../models/JobSnapshotDetails.js';
import { JobStatusFilters } from '../models/JobStatusFilters.js';
import { JobStep } from '../models/JobStep.js';
import { JobSucceededNotificationArguments } from '../models/JobSucceededNotificationArguments.js';
import { KeyspacesBackupConfig } from '../models/KeyspacesBackupConfig.js';
import { KeyspacesBackupConfigApplication } from '../models/KeyspacesBackupConfigApplication.js';
import { KeyspacesTableRestoreDestination } from '../models/KeyspacesTableRestoreDestination.js';
import { LimitData } from '../models/LimitData.js';
import { ListAccessGrantsResponse } from '../models/ListAccessGrantsResponse.js';
import { ListAccessPoliciesResponse } from '../models/ListAccessPoliciesResponse.js';
import { ListAccessibleAccountsResponse } from '../models/ListAccessibleAccountsResponse.js';
import { ListAccountsResponse } from '../models/ListAccountsResponse.js';
import { ListActionApprovalRulesResponse } from '../models/ListActionApprovalRulesResponse.js';
import { ListAiAssistantSessions502Response } from '../models/ListAiAssistantSessions502Response.js';
import { ListAllRegionsResponse } from '../models/ListAllRegionsResponse.js';
import { ListAllRegionsResponseRegions } from '../models/ListAllRegionsResponseRegions.js';
import { ListApiCredentialsResponse } from '../models/ListApiCredentialsResponse.js';
import { ListApplicationOverrideResponse } from '../models/ListApplicationOverrideResponse.js';
import { ListAtlasOrganizationsResponse } from '../models/ListAtlasOrganizationsResponse.js';
import { ListAuditLogRequest } from '../models/ListAuditLogRequest.js';
import { ListAuditLogResponse } from '../models/ListAuditLogResponse.js';
import { ListAuditLogsResponse } from '../models/ListAuditLogsResponse.js';
import { ListAwsVpcsResponse } from '../models/ListAwsVpcsResponse.js';
import { ListAwsVpcsResponseVpcsInner } from '../models/ListAwsVpcsResponseVpcsInner.js';
import { ListAzureAppRegistrationsResponse } from '../models/ListAzureAppRegistrationsResponse.js';
import { ListAzureCmkEligibleAppsResponse } from '../models/ListAzureCmkEligibleAppsResponse.js';
import { ListAzureDiskEncryptionSetsRequest } from '../models/ListAzureDiskEncryptionSetsRequest.js';
import { ListAzureDiskEncryptionSetsResponse } from '../models/ListAzureDiskEncryptionSetsResponse.js';
import { ListAzureFileShares200Response } from '../models/ListAzureFileShares200Response.js';
import { ListAzureFileShares200ResponseFileSharesInner } from '../models/ListAzureFileShares200ResponseFileSharesInner.js';
import { ListAzureFileSharesRequest } from '../models/ListAzureFileSharesRequest.js';
import { ListAzureKeyVaultKeysRequest } from '../models/ListAzureKeyVaultKeysRequest.js';
import { ListAzureKeyVaultKeysResponse } from '../models/ListAzureKeyVaultKeysResponse.js';
import { ListAzureRegions200Response } from '../models/ListAzureRegions200Response.js';
import { ListAzureSKUs200Response } from '../models/ListAzureSKUs200Response.js';
import { ListAzureSKUs200ResponseSkusInner } from '../models/ListAzureSKUs200ResponseSkusInner.js';
import { ListAzureSKUsRequest } from '../models/ListAzureSKUsRequest.js';
import { ListAzureStorageAccountContainers200Response } from '../models/ListAzureStorageAccountContainers200Response.js';
import { ListAzureStorageAccountContainersRequest } from '../models/ListAzureStorageAccountContainersRequest.js';
import { ListAzureSubnets200Response } from '../models/ListAzureSubnets200Response.js';
import { ListAzureSubnets200ResponseSubnetsInner } from '../models/ListAzureSubnets200ResponseSubnetsInner.js';
import { ListAzureSubnetsRequest } from '../models/ListAzureSubnetsRequest.js';
import { ListAzureUnassignedNetworkInterfaces200Response } from '../models/ListAzureUnassignedNetworkInterfaces200Response.js';
import { ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner } from '../models/ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner.js';
import { ListAzureUnassignedNetworkInterfacesRequest } from '../models/ListAzureUnassignedNetworkInterfacesRequest.js';
import { ListAzureVirtualNetworks200Response } from '../models/ListAzureVirtualNetworks200Response.js';
import { ListAzureVirtualNetworks200ResponseVirtualNetworksInner } from '../models/ListAzureVirtualNetworks200ResponseVirtualNetworksInner.js';
import { ListAzureVirtualNetworksRequest } from '../models/ListAzureVirtualNetworksRequest.js';
import { ListBackupJobTypesResponse } from '../models/ListBackupJobTypesResponse.js';
import { ListBackupJobsInternal200Response } from '../models/ListBackupJobsInternal200Response.js';
import { ListBackupJobsRequest } from '../models/ListBackupJobsRequest.js';
import { ListBackupJobsResponse } from '../models/ListBackupJobsResponse.js';
import { ListBackupPoliciesResponse } from '../models/ListBackupPoliciesResponse.js';
import { ListBackupPolicyResponse } from '../models/ListBackupPolicyResponse.js';
import { ListBackupPostureControlsRequest } from '../models/ListBackupPostureControlsRequest.js';
import { ListBackupPostureControlsResponse } from '../models/ListBackupPostureControlsResponse.js';
import { ListBackupVaultResponse } from '../models/ListBackupVaultResponse.js';
import { ListBackupZeroEtlPoliciesResponse } from '../models/ListBackupZeroEtlPoliciesResponse.js';
import { ListBillingTransactionHistoryRequest } from '../models/ListBillingTransactionHistoryRequest.js';
import { ListBillingTransactionHistoryResponse } from '../models/ListBillingTransactionHistoryResponse.js';
import { ListCatalogDatabasesResponse } from '../models/ListCatalogDatabasesResponse.js';
import { ListCatalogTablesResponse } from '../models/ListCatalogTablesResponse.js';
import { ListCatalogsResponse } from '../models/ListCatalogsResponse.js';
import { ListClassificationCategoriesResponse } from '../models/ListClassificationCategoriesResponse.js';
import { ListClassificationPoliciesResponse } from '../models/ListClassificationPoliciesResponse.js';
import { ListCloudSnapshotsResponse } from '../models/ListCloudSnapshotsResponse.js';
import { ListComplianceResourcesResponse } from '../models/ListComplianceResourcesResponse.js';
import { ListControlViolationsResponse } from '../models/ListControlViolationsResponse.js';
import { ListCredentialFindingsResponse } from '../models/ListCredentialFindingsResponse.js';
import { ListDailySnapshotsResponse } from '../models/ListDailySnapshotsResponse.js';
import { ListDataCatalogChildrenRequest } from '../models/ListDataCatalogChildrenRequest.js';
import { ListDataCatalogChildrenResponse } from '../models/ListDataCatalogChildrenResponse.js';
import { ListDataCatalogDatasetEventsRequest } from '../models/ListDataCatalogDatasetEventsRequest.js';
import { ListDataCatalogDatasetEventsResponse } from '../models/ListDataCatalogDatasetEventsResponse.js';
import { ListDataCatalogDatasetsFlatRequest } from '../models/ListDataCatalogDatasetsFlatRequest.js';
import { ListDataCatalogDatasetsFlatResponse } from '../models/ListDataCatalogDatasetsFlatResponse.js';
import { ListDataCatalogDatasetsRequest } from '../models/ListDataCatalogDatasetsRequest.js';
import { ListDataCatalogDatasetsResponse } from '../models/ListDataCatalogDatasetsResponse.js';
import { ListDataCatalogJoinabilityRequest } from '../models/ListDataCatalogJoinabilityRequest.js';
import { ListDataCatalogJoinabilityResponse } from '../models/ListDataCatalogJoinabilityResponse.js';
import { ListDataCatalogNamespacesRequest } from '../models/ListDataCatalogNamespacesRequest.js';
import { ListDataCatalogNamespacesResponse } from '../models/ListDataCatalogNamespacesResponse.js';
import { ListDataCatalogPipelineVersionsResponse } from '../models/ListDataCatalogPipelineVersionsResponse.js';
import { ListDataCatalogPipelinesRequest } from '../models/ListDataCatalogPipelinesRequest.js';
import { ListDataCatalogPipelinesResponse } from '../models/ListDataCatalogPipelinesResponse.js';
import { ListDataCatalogSemanticLayerRunsResponse } from '../models/ListDataCatalogSemanticLayerRunsResponse.js';
import { ListDataClassificationEntitiesResponse } from '../models/ListDataClassificationEntitiesResponse.js';
import { ListDatabaseSnapshotsResponse } from '../models/ListDatabaseSnapshotsResponse.js';
import { ListDirectoryEdgesRequest } from '../models/ListDirectoryEdgesRequest.js';
import { ListDirectoryEdgesResponse } from '../models/ListDirectoryEdgesResponse.js';
import { ListDlsgPoliciesResponse } from '../models/ListDlsgPoliciesResponse.js';
import { ListDynamoDbBackupConfigsResponse } from '../models/ListDynamoDbBackupConfigsResponse.js';
import { ListEffectivePoliciesRequest } from '../models/ListEffectivePoliciesRequest.js';
import { ListEffectivePoliciesResponse } from '../models/ListEffectivePoliciesResponse.js';
import { ListEffectiveTagsRequest } from '../models/ListEffectiveTagsRequest.js';
import { ListEffectiveTagsResponse } from '../models/ListEffectiveTagsResponse.js';
import { ListEksClustersResponse } from '../models/ListEksClustersResponse.js';
import { ListExclusionPatternResourcesResponse } from '../models/ListExclusionPatternResourcesResponse.js';
import { ListFindingExclusionsRequest } from '../models/ListFindingExclusionsRequest.js';
import { ListFindingExclusionsResponse } from '../models/ListFindingExclusionsResponse.js';
import { ListFindingsResponse } from '../models/ListFindingsResponse.js';
import { ListGcpFoldersResponse } from '../models/ListGcpFoldersResponse.js';
import { ListGcpNetworksResponse } from '../models/ListGcpNetworksResponse.js';
import { ListGcpNetworksResponseNetworksInner } from '../models/ListGcpNetworksResponseNetworksInner.js';
import { ListGcpOrganizationsResponse } from '../models/ListGcpOrganizationsResponse.js';
import { ListGcpSubnetsResponse } from '../models/ListGcpSubnetsResponse.js';
import { ListGdsgEnvironmentsResponse } from '../models/ListGdsgEnvironmentsResponse.js';
import { ListGdsgInventoryReportConfigurationsResponse } from '../models/ListGdsgInventoryReportConfigurationsResponse.js';
import { ListGdsgInventoryReportRunsResponse } from '../models/ListGdsgInventoryReportRunsResponse.js';
import { ListGdsgObjectsResponse } from '../models/ListGdsgObjectsResponse.js';
import { ListGoogleWorkspaceGroups200Response } from '../models/ListGoogleWorkspaceGroups200Response.js';
import { ListGoogleWorkspaceGroupsRequest } from '../models/ListGoogleWorkspaceGroupsRequest.js';
import { ListGoogleWorkspaceOrgUnits200Response } from '../models/ListGoogleWorkspaceOrgUnits200Response.js';
import { ListGoogleWorkspaceOrgUnitsRequest } from '../models/ListGoogleWorkspaceOrgUnitsRequest.js';
import { ListGoogleWorkspacesWithPolicyStatusResponse } from '../models/ListGoogleWorkspacesWithPolicyStatusResponse.js';
import { ListGrantedOrganizationGroupAccessResponse } from '../models/ListGrantedOrganizationGroupAccessResponse.js';
import { ListGroupConversationsRequest } from '../models/ListGroupConversationsRequest.js';
import { ListIdpGroupsResponse } from '../models/ListIdpGroupsResponse.js';
import { ListIdpsResponse } from '../models/ListIdpsResponse.js';
import { ListInfectedSnapshotsResponse } from '../models/ListInfectedSnapshotsResponse.js';
import { ListInitiatorsResponse } from '../models/ListInitiatorsResponse.js';
import { ListInstanceProfilesResponse } from '../models/ListInstanceProfilesResponse.js';
import { ListInstanceTypesResponse } from '../models/ListInstanceTypesResponse.js';
import { ListIntegrationsResponse } from '../models/ListIntegrationsResponse.js';
import { ListInventoryAppsResponse } from '../models/ListInventoryAppsResponse.js';
import { ListInventoryBackupRegionsResponse } from '../models/ListInventoryBackupRegionsResponse.js';
import { ListInventoryClassificationEntitiesResponse } from '../models/ListInventoryClassificationEntitiesResponse.js';
import { ListInventoryEnvironmentsResponse } from '../models/ListInventoryEnvironmentsResponse.js';
import { ListInventoryGlobalDatabasesResponse } from '../models/ListInventoryGlobalDatabasesResponse.js';
import { ListInventoryItemSnapshotsResponse } from '../models/ListInventoryItemSnapshotsResponse.js';
import { ListInventoryNetworksResponse } from '../models/ListInventoryNetworksResponse.js';
import { ListInventoryRequest } from '../models/ListInventoryRequest.js';
import { ListInventoryResourceGroupsResponse } from '../models/ListInventoryResourceGroupsResponse.js';
import { ListInventoryResourceIdentifiersResponse } from '../models/ListInventoryResourceIdentifiersResponse.js';
import { ListInventoryResourceTypesResponse } from '../models/ListInventoryResourceTypesResponse.js';
import { ListInventoryResourcesResponse } from '../models/ListInventoryResourcesResponse.js';
import { ListInventorySensitivityAnnotationValuesResponse } from '../models/ListInventorySensitivityAnnotationValuesResponse.js';
import { ListInventorySnapshotsRequest } from '../models/ListInventorySnapshotsRequest.js';
import { ListInventorySnapshotsResponse } from '../models/ListInventorySnapshotsResponse.js';
import { ListInventorySourceRegionsResponse } from '../models/ListInventorySourceRegionsResponse.js';
import { ListInventorySubnetsResponse } from '../models/ListInventorySubnetsResponse.js';
import { ListInventoryTagsResponse } from '../models/ListInventoryTagsResponse.js';
import { ListJobErrorCodesResponse } from '../models/ListJobErrorCodesResponse.js';
import { ListKeyspacesBackupConfigsResponse } from '../models/ListKeyspacesBackupConfigsResponse.js';
import { ListKnownAppsResponse } from '../models/ListKnownAppsResponse.js';
import { ListLogSourcesPoliciesResponse } from '../models/ListLogSourcesPoliciesResponse.js';
import { ListLogSourcesResponse } from '../models/ListLogSourcesResponse.js';
import { ListMPAOperationsResponse } from '../models/ListMPAOperationsResponse.js';
import { ListMPARequestsRequest } from '../models/ListMPARequestsRequest.js';
import { ListMPARequestsRequestFilters } from '../models/ListMPARequestsRequestFilters.js';
import { ListMPARequestsResponse } from '../models/ListMPARequestsResponse.js';
import { ListMPARequestsSort } from '../models/ListMPARequestsSort.js';
import { ListMappableRolesRequest } from '../models/ListMappableRolesRequest.js';
import { ListMappableRolesResponse } from '../models/ListMappableRolesResponse.js';
import { ListMicrosoft365GroupMembers200Response } from '../models/ListMicrosoft365GroupMembers200Response.js';
import { ListMicrosoft365GroupMembersRequest } from '../models/ListMicrosoft365GroupMembersRequest.js';
import { ListMicrosoft365GroupMembersSort } from '../models/ListMicrosoft365GroupMembersSort.js';
import { ListMicrosoft365Groups200Response } from '../models/ListMicrosoft365Groups200Response.js';
import { ListMicrosoft365GroupsRequest } from '../models/ListMicrosoft365GroupsRequest.js';
import { ListMicrosoft365SharePointSites200Response } from '../models/ListMicrosoft365SharePointSites200Response.js';
import { ListMicrosoft365SharePointSitesRequest } from '../models/ListMicrosoft365SharePointSitesRequest.js';
import { ListMicrosoft365Users200Response } from '../models/ListMicrosoft365Users200Response.js';
import { ListMicrosoft365UsersRequest } from '../models/ListMicrosoft365UsersRequest.js';
import { ListMongoAtlasPrivateLinks200Response } from '../models/ListMongoAtlasPrivateLinks200Response.js';
import { ListMongoDbBackupConfigsResponse } from '../models/ListMongoDbBackupConfigsResponse.js';
import { ListMyMPARequestsRequest } from '../models/ListMyMPARequestsRequest.js';
import { ListMyMPARequestsRequestFilters } from '../models/ListMyMPARequestsRequestFilters.js';
import { ListMyMPARequestsResponse } from '../models/ListMyMPARequestsResponse.js';
import { ListNotificationPoliciesResponse } from '../models/ListNotificationPoliciesResponse.js';
import { ListNotificationsResponse } from '../models/ListNotificationsResponse.js';
import { ListOAuthAppsResponse } from '../models/ListOAuthAppsResponse.js';
import { ListObjectStoreExclusionRulesResponse } from '../models/ListObjectStoreExclusionRulesResponse.js';
import { ListOrganizationAccountsResponse } from '../models/ListOrganizationAccountsResponse.js';
import { ListOrganizationIdpGroupsRequest } from '../models/ListOrganizationIdpGroupsRequest.js';
import { ListOrganizationIdpGroupsResponse } from '../models/ListOrganizationIdpGroupsResponse.js';
import { ListOrganizationIdpsResponse } from '../models/ListOrganizationIdpsResponse.js';
import { ListOrganizationUsersResponse } from '../models/ListOrganizationUsersResponse.js';
import { ListPermissionsResponse } from '../models/ListPermissionsResponse.js';
import { ListProjectsResponse } from '../models/ListProjectsResponse.js';
import { ListQueryExecutionsRequest } from '../models/ListQueryExecutionsRequest.js';
import { ListQueryExecutionsRequestFilters } from '../models/ListQueryExecutionsRequestFilters.js';
import { ListQueryExecutionsRequestFiltersCreatedAt } from '../models/ListQueryExecutionsRequestFiltersCreatedAt.js';
import { ListQueryExecutionsRequestFiltersId } from '../models/ListQueryExecutionsRequestFiltersId.js';
import { ListQueryExecutionsRequestFiltersStatus } from '../models/ListQueryExecutionsRequestFiltersStatus.js';
import { ListQueryExecutionsRequestSortsInner } from '../models/ListQueryExecutionsRequestSortsInner.js';
import { ListQueryExecutionsResponse } from '../models/ListQueryExecutionsResponse.js';
import { ListResourceAttachmentEventsResponse } from '../models/ListResourceAttachmentEventsResponse.js';
import { ListResourcesResponse } from '../models/ListResourcesResponse.js';
import { ListRestoreAccountsRequest } from '../models/ListRestoreAccountsRequest.js';
import { ListRestoreAccountsResponse } from '../models/ListRestoreAccountsResponse.js';
import { ListRestoreAwsOrganizationalUnitsResponse } from '../models/ListRestoreAwsOrganizationalUnitsResponse.js';
import { ListRestoreJobTypesResponse } from '../models/ListRestoreJobTypesResponse.js';
import { ListRestoreJobsInternal200Response } from '../models/ListRestoreJobsInternal200Response.js';
import { ListRestoreJobsRequest } from '../models/ListRestoreJobsRequest.js';
import { ListRestoreJobsResponse } from '../models/ListRestoreJobsResponse.js';
import { ListRestoreTemplatesRequest } from '../models/ListRestoreTemplatesRequest.js';
import { ListRestoreTemplatesResponse } from '../models/ListRestoreTemplatesResponse.js';
import { ListRestoreTemplatesResponsePagination } from '../models/ListRestoreTemplatesResponsePagination.js';
import { ListRolesResponse } from '../models/ListRolesResponse.js';
import { ListSaasEntitiesRequest } from '../models/ListSaasEntitiesRequest.js';
import { ListSaasEntitiesRequestFilters } from '../models/ListSaasEntitiesRequestFilters.js';
import { ListSaasEntitiesResponse } from '../models/ListSaasEntitiesResponse.js';
import { ListSaasEntitySnapshotsResponse } from '../models/ListSaasEntitySnapshotsResponse.js';
import { ListScanJobTypesResponse } from '../models/ListScanJobTypesResponse.js';
import { ListScanJobsInternal200Response } from '../models/ListScanJobsInternal200Response.js';
import { ListScanJobsRequest } from '../models/ListScanJobsRequest.js';
import { ListScanJobsResponse } from '../models/ListScanJobsResponse.js';
import { ListSecurityFindingsRequest } from '../models/ListSecurityFindingsRequest.js';
import { ListSensitivityAnnotationsResponse } from '../models/ListSensitivityAnnotationsResponse.js';
import { ListSnapshotRecipeEntriesRequest } from '../models/ListSnapshotRecipeEntriesRequest.js';
import { ListSnapshotRecipeEntriesResponse } from '../models/ListSnapshotRecipeEntriesResponse.js';
import { ListSnapshotRecipesResponse } from '../models/ListSnapshotRecipesResponse.js';
import { ListSourceAccountsRequest } from '../models/ListSourceAccountsRequest.js';
import { ListSourceAccountsResponse } from '../models/ListSourceAccountsResponse.js';
import { ListSourceAwsOrganizationalUnitsResponse } from '../models/ListSourceAwsOrganizationalUnitsResponse.js';
import { ListStagingBucketsResponse } from '../models/ListStagingBucketsResponse.js';
import { ListStorageGatewaysResponse } from '../models/ListStorageGatewaysResponse.js';
import { ListSubnetsResponse } from '../models/ListSubnetsResponse.js';
import { ListSubnetsResponseV2 } from '../models/ListSubnetsResponseV2.js';
import { ListSubnetsResponseV2SubnetsInner } from '../models/ListSubnetsResponseV2SubnetsInner.js';
import { ListTagDefinitionsResponse } from '../models/ListTagDefinitionsResponse.js';
import { ListTestResourceSnapshots200Response } from '../models/ListTestResourceSnapshots200Response.js';
import { ListTestResourceSnapshots200ResponseSnapshotsInner } from '../models/ListTestResourceSnapshots200ResponseSnapshotsInner.js';
import { ListThreatHuntingResultsRequest } from '../models/ListThreatHuntingResultsRequest.js';
import { ListThreatHuntingResultsResponse } from '../models/ListThreatHuntingResultsResponse.js';
import { ListThreatHuntingScanRequestsRequest } from '../models/ListThreatHuntingScanRequestsRequest.js';
import { ListThreatHuntingScanRequestsResponse } from '../models/ListThreatHuntingScanRequestsResponse.js';
import { ListUsersResponse } from '../models/ListUsersResponse.js';
import { ListVaultBlockedRegionsResponse } from '../models/ListVaultBlockedRegionsResponse.js';
import { ListVaultsRequest } from '../models/ListVaultsRequest.js';
import { ListZeroEtlJobSyncsRequest } from '../models/ListZeroEtlJobSyncsRequest.js';
import { ListZeroEtlJobSyncsResponse } from '../models/ListZeroEtlJobSyncsResponse.js';
import { ListZeroEtlJobsRequest } from '../models/ListZeroEtlJobsRequest.js';
import { ListZeroEtlJobsResponse } from '../models/ListZeroEtlJobsResponse.js';
import { ListZeroEtlTargetTablesRequest } from '../models/ListZeroEtlTargetTablesRequest.js';
import { ListZeroEtlTargetTablesResponse } from '../models/ListZeroEtlTargetTablesResponse.js';
import { LlgLocationResource } from '../models/LlgLocationResource.js';
import { LlgLocationWithResources } from '../models/LlgLocationWithResources.js';
import { LlgResourcePolicy } from '../models/LlgResourcePolicy.js';
import { LogRecord } from '../models/LogRecord.js';
import { LogSource } from '../models/LogSource.js';
import { LogSourceLocation } from '../models/LogSourceLocation.js';
import { LogSourceLocationCloudTrail } from '../models/LogSourceLocationCloudTrail.js';
import { LogSourceLocationCloudWatchLogs } from '../models/LogSourceLocationCloudWatchLogs.js';
import { LogSourceLocationDatadog } from '../models/LogSourceLocationDatadog.js';
import { LogSourceLocationGcpCloudLogging } from '../models/LogSourceLocationGcpCloudLogging.js';
import { LogSourceLocationSplunkDdss } from '../models/LogSourceLocationSplunkDdss.js';
import { LogSourceWithPolicy } from '../models/LogSourceWithPolicy.js';
import { LogsHistogramDataPoint } from '../models/LogsHistogramDataPoint.js';
import { LogsSchema } from '../models/LogsSchema.js';
import { LogsSchemaColumn } from '../models/LogsSchemaColumn.js';
import { LogsSchemaEntry } from '../models/LogsSchemaEntry.js';
import { LogsSchemasResponse } from '../models/LogsSchemasResponse.js';
import { LuceneQueryInput } from '../models/LuceneQueryInput.js';
import { MPAInterceptedResponse } from '../models/MPAInterceptedResponse.js';
import { MPAOperationInfo } from '../models/MPAOperationInfo.js';
import { MPAPoliciesInfo } from '../models/MPAPoliciesInfo.js';
import { MPAPrincipal } from '../models/MPAPrincipal.js';
import { MPARequest } from '../models/MPARequest.js';
import { MPARequestDetail } from '../models/MPARequestDetail.js';
import { MPARequestNotificationArguments } from '../models/MPARequestNotificationArguments.js';
import { MPARequestPolicyDetail } from '../models/MPARequestPolicyDetail.js';
import { MPAReview } from '../models/MPAReview.js';
import { MPAReviewNotificationArguments } from '../models/MPAReviewNotificationArguments.js';
import { MaxRetentionDaysLimit } from '../models/MaxRetentionDaysLimit.js';
import { MaxRetentionRule } from '../models/MaxRetentionRule.js';
import { Message } from '../models/Message.js';
import { Microsoft365BackupScope } from '../models/Microsoft365BackupScope.js';
import { Microsoft365ConnectionInfo } from '../models/Microsoft365ConnectionInfo.js';
import { Microsoft365EntityFilters } from '../models/Microsoft365EntityFilters.js';
import { Microsoft365EntitySelection } from '../models/Microsoft365EntitySelection.js';
import { Microsoft365FilterSelectionRef } from '../models/Microsoft365FilterSelectionRef.js';
import { Microsoft365Group } from '../models/Microsoft365Group.js';
import { Microsoft365Permission } from '../models/Microsoft365Permission.js';
import { Microsoft365PolicyConfig } from '../models/Microsoft365PolicyConfig.js';
import { Microsoft365Resource } from '../models/Microsoft365Resource.js';
import { Microsoft365RestoreAccountAttributes } from '../models/Microsoft365RestoreAccountAttributes.js';
import { Microsoft365RestoreAccountAttributesInput } from '../models/Microsoft365RestoreAccountAttributesInput.js';
import { Microsoft365SharePointSite } from '../models/Microsoft365SharePointSite.js';
import { Microsoft365SharePointSiteSelectedItemsOptions } from '../models/Microsoft365SharePointSiteSelectedItemsOptions.js';
import { Microsoft365SourceAccountAttributesInput } from '../models/Microsoft365SourceAccountAttributesInput.js';
import { Microsoft365TeamSelectedItemsOptions } from '../models/Microsoft365TeamSelectedItemsOptions.js';
import { Microsoft365TeamsRestoreDestination } from '../models/Microsoft365TeamsRestoreDestination.js';
import { Microsoft365User } from '../models/Microsoft365User.js';
import { Microsoft365UserChatsSelectedItemsOptions } from '../models/Microsoft365UserChatsSelectedItemsOptions.js';
import { Microsoft365UserDriveSelectedItemsOptions } from '../models/Microsoft365UserDriveSelectedItemsOptions.js';
import { Microsoft365UserExclusions } from '../models/Microsoft365UserExclusions.js';
import { Microsoft365UserMailSelectedItemsOptions } from '../models/Microsoft365UserMailSelectedItemsOptions.js';
import { Microsoft365UserRestoreData } from '../models/Microsoft365UserRestoreData.js';
import { Microsoft365UserRestoreSelection } from '../models/Microsoft365UserRestoreSelection.js';
import { Microsoft365UserRestoreWorkload } from '../models/Microsoft365UserRestoreWorkload.js';
import { Microsoft365WholeUserRestore } from '../models/Microsoft365WholeUserRestore.js';
import { MicrosoftFabricIntegrationConfig } from '../models/MicrosoftFabricIntegrationConfig.js';
import { MinRetentionRule } from '../models/MinRetentionRule.js';
import { ModelError } from '../models/ModelError.js';
import { MongoAtlasClusterResource } from '../models/MongoAtlasClusterResource.js';
import { MongoAtlasOidc } from '../models/MongoAtlasOidc.js';
import { MongoAtlasPrivateLinkEntry } from '../models/MongoAtlasPrivateLinkEntry.js';
import { MongoAtlasRegionPlacement } from '../models/MongoAtlasRegionPlacement.js';
import { MongoAtlasRequiredPrivateLink } from '../models/MongoAtlasRequiredPrivateLink.js';
import { MongoAtlasRestoreAccountAttributes } from '../models/MongoAtlasRestoreAccountAttributes.js';
import { MongoAtlasRestoreAccountAttributesInput } from '../models/MongoAtlasRestoreAccountAttributesInput.js';
import { MongoAtlasRestoreDestination } from '../models/MongoAtlasRestoreDestination.js';
import { MongoAtlasSourceAccountAttributes } from '../models/MongoAtlasSourceAccountAttributes.js';
import { MongoAtlasSourceAccountAttributesInput } from '../models/MongoAtlasSourceAccountAttributesInput.js';
import { MongoDbBackupConfig } from '../models/MongoDbBackupConfig.js';
import { MonthlyConfig } from '../models/MonthlyConfig.js';
import { MonthlySnapshotData } from '../models/MonthlySnapshotData.js';
import { MsaAcceptanceResponse } from '../models/MsaAcceptanceResponse.js';
import { MultiResourceBackupZeroEtlConfiguration } from '../models/MultiResourceBackupZeroEtlConfiguration.js';
import { NativePasswordAccounts } from '../models/NativePasswordAccounts.js';
import { NativeStandardConfig } from '../models/NativeStandardConfig.js';
import { NeptuneClusterParameterGroup } from '../models/NeptuneClusterParameterGroup.js';
import { NeptuneClusterParameterGroups } from '../models/NeptuneClusterParameterGroups.js';
import { NeptuneRestoreDestination } from '../models/NeptuneRestoreDestination.js';
import { NeptuneSnapshotProperties } from '../models/NeptuneSnapshotProperties.js';
import { NetworkClassificationCondition } from '../models/NetworkClassificationCondition.js';
import { NetworkClassificationDetails } from '../models/NetworkClassificationDetails.js';
import { NetworkClassificationFilters } from '../models/NetworkClassificationFilters.js';
import { NetworkInterfaceConfig } from '../models/NetworkInterfaceConfig.js';
import { Notification } from '../models/Notification.js';
import { NotificationArguments } from '../models/NotificationArguments.js';
import { NotificationPolicy } from '../models/NotificationPolicy.js';
import { NotificationPolicyConfig } from '../models/NotificationPolicyConfig.js';
import { NotificationPolicyConfigDatadog } from '../models/NotificationPolicyConfigDatadog.js';
import { NotificationPolicyConfigEmail } from '../models/NotificationPolicyConfigEmail.js';
import { NotificationPolicyConfigServiceNow } from '../models/NotificationPolicyConfigServiceNow.js';
import { NotificationPolicyConfigSlack } from '../models/NotificationPolicyConfigSlack.js';
import { NotificationPolicyConfigSns } from '../models/NotificationPolicyConfigSns.js';
import { NotificationPolicyConfigSplunk } from '../models/NotificationPolicyConfigSplunk.js';
import { NotificationPolicyConfigWebhook } from '../models/NotificationPolicyConfigWebhook.js';
import { NumberOfCopiesRule } from '../models/NumberOfCopiesRule.js';
import { OAuthApp } from '../models/OAuthApp.js';
import { Oauth2TokenResponse } from '../models/Oauth2TokenResponse.js';
import { ObjectStorageDestination } from '../models/ObjectStorageDestination.js';
import { ObjectStoreCoverageBreakdown } from '../models/ObjectStoreCoverageBreakdown.js';
import { ObjectStoreCoverageReasonEntry } from '../models/ObjectStoreCoverageReasonEntry.js';
import { ObjectStoreExclusionRule } from '../models/ObjectStoreExclusionRule.js';
import { ObjectStoreScanMethod } from '../models/ObjectStoreScanMethod.js';
import { ObjectStoreScanMethodSetting } from '../models/ObjectStoreScanMethodSetting.js';
import { ObjectStoreTierClass } from '../models/ObjectStoreTierClass.js';
import { OnboardAdditionalAzureApps200Response } from '../models/OnboardAdditionalAzureApps200Response.js';
import { OnboardAdditionalAzureAppsRequest } from '../models/OnboardAdditionalAzureAppsRequest.js';
import { OnboardRdsCdcRequest } from '../models/OnboardRdsCdcRequest.js';
import { OnboardRdsCdcResponse } from '../models/OnboardRdsCdcResponse.js';
import { OnboardingAzureResourceGroup } from '../models/OnboardingAzureResourceGroup.js';
import { OperatingSystem } from '../models/OperatingSystem.js';
import { OperationIdFilters } from '../models/OperationIdFilters.js';
import { OrgCostDataFilters } from '../models/OrgCostDataFilters.js';
import { OrgSaasAccountCost } from '../models/OrgSaasAccountCost.js';
import { OrganizationAccount } from '../models/OrganizationAccount.js';
import { OrganizationGroupAccess } from '../models/OrganizationGroupAccess.js';
import { OrganizationIdp } from '../models/OrganizationIdp.js';
import { OrganizationIdpGroup } from '../models/OrganizationIdpGroup.js';
import { OrganizationRoleGrant } from '../models/OrganizationRoleGrant.js';
import { OrganizationSamlServiceProviderDetails } from '../models/OrganizationSamlServiceProviderDetails.js';
import { OrganizationUser } from '../models/OrganizationUser.js';
import { OrganizationUserRole } from '../models/OrganizationUserRole.js';
import { OverrideDataClassificationsRequest } from '../models/OverrideDataClassificationsRequest.js';
import { OverrideDataClassificationsResponse } from '../models/OverrideDataClassificationsResponse.js';
import { OverrideEnvironmentRequest } from '../models/OverrideEnvironmentRequest.js';
import { OverrideEnvironmentResponse } from '../models/OverrideEnvironmentResponse.js';
import { OverrideNetworkClassificationRequest } from '../models/OverrideNetworkClassificationRequest.js';
import { OverrideNetworkClassificationResponse } from '../models/OverrideNetworkClassificationResponse.js';
import { OverrideSensitivityAnnotationsRequest } from '../models/OverrideSensitivityAnnotationsRequest.js';
import { Pagination } from '../models/Pagination.js';
import { ParameterCheckResult } from '../models/ParameterCheckResult.js';
import { ParentIdFilters } from '../models/ParentIdFilters.js';
import { PartialRestoreData } from '../models/PartialRestoreData.js';
import { Path } from '../models/Path.js';
import { PathSnapshotsRequest } from '../models/PathSnapshotsRequest.js';
import { PathSnapshotsResponse } from '../models/PathSnapshotsResponse.js';
import { Permission } from '../models/Permission.js';
import { PermissionGrant } from '../models/PermissionGrant.js';
import { PermissionGrantInput } from '../models/PermissionGrantInput.js';
import { PersistentVolumeClaimProperties } from '../models/PersistentVolumeClaimProperties.js';
import { PitrBackupPolicyPlan } from '../models/PitrBackupPolicyPlan.js';
import { PitrBackupResourceType } from '../models/PitrBackupResourceType.js';
import { PitrBackupSchedules } from '../models/PitrBackupSchedules.js';
import { PitrIntervalConfig } from '../models/PitrIntervalConfig.js';
import { PitrRestoreVaultWindows } from '../models/PitrRestoreVaultWindows.js';
import { PitrRestoreWindow } from '../models/PitrRestoreWindow.js';
import { PitrRestoreWindowsResponse } from '../models/PitrRestoreWindowsResponse.js';
import { Preferences } from '../models/Preferences.js';
import { PreviewBackupPolicyResourcesRequest } from '../models/PreviewBackupPolicyResourcesRequest.js';
import { PreviewBackupPolicyResourcesResponse } from '../models/PreviewBackupPolicyResourcesResponse.js';
import { PrivateLinkCheckResult } from '../models/PrivateLinkCheckResult.js';
import { PrivateLinkFormatInstructions } from '../models/PrivateLinkFormatInstructions.js';
import { PrivateLinkInstructionStep } from '../models/PrivateLinkInstructionStep.js';
import { Project } from '../models/Project.js';
import { ProjectIdFilters } from '../models/ProjectIdFilters.js';
import { ProviderAccountIdFilters } from '../models/ProviderAccountIdFilters.js';
import { ProviderCategoryFilters } from '../models/ProviderCategoryFilters.js';
import { ProviderParentIdFilters } from '../models/ProviderParentIdFilters.js';
import { ProviderRestoreAccountConnectivityConfig } from '../models/ProviderRestoreAccountConnectivityConfig.js';
import { PulumiConfiguration } from '../models/PulumiConfiguration.js';
import { PulumiConfigurations } from '../models/PulumiConfigurations.js';
import { PulumiConfigurationsFilterConditions } from '../models/PulumiConfigurationsFilterConditions.js';
import { PulumiConfigurationsRequest } from '../models/PulumiConfigurationsRequest.js';
import { PutDashboardRequest } from '../models/PutDashboardRequest.js';
import { PutDataCatalogExternalContextDocumentRequest } from '../models/PutDataCatalogExternalContextDocumentRequest.js';
import { PutDataCatalogExternalContextDocumentResponse } from '../models/PutDataCatalogExternalContextDocumentResponse.js';
import { QueryCostDataRequest } from '../models/QueryCostDataRequest.js';
import { QueryCostDataResponse } from '../models/QueryCostDataResponse.js';
import { QueryDBRequest } from '../models/QueryDBRequest.js';
import { QueryDBResponse } from '../models/QueryDBResponse.js';
import { QueryDBRestoreDestination } from '../models/QueryDBRestoreDestination.js';
import { QueryDBResultResponse } from '../models/QueryDBResultResponse.js';
import { QueryDBStatusResponse } from '../models/QueryDBStatusResponse.js';
import { QueryExecution } from '../models/QueryExecution.js';
import { QueryExecutionResultColumn } from '../models/QueryExecutionResultColumn.js';
import { QueryOrganizationCostData400Response } from '../models/QueryOrganizationCostData400Response.js';
import { QueryOrganizationCostDataRequest } from '../models/QueryOrganizationCostDataRequest.js';
import { QueryOrganizationCostDataResponse } from '../models/QueryOrganizationCostDataResponse.js';
import { QuotaStatusFilters } from '../models/QuotaStatusFilters.js';
import { RamShareCheckResult } from '../models/RamShareCheckResult.js';
import { RansomwareResourceNotificationArguments } from '../models/RansomwareResourceNotificationArguments.js';
import { RdsNativePitrAdvancedConfig } from '../models/RdsNativePitrAdvancedConfig.js';
import { RdsNativePitrClusterAdvancedConfig } from '../models/RdsNativePitrClusterAdvancedConfig.js';
import { RdsNativePitrNetworkConfig } from '../models/RdsNativePitrNetworkConfig.js';
import { RdsNativePitrWindow } from '../models/RdsNativePitrWindow.js';
import { RdsPasswordConfig } from '../models/RdsPasswordConfig.js';
import { RdsSecurityGroup } from '../models/RdsSecurityGroup.js';
import { ReactivateAccountRequest } from '../models/ReactivateAccountRequest.js';
import { ReassessActionRequiredRequest } from '../models/ReassessActionRequiredRequest.js';
import { ReassessActionRequiredResponse } from '../models/ReassessActionRequiredResponse.js';
import { ReconnectCustomerVaultAccountResponse } from '../models/ReconnectCustomerVaultAccountResponse.js';
import { ReconnectRestoreAccountResponse } from '../models/ReconnectRestoreAccountResponse.js';
import { ReconnectRestoreAwsOrganizationalUnitResponse } from '../models/ReconnectRestoreAwsOrganizationalUnitResponse.js';
import { ReconnectSourceAccountResponse } from '../models/ReconnectSourceAccountResponse.js';
import { ReconnectSourceAwsOrganizationalUnitResponse } from '../models/ReconnectSourceAwsOrganizationalUnitResponse.js';
import { RecordRestoreResult } from '../models/RecordRestoreResult.js';
import { RecoveryPointData } from '../models/RecoveryPointData.js';
import { RegionCondition } from '../models/RegionCondition.js';
import { RegisterInput } from '../models/RegisterInput.js';
import { RegisterInputBillingToken } from '../models/RegisterInputBillingToken.js';
import { RegisterResponse } from '../models/RegisterResponse.js';
import { RelatedGlobalDbCluster } from '../models/RelatedGlobalDbCluster.js';
import { RequestDetails } from '../models/RequestDetails.js';
import { ResourceBackupSettings } from '../models/ResourceBackupSettings.js';
import { ResourceBlockerDetail } from '../models/ResourceBlockerDetail.js';
import { ResourceComplianceRow } from '../models/ResourceComplianceRow.js';
import { ResourceDetails } from '../models/ResourceDetails.js';
import { ResourceGroupNameCondition } from '../models/ResourceGroupNameCondition.js';
import { ResourceGroupNameFilters } from '../models/ResourceGroupNameFilters.js';
import { ResourceIdCondition } from '../models/ResourceIdCondition.js';
import { ResourceIdFilters } from '../models/ResourceIdFilters.js';
import { ResourceIdentifiers } from '../models/ResourceIdentifiers.js';
import { ResourceNameCondition } from '../models/ResourceNameCondition.js';
import { ResourceNameFilters } from '../models/ResourceNameFilters.js';
import { ResourceProperties } from '../models/ResourceProperties.js';
import { ResourceQuota } from '../models/ResourceQuota.js';
import { ResourceReference } from '../models/ResourceReference.js';
import { ResourceSnapshot } from '../models/ResourceSnapshot.js';
import { ResourceSnapshotProperties } from '../models/ResourceSnapshotProperties.js';
import { ResourceTag } from '../models/ResourceTag.js';
import { ResourceTypeCondition } from '../models/ResourceTypeCondition.js';
import { ResourceTypeFilters } from '../models/ResourceTypeFilters.js';
import { ResourceTypeToSecurityGroup } from '../models/ResourceTypeToSecurityGroup.js';
import { ResourceValidationError } from '../models/ResourceValidationError.js';
import { RestoreAccount } from '../models/RestoreAccount.js';
import { RestoreAccountAttributesInput } from '../models/RestoreAccountAttributesInput.js';
import { RestoreAccountCloudAttributes } from '../models/RestoreAccountCloudAttributes.js';
import { RestoreAccountConnectivityConfig } from '../models/RestoreAccountConnectivityConfig.js';
import { RestoreAccountMetricsConfig } from '../models/RestoreAccountMetricsConfig.js';
import { RestoreAccountRegions } from '../models/RestoreAccountRegions.js';
import { RestoreAccountsFilterConditions } from '../models/RestoreAccountsFilterConditions.js';
import { RestoreAtlasClusterInput } from '../models/RestoreAtlasClusterInput.js';
import { RestoreAvailabilityZones } from '../models/RestoreAvailabilityZones.js';
import { RestoreAwsCassandraClusterRequest } from '../models/RestoreAwsCassandraClusterRequest.js';
import { RestoreAwsEc2InstanceRequest } from '../models/RestoreAwsEc2InstanceRequest.js';
import { RestoreAwsOpenSearchDomainRequest } from '../models/RestoreAwsOpenSearchDomainRequest.js';
import { RestoreAwsOrganizationalUnit } from '../models/RestoreAwsOrganizationalUnit.js';
import { RestoreAzureDiskConfig } from '../models/RestoreAzureDiskConfig.js';
import { RestoreAzureDiskRequest } from '../models/RestoreAzureDiskRequest.js';
import { RestoreAzureEntraIdRequest } from '../models/RestoreAzureEntraIdRequest.js';
import { RestoreAzureFileShareRequest } from '../models/RestoreAzureFileShareRequest.js';
import { RestoreAzureInstanceDiskInput } from '../models/RestoreAzureInstanceDiskInput.js';
import { RestoreAzurePostgresDatabaseRequest } from '../models/RestoreAzurePostgresDatabaseRequest.js';
import { RestoreAzureSqlDatabaseNativePitrRequest } from '../models/RestoreAzureSqlDatabaseNativePitrRequest.js';
import { RestoreAzureSqlDatabaseRequest } from '../models/RestoreAzureSqlDatabaseRequest.js';
import { RestoreAzureSqlVmPitrRequest } from '../models/RestoreAzureSqlVmPitrRequest.js';
import { RestoreAzureVMInstanceConfig } from '../models/RestoreAzureVMInstanceConfig.js';
import { RestoreAzureVmInstanceRequest } from '../models/RestoreAzureVmInstanceRequest.js';
import { RestoreAzureVmNativeRequest } from '../models/RestoreAzureVmNativeRequest.js';
import { RestoreBigQueryDatasetRequest } from '../models/RestoreBigQueryDatasetRequest.js';
import { RestoreBigQueryNativePitrRequest } from '../models/RestoreBigQueryNativePitrRequest.js';
import { RestoreBucketRequest } from '../models/RestoreBucketRequest.js';
import { RestoreDbToRdsInstanceRequest } from '../models/RestoreDbToRdsInstanceRequest.js';
import { RestoreDbToRdsSnapshotRequest } from '../models/RestoreDbToRdsSnapshotRequest.js';
import { RestoreDestinationLimits } from '../models/RestoreDestinationLimits.js';
import { RestoreDestinationTagLimits } from '../models/RestoreDestinationTagLimits.js';
import { RestoreDocumentDBRequest } from '../models/RestoreDocumentDBRequest.js';
import { RestoreDynamoDBTableRequest } from '../models/RestoreDynamoDBTableRequest.js';
import { RestoreDynamoDBToExistingTableRequest } from '../models/RestoreDynamoDBToExistingTableRequest.js';
import { RestoreDynamoDBToS3Request } from '../models/RestoreDynamoDBToS3Request.js';
import { RestoreDynamoDbTableConfig } from '../models/RestoreDynamoDbTableConfig.js';
import { RestoreEFSRequest } from '../models/RestoreEFSRequest.js';
import { RestoreEbsVolumeConfig } from '../models/RestoreEbsVolumeConfig.js';
import { RestoreEc2InstanceConfig } from '../models/RestoreEc2InstanceConfig.js';
import { RestoreEksClusterRequest } from '../models/RestoreEksClusterRequest.js';
import { RestoreEksNamespaceConfig } from '../models/RestoreEksNamespaceConfig.js';
import { RestoreEksNamespaceInput } from '../models/RestoreEksNamespaceInput.js';
import { RestoreEksNamespaceVolumeInput } from '../models/RestoreEksNamespaceVolumeInput.js';
import { RestoreEntraIdWithMicrosoft365Request } from '../models/RestoreEntraIdWithMicrosoft365Request.js';
import { RestoreFSxRequest } from '../models/RestoreFSxRequest.js';
import { RestoreFilesRequest } from '../models/RestoreFilesRequest.js';
import { RestoreGceDiskConfig } from '../models/RestoreGceDiskConfig.js';
import { RestoreGceInstanceConfig } from '../models/RestoreGceInstanceConfig.js';
import { RestoreGcpCloudSqlDatabaseConfig } from '../models/RestoreGcpCloudSqlDatabaseConfig.js';
import { RestoreGcpCloudSqlRequest } from '../models/RestoreGcpCloudSqlRequest.js';
import { RestoreGcpDiskRequest } from '../models/RestoreGcpDiskRequest.js';
import { RestoreGcpInstanceDiskInput } from '../models/RestoreGcpInstanceDiskInput.js';
import { RestoreGcpVmInstanceRequest } from '../models/RestoreGcpVmInstanceRequest.js';
import { RestoreGoogleWorkspaceGroupMessagesRequest } from '../models/RestoreGoogleWorkspaceGroupMessagesRequest.js';
import { RestoreGoogleWorkspaceGroupRequest } from '../models/RestoreGoogleWorkspaceGroupRequest.js';
import { RestoreGoogleWorkspaceSharedDriveRequest } from '../models/RestoreGoogleWorkspaceSharedDriveRequest.js';
import { RestoreGoogleWorkspaceUserDriveRequest } from '../models/RestoreGoogleWorkspaceUserDriveRequest.js';
import { RestoreGoogleWorkspaceUserMailRequest } from '../models/RestoreGoogleWorkspaceUserMailRequest.js';
import { RestoreGoogleWorkspaceUserRequest } from '../models/RestoreGoogleWorkspaceUserRequest.js';
import { RestoreImageImageDeviceInput } from '../models/RestoreImageImageDeviceInput.js';
import { RestoreImageImageInput } from '../models/RestoreImageImageInput.js';
import { RestoreImageInput } from '../models/RestoreImageInput.js';
import { RestoreImageVolumeInput } from '../models/RestoreImageVolumeInput.js';
import { RestoreInstanceImageDeviceInput } from '../models/RestoreInstanceImageDeviceInput.js';
import { RestoreInstanceImageInput } from '../models/RestoreInstanceImageInput.js';
import { RestoreInstanceVolumeInput } from '../models/RestoreInstanceVolumeInput.js';
import { RestoreJob } from '../models/RestoreJob.js';
import { RestoreJobConfiguration } from '../models/RestoreJobConfiguration.js';
import { RestoreJobInitiationResponse } from '../models/RestoreJobInitiationResponse.js';
import { RestoreJobTypeFilters } from '../models/RestoreJobTypeFilters.js';
import { RestoreJobsFilterConditions } from '../models/RestoreJobsFilterConditions.js';
import { RestoreKeyspacesTableRequest } from '../models/RestoreKeyspacesTableRequest.js';
import { RestoreMicrosoft365ItemsRequest } from '../models/RestoreMicrosoft365ItemsRequest.js';
import { RestoreMicrosoft365Request } from '../models/RestoreMicrosoft365Request.js';
import { RestoreMicrosoft365SharePointSiteByEntityRequest } from '../models/RestoreMicrosoft365SharePointSiteByEntityRequest.js';
import { RestoreMicrosoft365TeamByEntityRequest } from '../models/RestoreMicrosoft365TeamByEntityRequest.js';
import { RestoreMicrosoft365UserByEntityRequest } from '../models/RestoreMicrosoft365UserByEntityRequest.js';
import { RestoreMicrosoft365UserChatsByEntityRequest } from '../models/RestoreMicrosoft365UserChatsByEntityRequest.js';
import { RestoreMicrosoft365UserDriveByEntityRequest } from '../models/RestoreMicrosoft365UserDriveByEntityRequest.js';
import { RestoreMicrosoft365UserMailByEntityRequest } from '../models/RestoreMicrosoft365UserMailByEntityRequest.js';
import { RestoreMicrosoft365UserRequest } from '../models/RestoreMicrosoft365UserRequest.js';
import { RestoreNeptuneRequest } from '../models/RestoreNeptuneRequest.js';
import { RestoreObfuscationConfig } from '../models/RestoreObfuscationConfig.js';
import { RestoreRdsInstanceClasses } from '../models/RestoreRdsInstanceClasses.js';
import { RestoreRdsInstanceConfig } from '../models/RestoreRdsInstanceConfig.js';
import { RestoreRdsNativePitrRequest } from '../models/RestoreRdsNativePitrRequest.js';
import { RestoreRdsSubnetGroups } from '../models/RestoreRdsSubnetGroups.js';
import { RestoreRdsSubnetGroupsRdsSubnetGroupsInner } from '../models/RestoreRdsSubnetGroupsRdsSubnetGroupsInner.js';
import { RestoreRecipeRef } from '../models/RestoreRecipeRef.js';
import { RestoreResult } from '../models/RestoreResult.js';
import { RestoreSecurityGroups } from '../models/RestoreSecurityGroups.js';
import { RestoreSecurityGroupsSecurityGroupsInner } from '../models/RestoreSecurityGroupsSecurityGroupsInner.js';
import { RestoreTemplate } from '../models/RestoreTemplate.js';
import { RestoreTemplateFilterConditions } from '../models/RestoreTemplateFilterConditions.js';
import { RestoreTemplateIdFilters } from '../models/RestoreTemplateIdFilters.js';
import { RestoreTemplateResourceTypeFilters } from '../models/RestoreTemplateResourceTypeFilters.js';
import { RestoreVolumeToEbsRequest } from '../models/RestoreVolumeToEbsRequest.js';
import { RestoreVolumeToEbsSnapshotRequest } from '../models/RestoreVolumeToEbsSnapshotRequest.js';
import { RevalidateRestoreTemplateRequest } from '../models/RevalidateRestoreTemplateRequest.js';
import { RevalidateRestoreTemplateResponse } from '../models/RevalidateRestoreTemplateResponse.js';
import { RevalidationReport } from '../models/RevalidationReport.js';
import { RiskLevelFilters } from '../models/RiskLevelFilters.js';
import { Role } from '../models/Role.js';
import { RoleAccessGroupCondition } from '../models/RoleAccessGroupCondition.js';
import { RoleSummary } from '../models/RoleSummary.js';
import { RoleUsage } from '../models/RoleUsage.js';
import { RuleOutcome } from '../models/RuleOutcome.js';
import { RuleOutcomeList } from '../models/RuleOutcomeList.js';
import { RunAgentRequest } from '../models/RunAgentRequest.js';
import { S3Bucket } from '../models/S3Bucket.js';
import { S3Buckets } from '../models/S3Buckets.js';
import { S3RestoreDestination } from '../models/S3RestoreDestination.js';
import { S3RestoreTarget } from '../models/S3RestoreTarget.js';
import { S3TemplateParams } from '../models/S3TemplateParams.js';
import { SAMLCallback400Response } from '../models/SAMLCallback400Response.js';
import { SAMLCallback401Response } from '../models/SAMLCallback401Response.js';
import { SAMLCallback500Response } from '../models/SAMLCallback500Response.js';
import { SaasAppCost } from '../models/SaasAppCost.js';
import { SaasCommitmentWindowCost } from '../models/SaasCommitmentWindowCost.js';
import { SaasEmailSearchFilter } from '../models/SaasEmailSearchFilter.js';
import { SaasEntity } from '../models/SaasEntity.js';
import { SaasEntityExternalIdFilters } from '../models/SaasEntityExternalIdFilters.js';
import { SaasEntityProperties } from '../models/SaasEntityProperties.js';
import { SaasEntitySnapshot } from '../models/SaasEntitySnapshot.js';
import { SaasEntityTypeFilters } from '../models/SaasEntityTypeFilters.js';
import { SaasGoogleWorkspaceUserProperties } from '../models/SaasGoogleWorkspaceUserProperties.js';
import { SaasGroupProperties } from '../models/SaasGroupProperties.js';
import { SaasItemSearchRequest } from '../models/SaasItemSearchRequest.js';
import { SaasItemSearchResponse } from '../models/SaasItemSearchResponse.js';
import { SaasMailDetails } from '../models/SaasMailDetails.js';
import { SaasMicrosoft365UserProperties } from '../models/SaasMicrosoft365UserProperties.js';
import { SaasProtectionStatusFilters } from '../models/SaasProtectionStatusFilters.js';
import { SaasRestoreItem } from '../models/SaasRestoreItem.js';
import { SaasSharePointSiteProperties } from '../models/SaasSharePointSiteProperties.js';
import { SaasSnapshotItem } from '../models/SaasSnapshotItem.js';
import { SaasTeamProperties } from '../models/SaasTeamProperties.js';
import { SaasWorkloadStatus } from '../models/SaasWorkloadStatus.js';
import { SameSourceAccountRestoreLimits } from '../models/SameSourceAccountRestoreLimits.js';
import { SamlIdentityProvider } from '../models/SamlIdentityProvider.js';
import { SamlIdentityProviderConfigsResponse } from '../models/SamlIdentityProviderConfigsResponse.js';
import { SapHanaInstance } from '../models/SapHanaInstance.js';
import { SapHanaRestoreProperties } from '../models/SapHanaRestoreProperties.js';
import { SaveCloudResourceSecurityPropertiesRequest } from '../models/SaveCloudResourceSecurityPropertiesRequest.js';
import { ScanJob } from '../models/ScanJob.js';
import { SchemaRecord } from '../models/SchemaRecord.js';
import { SearchAllEvent } from '../models/SearchAllEvent.js';
import { SearchAllPlan } from '../models/SearchAllPlan.js';
import { SearchAllRequest } from '../models/SearchAllRequest.js';
import { SearchAllSection } from '../models/SearchAllSection.js';
import { SearchAllSectionQuery } from '../models/SearchAllSectionQuery.js';
import { SearchAllSectionRef } from '../models/SearchAllSectionRef.js';
import { SearchAllSectionResult } from '../models/SearchAllSectionResult.js';
import { SearchDBResponse } from '../models/SearchDBResponse.js';
import { SearchDirectoryEntitiesRequest } from '../models/SearchDirectoryEntitiesRequest.js';
import { SearchDirectoryEntitiesResponse } from '../models/SearchDirectoryEntitiesResponse.js';
import { SearchFilesResponse } from '../models/SearchFilesResponse.js';
import { SearchInput } from '../models/SearchInput.js';
import { SearchLogsHistogramInput } from '../models/SearchLogsHistogramInput.js';
import { SearchLogsHistogramResponse } from '../models/SearchLogsHistogramResponse.js';
import { SearchLogsInput } from '../models/SearchLogsInput.js';
import { SearchLogsResponse } from '../models/SearchLogsResponse.js';
import { SearchWorkspaceDirectoryRequest } from '../models/SearchWorkspaceDirectoryRequest.js';
import { SearchWorkspaceFilesRequest } from '../models/SearchWorkspaceFilesRequest.js';
import { SearchWorkspaceMailRequest } from '../models/SearchWorkspaceMailRequest.js';
import { SecurityFindingsFilterConditions } from '../models/SecurityFindingsFilterConditions.js';
import { SecurityInformation } from '../models/SecurityInformation.js';
import { SecurityPlan } from '../models/SecurityPlan.js';
import { SecurityPlanEnabledResponse } from '../models/SecurityPlanEnabledResponse.js';
import { SecurityResourceNotificationArguments } from '../models/SecurityResourceNotificationArguments.js';
import { SecurityScan } from '../models/SecurityScan.js';
import { SecurityScanConclusionCondition } from '../models/SecurityScanConclusionCondition.js';
import { SecurityScanConclusionFilters } from '../models/SecurityScanConclusionFilters.js';
import { SecurityScanNotificationData } from '../models/SecurityScanNotificationData.js';
import { SecurityScanResult } from '../models/SecurityScanResult.js';
import { SecurityScansSummaryResponse } from '../models/SecurityScansSummaryResponse.js';
import { SecuritySnapshotNotificationArguments } from '../models/SecuritySnapshotNotificationArguments.js';
import { SecuritySummary } from '../models/SecuritySummary.js';
import { SendA2AMessageRequest } from '../models/SendA2AMessageRequest.js';
import { SensitivityAnnotation } from '../models/SensitivityAnnotation.js';
import { SensitivityAnnotationsCondition } from '../models/SensitivityAnnotationsCondition.js';
import { SensitivityLabelsDetails } from '../models/SensitivityLabelsDetails.js';
import { SensitivityLabelsFilters } from '../models/SensitivityLabelsFilters.js';
import { ServiceProviderDetails } from '../models/ServiceProviderDetails.js';
import { Session } from '../models/Session.js';
import { SetDataCatalogDatasetAccessControlModeRequest } from '../models/SetDataCatalogDatasetAccessControlModeRequest.js';
import { SetDataCatalogDatasetAccessControlModeResponse } from '../models/SetDataCatalogDatasetAccessControlModeResponse.js';
import { SetResourceTagRequest } from '../models/SetResourceTagRequest.js';
import { SetupAwsPrivateLinkRequest } from '../models/SetupAwsPrivateLinkRequest.js';
import { SetupAwsPrivateLinkResponse } from '../models/SetupAwsPrivateLinkResponse.js';
import { SetupMongoAtlasPrivateLinkRequest } from '../models/SetupMongoAtlasPrivateLinkRequest.js';
import { SetupMongoAtlasPrivateLinkResponse } from '../models/SetupMongoAtlasPrivateLinkResponse.js';
import { SeverityFilters } from '../models/SeverityFilters.js';
import { ShovalAgentInstallCommand } from '../models/ShovalAgentInstallCommand.js';
import { SingleResourceBackupZeroEtlConfiguration } from '../models/SingleResourceBackupZeroEtlConfiguration.js';
import { Snapshot } from '../models/Snapshot.js';
import { SnapshotAccessDeniedNotificationArguments } from '../models/SnapshotAccessDeniedNotificationArguments.js';
import { SnapshotCoverage } from '../models/SnapshotCoverage.js';
import { SnapshotDateFilters } from '../models/SnapshotDateFilters.js';
import { SnapshotFilterConditions } from '../models/SnapshotFilterConditions.js';
import { SnapshotFindingCountsResponse } from '../models/SnapshotFindingCountsResponse.js';
import { SnapshotHistogramBucket } from '../models/SnapshotHistogramBucket.js';
import { SnapshotIdFilters } from '../models/SnapshotIdFilters.js';
import { SnapshotLocation } from '../models/SnapshotLocation.js';
import { SnapshotRecipe } from '../models/SnapshotRecipe.js';
import { SnapshotRecipeDirectorySummary } from '../models/SnapshotRecipeDirectorySummary.js';
import { SnapshotRecipeEntry } from '../models/SnapshotRecipeEntry.js';
import { SnapshotRecipeInvalidSnapshot } from '../models/SnapshotRecipeInvalidSnapshot.js';
import { SnapshotRecipeProposal } from '../models/SnapshotRecipeProposal.js';
import { SnapshotRecipeRule } from '../models/SnapshotRecipeRule.js';
import { SnapshotRecipeRuleError } from '../models/SnapshotRecipeRuleError.js';
import { SnapshotRecipeSourceSummary } from '../models/SnapshotRecipeSourceSummary.js';
import { SnapshotRecipeSummary } from '../models/SnapshotRecipeSummary.js';
import { SnapshotRecipeValidity } from '../models/SnapshotRecipeValidity.js';
import { SnapshotReference } from '../models/SnapshotReference.js';
import { SnapshotStorage } from '../models/SnapshotStorage.js';
import { SnapshotTimeFilters } from '../models/SnapshotTimeFilters.js';
import { SnapshotsSummaryResponse } from '../models/SnapshotsSummaryResponse.js';
import { SnowflakeIntegrationConfig } from '../models/SnowflakeIntegrationConfig.js';
import { SortBackupJobBy } from '../models/SortBackupJobBy.js';
import { SortLogsBy } from '../models/SortLogsBy.js';
import { SortResourceBy } from '../models/SortResourceBy.js';
import { SortRestoreAccountsBy } from '../models/SortRestoreAccountsBy.js';
import { SortRestoreJobBy } from '../models/SortRestoreJobBy.js';
import { SortSnapshotsBy } from '../models/SortSnapshotsBy.js';
import { SortSourceAccountsBy } from '../models/SortSourceAccountsBy.js';
import { SourceAccount } from '../models/SourceAccount.js';
import { SourceAccountAttributesInput } from '../models/SourceAccountAttributesInput.js';
import { SourceAccountCloudAttributes } from '../models/SourceAccountCloudAttributes.js';
import { SourceAccountMetricsConfig } from '../models/SourceAccountMetricsConfig.js';
import { SourceAccountProviderIdFilters } from '../models/SourceAccountProviderIdFilters.js';
import { SourceAccountTagKeyValuesCondition } from '../models/SourceAccountTagKeyValuesCondition.js';
import { SourceAccountTagKeysCondition } from '../models/SourceAccountTagKeysCondition.js';
import { SourceAccountsFilterConditions } from '../models/SourceAccountsFilterConditions.js';
import { SourceAwsOrganizationalUnit } from '../models/SourceAwsOrganizationalUnit.js';
import { SourceRegionFilters } from '../models/SourceRegionFilters.js';
import { SourceSizeCheckResult } from '../models/SourceSizeCheckResult.js';
import { SourceStorage } from '../models/SourceStorage.js';
import { SourceStorageBackupStatus } from '../models/SourceStorageBackupStatus.js';
import { SourceStorageSizeCondition } from '../models/SourceStorageSizeCondition.js';
import { SqlInstructions } from '../models/SqlInstructions.js';
import { SqlSetupCheckResult } from '../models/SqlSetupCheckResult.js';
import { SqlVmNetworkInfo } from '../models/SqlVmNetworkInfo.js';
import { SqlVmPitrRestoreProperties } from '../models/SqlVmPitrRestoreProperties.js';
import { SsoIntegrationSettings } from '../models/SsoIntegrationSettings.js';
import { StackNameFilters } from '../models/StackNameFilters.js';
import { StagingAccount } from '../models/StagingAccount.js';
import { StagingAccountConfig } from '../models/StagingAccountConfig.js';
import { StagingBucket } from '../models/StagingBucket.js';
import { StagingBucketConfig } from '../models/StagingBucketConfig.js';
import { StandardBackupPolicyPlan } from '../models/StandardBackupPolicyPlan.js';
import { StandardBackupScheduleConfig } from '../models/StandardBackupScheduleConfig.js';
import { StandardBackupSchedules } from '../models/StandardBackupSchedules.js';
import { StandardIntervalConfig } from '../models/StandardIntervalConfig.js';
import { StartQueryExecutionRequest } from '../models/StartQueryExecutionRequest.js';
import { StartTimeDateFilters } from '../models/StartTimeDateFilters.js';
import { StatusCodeFilters } from '../models/StatusCodeFilters.js';
import { StatusProperties } from '../models/StatusProperties.js';
import { StepProgressMetric } from '../models/StepProgressMetric.js';
import { StepProgressView } from '../models/StepProgressView.js';
import { StorageAccountContainerRestoreDestination } from '../models/StorageAccountContainerRestoreDestination.js';
import { StorageAccountRestoreTarget } from '../models/StorageAccountRestoreTarget.js';
import { StorageGateway } from '../models/StorageGateway.js';
import { StorageGatewayDetails } from '../models/StorageGatewayDetails.js';
import { SubmitMyMPARequestRequest } from '../models/SubmitMyMPARequestRequest.js';
import { SubmitMyMPARequestResponse } from '../models/SubmitMyMPARequestResponse.js';
import { SubnetConfig } from '../models/SubnetConfig.js';
import { SubnetFilters } from '../models/SubnetFilters.js';
import { SubnetPerAvailabilityZone } from '../models/SubnetPerAvailabilityZone.js';
import { SubnetsCondition } from '../models/SubnetsCondition.js';
import { SupportedProviders } from '../models/SupportedProviders.js';
import { Table } from '../models/Table.js';
import { TableRecord } from '../models/TableRecord.js';
import { TagKeyValue } from '../models/TagKeyValue.js';
import { TagKeyValuesCondition } from '../models/TagKeyValuesCondition.js';
import { TagKeyValuesFilters } from '../models/TagKeyValuesFilters.js';
import { TagKeysCondition } from '../models/TagKeysCondition.js';
import { TagKeysFilters } from '../models/TagKeysFilters.js';
import { TakeNativeSnapshotRequest } from '../models/TakeNativeSnapshotRequest.js';
import { TakeSnapshotRequest } from '../models/TakeSnapshotRequest.js';
import { TakeSnapshotResponse } from '../models/TakeSnapshotResponse.js';
import { TeardownAwsPrivateLinkResponse } from '../models/TeardownAwsPrivateLinkResponse.js';
import { TeardownMongoAtlasPrivateLinkResponse } from '../models/TeardownMongoAtlasPrivateLinkResponse.js';
import { ThreatDetectionFilters } from '../models/ThreatDetectionFilters.js';
import { ThreatHuntingResult } from '../models/ThreatHuntingResult.js';
import { ThreatHuntingScanRequest } from '../models/ThreatHuntingScanRequest.js';
import { TimeFrame } from '../models/TimeFrame.js';
import { TimeOfDay } from '../models/TimeOfDay.js';
import { TimeOfYear } from '../models/TimeOfYear.js';
import { TokenResponse } from '../models/TokenResponse.js';
import { TotalSourceStorageSizeRequest } from '../models/TotalSourceStorageSizeRequest.js';
import { TotalSourceStorageSizeResponse } from '../models/TotalSourceStorageSizeResponse.js';
import { TrendPoint } from '../models/TrendPoint.js';
import { TriggerKeyspacesScheduledDump200Response } from '../models/TriggerKeyspacesScheduledDump200Response.js';
import { UnifiedDBRecord } from '../models/UnifiedDBRecord.js';
import { UnifiedDBServerRecord } from '../models/UnifiedDBServerRecord.js';
import { UnifiedDatabaseRecord } from '../models/UnifiedDatabaseRecord.js';
import { UnifiedRestoreEntity } from '../models/UnifiedRestoreEntity.js';
import { UnifiedRestoreEntityMicrosoft365 } from '../models/UnifiedRestoreEntityMicrosoft365.js';
import { UnifiedRestoreEntityRelationships } from '../models/UnifiedRestoreEntityRelationships.js';
import { UnifiedRestoreMicrosoft365Request } from '../models/UnifiedRestoreMicrosoft365Request.js';
import { UnifiedRestoreMicrosoft365Snapshot } from '../models/UnifiedRestoreMicrosoft365Snapshot.js';
import { UnifiedRestoreMicrosoft365User } from '../models/UnifiedRestoreMicrosoft365User.js';
import { UnifiedRestorePlan } from '../models/UnifiedRestorePlan.js';
import { UnifiedRestoreWorkload } from '../models/UnifiedRestoreWorkload.js';
import { UnifiedSchemaRecord } from '../models/UnifiedSchemaRecord.js';
import { UnifiedTableRecord } from '../models/UnifiedTableRecord.js';
import { UpPulumiStacksResponse } from '../models/UpPulumiStacksResponse.js';
import { UpdateAccessGrantRequest } from '../models/UpdateAccessGrantRequest.js';
import { UpdateAccessPolicyRequest } from '../models/UpdateAccessPolicyRequest.js';
import { UpdateAccountCompanyContactsRequest } from '../models/UpdateAccountCompanyContactsRequest.js';
import { UpdateAccountLabelsRequest } from '../models/UpdateAccountLabelsRequest.js';
import { UpdateAccountProfileResponse } from '../models/UpdateAccountProfileResponse.js';
import { UpdateActionApprovalRuleRequest } from '../models/UpdateActionApprovalRuleRequest.js';
import { UpdateActionApprovalRuleResponse } from '../models/UpdateActionApprovalRuleResponse.js';
import { UpdateApiCredentialsRequest } from '../models/UpdateApiCredentialsRequest.js';
import { UpdateAwsRestoreAccountAttributes } from '../models/UpdateAwsRestoreAccountAttributes.js';
import { UpdateAwsSourceAccountAttributes } from '../models/UpdateAwsSourceAccountAttributes.js';
import { UpdateAzureSourceAccountAttributes } from '../models/UpdateAzureSourceAccountAttributes.js';
import { UpdateBackupPolicyRequest } from '../models/UpdateBackupPolicyRequest.js';
import { UpdateBackupPolicyResponse } from '../models/UpdateBackupPolicyResponse.js';
import { UpdateBackupPostureControlRequest } from '../models/UpdateBackupPostureControlRequest.js';
import { UpdateBackupZeroEtlPolicyInput } from '../models/UpdateBackupZeroEtlPolicyInput.js';
import { UpdateClassificationPolicyRequest } from '../models/UpdateClassificationPolicyRequest.js';
import { UpdateClassificationPolicyResponse } from '../models/UpdateClassificationPolicyResponse.js';
import { UpdateCloudResourceConfigurationRequest } from '../models/UpdateCloudResourceConfigurationRequest.js';
import { UpdateCloudResourceConfigurationRequestCdcBackup } from '../models/UpdateCloudResourceConfigurationRequestCdcBackup.js';
import { UpdateCloudResourceConfigurationRequestInventoryBackup } from '../models/UpdateCloudResourceConfigurationRequestInventoryBackup.js';
import { UpdateControlViolationInput } from '../models/UpdateControlViolationInput.js';
import { UpdateDataCatalogPipelineRequest } from '../models/UpdateDataCatalogPipelineRequest.js';
import { UpdateDlsgPolicyRequest } from '../models/UpdateDlsgPolicyRequest.js';
import { UpdateDlsgPolicyResponse } from '../models/UpdateDlsgPolicyResponse.js';
import { UpdateFindingExclusionRequest } from '../models/UpdateFindingExclusionRequest.js';
import { UpdateFindingExclusionResponse } from '../models/UpdateFindingExclusionResponse.js';
import { UpdateGcpRestoreAccountAttributes } from '../models/UpdateGcpRestoreAccountAttributes.js';
import { UpdateGcpSourceAccountAttributes } from '../models/UpdateGcpSourceAccountAttributes.js';
import { UpdateGdsgInventoryReportConfigurationRequest } from '../models/UpdateGdsgInventoryReportConfigurationRequest.js';
import { UpdateGdsgInventoryReportConfigurationResponse } from '../models/UpdateGdsgInventoryReportConfigurationResponse.js';
import { UpdateGwsBackupFilterRequest } from '../models/UpdateGwsBackupFilterRequest.js';
import { UpdateIdpGroupRequest } from '../models/UpdateIdpGroupRequest.js';
import { UpdateIdpGroupResponse } from '../models/UpdateIdpGroupResponse.js';
import { UpdateIntegrationRequest } from '../models/UpdateIntegrationRequest.js';
import { UpdateIntegrationResponse } from '../models/UpdateIntegrationResponse.js';
import { UpdateObjectStoreScanMethodRequest } from '../models/UpdateObjectStoreScanMethodRequest.js';
import { UpdateObjectStoreScanMethodResponse } from '../models/UpdateObjectStoreScanMethodResponse.js';
import { UpdateObjectStoreScanMethodSetting } from '../models/UpdateObjectStoreScanMethodSetting.js';
import { UpdateOrganizationIdpGroupRequest } from '../models/UpdateOrganizationIdpGroupRequest.js';
import { UpdateOrganizationIdpGroupResponse } from '../models/UpdateOrganizationIdpGroupResponse.js';
import { UpdateOrganizationIdpRequest } from '../models/UpdateOrganizationIdpRequest.js';
import { UpdateOrganizationIdpResponse } from '../models/UpdateOrganizationIdpResponse.js';
import { UpdateOrganizationUserRequest } from '../models/UpdateOrganizationUserRequest.js';
import { UpdateOrganizationUserResponse } from '../models/UpdateOrganizationUserResponse.js';
import { UpdateProjectConfigurationKeyRequest } from '../models/UpdateProjectConfigurationKeyRequest.js';
import { UpdatePulumiConfigurationRequest } from '../models/UpdatePulumiConfigurationRequest.js';
import { UpdateResourceSecurityScansExclusionRequest } from '../models/UpdateResourceSecurityScansExclusionRequest.js';
import { UpdateRestoreAccountAttributesInput } from '../models/UpdateRestoreAccountAttributesInput.js';
import { UpdateRestoreAccountConnectivityConfigRequest } from '../models/UpdateRestoreAccountConnectivityConfigRequest.js';
import { UpdateRestoreAccountConnectivityConfigResponse } from '../models/UpdateRestoreAccountConnectivityConfigResponse.js';
import { UpdateRestoreAccountRequest } from '../models/UpdateRestoreAccountRequest.js';
import { UpdateRestoreAccountResponse } from '../models/UpdateRestoreAccountResponse.js';
import { UpdateRestoreTemplateRequest } from '../models/UpdateRestoreTemplateRequest.js';
import { UpdateRestoreTemplateResponse } from '../models/UpdateRestoreTemplateResponse.js';
import { UpdateRoleRequest } from '../models/UpdateRoleRequest.js';
import { UpdateRoleResponse } from '../models/UpdateRoleResponse.js';
import { UpdateSamlIdentityProviderInput } from '../models/UpdateSamlIdentityProviderInput.js';
import { UpdateSessionRequest } from '../models/UpdateSessionRequest.js';
import { UpdateShouldFullBackupResourceRequest } from '../models/UpdateShouldFullBackupResourceRequest.js';
import { UpdateSnapshotRecipeRequest } from '../models/UpdateSnapshotRecipeRequest.js';
import { UpdateSnapshotRecipeResponse } from '../models/UpdateSnapshotRecipeResponse.js';
import { UpdateSourceAccountAttributesInput } from '../models/UpdateSourceAccountAttributesInput.js';
import { UpdateSourceAccountRequest } from '../models/UpdateSourceAccountRequest.js';
import { UpdateSourceAccountResponse } from '../models/UpdateSourceAccountResponse.js';
import { UpdateTagDefinitionRequest } from '../models/UpdateTagDefinitionRequest.js';
import { UpdateThreatHuntingScanRequestRequest } from '../models/UpdateThreatHuntingScanRequestRequest.js';
import { UpdateUserInput } from '../models/UpdateUserInput.js';
import { UpdateVaultRequest } from '../models/UpdateVaultRequest.js';
import { UpdateVaultResponse } from '../models/UpdateVaultResponse.js';
import { UpdateViewerRoleRequest } from '../models/UpdateViewerRoleRequest.js';
import { Usage } from '../models/Usage.js';
import { UsageTypeFilters } from '../models/UsageTypeFilters.js';
import { User } from '../models/User.js';
import { UserIdFilters } from '../models/UserIdFilters.js';
import { VNetConfig } from '../models/VNetConfig.js';
import { ValidateAccessGrantRequest } from '../models/ValidateAccessGrantRequest.js';
import { ValidateAccessGrantResponse } from '../models/ValidateAccessGrantResponse.js';
import { ValidateAccessPolicyRequest } from '../models/ValidateAccessPolicyRequest.js';
import { ValidateAccessPolicyResponse } from '../models/ValidateAccessPolicyResponse.js';
import { ValidateDataCatalogPipelineRequest } from '../models/ValidateDataCatalogPipelineRequest.js';
import { ValidateDataCatalogPipelineResponse } from '../models/ValidateDataCatalogPipelineResponse.js';
import { ValidateResourceConfigurationRequest } from '../models/ValidateResourceConfigurationRequest.js';
import { ValidateResourceConfigurationResponse } from '../models/ValidateResourceConfigurationResponse.js';
import { VaultEncryptionTypeFilters } from '../models/VaultEncryptionTypeFilters.js';
import { VaultFilters } from '../models/VaultFilters.js';
import { VaultMetadataReplicationConfig } from '../models/VaultMetadataReplicationConfig.js';
import { VaultNotificationArguments } from '../models/VaultNotificationArguments.js';
import { VaultProviderAttributes } from '../models/VaultProviderAttributes.js';
import { VaultProviderAttributesInput } from '../models/VaultProviderAttributesInput.js';
import { VaultRegionFilters } from '../models/VaultRegionFilters.js';
import { VaultSnapshotCount } from '../models/VaultSnapshotCount.js';
import { VaultStatusFilters } from '../models/VaultStatusFilters.js';
import { VaultTagFilters } from '../models/VaultTagFilters.js';
import { VaultTieringPolicy } from '../models/VaultTieringPolicy.js';
import { VaultTypeFilters } from '../models/VaultTypeFilters.js';
import { VaultsFilterConditions } from '../models/VaultsFilterConditions.js';
import { VerifyMongoAtlasPrivateLinkResponse } from '../models/VerifyMongoAtlasPrivateLinkResponse.js';
import { VerifyRdsCdcSqlSetupResponse } from '../models/VerifyRdsCdcSqlSetupResponse.js';
import { Viewer } from '../models/Viewer.js';
import { ViolationsDetectionNotificationArguments } from '../models/ViolationsDetectionNotificationArguments.js';
import { VirtualMachineRestoreDestination } from '../models/VirtualMachineRestoreDestination.js';
import { VisualizationHistogramSeries } from '../models/VisualizationHistogramSeries.js';
import { VisualizationHistogramTimePoint } from '../models/VisualizationHistogramTimePoint.js';
import { VisualizationLabel } from '../models/VisualizationLabel.js';
import { VolumeSettings } from '../models/VolumeSettings.js';
import { VpcCondition } from '../models/VpcCondition.js';
import { VpcPropertyFilters } from '../models/VpcPropertyFilters.js';
import { WebhookV1AnomalyDataPoint } from '../models/WebhookV1AnomalyDataPoint.js';
import { WebhookV1AnomalyGraphData } from '../models/WebhookV1AnomalyGraphData.js';
import { WebhookV1AuditEvent } from '../models/WebhookV1AuditEvent.js';
import { WebhookV1AuditPayload } from '../models/WebhookV1AuditPayload.js';
import { WebhookV1BackupJobDetails } from '../models/WebhookV1BackupJobDetails.js';
import { WebhookV1BackupJobFailedArguments } from '../models/WebhookV1BackupJobFailedArguments.js';
import { WebhookV1BackupJobPartialArguments } from '../models/WebhookV1BackupJobPartialArguments.js';
import { WebhookV1BackupJobRejectedArguments } from '../models/WebhookV1BackupJobRejectedArguments.js';
import { WebhookV1BackupJobSkippedArguments } from '../models/WebhookV1BackupJobSkippedArguments.js';
import { WebhookV1BackupJobSucceededArguments } from '../models/WebhookV1BackupJobSucceededArguments.js';
import { WebhookV1BackupPolicyNotificationArguments } from '../models/WebhookV1BackupPolicyNotificationArguments.js';
import { WebhookV1ClassificationJobFailedArguments } from '../models/WebhookV1ClassificationJobFailedArguments.js';
import { WebhookV1ClassificationJobRejectedArguments } from '../models/WebhookV1ClassificationJobRejectedArguments.js';
import { WebhookV1ClassificationJobSkippedArguments } from '../models/WebhookV1ClassificationJobSkippedArguments.js';
import { WebhookV1CloudAccountArguments } from '../models/WebhookV1CloudAccountArguments.js';
import { WebhookV1CreditsMonthlyUsageNotificationArguments } from '../models/WebhookV1CreditsMonthlyUsageNotificationArguments.js';
import { WebhookV1CreditsNotificationArguments } from '../models/WebhookV1CreditsNotificationArguments.js';
import { WebhookV1GdsgOperationalNotificationArguments } from '../models/WebhookV1GdsgOperationalNotificationArguments.js';
import { WebhookV1InitiatorArguments } from '../models/WebhookV1InitiatorArguments.js';
import { WebhookV1IssueMutedNotificationArguments } from '../models/WebhookV1IssueMutedNotificationArguments.js';
import { WebhookV1JobMetricsReportFailedArguments } from '../models/WebhookV1JobMetricsReportFailedArguments.js';
import { WebhookV1MPARequestNotificationArguments } from '../models/WebhookV1MPARequestNotificationArguments.js';
import { WebhookV1MPAReviewNotificationArguments } from '../models/WebhookV1MPAReviewNotificationArguments.js';
import { WebhookV1NotificationTargetChangeArguments } from '../models/WebhookV1NotificationTargetChangeArguments.js';
import { WebhookV1OnboardingPayload } from '../models/WebhookV1OnboardingPayload.js';
import { WebhookV1Payload } from '../models/WebhookV1Payload.js';
import { WebhookV1PolicyArguments } from '../models/WebhookV1PolicyArguments.js';
import { WebhookV1ProtobufDuration } from '../models/WebhookV1ProtobufDuration.js';
import { WebhookV1ProtobufTimestamp } from '../models/WebhookV1ProtobufTimestamp.js';
import { WebhookV1ResourceArguments } from '../models/WebhookV1ResourceArguments.js';
import { WebhookV1RestoreJobFailedArguments } from '../models/WebhookV1RestoreJobFailedArguments.js';
import { WebhookV1RestoreJobRejectedArguments } from '../models/WebhookV1RestoreJobRejectedArguments.js';
import { WebhookV1RestoreJobSucceededArguments } from '../models/WebhookV1RestoreJobSucceededArguments.js';
import { WebhookV1SecurityEvidence } from '../models/WebhookV1SecurityEvidence.js';
import { WebhookV1SecurityScan } from '../models/WebhookV1SecurityScan.js';
import { WebhookV1SecurityScanResult } from '../models/WebhookV1SecurityScanResult.js';
import { WebhookV1SnapshotAccessDeniedArguments } from '../models/WebhookV1SnapshotAccessDeniedArguments.js';
import { WebhookV1SnapshotArguments } from '../models/WebhookV1SnapshotArguments.js';
import { WebhookV1StandardPayload } from '../models/WebhookV1StandardPayload.js';
import { WebhookV1StandardPayloadBackupJobFailed } from '../models/WebhookV1StandardPayloadBackupJobFailed.js';
import { WebhookV1StandardPayloadBackupJobFailedArguments } from '../models/WebhookV1StandardPayloadBackupJobFailedArguments.js';
import { WebhookV1StandardPayloadBackupJobPartial } from '../models/WebhookV1StandardPayloadBackupJobPartial.js';
import { WebhookV1StandardPayloadBackupJobPartialArguments } from '../models/WebhookV1StandardPayloadBackupJobPartialArguments.js';
import { WebhookV1StandardPayloadBackupJobRejected } from '../models/WebhookV1StandardPayloadBackupJobRejected.js';
import { WebhookV1StandardPayloadBackupJobRejectedArguments } from '../models/WebhookV1StandardPayloadBackupJobRejectedArguments.js';
import { WebhookV1StandardPayloadBackupJobSkipped } from '../models/WebhookV1StandardPayloadBackupJobSkipped.js';
import { WebhookV1StandardPayloadBackupJobSkippedArguments } from '../models/WebhookV1StandardPayloadBackupJobSkippedArguments.js';
import { WebhookV1StandardPayloadBackupJobSucceeded } from '../models/WebhookV1StandardPayloadBackupJobSucceeded.js';
import { WebhookV1StandardPayloadBackupJobSucceededArguments } from '../models/WebhookV1StandardPayloadBackupJobSucceededArguments.js';
import { WebhookV1StandardPayloadBackupVault } from '../models/WebhookV1StandardPayloadBackupVault.js';
import { WebhookV1StandardPayloadBackupVaultArguments } from '../models/WebhookV1StandardPayloadBackupVaultArguments.js';
import { WebhookV1StandardPayloadClassificationJobFailed } from '../models/WebhookV1StandardPayloadClassificationJobFailed.js';
import { WebhookV1StandardPayloadClassificationJobFailedArguments } from '../models/WebhookV1StandardPayloadClassificationJobFailedArguments.js';
import { WebhookV1StandardPayloadClassificationJobRejected } from '../models/WebhookV1StandardPayloadClassificationJobRejected.js';
import { WebhookV1StandardPayloadClassificationJobRejectedArguments } from '../models/WebhookV1StandardPayloadClassificationJobRejectedArguments.js';
import { WebhookV1StandardPayloadClassificationJobSkipped } from '../models/WebhookV1StandardPayloadClassificationJobSkipped.js';
import { WebhookV1StandardPayloadClassificationJobSkippedArguments } from '../models/WebhookV1StandardPayloadClassificationJobSkippedArguments.js';
import { WebhookV1StandardPayloadCloudAccount } from '../models/WebhookV1StandardPayloadCloudAccount.js';
import { WebhookV1StandardPayloadCloudAccountArguments } from '../models/WebhookV1StandardPayloadCloudAccountArguments.js';
import { WebhookV1StandardPayloadCreditsMonthlyUsage } from '../models/WebhookV1StandardPayloadCreditsMonthlyUsage.js';
import { WebhookV1StandardPayloadCreditsMonthlyUsageArguments } from '../models/WebhookV1StandardPayloadCreditsMonthlyUsageArguments.js';
import { WebhookV1StandardPayloadCreditsUsage } from '../models/WebhookV1StandardPayloadCreditsUsage.js';
import { WebhookV1StandardPayloadCreditsUsageArguments } from '../models/WebhookV1StandardPayloadCreditsUsageArguments.js';
import { WebhookV1StandardPayloadGdsgOperational } from '../models/WebhookV1StandardPayloadGdsgOperational.js';
import { WebhookV1StandardPayloadGdsgOperationalArguments } from '../models/WebhookV1StandardPayloadGdsgOperationalArguments.js';
import { WebhookV1StandardPayloadIssueMuted } from '../models/WebhookV1StandardPayloadIssueMuted.js';
import { WebhookV1StandardPayloadIssueMutedArguments } from '../models/WebhookV1StandardPayloadIssueMutedArguments.js';
import { WebhookV1StandardPayloadJobMetricsReportFailed } from '../models/WebhookV1StandardPayloadJobMetricsReportFailed.js';
import { WebhookV1StandardPayloadJobMetricsReportFailedArguments } from '../models/WebhookV1StandardPayloadJobMetricsReportFailedArguments.js';
import { WebhookV1StandardPayloadMpaRequest } from '../models/WebhookV1StandardPayloadMpaRequest.js';
import { WebhookV1StandardPayloadMpaRequestArguments } from '../models/WebhookV1StandardPayloadMpaRequestArguments.js';
import { WebhookV1StandardPayloadMpaReview } from '../models/WebhookV1StandardPayloadMpaReview.js';
import { WebhookV1StandardPayloadMpaReviewArguments } from '../models/WebhookV1StandardPayloadMpaReviewArguments.js';
import { WebhookV1StandardPayloadNotificationTargetChange } from '../models/WebhookV1StandardPayloadNotificationTargetChange.js';
import { WebhookV1StandardPayloadNotificationTargetChangeArguments } from '../models/WebhookV1StandardPayloadNotificationTargetChangeArguments.js';
import { WebhookV1StandardPayloadPolicyAssignment } from '../models/WebhookV1StandardPayloadPolicyAssignment.js';
import { WebhookV1StandardPayloadPolicyAssignmentArguments } from '../models/WebhookV1StandardPayloadPolicyAssignmentArguments.js';
import { WebhookV1StandardPayloadPolicyChange } from '../models/WebhookV1StandardPayloadPolicyChange.js';
import { WebhookV1StandardPayloadPolicyChangeArguments } from '../models/WebhookV1StandardPayloadPolicyChangeArguments.js';
import { WebhookV1StandardPayloadResource } from '../models/WebhookV1StandardPayloadResource.js';
import { WebhookV1StandardPayloadResourceArguments } from '../models/WebhookV1StandardPayloadResourceArguments.js';
import { WebhookV1StandardPayloadRestoreJobFailed } from '../models/WebhookV1StandardPayloadRestoreJobFailed.js';
import { WebhookV1StandardPayloadRestoreJobFailedArguments } from '../models/WebhookV1StandardPayloadRestoreJobFailedArguments.js';
import { WebhookV1StandardPayloadRestoreJobRejected } from '../models/WebhookV1StandardPayloadRestoreJobRejected.js';
import { WebhookV1StandardPayloadRestoreJobRejectedArguments } from '../models/WebhookV1StandardPayloadRestoreJobRejectedArguments.js';
import { WebhookV1StandardPayloadRestoreJobSucceeded } from '../models/WebhookV1StandardPayloadRestoreJobSucceeded.js';
import { WebhookV1StandardPayloadRestoreJobSucceededArguments } from '../models/WebhookV1StandardPayloadRestoreJobSucceededArguments.js';
import { WebhookV1StandardPayloadSnapshot } from '../models/WebhookV1StandardPayloadSnapshot.js';
import { WebhookV1StandardPayloadSnapshotAccessDenied } from '../models/WebhookV1StandardPayloadSnapshotAccessDenied.js';
import { WebhookV1StandardPayloadSnapshotAccessDeniedArguments } from '../models/WebhookV1StandardPayloadSnapshotAccessDeniedArguments.js';
import { WebhookV1StandardPayloadSnapshotArguments } from '../models/WebhookV1StandardPayloadSnapshotArguments.js';
import { WebhookV1StandardPayloadSnapshotUserProtection } from '../models/WebhookV1StandardPayloadSnapshotUserProtection.js';
import { WebhookV1StandardPayloadSnapshotUserProtectionArguments } from '../models/WebhookV1StandardPayloadSnapshotUserProtectionArguments.js';
import { WebhookV1StandardPayloadViolations } from '../models/WebhookV1StandardPayloadViolations.js';
import { WebhookV1StandardPayloadViolationsArguments } from '../models/WebhookV1StandardPayloadViolationsArguments.js';
import { WebhookV1VaultArguments } from '../models/WebhookV1VaultArguments.js';
import { WebhookV1ViolationsDetectionNotificationArguments } from '../models/WebhookV1ViolationsDetectionNotificationArguments.js';
import { WeeklyConfig } from '../models/WeeklyConfig.js';
import { YearlySnapshotDistribution } from '../models/YearlySnapshotDistribution.js';
import { ZeroEtlJob } from '../models/ZeroEtlJob.js';
import { ZeroEtlJobSync } from '../models/ZeroEtlJobSync.js';
import { ZeroEtlJobSyncsFilters } from '../models/ZeroEtlJobSyncsFilters.js';
import { ZeroEtlJobTableCounts } from '../models/ZeroEtlJobTableCounts.js';
import { ZeroEtlJobsFilters } from '../models/ZeroEtlJobsFilters.js';
import { ZeroEtlJobsSort } from '../models/ZeroEtlJobsSort.js';
import { ZeroEtlTargetTable } from '../models/ZeroEtlTargetTable.js';
import { ZeroEtlTargetTablesFilters } from '../models/ZeroEtlTargetTablesFilters.js';
import { ZeroEtlTargetTablesSort } from '../models/ZeroEtlTargetTablesSort.js';
let primitives = [
    "string",
    "boolean",
    "double",
    "integer",
    "long",
    "float",
    "number",
    "any"
];
let enumsMap = new Set([
    "AccessConditionEffect",
    "AccountInstallationMethod",
    "AccountState",
    "AccountStatusReason",
    "ActionApprovalOperationType",
    "AgreementWithCreditsTypeEnum",
    "AuditLogAction",
    "AuditLogAuthMethod",
    "AuditLogAuthStatus",
    "AuditLogChangeSource",
    "AuditLogEnrichmentStatus",
    "AuditLogInitiatorType",
    "AuditLogMfaMethod",
    "AwsEbsVolumeResourceVolumeTypeEnum",
    "AwsEbsVolumeResourceStateEnum",
    "AwsFsxResourceFileSystemTypeEnum",
    "AwsFsxResourceStorageTypeEnum",
    "AwsFsxResourceLifecycleStatusEnum",
    "AwsKeyspacesResourceCdcStatusEnum",
    "AwsKeyspacesResourceCdcViewTypeEnum",
    "AwsNativeStandardIntervalConfigIntervalHoursEnum",
    "AwsRdsEngine",
    "AzureAppRegistrationOptionApplicationTypeEnum",
    "AzureDiskEncryptionSetAccessProblem",
    "AzureDiskEncryptionSetEncryptionType",
    "AzureEntraIdRestoreConsentKindEnum",
    "AzureFileShareRestoreFileSpecFileSpecTypeEnum",
    "AzureFilesBackupPolicyPlanStorageRedundancyEnum",
    "AzureFilesBackupPolicyPlanScheduleModeEnum",
    "AzureMarketplaceWebhookInputActionEnum",
    "AzureMarketplaceWebhookInputStatusEnum",
    "AzureMarketplaceWebhookInputOperationRequestSourceEnum",
    "AzureMarketplaceWebhookInputSubscriptionAllowedCustomerOperationsEnum",
    "AzureMarketplaceWebhookInputSubscriptionSessionModeEnum",
    "AzureMarketplaceWebhookInputSubscriptionSandboxTypeEnum",
    "AzureMarketplaceWebhookInputSubscriptionSaasSubscriptionStatusEnum",
    "AzureMarketplaceWebhookInputSubscriptionTermTermUnitEnum",
    "AzureOnboardingStatusStatusEnum",
    "AzureRestorePointDataRestorePointTypeEnum",
    "AzureVaultType",
    "AzureVmNativeRestoreTargetAvailabilityZoneEnum",
    "BackedByCategory",
    "BackupJobSortField",
    "BackupJobType",
    "BackupPolicyType",
    "BackupPostureControlSortField",
    "BackupStatus",
    "BackupZeroEtlExtendedJsonMode",
    "BackupZeroEtlIcebergTransformType",
    "BackupZeroEtlIdentityColumnField",
    "BackupZeroEtlOrderingStrategy",
    "BackupZeroEtlPolicyScope",
    "BackupZeroEtlRoutingMode",
    "BackupZeroEtlSingleResourceTableMappingMode",
    "BackupZeroEtlTableSelectionMode",
    "BillingProvider",
    "BillingTransactionHistoryTransactionTypeEnum",
    "BulkRestoreItemStatus",
    "BulkSelectSnapshotStatus",
    "CdcBackupModeCheckResultModeEnum",
    "ClassificationScheduleFrequency",
    "CloudAccountType",
    "CloudResourceAttachmentEventType",
    "CognitoExchangeRequestGrantTypeEnum",
    "ComplianceStatus",
    "ConditionOperatorEnum",
    "ConfigurationStatus",
    "CostDataGroupBy",
    "CostGranularity",
    "CostProduct",
    "CostRecordMetadataType",
    "CostUnit",
    "CreateOAuthAppRequestTypeEnum",
    "DBSnapshotType",
    "DataCatalogColumnType",
    "DataCatalogDatasetAccessControlMode",
    "DataCatalogDatasetAvailability",
    "DataCatalogDatasetEventKind",
    "DataCatalogDatasetHealthIssueKind",
    "DataCatalogDatasetHealthStatus",
    "DataCatalogDatasetType",
    "DataCatalogGrantStatus",
    "DataCatalogIssueSeverity",
    "DataCatalogMaskTransformKind",
    "DataCatalogPipelineEngine",
    "DataCatalogPipelineRunMode",
    "DataCatalogPipelineState",
    "DataCatalogPipelineWriteMode",
    "DataCatalogPolicyKind",
    "DataCatalogPolicyResourceType",
    "DataCatalogPrivilege",
    "DataCatalogRowOperator",
    "DataCatalogSubjectType",
    "DataCatalogTagInheritance",
    "DataCatalogTagKind",
    "DataCatalogTagOperator",
    "DataCatalogTagResourceType",
    "DataCatalogTagSource",
    "DataCatalogTreeItemType",
    "DataTransferOperationType",
    "DayOfWeek",
    "DetectorSummaryDetectorTypeEnum",
    "DetectorSummaryConclusionEnum",
    "DetectorType",
    "DirectoryEdgeType",
    "DirectoryEntityType",
    "DirectoryScopeKind",
    "DownloadGdsgObjectsRequestRoleEnum",
    "DsgRequestType",
    "DsgStorageTier",
    "DynamoDBRestoreToS3OutputFormat",
    "DynamoDbBillingMode",
    "DynamoDbKeyType",
    "DynamoDbProjectionType",
    "EFSRestoreDestinationRestoreTypeEnum",
    "EFSRestoreDestinationPerformanceModeEnum",
    "EFSRestoreDestinationThroughputModeEnum",
    "EfsSnapshotPropertiesPerformanceModeEnum",
    "EfsSnapshotPropertiesThroughputModeEnum",
    "EksClusterRestoreDestinationType",
    "EksClusterStatus",
    "EncryptionType",
    "EntraIdSelectionMode",
    "EntraRestoreReportReportTypeEnum",
    "EntraRestoreReportEntityEntityTypeEnum",
    "EntraRestoreReportEntityOutcomeEnum",
    "EntraRestoreReportEntityRequiredActionsInnerCodeEnum",
    "EntraRestoreReportEntityRequiredActionsInnerSeverityEnum",
    "EntraRestoreReportJobStatusEnum",
    "Environment",
    "EonAccountStatus",
    "EonAccountType",
    "ErrorCode",
    "ExportComplianceReportRequestFormatEnum",
    "FindingExclusionDetectorType",
    "FindingExclusionScope",
    "FindingObjectType",
    "FindingStatus",
    "FsxOntapVolumeVolumeTypeEnum",
    "FsxOntapVolumeSecurityStyleEnum",
    "GcpDiskResourceDiskTypeEnum",
    "GcpDiskResourceStatusEnum",
    "GcpNetworkType",
    "GcpSqlVmBackupHealth",
    "GcpSqlVmSetupPath",
    "GcsLocationType",
    "GdsgDeleteResultOutcomeEnum",
    "GdsgInventoryReportCsvRecordSeparator",
    "GdsgInventoryReportFormat",
    "GdsgInventoryReportFrequency",
    "GdsgInventoryReportMetadataField",
    "GdsgInventoryReportRunStatus",
    "GdsgObjectEntryRoleEnum",
    "GdsgObjectEntryTierEnum",
    "GetAdditionalAzureAppsOnboardingStatus200ResponseStatusEnum",
    "GetAwsPrivateLinkStatusResponseStatusEnum",
    "GoogleWorkspaceGroupMessageTargetType",
    "GoogleWorkspaceGroupRestoreWorkloadType",
    "GoogleWorkspaceRestoreWorkload",
    "GoogleWorkspaceSharedDriveRestoreScope",
    "GoogleWorkspaceUserDriveRestoreScope",
    "GoogleWorkspaceUserMailRestoreScope",
    "GoogleWorkspaceUserRestoreWorkloadType",
    "HighFrequencyBackupScheduleFrequency",
    "HighFrequencyIntervalConfigIntervalMinutesEnum",
    "IndexRestoreMode",
    "InitiatorType",
    "IntegType",
    "InventoryDetail",
    "IssueType",
    "JobProgressStepBucketDataBackupDataCoverageNotBackedUpInnerReasonEnum",
    "JobProgressStepKind",
    "JobProgressStepScanningBucketDataScanTypeEnum",
    "JobProgressStepStatus",
    "JobStatus",
    "JobStepName",
    "JobStepStatus",
    "KubeAccessStatus",
    "KubernetesAccessMode",
    "ListOperators",
    "ListQueryExecutionsRequestSortsInnerFieldEnum",
    "ListQueryExecutionsRequestSortsInnerOrderEnum",
    "LogSourceTypeEnum",
    "LogSourceWithPolicyTypeEnum",
    "LogicalOperator",
    "MPADecision",
    "MPAEntityType",
    "MPAListRequestSortField",
    "MPAOperationScope",
    "MPAOperationType",
    "MPARequestListPerspective",
    "MPARequestStatus",
    "MPAReviewSubmitDecision",
    "MPASubmitAction",
    "MeteringDimension",
    "Microsoft365GroupMemberSortField",
    "Microsoft365RestoreWorkload",
    "Microsoft365SelectionMode",
    "Microsoft365SharePointSiteRestoreScope",
    "Microsoft365TeamRestoreScope",
    "Microsoft365UserChatsRestoreScope",
    "Microsoft365UserDriveRestoreScope",
    "Microsoft365UserLicenseStatus",
    "Microsoft365UserMailRestoreScope",
    "Microsoft365UserRestoreWorkloadType",
    "MinRetentionRuleFrequencyEnum",
    "MongoAtlasPrivateLinkProvider",
    "MongoDbBackupConfigAnalyticsNodeModeEnum",
    "MongoDbBackupConfigScanThrottleModeEnum",
    "MongoDbBackupConfigScanStrategyEnum",
    "NetworkClassification",
    "NetworkInterfaceConfigModeEnum",
    "NotificationPolicyTypeEnum",
    "NotificationStatus",
    "NotificationType",
    "NumericOperators",
    "OAuthAppTypeEnum",
    "ObjectStoreCoverageReason",
    "ObjectStoreExclusionRuleStoreTypeEnum",
    "ObjectStoreExclusionRuleMatchTypeEnum",
    "OrgCostDataGroupBy",
    "OrganizationRoleGrantTargetKind",
    "OrganizationUserStatus",
    "PartialRestoreType",
    "PathType",
    "PermissionActionCategory",
    "PermissionArea",
    "PermissionType",
    "PitrIntervalConfigIntervalMinutesEnum",
    "PrivateLinkCheckResultStatusEnum",
    "ProjectConfigurationKeyEnum",
    "Provider",
    "ProviderCategory",
    "QueryDBRestoreDestinationType",
    "QueryDBStatus",
    "QueryEngine",
    "QueryExecutionStatus",
    "QuotaStatus",
    "RdsCdcCheckScope",
    "RdsPasswordConfigPasswordManagementTypeEnum",
    "RemoteCatalogType",
    "ResourceBlockerGroup",
    "ResourceBlockerType",
    "ResourceSelectorMode",
    "ResourceSortField",
    "ResourceType",
    "RestoreAccountSortField",
    "RestoreAccountTagOperator",
    "RestoreAccountTagSubject",
    "RestoreAtlasClusterInputShardingModeEnum",
    "RestoreAzureFileShareRequestRestoreRequestTypeEnum",
    "RestoreAzureFileShareRequestRecoveryTypeEnum",
    "RestoreAzureVmNativeRequestRestoreTypeEnum",
    "RestoreJobSortField",
    "RestoreJobType",
    "RestoreMethod",
    "RestoreMethodAvailabilityReason",
    "RestoreObfuscationConfigModeEnum",
    "RestoreTemplateResourceType",
    "RevalidationStatus",
    "RiskLevel",
    "RoleInstallationMethod",
    "RuleComponent",
    "SaasBackupStatus",
    "SaasEntityType",
    "SaasProtectionStatus",
    "SaasRestoreMode",
    "SaasWorkload",
    "ScalarOperators",
    "ScanJobType",
    "ScheduleMode",
    "ScheduleTimezone",
    "ScheduleType",
    "SearchAllSectionStatus",
    "SearchAllType",
    "SecurityAssignmentStatus",
    "SecurityScanConclusionEnum",
    "SecurityScanDetectorTypeEnum",
    "SecurityScanReviewerTypeEnum",
    "SecurityScanConclusion",
    "SecurityScanNotificationDataDetectorTypeEnum",
    "SecurityScanNotificationDataConclusionEnum",
    "SecurityScanResultEvidenceTypeEnum",
    "SecurityScanResultTypeEnum",
    "SendA2AMessageRequestJsonrpcEnum",
    "SendA2AMessageRequestMethodEnum",
    "SensitivityLevel",
    "SessionScope",
    "Severity",
    "SeverityFilterValue",
    "ShadowSnapshotType",
    "ShovalAgentInstallPlatform",
    "SnapshotCoverageAvailability",
    "SnapshotHoldReason",
    "SnapshotLocationSnapshotTypeEnum",
    "SnapshotRangePick",
    "SnapshotRecipeEntryAction",
    "SnapshotRecipeEntryReason",
    "SnapshotRecipeInvalidReason",
    "SnapshotRecipeProposalMode",
    "SnapshotRecipeRuleOp",
    "SnapshotRecipeStatus",
    "SnapshotSortField",
    "SnapshotStatus",
    "SortLogsByFieldEnum",
    "SortOrder",
    "SourceAccountSortField",
    "SqlSetupCheckStatus",
    "StandardBackupScheduleFrequency",
    "StandardIntervalConfigIntervalHoursEnum",
    "StepProgressUnit",
    "StorageGatewayStatus",
    "StringOperators",
    "SubnetConfigModeEnum",
    "ThreatHuntingStatus",
    "UnifiedRestoreDirectoryPresence",
    "UnifiedRestoreEntityType",
    "UpdateCloudResourceConfigurationRequestSetDbBackupModeEnum",
    "UsageType",
    "UsageUnit",
    "UserType",
    "VNetConfigModeEnum",
    "VaultEncryptionType",
    "VaultProtectionMode",
    "VaultStatus",
    "VaultStorageTier",
    "VaultTieringPolicyType",
    "VaultType",
    "WebhookV1AuditEventTypeEnum",
    "WebhookV1ConclusionTypes",
    "WebhookV1DetectorType",
    "WebhookV1FindingObjectType",
    "WebhookV1OnboardingPayloadTypeEnum",
    "WebhookV1PayloadTypeEnum",
    "WebhookV1ReviewerType",
    "WebhookV1RiskLevel",
    "WebhookV1SecurityScanApproval",
    "WebhookV1StandardPayloadTypeEnum",
    "WebhookV1StandardPayloadBackupJobFailedTypeEnum",
    "WebhookV1StandardPayloadBackupJobPartialTypeEnum",
    "WebhookV1StandardPayloadBackupJobRejectedTypeEnum",
    "WebhookV1StandardPayloadBackupJobSkippedTypeEnum",
    "WebhookV1StandardPayloadBackupJobSucceededTypeEnum",
    "WebhookV1StandardPayloadBackupVaultTypeEnum",
    "WebhookV1StandardPayloadClassificationJobFailedTypeEnum",
    "WebhookV1StandardPayloadClassificationJobRejectedTypeEnum",
    "WebhookV1StandardPayloadClassificationJobSkippedTypeEnum",
    "WebhookV1StandardPayloadCloudAccountTypeEnum",
    "WebhookV1StandardPayloadCreditsMonthlyUsageTypeEnum",
    "WebhookV1StandardPayloadCreditsUsageTypeEnum",
    "WebhookV1StandardPayloadGdsgOperationalTypeEnum",
    "WebhookV1StandardPayloadIssueMutedTypeEnum",
    "WebhookV1StandardPayloadJobMetricsReportFailedTypeEnum",
    "WebhookV1StandardPayloadMpaRequestTypeEnum",
    "WebhookV1StandardPayloadMpaReviewTypeEnum",
    "WebhookV1StandardPayloadNotificationTargetChangeTypeEnum",
    "WebhookV1StandardPayloadPolicyAssignmentTypeEnum",
    "WebhookV1StandardPayloadPolicyChangeTypeEnum",
    "WebhookV1StandardPayloadResourceTypeEnum",
    "WebhookV1StandardPayloadRestoreJobFailedTypeEnum",
    "WebhookV1StandardPayloadRestoreJobRejectedTypeEnum",
    "WebhookV1StandardPayloadRestoreJobSucceededTypeEnum",
    "WebhookV1StandardPayloadSnapshotTypeEnum",
    "WebhookV1StandardPayloadSnapshotAccessDeniedTypeEnum",
    "WebhookV1StandardPayloadSnapshotUserProtectionTypeEnum",
    "WebhookV1StandardPayloadViolationsTypeEnum",
    "WorkspaceRestoreMode",
    "ZeroEtlJobSyncStatus",
    "ZeroEtlJobType",
    "ZeroEtlJobsSortField",
    "ZeroEtlTableFormat",
    "ZeroEtlTargetTableStatus",
    "ZeroEtlTargetTablesSortField",
]);
let typeMap = {
    "AccessCondition": AccessCondition,
    "AccessConditionalExpression": AccessConditionalExpression,
    "AccessibleOrganizationAccount": AccessibleOrganizationAccount,
    "Account": Account,
    "AccountConfigInput": AccountConfigInput,
    "AccountDisplayNameFilters": AccountDisplayNameFilters,
    "AccountIdCondition": AccountIdCondition,
    "AccountIdFilters": AccountIdFilters,
    "AccountMetricsDestination": AccountMetricsDestination,
    "AccountModuleVersion": AccountModuleVersion,
    "AccountNameFilters": AccountNameFilters,
    "AccountStatusFilters": AccountStatusFilters,
    "AccountUpdateInput": AccountUpdateInput,
    "AccountVersion": AccountVersion,
    "ActionApprovalRule": ActionApprovalRule,
    "ActionApprovalRuleExpression": ActionApprovalRuleExpression,
    "ActionApprovalRuleGroupCondition": ActionApprovalRuleGroupCondition,
    "ActionApprovalRuleResourceSelector": ActionApprovalRuleResourceSelector,
    "ActionFilters": ActionFilters,
    "ActivateAtlasOrganizationResponse": ActivateAtlasOrganizationResponse,
    "ActivateGcpFolderResponse": ActivateGcpFolderResponse,
    "ActivateGcpOrganizationResponse": ActivateGcpOrganizationResponse,
    "AddRestoreAtlasPrivateLinkRequest": AddRestoreAtlasPrivateLinkRequest,
    "AdeRestoreEncryptionConfig": AdeRestoreEncryptionConfig,
    "AgreementWithCredits": AgreementWithCredits,
    "Ami": Ami,
    "AmiBlockDevice": AmiBlockDevice,
    "AnnuallyConfig": AnnuallyConfig,
    "AnomalyDataPoint": AnomalyDataPoint,
    "AnomalyGraphData": AnomalyGraphData,
    "ApiCredentials": ApiCredentials,
    "ApiCredentialsProperties": ApiCredentialsProperties,
    "App": App,
    "AppFilters": AppFilters,
    "ApplicationOverride": ApplicationOverride,
    "AppsCondition": AppsCondition,
    "AppsDetails": AppsDetails,
    "AtlasCluster": AtlasCluster,
    "AtlasClusters": AtlasClusters,
    "AtlasOrganization": AtlasOrganization,
    "AtlasProject": AtlasProject,
    "AtlasProjects": AtlasProjects,
    "AuditLog": AuditLog,
    "AuditLogCloudContext": AuditLogCloudContext,
    "AuditLogEntitiesInner": AuditLogEntitiesInner,
    "AuditLogExtendedData": AuditLogExtendedData,
    "AuditLogExtendedDataAuth": AuditLogExtendedDataAuth,
    "AuditLogExtendedDataMpa": AuditLogExtendedDataMpa,
    "AuditLogFilterConditions": AuditLogFilterConditions,
    "AuditLogSecurityContext": AuditLogSecurityContext,
    "AuditLogStateSnapshot": AuditLogStateSnapshot,
    "AuthResponse": AuthResponse,
    "AuthV2AssociateSoftwareTokenRequest": AuthV2AssociateSoftwareTokenRequest,
    "AuthV2AssociateSoftwareTokenResponse": AuthV2AssociateSoftwareTokenResponse,
    "AuthV2ConfirmForgotPasswordRequest": AuthV2ConfirmForgotPasswordRequest,
    "AuthV2ForgotPasswordRequest": AuthV2ForgotPasswordRequest,
    "AuthV2ForgotPasswordResponse": AuthV2ForgotPasswordResponse,
    "AuthV2LoginRequest": AuthV2LoginRequest,
    "AuthV2RespondChallengeRequest": AuthV2RespondChallengeRequest,
    "AuthV2VerifySoftwareTokenRequest": AuthV2VerifySoftwareTokenRequest,
    "AuthV2VerifySoftwareTokenResponse": AuthV2VerifySoftwareTokenResponse,
    "AwsAccountConfigInput": AwsAccountConfigInput,
    "AwsAccountMetricsDestination": AwsAccountMetricsDestination,
    "AwsCassandraClusterRestoreDestination": AwsCassandraClusterRestoreDestination,
    "AwsCassandraClusterRestoreTarget": AwsCassandraClusterRestoreTarget,
    "AwsDatabaseDestination": AwsDatabaseDestination,
    "AwsDynamoDBDestination": AwsDynamoDBDestination,
    "AwsDynamoDbResource": AwsDynamoDbResource,
    "AwsDynamoDbSnapshotProperties": AwsDynamoDbSnapshotProperties,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput,
    "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner": AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner,
    "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner": AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner,
    "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection": AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection,
    "AwsEbsSnapshotConvertResult": AwsEbsSnapshotConvertResult,
    "AwsEbsVolumeResource": AwsEbsVolumeResource,
    "AwsEbsVolumeRestoreData": AwsEbsVolumeRestoreData,
    "AwsEbsVolumeRestoreResult": AwsEbsVolumeRestoreResult,
    "AwsEbsVolumeSnapshotProperties": AwsEbsVolumeSnapshotProperties,
    "AwsEc2AmiConvertResult": AwsEc2AmiConvertResult,
    "AwsEc2InstanceRestoreDestination": AwsEc2InstanceRestoreDestination,
    "AwsEc2InstanceRestoreResult": AwsEc2InstanceRestoreResult,
    "AwsEc2InstanceRestoreTarget": AwsEc2InstanceRestoreTarget,
    "AwsEc2Resource": AwsEc2Resource,
    "AwsEc2SnapshotProperties": AwsEc2SnapshotProperties,
    "AwsEksClusterResource": AwsEksClusterResource,
    "AwsEksNamespaceResource": AwsEksNamespaceResource,
    "AwsEksNamespaceSnapshotProperties": AwsEksNamespaceSnapshotProperties,
    "AwsFsxResource": AwsFsxResource,
    "AwsKeyspacesDestination": AwsKeyspacesDestination,
    "AwsKeyspacesResource": AwsKeyspacesResource,
    "AwsNativePitrBackupPolicyPlan": AwsNativePitrBackupPolicyPlan,
    "AwsNativePitrBackupResourceType": AwsNativePitrBackupResourceType,
    "AwsNativePitrConfig": AwsNativePitrConfig,
    "AwsNativeStandardBackupPolicyPlan": AwsNativeStandardBackupPolicyPlan,
    "AwsNativeStandardBackupScheduleConfig": AwsNativeStandardBackupScheduleConfig,
    "AwsNativeStandardBackupSchedules": AwsNativeStandardBackupSchedules,
    "AwsNativeStandardIntervalConfig": AwsNativeStandardIntervalConfig,
    "AwsNeptuneResource": AwsNeptuneResource,
    "AwsOpenSearchDomainRestoreDestination": AwsOpenSearchDomainRestoreDestination,
    "AwsOpenSearchDomainRestoreTarget": AwsOpenSearchDomainRestoreTarget,
    "AwsOpenSearchIndexSelection": AwsOpenSearchIndexSelection,
    "AwsRdsResource": AwsRdsResource,
    "AwsRdsResourceAurora": AwsRdsResourceAurora,
    "AwsRdsResourceStorageSettings": AwsRdsResourceStorageSettings,
    "AwsRdsSnapshotProperties": AwsRdsSnapshotProperties,
    "AwsRestoreAccountAttributes": AwsRestoreAccountAttributes,
    "AwsRestoreAccountAttributesInput": AwsRestoreAccountAttributesInput,
    "AwsRestoreAccountConnectivityConfig": AwsRestoreAccountConnectivityConfig,
    "AwsRestoreServerNetworkParams": AwsRestoreServerNetworkParams,
    "AwsSourceAccountAttributes": AwsSourceAccountAttributes,
    "AwsSourceAccountAttributesInput": AwsSourceAccountAttributesInput,
    "AwsVaultConfig": AwsVaultConfig,
    "AwsVaultConfigInput": AwsVaultConfigInput,
    "AwsVpcConnectivityConfig": AwsVpcConnectivityConfig,
    "AzureAccountConfigInput": AzureAccountConfigInput,
    "AzureAksNamespaceResource": AzureAksNamespaceResource,
    "AzureAppRegistrationOption": AzureAppRegistrationOption,
    "AzureBackupApplicationsResponse": AzureBackupApplicationsResponse,
    "AzureCmkEligibleApp": AzureCmkEligibleApp,
    "AzureConsentUrlResponse": AzureConsentUrlResponse,
    "AzureDisk": AzureDisk,
    "AzureDiskEncryptionSet": AzureDiskEncryptionSet,
    "AzureDiskRestoreData": AzureDiskRestoreData,
    "AzureDiskRestoreDestination": AzureDiskRestoreDestination,
    "AzureDiskRestoreResult": AzureDiskRestoreResult,
    "AzureDiskSettings": AzureDiskSettings,
    "AzureDiskTarget": AzureDiskTarget,
    "AzureEntraIdPolicyConfig": AzureEntraIdPolicyConfig,
    "AzureEntraIdResource": AzureEntraIdResource,
    "AzureEntraIdRestoreConsent": AzureEntraIdRestoreConsent,
    "AzureEntraIdRestoreEntity": AzureEntraIdRestoreEntity,
    "AzureEonApplication": AzureEonApplication,
    "AzureFileShareRestoreFileSpec": AzureFileShareRestoreFileSpec,
    "AzureFilesBackupPolicyPlan": AzureFilesBackupPolicyPlan,
    "AzureFilesBackupSchedules": AzureFilesBackupSchedules,
    "AzureFilesStorageAccountSelection": AzureFilesStorageAccountSelection,
    "AzureKeyVaultKey": AzureKeyVaultKey,
    "AzureListResourceGroupsResponse": AzureListResourceGroupsResponse,
    "AzureListSubscriptionsResponse": AzureListSubscriptionsResponse,
    "AzureManagementGroup": AzureManagementGroup,
    "AzureManagementGroups": AzureManagementGroups,
    "AzureMarketplaceWebhookInput": AzureMarketplaceWebhookInput,
    "AzureMarketplaceWebhookInputSubscription": AzureMarketplaceWebhookInputSubscription,
    "AzureMarketplaceWebhookInputSubscriptionBeneficiary": AzureMarketplaceWebhookInputSubscriptionBeneficiary,
    "AzureMarketplaceWebhookInputSubscriptionPurchaser": AzureMarketplaceWebhookInputSubscriptionPurchaser,
    "AzureMarketplaceWebhookInputSubscriptionTerm": AzureMarketplaceWebhookInputSubscriptionTerm,
    "AzureMssqlSnapshotProperties": AzureMssqlSnapshotProperties,
    "AzureOnboardedTenantsResponse": AzureOnboardedTenantsResponse,
    "AzureOnboardingStatus": AzureOnboardingStatus,
    "AzureOptionalCapabilities": AzureOptionalCapabilities,
    "AzurePostgresDatabaseRestoreDestination": AzurePostgresDatabaseRestoreDestination,
    "AzurePostgresDatabaseRestoreTarget": AzurePostgresDatabaseRestoreTarget,
    "AzureResourceGroup": AzureResourceGroup,
    "AzureResourceGroups": AzureResourceGroups,
    "AzureRestoreAccountAttributes": AzureRestoreAccountAttributes,
    "AzureRestoreAccountAttributesInput": AzureRestoreAccountAttributesInput,
    "AzureRestoreAccountConnectivityConfig": AzureRestoreAccountConnectivityConfig,
    "AzureRestorePointData": AzureRestorePointData,
    "AzureRestorePointDisk": AzureRestorePointDisk,
    "AzureRestorePointSpec": AzureRestorePointSpec,
    "AzureSapHanaResource": AzureSapHanaResource,
    "AzureScanningAccountSetupStatus200Response": AzureScanningAccountSetupStatus200Response,
    "AzureSourceAccountAttributes": AzureSourceAccountAttributes,
    "AzureSourceAccountAttributesInput": AzureSourceAccountAttributesInput,
    "AzureSqlDatabaseNativePitrBackupPolicyPlan": AzureSqlDatabaseNativePitrBackupPolicyPlan,
    "AzureSqlDatabaseNativePitrBackupResourceType": AzureSqlDatabaseNativePitrBackupResourceType,
    "AzureSqlDatabaseNativePitrConfig": AzureSqlDatabaseNativePitrConfig,
    "AzureSqlDatabaseRestoreDestination": AzureSqlDatabaseRestoreDestination,
    "AzureSqlDatabaseRestoreTarget": AzureSqlDatabaseRestoreTarget,
    "AzureSqlRestoreTargetServers": AzureSqlRestoreTargetServers,
    "AzureSqlServer": AzureSqlServer,
    "AzureSqlTdeRestoreConfig": AzureSqlTdeRestoreConfig,
    "AzureStorageAccount": AzureStorageAccount,
    "AzureStorageAccounts": AzureStorageAccounts,
    "AzureSubscription": AzureSubscription,
    "AzureTenant": AzureTenant,
    "AzureVaultConfig": AzureVaultConfig,
    "AzureVaultConfigInput": AzureVaultConfigInput,
    "AzureVmInstanceRestoreDestination": AzureVmInstanceRestoreDestination,
    "AzureVmInstanceRestoreResult": AzureVmInstanceRestoreResult,
    "AzureVmInstanceRestoreTarget": AzureVmInstanceRestoreTarget,
    "AzureVmNativeRestoreTarget": AzureVmNativeRestoreTarget,
    "AzureVmResource": AzureVmResource,
    "AzureVmSnapshotProperties": AzureVmSnapshotProperties,
    "AzureVnetConnectivityConfig": AzureVnetConnectivityConfig,
    "BackedUpByResourceType": BackedUpByResourceType,
    "BackedUpByResourceTypeDataInner": BackedUpByResourceTypeDataInner,
    "BackedUpStorageDateHistogram": BackedUpStorageDateHistogram,
    "BackupControlViolations": BackupControlViolations,
    "BackupJob": BackupJob,
    "BackupJobResponse": BackupJobResponse,
    "BackupJobTypeFilters": BackupJobTypeFilters,
    "BackupJobsFilterConditions": BackupJobsFilterConditions,
    "BackupPoliciesFilters": BackupPoliciesFilters,
    "BackupPoliciesLimits": BackupPoliciesLimits,
    "BackupPoliciesSecurityConfig": BackupPoliciesSecurityConfig,
    "BackupPolicy": BackupPolicy,
    "BackupPolicyAppliesNotificationArguments": BackupPolicyAppliesNotificationArguments,
    "BackupPolicyConfig": BackupPolicyConfig,
    "BackupPolicyConfigResponse": BackupPolicyConfigResponse,
    "BackupPolicyExpression": BackupPolicyExpression,
    "BackupPolicyGroupCondition": BackupPolicyGroupCondition,
    "BackupPolicyNotificationArguments": BackupPolicyNotificationArguments,
    "BackupPolicyPlan": BackupPolicyPlan,
    "BackupPolicyResourceSelector": BackupPolicyResourceSelector,
    "BackupPolicySecurityConfig": BackupPolicySecurityConfig,
    "BackupPostureControl": BackupPostureControl,
    "BackupPostureControlExpression": BackupPostureControlExpression,
    "BackupPostureControlGroupCondition": BackupPostureControlGroupCondition,
    "BackupPostureControlResourceSelector": BackupPostureControlResourceSelector,
    "BackupPostureControlRules": BackupPostureControlRules,
    "BackupPostureControlSort": BackupPostureControlSort,
    "BackupRegionsFilters": BackupRegionsFilters,
    "BackupSchedule": BackupSchedule,
    "BackupScope": BackupScope,
    "BackupScopeResourcesLosingBackupCountResponse": BackupScopeResourcesLosingBackupCountResponse,
    "BackupScopeSummary": BackupScopeSummary,
    "BackupStatusFilters": BackupStatusFilters,
    "BackupVault": BackupVault,
    "BackupZeroEtlAccessConfiguration": BackupZeroEtlAccessConfiguration,
    "BackupZeroEtlAwsAccessConfiguration": BackupZeroEtlAwsAccessConfiguration,
    "BackupZeroEtlAwsGlueCatalogConfiguration": BackupZeroEtlAwsGlueCatalogConfiguration,
    "BackupZeroEtlCatalogConfiguration": BackupZeroEtlCatalogConfiguration,
    "BackupZeroEtlColumnDefinition": BackupZeroEtlColumnDefinition,
    "BackupZeroEtlColumnDefinitions": BackupZeroEtlColumnDefinitions,
    "BackupZeroEtlColumnExtract": BackupZeroEtlColumnExtract,
    "BackupZeroEtlFilters": BackupZeroEtlFilters,
    "BackupZeroEtlGlueCatalogLocation": BackupZeroEtlGlueCatalogLocation,
    "BackupZeroEtlIcebergPartitionSpec": BackupZeroEtlIcebergPartitionSpec,
    "BackupZeroEtlIcebergPartitionTransform": BackupZeroEtlIcebergPartitionTransform,
    "BackupZeroEtlIdentityColumnSpec": BackupZeroEtlIdentityColumnSpec,
    "BackupZeroEtlLakeStorageLocation": BackupZeroEtlLakeStorageLocation,
    "BackupZeroEtlMultiResourceRoutingPolicy": BackupZeroEtlMultiResourceRoutingPolicy,
    "BackupZeroEtlOrderingSpec": BackupZeroEtlOrderingSpec,
    "BackupZeroEtlPolicy": BackupZeroEtlPolicy,
    "BackupZeroEtlResourceSelector": BackupZeroEtlResourceSelector,
    "BackupZeroEtlSingleResourceColumnDefinitionConfig": BackupZeroEtlSingleResourceColumnDefinitionConfig,
    "BackupZeroEtlSingleResourceDatabaseNameAffixes": BackupZeroEtlSingleResourceDatabaseNameAffixes,
    "BackupZeroEtlSingleResourcePartitionConfig": BackupZeroEtlSingleResourcePartitionConfig,
    "BackupZeroEtlSingleResourceRoutingPolicy": BackupZeroEtlSingleResourceRoutingPolicy,
    "BackupZeroEtlSingleResourceTableMappingMergeDatabasesParams": BackupZeroEtlSingleResourceTableMappingMergeDatabasesParams,
    "BackupZeroEtlStorageConfiguration": BackupZeroEtlStorageConfiguration,
    "BackupZeroEtlTableFilter": BackupZeroEtlTableFilter,
    "BackupZeroEtlTableSelection": BackupZeroEtlTableSelection,
    "BatchApplicationOverrides": BatchApplicationOverrides,
    "BatchOperationResponse": BatchOperationResponse,
    "BatchResourceValidationResult": BatchResourceValidationResult,
    "BatchUpdateLlgPoliciesRequest": BatchUpdateLlgPoliciesRequest,
    "BatchUpdateLlgPolicyItem": BatchUpdateLlgPolicyItem,
    "BatchValidateResourceConfigurationRequest": BatchValidateResourceConfigurationRequest,
    "BatchValidateResourceConfigurationResponse": BatchValidateResourceConfigurationResponse,
    "BigQueryDatasetDestination": BigQueryDatasetDestination,
    "BigQueryIntegrationConfig": BigQueryIntegrationConfig,
    "BigQueryNativePitrBackupPolicyPlan": BigQueryNativePitrBackupPolicyPlan,
    "BigQueryNativePitrBackupResourceType": BigQueryNativePitrBackupResourceType,
    "BigQueryNativePitrConfig": BigQueryNativePitrConfig,
    "BigQueryNativePitrDestination": BigQueryNativePitrDestination,
    "BillingPeriod": BillingPeriod,
    "BillingTransactionHistory": BillingTransactionHistory,
    "BooleanFilters": BooleanFilters,
    "BulkAttachRestoreTemplateRequest": BulkAttachRestoreTemplateRequest,
    "BulkDetachRestoreTemplateRequest": BulkDetachRestoreTemplateRequest,
    "BulkRestoreItem": BulkRestoreItem,
    "BulkRestoreRequest": BulkRestoreRequest,
    "BulkRestoreResponse": BulkRestoreResponse,
    "BulkRestoreResponseItemsInner": BulkRestoreResponseItemsInner,
    "BulkRestoreResponseJobsInner": BulkRestoreResponseJobsInner,
    "BulkRestoreValidateRequest": BulkRestoreValidateRequest,
    "BulkRestoreValidateResponse": BulkRestoreValidateResponse,
    "BulkRestoreValidateResponseItemsInner": BulkRestoreValidateResponseItemsInner,
    "BulkSelectSnapshotsForResourcesRequest": BulkSelectSnapshotsForResourcesRequest,
    "BulkSelectSnapshotsForResourcesResponse": BulkSelectSnapshotsForResourcesResponse,
    "BulkSelectSnapshotsForResourcesResponseItemsInner": BulkSelectSnapshotsForResourcesResponseItemsInner,
    "CancelExclusionFromBackupResponse": CancelExclusionFromBackupResponse,
    "CancelMyMPARequestResponse": CancelMyMPARequestResponse,
    "CassandraClusterResource": CassandraClusterResource,
    "Catalog": Catalog,
    "CdcBackupModeCheckResult": CdcBackupModeCheckResult,
    "CheckAzureDiskEncryptionSetAccessRequest": CheckAzureDiskEncryptionSetAccessRequest,
    "CheckAzureDiskEncryptionSetAccessResponse": CheckAzureDiskEncryptionSetAccessResponse,
    "CheckAzureVMNameExists200Response": CheckAzureVMNameExists200Response,
    "CheckAzureVMNameExistsRequest": CheckAzureVMNameExistsRequest,
    "CheckCdcPrerequisitesResponse": CheckCdcPrerequisitesResponse,
    "CheckIngestionPipelineAccessRequest": CheckIngestionPipelineAccessRequest,
    "CheckIngestionPipelineAccessResponse": CheckIngestionPipelineAccessResponse,
    "ClassificationCategory": ClassificationCategory,
    "ClassificationPolicy": ClassificationPolicy,
    "ClassificationPolicySchedule": ClassificationPolicySchedule,
    "ClassificationScheduleConfig": ClassificationScheduleConfig,
    "Classifications": Classifications,
    "CloudAccountIdFilters": CloudAccountIdFilters,
    "CloudAccountNotificationArguments": CloudAccountNotificationArguments,
    "CloudProviderCondition": CloudProviderCondition,
    "CloudProviderFilters": CloudProviderFilters,
    "CloudRegion": CloudRegion,
    "CloudResourceAttachmentEvent": CloudResourceAttachmentEvent,
    "CloudResourceConfiguration": CloudResourceConfiguration,
    "CloudResourceConfigurationCdcBackup": CloudResourceConfigurationCdcBackup,
    "CloudResourceConfigurationInventoryBackup": CloudResourceConfigurationInventoryBackup,
    "CloudResourceSecurityProperties": CloudResourceSecurityProperties,
    "CloudSnapshotsPerVolume": CloudSnapshotsPerVolume,
    "ClusterNameFilters": ClusterNameFilters,
    "CognitoExchangeRequest": CognitoExchangeRequest,
    "CognitoExchangeResponse": CognitoExchangeResponse,
    "Column": Column,
    "ColumnMetadata": ColumnMetadata,
    "ColumnValueDistribution": ColumnValueDistribution,
    "CompanyContact": CompanyContact,
    "ComplianceControlTrends": ComplianceControlTrends,
    "ComplianceStatusFilters": ComplianceStatusFilters,
    "ComplianceSummary": ComplianceSummary,
    "ComplianceTrend": ComplianceTrend,
    "Condition": Condition,
    "ConfigurationStatusFilters": ConfigurationStatusFilters,
    "ConnectAtlasOrganizationRequest": ConnectAtlasOrganizationRequest,
    "ConnectAtlasOrganizationResponse": ConnectAtlasOrganizationResponse,
    "ConnectAzureBackupAccountRequest": ConnectAzureBackupAccountRequest,
    "ConnectAzureBackupApplicationsRequest": ConnectAzureBackupApplicationsRequest,
    "ConnectAzureRestoreAccountRequest": ConnectAzureRestoreAccountRequest,
    "ConnectAzureSourceAccountRequest": ConnectAzureSourceAccountRequest,
    "ConnectAzureVaultAccountRequest": ConnectAzureVaultAccountRequest,
    "ConnectBYOApps200Response": ConnectBYOApps200Response,
    "ConnectBYOAppsRequest": ConnectBYOAppsRequest,
    "ConnectBYOAzureBackupApplicationsRequest": ConnectBYOAzureBackupApplicationsRequest,
    "ConnectCustomerVaultAccountRequest": ConnectCustomerVaultAccountRequest,
    "ConnectCustomerVaultAccountResponse": ConnectCustomerVaultAccountResponse,
    "ConnectGcpFolderRequest": ConnectGcpFolderRequest,
    "ConnectGcpFolderResponse": ConnectGcpFolderResponse,
    "ConnectGcpOrganizationRequest": ConnectGcpOrganizationRequest,
    "ConnectGcpOrganizationResponse": ConnectGcpOrganizationResponse,
    "ConnectRestoreAccountRequest": ConnectRestoreAccountRequest,
    "ConnectRestoreAccountResponse": ConnectRestoreAccountResponse,
    "ConnectRestoreAwsOrganizationalUnitRequest": ConnectRestoreAwsOrganizationalUnitRequest,
    "ConnectRestoreAwsOrganizationalUnitResponse": ConnectRestoreAwsOrganizationalUnitResponse,
    "ConnectSourceAccountRequest": ConnectSourceAccountRequest,
    "ConnectSourceAccountResponse": ConnectSourceAccountResponse,
    "ConnectSourceAwsOrganizationalUnitRequest": ConnectSourceAwsOrganizationalUnitRequest,
    "ConnectSourceAwsOrganizationalUnitResponse": ConnectSourceAwsOrganizationalUnitResponse,
    "ControlComplianceEntry": ControlComplianceEntry,
    "ControlFailureCount": ControlFailureCount,
    "ControlPlaneConfig": ControlPlaneConfig,
    "ControlTrendEntry": ControlTrendEntry,
    "ControlViolation": ControlViolation,
    "ControlViolations": ControlViolations,
    "ControlViolationsPerSeverity": ControlViolationsPerSeverity,
    "ControlViolationsPerSeverityViolatedControlsInner": ControlViolationsPerSeverityViolatedControlsInner,
    "ControlsFilters": ControlsFilters,
    "ConvertEbsSnapshotConfig": ConvertEbsSnapshotConfig,
    "ConvertEc2ImageConfig": ConvertEc2ImageConfig,
    "ConvertOtherSnapshotsOnDemandRequest": ConvertOtherSnapshotsOnDemandRequest,
    "ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner": ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner,
    "ConvertResourceSnapshotsRequest": ConvertResourceSnapshotsRequest,
    "ConvertResourceSnapshotsResponse": ConvertResourceSnapshotsResponse,
    "Cost": Cost,
    "CostDataFilters": CostDataFilters,
    "CostDataRecord": CostDataRecord,
    "CostDataRecordCost": CostDataRecordCost,
    "CostDataRecordDimensions": CostDataRecordDimensions,
    "CostProductFilters": CostProductFilters,
    "CostRecordMetadata": CostRecordMetadata,
    "CostRecordMetadataDataTransfer": CostRecordMetadataDataTransfer,
    "CreateAccessGrantRequest": CreateAccessGrantRequest,
    "CreateAccessPolicyRequest": CreateAccessPolicyRequest,
    "CreateAccountInput": CreateAccountInput,
    "CreateActionApprovalRuleRequest": CreateActionApprovalRuleRequest,
    "CreateActionApprovalRuleResponse": CreateActionApprovalRuleResponse,
    "CreateApiCredentialsRequest": CreateApiCredentialsRequest,
    "CreateApiCredentialsResponse": CreateApiCredentialsResponse,
    "CreateBackupPolicyRequest": CreateBackupPolicyRequest,
    "CreateBackupPolicyResponse": CreateBackupPolicyResponse,
    "CreateBackupPostureControlRequest": CreateBackupPostureControlRequest,
    "CreateBackupZeroEtlPolicyInput": CreateBackupZeroEtlPolicyInput,
    "CreateClassificationPolicyRequest": CreateClassificationPolicyRequest,
    "CreateClassificationPolicyResponse": CreateClassificationPolicyResponse,
    "CreateDataCatalogPipelineRequest": CreateDataCatalogPipelineRequest,
    "CreateDlsgPolicyRequest": CreateDlsgPolicyRequest,
    "CreateDlsgPolicyResponse": CreateDlsgPolicyResponse,
    "CreateFabricTableShortcutDemoRequest": CreateFabricTableShortcutDemoRequest,
    "CreateFabricTableShortcutDemoRequestShortcutsInner": CreateFabricTableShortcutDemoRequestShortcutsInner,
    "CreateFabricTableShortcutDemoResponse": CreateFabricTableShortcutDemoResponse,
    "CreateFabricTableShortcutDemoResponseResultsInner": CreateFabricTableShortcutDemoResponseResultsInner,
    "CreateFindingExclusionRequest": CreateFindingExclusionRequest,
    "CreateFindingExclusionResponse": CreateFindingExclusionResponse,
    "CreateGdsgInventoryReportConfigurationRequest": CreateGdsgInventoryReportConfigurationRequest,
    "CreateGdsgInventoryReportConfigurationResponse": CreateGdsgInventoryReportConfigurationResponse,
    "CreateIdpGroupRequest": CreateIdpGroupRequest,
    "CreateIdpGroupResponse": CreateIdpGroupResponse,
    "CreateIntegrationRequest": CreateIntegrationRequest,
    "CreateIntegrationResponse": CreateIntegrationResponse,
    "CreateMPARequestReviewRequest": CreateMPARequestReviewRequest,
    "CreateMPARequestReviewResponse": CreateMPARequestReviewResponse,
    "CreateOAuthAppRequest": CreateOAuthAppRequest,
    "CreateOAuthAppResponse": CreateOAuthAppResponse,
    "CreateOrganizationIdpGroupRequest": CreateOrganizationIdpGroupRequest,
    "CreateOrganizationIdpGroupResponse": CreateOrganizationIdpGroupResponse,
    "CreateOrganizationIdpRequest": CreateOrganizationIdpRequest,
    "CreateOrganizationIdpResponse": CreateOrganizationIdpResponse,
    "CreateOrganizationUserRequest": CreateOrganizationUserRequest,
    "CreateOrganizationUserResponse": CreateOrganizationUserResponse,
    "CreatePolicyInput": CreatePolicyInput,
    "CreatePolicyScheduleInput": CreatePolicyScheduleInput,
    "CreateProjectInput": CreateProjectInput,
    "CreatePulumiConfigurationRequest": CreatePulumiConfigurationRequest,
    "CreateRestoreTemplateRequest": CreateRestoreTemplateRequest,
    "CreateRestoreTemplateResponse": CreateRestoreTemplateResponse,
    "CreateRoleRequest": CreateRoleRequest,
    "CreateRoleResponse": CreateRoleResponse,
    "CreateSamlIdentityProviderConfigInput": CreateSamlIdentityProviderConfigInput,
    "CreateScanJobInput": CreateScanJobInput,
    "CreateScanJobResponse": CreateScanJobResponse,
    "CreateSessionRequest": CreateSessionRequest,
    "CreateSnapshotRecipeRequest": CreateSnapshotRecipeRequest,
    "CreateSnapshotRecipeResponse": CreateSnapshotRecipeResponse,
    "CreateTagDefinitionRequest": CreateTagDefinitionRequest,
    "CreateThreatHuntingScanRequestRequest": CreateThreatHuntingScanRequestRequest,
    "CreateThreatHuntingScanRequestResponse": CreateThreatHuntingScanRequestResponse,
    "CreateUserInput": CreateUserInput,
    "CreateVaultRequest": CreateVaultRequest,
    "CreateVaultResponse": CreateVaultResponse,
    "CredentialFinding": CredentialFinding,
    "CreditsMonthlyUsageNotificationArguments": CreditsMonthlyUsageNotificationArguments,
    "CreditsNotificationArguments": CreditsNotificationArguments,
    "CrossResourceQueryRequest": CrossResourceQueryRequest,
    "CrossResourceQueryRequestResourcesInner": CrossResourceQueryRequestResourcesInner,
    "CustomTagsInner": CustomTagsInner,
    "CustomerVaultAccount": CustomerVaultAccount,
    "DBResourceMetadata": DBResourceMetadata,
    "DBServerRecord": DBServerRecord,
    "DBSnapshotMetadata": DBSnapshotMetadata,
    "DBValueDistributionResponse": DBValueDistributionResponse,
    "DailyConfig": DailyConfig,
    "DailySnapshotData": DailySnapshotData,
    "DailyStorageSummaries": DailyStorageSummaries,
    "DailyStorageSummary": DailyStorageSummary,
    "Dashboard": Dashboard,
    "Dashboards": Dashboards,
    "DataCatalogAccessGrant": DataCatalogAccessGrant,
    "DataCatalogAccessPolicy": DataCatalogAccessPolicy,
    "DataCatalogDataset": DataCatalogDataset,
    "DataCatalogDatasetEvent": DataCatalogDatasetEvent,
    "DataCatalogDatasetHealth": DataCatalogDatasetHealth,
    "DataCatalogDatasetHealthIssue": DataCatalogDatasetHealthIssue,
    "DataCatalogDatasetSchema": DataCatalogDatasetSchema,
    "DataCatalogDatasetSchemaColumnsInner": DataCatalogDatasetSchemaColumnsInner,
    "DataCatalogDiscoveryProperties": DataCatalogDiscoveryProperties,
    "DataCatalogEffectiveTag": DataCatalogEffectiveTag,
    "DataCatalogGrantScope": DataCatalogGrantScope,
    "DataCatalogJoinabilityEntry": DataCatalogJoinabilityEntry,
    "DataCatalogJoinabilitySide": DataCatalogJoinabilitySide,
    "DataCatalogMaskTransform": DataCatalogMaskTransform,
    "DataCatalogMaskingPolicyBody": DataCatalogMaskingPolicyBody,
    "DataCatalogNamespace": DataCatalogNamespace,
    "DataCatalogPipeline": DataCatalogPipeline,
    "DataCatalogPipelineAddressPart": DataCatalogPipelineAddressPart,
    "DataCatalogPipelineAddressPartPattern": DataCatalogPipelineAddressPartPattern,
    "DataCatalogPipelineDefinition": DataCatalogPipelineDefinition,
    "DataCatalogPipelineOutput": DataCatalogPipelineOutput,
    "DataCatalogPipelineOutputPartitionSpecInner": DataCatalogPipelineOutputPartitionSpecInner,
    "DataCatalogPipelineResolvedDataset": DataCatalogPipelineResolvedDataset,
    "DataCatalogPipelineResolvedGroup": DataCatalogPipelineResolvedGroup,
    "DataCatalogPipelineResolvedGroupKeyInner": DataCatalogPipelineResolvedGroupKeyInner,
    "DataCatalogPipelineSchedule": DataCatalogPipelineSchedule,
    "DataCatalogPipelineSource": DataCatalogPipelineSource,
    "DataCatalogPipelineViolation": DataCatalogPipelineViolation,
    "DataCatalogPolicyScope": DataCatalogPolicyScope,
    "DataCatalogRowExpression": DataCatalogRowExpression,
    "DataCatalogRowFilterPolicyBody": DataCatalogRowFilterPolicyBody,
    "DataCatalogRowLiteral": DataCatalogRowLiteral,
    "DataCatalogRowPredicate": DataCatalogRowPredicate,
    "DataCatalogSemanticLayerRun": DataCatalogSemanticLayerRun,
    "DataCatalogSubjectRef": DataCatalogSubjectRef,
    "DataCatalogSubjectSet": DataCatalogSubjectSet,
    "DataCatalogTagAssignment": DataCatalogTagAssignment,
    "DataCatalogTagConjunction": DataCatalogTagConjunction,
    "DataCatalogTagDefinition": DataCatalogTagDefinition,
    "DataCatalogTagExpression": DataCatalogTagExpression,
    "DataCatalogTagPredicate": DataCatalogTagPredicate,
    "DataCatalogTagResourceRef": DataCatalogTagResourceRef,
    "DataCatalogTreeItem": DataCatalogTreeItem,
    "DataCatalogValidationIssue": DataCatalogValidationIssue,
    "DataCatalogViewAiProperties": DataCatalogViewAiProperties,
    "DataCatalogViewProperties": DataCatalogViewProperties,
    "DataCatalogViewQuery": DataCatalogViewQuery,
    "DataClassEntitiesFilters": DataClassEntitiesFilters,
    "DataClassesCondition": DataClassesCondition,
    "DataClassesDetails": DataClassesDetails,
    "DataClassesFilters": DataClassesFilters,
    "DataClassificationEntity": DataClassificationEntity,
    "DataClassificationEntityOption": DataClassificationEntityOption,
    "DataShareIntegrationConfig": DataShareIntegrationConfig,
    "Database": Database,
    "DatabaseDestination": DatabaseDestination,
    "DatabaseRecord": DatabaseRecord,
    "DatabricksIntegrationConfig": DatabricksIntegrationConfig,
    "DeactivateAccountRequest": DeactivateAccountRequest,
    "DeactivateAccountResponse": DeactivateAccountResponse,
    "DeactivateAtlasOrganizationResponse": DeactivateAtlasOrganizationResponse,
    "DeactivateGcpFolderResponse": DeactivateGcpFolderResponse,
    "DeactivateGcpOrganizationResponse": DeactivateGcpOrganizationResponse,
    "DeleteGdsgObjectsRequest": DeleteGdsgObjectsRequest,
    "DeleteGdsgObjectsResponse": DeleteGdsgObjectsResponse,
    "DeleteResourceTagRequest": DeleteResourceTagRequest,
    "DestinationDetails": DestinationDetails,
    "DestinationProviderAttributes": DestinationProviderAttributes,
    "DestinationProviderAttributesAzure": DestinationProviderAttributesAzure,
    "DestinationRestoreTypeAttributes": DestinationRestoreTypeAttributes,
    "DetectorSummary": DetectorSummary,
    "DetectorTypeFilters": DetectorTypeFilters,
    "DirectoryApplicationSummary": DirectoryApplicationSummary,
    "DirectoryEdgeRecord": DirectoryEdgeRecord,
    "DirectoryEntityRecord": DirectoryEntityRecord,
    "DirectoryEntityTypeCount": DirectoryEntityTypeCount,
    "DirectorySearchFilter": DirectorySearchFilter,
    "DisableResourceOverrideLimitsResponse": DisableResourceOverrideLimitsResponse,
    "DisconnectCustomerVaultAccountResponse": DisconnectCustomerVaultAccountResponse,
    "DisconnectRestoreAccountResponse": DisconnectRestoreAccountResponse,
    "DisconnectRestoreAwsOrganizationalUnitResponse": DisconnectRestoreAwsOrganizationalUnitResponse,
    "DisconnectSourceAccountResponse": DisconnectSourceAccountResponse,
    "DisconnectSourceAwsOrganizationalUnitResponse": DisconnectSourceAwsOrganizationalUnitResponse,
    "DiscoveryInvokeParams": DiscoveryInvokeParams,
    "DiscoveryJob": DiscoveryJob,
    "DiscoveryStatusResponse": DiscoveryStatusResponse,
    "DlsgPolicy": DlsgPolicy,
    "DlsgPolicyConfig": DlsgPolicyConfig,
    "DlsgPolicyFilters": DlsgPolicyFilters,
    "DlsgPolicyPlan": DlsgPolicyPlan,
    "DlsgSettings": DlsgSettings,
    "DocumentDBRestoreDestination": DocumentDBRestoreDestination,
    "DocumentDbClusterParameterGroup": DocumentDbClusterParameterGroup,
    "DocumentDbClusterParameterGroups": DocumentDbClusterParameterGroups,
    "DocumentDbSnapshotProperties": DocumentDbSnapshotProperties,
    "DownloadGdsgObjectsRequest": DownloadGdsgObjectsRequest,
    "DriftProtectionPolicy": DriftProtectionPolicy,
    "DriftProtectionSummary": DriftProtectionSummary,
    "DriftProtectionTimePoint": DriftProtectionTimePoint,
    "DsgBucketFilters": DsgBucketFilters,
    "DsgEnvironmentFilters": DsgEnvironmentFilters,
    "DsgRegionFilters": DsgRegionFilters,
    "DsgRequestTypeFilters": DsgRequestTypeFilters,
    "DsgStorageTierFilters": DsgStorageTierFilters,
    "DynamoDBAdvancedIndexConfig": DynamoDBAdvancedIndexConfig,
    "DynamoDBRestoreMethodAvailabilityRequest": DynamoDBRestoreMethodAvailabilityRequest,
    "DynamoDBRestoreMethodAvailabilityResponse": DynamoDBRestoreMethodAvailabilityResponse,
    "DynamoDbBackupConfig": DynamoDbBackupConfig,
    "DynamoDbBackupConfigApplication": DynamoDbBackupConfigApplication,
    "DynamoDbGlobalSecondaryIndex": DynamoDbGlobalSecondaryIndex,
    "DynamoDbIndexKeySchemaElement": DynamoDbIndexKeySchemaElement,
    "DynamoDbIndexProjection": DynamoDbIndexProjection,
    "DynamoDbIndexThroughput": DynamoDbIndexThroughput,
    "DynamoDbLocalSecondaryIndex": DynamoDbLocalSecondaryIndex,
    "DynamodbTableRestoreDestination": DynamodbTableRestoreDestination,
    "EFSRestoreDestination": EFSRestoreDestination,
    "EbsRestoreDestination": EbsRestoreDestination,
    "EbsSnapshotRestoreDestination": EbsSnapshotRestoreDestination,
    "EbsSnapshotTarget": EbsSnapshotTarget,
    "EbsTarget": EbsTarget,
    "Ec2TemplateParams": Ec2TemplateParams,
    "Ec2TemplateParamsAdditionalTagsInner": Ec2TemplateParamsAdditionalTagsInner,
    "EfsSnapshotProperties": EfsSnapshotProperties,
    "EksBackupNamespaces": EksBackupNamespaces,
    "EksCluster": EksCluster,
    "EksClusterRestoreDestination": EksClusterRestoreDestination,
    "EksClusterSnapshotProperties": EksClusterSnapshotProperties,
    "EksNamespaceRestoreDestination": EksNamespaceRestoreDestination,
    "EksNamespaceRestoreResult": EksNamespaceRestoreResult,
    "EksRestoreTargetClusters": EksRestoreTargetClusters,
    "EksVolumeRestoreResult": EksVolumeRestoreResult,
    "EmailSearchFilter": EmailSearchFilter,
    "EmrIntegrationConfig": EmrIntegrationConfig,
    "EnableFromLimitExceededResponse": EnableFromLimitExceededResponse,
    "EnableResourceOverrideLimitsResponse": EnableResourceOverrideLimitsResponse,
    "EnableRestoreAccountMetricsConfigRequest": EnableRestoreAccountMetricsConfigRequest,
    "EnableRestoreAccountMetricsConfigResponse": EnableRestoreAccountMetricsConfigResponse,
    "EnableSourceAccountMetricsConfigRequest": EnableSourceAccountMetricsConfigRequest,
    "EnableSourceAccountMetricsConfigResponse": EnableSourceAccountMetricsConfigResponse,
    "EncryptionKey": EncryptionKey,
    "EncryptionKeys": EncryptionKeys,
    "EncryptionTypeCondition": EncryptionTypeCondition,
    "EncryptionTypeFilters": EncryptionTypeFilters,
    "EndTimeDateFilters": EndTimeDateFilters,
    "EntraIdConnectionInfo": EntraIdConnectionInfo,
    "EntraIdEntitySelection": EntraIdEntitySelection,
    "EntraIdRestoreAccountAttributes": EntraIdRestoreAccountAttributes,
    "EntraIdRestoreAccountAttributesInput": EntraIdRestoreAccountAttributesInput,
    "EntraIdSourceAccountAttributesInput": EntraIdSourceAccountAttributesInput,
    "EntraRestoreReport": EntraRestoreReport,
    "EntraRestoreReportEntity": EntraRestoreReportEntity,
    "EntraRestoreReportEntityRelationships": EntraRestoreReportEntityRelationships,
    "EntraRestoreReportEntityRequiredActionsInner": EntraRestoreReportEntityRequiredActionsInner,
    "EntraRestoreReportJob": EntraRestoreReportJob,
    "EntraRestoreReportSummary": EntraRestoreReportSummary,
    "EntraRestoreReportSummaryByMethod": EntraRestoreReportSummaryByMethod,
    "EntraRestoreReportSummaryByTypeValue": EntraRestoreReportSummaryByTypeValue,
    "EnvironmentCondition": EnvironmentCondition,
    "EnvironmentDetails": EnvironmentDetails,
    "EnvironmentFilters": EnvironmentFilters,
    "EonAccount": EonAccount,
    "EonAccountIdFilters": EonAccountIdFilters,
    "EonOrganization": EonOrganization,
    "EonOrganizationSummary": EonOrganizationSummary,
    "EvaluateRestoreTemplateResponse": EvaluateRestoreTemplateResponse,
    "EvidenceTypeFilters": EvidenceTypeFilters,
    "ExcludeFromBackupResponse": ExcludeFromBackupResponse,
    "ExportAccessDeniedItemsRequest": ExportAccessDeniedItemsRequest,
    "ExportComplianceReportRequest": ExportComplianceReportRequest,
    "ExportComplianceReportResponse": ExportComplianceReportResponse,
    "ExportCostDataRequest": ExportCostDataRequest,
    "ExportOrganizationCostData400Response": ExportOrganizationCostData400Response,
    "ExportOrganizationCostDataRequest": ExportOrganizationCostDataRequest,
    "FSxRestoreDestination": FSxRestoreDestination,
    "FSxRestoreDestinationOntapRestoreOptions": FSxRestoreDestinationOntapRestoreOptions,
    "FeatureFlagOverrideGet200Response": FeatureFlagOverrideGet200Response,
    "FieldStatus": FieldStatus,
    "FileExplorerCountPathFilesResponse": FileExplorerCountPathFilesResponse,
    "FileExplorerCountSecurityAlertsInResourceResponse": FileExplorerCountSecurityAlertsInResourceResponse,
    "FileExplorerCountWorkspaceEntitiesResponse": FileExplorerCountWorkspaceEntitiesResponse,
    "FileExplorerResponse": FileExplorerResponse,
    "FilePath": FilePath,
    "FileRestoreData": FileRestoreData,
    "FileSearchRecord": FileSearchRecord,
    "FileSnapshot": FileSnapshot,
    "FilterQueryRequest": FilterQueryRequest,
    "FindingCountEntry": FindingCountEntry,
    "FindingEntry": FindingEntry,
    "FindingExclusion": FindingExclusion,
    "FindingExclusionDetectorFilters": FindingExclusionDetectorFilters,
    "FindingExclusionFilterConditions": FindingExclusionFilterConditions,
    "FindingExclusionResourceFilter": FindingExclusionResourceFilter,
    "FindingExclusionScopeFilters": FindingExclusionScopeFilters,
    "FindingExclusionTypeFilters": FindingExclusionTypeFilters,
    "FindingExclusionValueFilters": FindingExclusionValueFilters,
    "FindingObjectTypeFilters": FindingObjectTypeFilters,
    "FindingResourceFilters": FindingResourceFilters,
    "FindingSensitiveDataLocation": FindingSensitiveDataLocation,
    "FindingStatusFilters": FindingStatusFilters,
    "ForceDeleteSnapshotsRequest": ForceDeleteSnapshotsRequest,
    "FreeTextFilters": FreeTextFilters,
    "FsxOntapVolume": FsxOntapVolume,
    "FsxSnapshotProperties": FsxSnapshotProperties,
    "FsxVolumeBackupInfo": FsxVolumeBackupInfo,
    "GCSBucket": GCSBucket,
    "GCSBuckets": GCSBuckets,
    "GCSRestoreDestination": GCSRestoreDestination,
    "GCSRestoreTarget": GCSRestoreTarget,
    "GcpAccountConfigInput": GcpAccountConfigInput,
    "GcpBigQueryDatasetRestoreResult": GcpBigQueryDatasetRestoreResult,
    "GcpBigQueryResource": GcpBigQueryResource,
    "GcpBigQueryResourceMaterializedViewsInner": GcpBigQueryResourceMaterializedViewsInner,
    "GcpBigQueryResourceRoutinesInner": GcpBigQueryResourceRoutinesInner,
    "GcpBigQueryResourceTablesInner": GcpBigQueryResourceTablesInner,
    "GcpBigQueryResourceViewsInner": GcpBigQueryResourceViewsInner,
    "GcpCloudSqlResource": GcpCloudSqlResource,
    "GcpCloudSqlResourceStorageSettings": GcpCloudSqlResourceStorageSettings,
    "GcpCloudSqlRestoreDestination": GcpCloudSqlRestoreDestination,
    "GcpCloudSqlSnapshotProperties": GcpCloudSqlSnapshotProperties,
    "GcpCloudSqlTarget": GcpCloudSqlTarget,
    "GcpDiskResource": GcpDiskResource,
    "GcpDiskRestoreData": GcpDiskRestoreData,
    "GcpDiskRestoreDestination": GcpDiskRestoreDestination,
    "GcpDiskSettings": GcpDiskSettings,
    "GcpDiskSnapshotProperties": GcpDiskSnapshotProperties,
    "GcpDiskTarget": GcpDiskTarget,
    "GcpDiskTypesResponse": GcpDiskTypesResponse,
    "GcpEncryptionKey": GcpEncryptionKey,
    "GcpEncryptionKeys": GcpEncryptionKeys,
    "GcpGcsResource": GcpGcsResource,
    "GcpGkeNamespaceResource": GcpGkeNamespaceResource,
    "GcpGrantedServices": GcpGrantedServices,
    "GcpLabelFilter": GcpLabelFilter,
    "GcpMachineTypesResponse": GcpMachineTypesResponse,
    "GcpNetworkConnectivityConfig": GcpNetworkConnectivityConfig,
    "GcpOptionalCapabilities": GcpOptionalCapabilities,
    "GcpOrganization": GcpOrganization,
    "GcpRestoreAccountAttributes": GcpRestoreAccountAttributes,
    "GcpRestoreAccountAttributesInput": GcpRestoreAccountAttributesInput,
    "GcpRestoreAccountConnectivityConfig": GcpRestoreAccountConnectivityConfig,
    "GcpRestoreGrantedServices": GcpRestoreGrantedServices,
    "GcpSapHanaResource": GcpSapHanaResource,
    "GcpSourceAccountAttributes": GcpSourceAccountAttributes,
    "GcpSourceAccountAttributesInput": GcpSourceAccountAttributesInput,
    "GcpSourceServices": GcpSourceServices,
    "GcpSqlVmSetup": GcpSqlVmSetup,
    "GcpSubnet": GcpSubnet,
    "GcpSubnetPerRegion": GcpSubnetPerRegion,
    "GcpTagFilter": GcpTagFilter,
    "GcpVaultConfig": GcpVaultConfig,
    "GcpVaultConfigInput": GcpVaultConfigInput,
    "GcpVmInstanceRestoreDestination": GcpVmInstanceRestoreDestination,
    "GcpVmInstanceRestoreResult": GcpVmInstanceRestoreResult,
    "GcpVmInstanceRestoreTarget": GcpVmInstanceRestoreTarget,
    "GcpVmResource": GcpVmResource,
    "GcpVmSnapshotProperties": GcpVmSnapshotProperties,
    "GdsgActiveBatchJobs": GdsgActiveBatchJobs,
    "GdsgBigtableClusterStats": GdsgBigtableClusterStats,
    "GdsgBigtableStorageTypeBytes": GdsgBigtableStorageTypeBytes,
    "GdsgBigtableTableCpu": GdsgBigtableTableCpu,
    "GdsgBigtableTableStorage": GdsgBigtableTableStorage,
    "GdsgBucketStats": GdsgBucketStats,
    "GdsgDeleteResult": GdsgDeleteResult,
    "GdsgDevStats": GdsgDevStats,
    "GdsgEnvironment": GdsgEnvironment,
    "GdsgEnvironmentRegion": GdsgEnvironmentRegion,
    "GdsgInventoryReportConfiguration": GdsgInventoryReportConfiguration,
    "GdsgInventoryReportConfigurationInput": GdsgInventoryReportConfigurationInput,
    "GdsgInventoryReportCsvOptions": GdsgInventoryReportCsvOptions,
    "GdsgInventoryReportFrequencyOptions": GdsgInventoryReportFrequencyOptions,
    "GdsgInventoryReportRun": GdsgInventoryReportRun,
    "GdsgObjectEntry": GdsgObjectEntry,
    "GdsgOperationalNotificationArguments": GdsgOperationalNotificationArguments,
    "GdsgOperationalWarning": GdsgOperationalWarning,
    "GdsgQueueLagStats": GdsgQueueLagStats,
    "GdsgQueueScanSummary": GdsgQueueScanSummary,
    "GdsgRegionStats": GdsgRegionStats,
    "GdsgRegionStatsPoint": GdsgRegionStatsPoint,
    "GdsgStorageBreakdownEntry": GdsgStorageBreakdownEntry,
    "GdsgStorageByBucketEntry": GdsgStorageByBucketEntry,
    "GdsgStorageByTierEntry": GdsgStorageByTierEntry,
    "GdsgWorkerHeartbeatStats": GdsgWorkerHeartbeatStats,
    "GdsgWorkerHeartbeats": GdsgWorkerHeartbeats,
    "GenericSnapshotData": GenericSnapshotData,
    "GetAWSStackDetailsResponse": GetAWSStackDetailsResponse,
    "GetActionApprovalRuleResponse": GetActionApprovalRuleResponse,
    "GetActionApprovalSummaryResponse": GetActionApprovalSummaryResponse,
    "GetAdditionalAzureAppsOnboardingStatus200Response": GetAdditionalAzureAppsOnboardingStatus200Response,
    "GetAgreementsResponse": GetAgreementsResponse,
    "GetAwsPrivateLinkStatusResponse": GetAwsPrivateLinkStatusResponse,
    "GetAzureQueryExportStorage200Response": GetAzureQueryExportStorage200Response,
    "GetBackupJobResponse": GetBackupJobResponse,
    "GetBackupPolicyResponse": GetBackupPolicyResponse,
    "GetBackupZeroEtlPolicyConnectionInfoResponse": GetBackupZeroEtlPolicyConnectionInfoResponse,
    "GetBillingPeriodsResponse": GetBillingPeriodsResponse,
    "GetBulkRestoreSnapshotHistogramRequest": GetBulkRestoreSnapshotHistogramRequest,
    "GetBulkRestoreSnapshotHistogramResponse": GetBulkRestoreSnapshotHistogramResponse,
    "GetCdcSqlSetupCheckResponse": GetCdcSqlSetupCheckResponse,
    "GetClassificationPolicyResponse": GetClassificationPolicyResponse,
    "GetCloudResourceSecurityPropertiesResponse": GetCloudResourceSecurityPropertiesResponse,
    "GetCredits400Response": GetCredits400Response,
    "GetCreditsResponse": GetCreditsResponse,
    "GetDataCatalogDatasetResponse": GetDataCatalogDatasetResponse,
    "GetDataCatalogNamespaceResponse": GetDataCatalogNamespaceResponse,
    "GetDataCatalogPipelineCapabilitiesResponse": GetDataCatalogPipelineCapabilitiesResponse,
    "GetDataCatalogPipelineCapabilitiesResponseEngineAvailabilityInner": GetDataCatalogPipelineCapabilitiesResponseEngineAvailabilityInner,
    "GetDataCatalogSemanticLayerArtifactResponse": GetDataCatalogSemanticLayerArtifactResponse,
    "GetDataCatalogSemanticLayerScheduleResponse": GetDataCatalogSemanticLayerScheduleResponse,
    "GetDataCatalogSemanticLayerSeedArtifactResponse": GetDataCatalogSemanticLayerSeedArtifactResponse,
    "GetDirectoryEntityRequest": GetDirectoryEntityRequest,
    "GetDirectoryEntityResponse": GetDirectoryEntityResponse,
    "GetDlsgPolicyResponse": GetDlsgPolicyResponse,
    "GetFindingExclusionResponse": GetFindingExclusionResponse,
    "GetGcsServiceAgentResponse": GetGcsServiceAgentResponse,
    "GetGdsgDevStatsResponse": GetGdsgDevStatsResponse,
    "GetGdsgInventoryReportConfigurationResponse": GetGdsgInventoryReportConfigurationResponse,
    "GetGdsgRegionStatsResponse": GetGdsgRegionStatsResponse,
    "GetIdpGroupResponse": GetIdpGroupResponse,
    "GetIntegrationResponse": GetIntegrationResponse,
    "GetJobProgressStepsResponse": GetJobProgressStepsResponse,
    "GetLimitsResponseValue": GetLimitsResponseValue,
    "GetMPARequestResponse": GetMPARequestResponse,
    "GetMicrosoft365BackupScopeRequest": GetMicrosoft365BackupScopeRequest,
    "GetObjectStoreScanMethodResponse": GetObjectStoreScanMethodResponse,
    "GetProjectConfigurationKeyResponse": GetProjectConfigurationKeyResponse,
    "GetProjectConfigurationKeysResponse": GetProjectConfigurationKeysResponse,
    "GetQueryExecutionResultResponse": GetQueryExecutionResultResponse,
    "GetResourceResponse": GetResourceResponse,
    "GetRestoreAccountCanDelete200Response": GetRestoreAccountCanDelete200Response,
    "GetRestoreAccountConnectivityConfigResponse": GetRestoreAccountConnectivityConfigResponse,
    "GetRestoreAccountMetricsConfigResponse": GetRestoreAccountMetricsConfigResponse,
    "GetRestoreAccountResponse": GetRestoreAccountResponse,
    "GetRestoreJobResponse": GetRestoreJobResponse,
    "GetRestoreTemplateResponse": GetRestoreTemplateResponse,
    "GetRoleResponse": GetRoleResponse,
    "GetSaasEntityIdByExternalIdRequest": GetSaasEntityIdByExternalIdRequest,
    "GetSaasEntityIdByExternalIdResponse": GetSaasEntityIdByExternalIdResponse,
    "GetScanJobResponse": GetScanJobResponse,
    "GetSnapshotRecipeResponse": GetSnapshotRecipeResponse,
    "GetSnapshotResponse": GetSnapshotResponse,
    "GetSourceAccountCanDelete200Response": GetSourceAccountCanDelete200Response,
    "GetSourceAccountMetricsConfigResponse": GetSourceAccountMetricsConfigResponse,
    "GetSourceAccountResponse": GetSourceAccountResponse,
    "GetSqlVmNetworkInfoRequest": GetSqlVmNetworkInfoRequest,
    "GetSqlVmNetworkInfoResponse": GetSqlVmNetworkInfoResponse,
    "GetTestShadowConsistencyStatus200Response": GetTestShadowConsistencyStatus200Response,
    "GetTestSnapshot200Response": GetTestSnapshot200Response,
    "GetVaultResponse": GetVaultResponse,
    "GlobalClusterIdentifierCondition": GlobalClusterIdentifierCondition,
    "GlobalClusterIdentifierFilters": GlobalClusterIdentifierFilters,
    "GoogleWorkspaceBackupPolicyPlan": GoogleWorkspaceBackupPolicyPlan,
    "GoogleWorkspaceConnectionInfo": GoogleWorkspaceConnectionInfo,
    "GoogleWorkspaceDriveRestoreOptions": GoogleWorkspaceDriveRestoreOptions,
    "GoogleWorkspaceGmailRestoreOptions": GoogleWorkspaceGmailRestoreOptions,
    "GoogleWorkspaceGroup": GoogleWorkspaceGroup,
    "GoogleWorkspaceGroupMessageMailboxTarget": GoogleWorkspaceGroupMessageMailboxTarget,
    "GoogleWorkspaceGroupMessageTarget": GoogleWorkspaceGroupMessageTarget,
    "GoogleWorkspaceGroupRestoreWorkload": GoogleWorkspaceGroupRestoreWorkload,
    "GoogleWorkspaceOrgUnit": GoogleWorkspaceOrgUnit,
    "GoogleWorkspaceResource": GoogleWorkspaceResource,
    "GoogleWorkspaceRestoreAccountAttributes": GoogleWorkspaceRestoreAccountAttributes,
    "GoogleWorkspaceRestoreAccountAttributesInput": GoogleWorkspaceRestoreAccountAttributesInput,
    "GoogleWorkspaceServiceAccountInfo": GoogleWorkspaceServiceAccountInfo,
    "GoogleWorkspaceSharedDriveEntireDriveOptions": GoogleWorkspaceSharedDriveEntireDriveOptions,
    "GoogleWorkspaceSharedDriveSelectedItemsOptions": GoogleWorkspaceSharedDriveSelectedItemsOptions,
    "GoogleWorkspaceSnapshotProperties": GoogleWorkspaceSnapshotProperties,
    "GoogleWorkspaceSourceAccountAttributes": GoogleWorkspaceSourceAccountAttributes,
    "GoogleWorkspaceSourceAccountAttributesInput": GoogleWorkspaceSourceAccountAttributesInput,
    "GoogleWorkspaceUserDriveEntireDriveOptions": GoogleWorkspaceUserDriveEntireDriveOptions,
    "GoogleWorkspaceUserDriveSelectedItemsOptions": GoogleWorkspaceUserDriveSelectedItemsOptions,
    "GoogleWorkspaceUserMailEntireMailboxOptions": GoogleWorkspaceUserMailEntireMailboxOptions,
    "GoogleWorkspaceUserMailSelectedItemsOptions": GoogleWorkspaceUserMailSelectedItemsOptions,
    "GoogleWorkspaceUserRestoreData": GoogleWorkspaceUserRestoreData,
    "GoogleWorkspaceUserRestoreWorkload": GoogleWorkspaceUserRestoreWorkload,
    "GoogleWorkspaceWithPolicyStatus": GoogleWorkspaceWithPolicyStatus,
    "GroupBreakdown": GroupBreakdown,
    "GroupBreakdownEntry": GroupBreakdownEntry,
    "HighFrequencyBackupPolicyPlan": HighFrequencyBackupPolicyPlan,
    "HighFrequencyBackupResourceType": HighFrequencyBackupResourceType,
    "HighFrequencyBackupScheduleConfig": HighFrequencyBackupScheduleConfig,
    "HighFrequencyBackupSchedules": HighFrequencyBackupSchedules,
    "HighFrequencyIntervalConfig": HighFrequencyIntervalConfig,
    "HoldSnapshotRequest": HoldSnapshotRequest,
    "IDs": IDs,
    "IdFilters": IdFilters,
    "IdentityProvidersNames": IdentityProvidersNames,
    "Idp": Idp,
    "IdpGroup": IdpGroup,
    "IdpGroupUser": IdpGroupUser,
    "ImportDlsgCertificateRequest": ImportDlsgCertificateRequest,
    "InfectedDataByClassification": InfectedDataByClassification,
    "InfectedDataClassificationSize": InfectedDataClassificationSize,
    "InfectedDataOverTime": InfectedDataOverTime,
    "InfectedDateSize": InfectedDateSize,
    "InfectedResourcesCountResponse": InfectedResourcesCountResponse,
    "IngestionPipelineAccess": IngestionPipelineAccess,
    "IngestionPipelineAccessSubject": IngestionPipelineAccessSubject,
    "InitAuthInput": InitAuthInput,
    "InitiateAccountSwitch403Response": InitiateAccountSwitch403Response,
    "InitiateAccountSwitchRequest": InitiateAccountSwitchRequest,
    "InitiateAccountSwitchResponse": InitiateAccountSwitchResponse,
    "Initiator": Initiator,
    "InitiatorIdentity": InitiatorIdentity,
    "InitiatorNameFilters": InitiatorNameFilters,
    "IntegConfig": IntegConfig,
    "IntegrationConfig": IntegrationConfig,
    "IntrospectRequest": IntrospectRequest,
    "IntrospectResponse": IntrospectResponse,
    "InventoryAzureDisk": InventoryAzureDisk,
    "InventoryBackupPolicy": InventoryBackupPolicy,
    "InventoryClassificationPolicy": InventoryClassificationPolicy,
    "InventoryFilterConditions": InventoryFilterConditions,
    "InventoryGcpDisk": InventoryGcpDisk,
    "InventoryResource": InventoryResource,
    "InventoryResourceMetadata": InventoryResourceMetadata,
    "InventorySnapshotVolume": InventorySnapshotVolume,
    "InventoryVault": InventoryVault,
    "InventoryVolume": InventoryVolume,
    "IsVaultDeletableResponse": IsVaultDeletableResponse,
    "IssueMutedNotificationArguments": IssueMutedNotificationArguments,
    "IssuesFilters": IssuesFilters,
    "JobExecutionDetails": JobExecutionDetails,
    "JobFailedNotificationArguments": JobFailedNotificationArguments,
    "JobIdFilters": JobIdFilters,
    "JobInitiationResponse": JobInitiationResponse,
    "JobMetricsReportFailedArguments": JobMetricsReportFailedArguments,
    "JobProgressStep": JobProgressStep,
    "JobProgressStepBucketDataBackupData": JobProgressStepBucketDataBackupData,
    "JobProgressStepBucketDataBackupDataCoverage": JobProgressStepBucketDataBackupDataCoverage,
    "JobProgressStepBucketDataBackupDataCoverageNotBackedUpInner": JobProgressStepBucketDataBackupDataCoverageNotBackedUpInner,
    "JobProgressStepBucketDataRestorationData": JobProgressStepBucketDataRestorationData,
    "JobProgressStepConnectingToRestoreServerData": JobProgressStepConnectingToRestoreServerData,
    "JobProgressStepCreateInstanceData": JobProgressStepCreateInstanceData,
    "JobProgressStepDatabaseClusterCreationData": JobProgressStepDatabaseClusterCreationData,
    "JobProgressStepDatabaseConfigurationData": JobProgressStepDatabaseConfigurationData,
    "JobProgressStepDatabaseCopyCreationData": JobProgressStepDatabaseCopyCreationData,
    "JobProgressStepDatabaseCreationData": JobProgressStepDatabaseCreationData,
    "JobProgressStepDatabaseDataBackupData": JobProgressStepDatabaseDataBackupData,
    "JobProgressStepDatabaseDataRestorationData": JobProgressStepDatabaseDataRestorationData,
    "JobProgressStepGroupDirectoryRestorationData": JobProgressStepGroupDirectoryRestorationData,
    "JobProgressStepGroupMessageRestorationData": JobProgressStepGroupMessageRestorationData,
    "JobProgressStepIdentityRestorationData": JobProgressStepIdentityRestorationData,
    "JobProgressStepNetworkInterfaceCreationData": JobProgressStepNetworkInterfaceCreationData,
    "JobProgressStepRestoreVolumeData": JobProgressStepRestoreVolumeData,
    "JobProgressStepRestoreWorkerData": JobProgressStepRestoreWorkerData,
    "JobProgressStepScanningBucketData": JobProgressStepScanningBucketData,
    "JobProgressStepScanningBucketDataTierByClassInner": JobProgressStepScanningBucketDataTierByClassInner,
    "JobProgressStepSnapshotCreationData": JobProgressStepSnapshotCreationData,
    "JobProgressStepSnapshotCreationDataVolumesInner": JobProgressStepSnapshotCreationDataVolumesInner,
    "JobProgressStepTableConfigurationData": JobProgressStepTableConfigurationData,
    "JobProgressStepTableCreationData": JobProgressStepTableCreationData,
    "JobProgressStepThreatDetectionData": JobProgressStepThreatDetectionData,
    "JobProgressStepUserDataRestorationData": JobProgressStepUserDataRestorationData,
    "JobProgressStepUserWorkloadRestorationData": JobProgressStepUserWorkloadRestorationData,
    "JobProgressStepVolumeCreationData": JobProgressStepVolumeCreationData,
    "JobProgressStepVolumeDataBackupData": JobProgressStepVolumeDataBackupData,
    "JobSnapshotDetails": JobSnapshotDetails,
    "JobStatusFilters": JobStatusFilters,
    "JobStep": JobStep,
    "JobSucceededNotificationArguments": JobSucceededNotificationArguments,
    "KeyspacesBackupConfig": KeyspacesBackupConfig,
    "KeyspacesBackupConfigApplication": KeyspacesBackupConfigApplication,
    "KeyspacesTableRestoreDestination": KeyspacesTableRestoreDestination,
    "LimitData": LimitData,
    "ListAccessGrantsResponse": ListAccessGrantsResponse,
    "ListAccessPoliciesResponse": ListAccessPoliciesResponse,
    "ListAccessibleAccountsResponse": ListAccessibleAccountsResponse,
    "ListAccountsResponse": ListAccountsResponse,
    "ListActionApprovalRulesResponse": ListActionApprovalRulesResponse,
    "ListAiAssistantSessions502Response": ListAiAssistantSessions502Response,
    "ListAllRegionsResponse": ListAllRegionsResponse,
    "ListAllRegionsResponseRegions": ListAllRegionsResponseRegions,
    "ListApiCredentialsResponse": ListApiCredentialsResponse,
    "ListApplicationOverrideResponse": ListApplicationOverrideResponse,
    "ListAtlasOrganizationsResponse": ListAtlasOrganizationsResponse,
    "ListAuditLogRequest": ListAuditLogRequest,
    "ListAuditLogResponse": ListAuditLogResponse,
    "ListAuditLogsResponse": ListAuditLogsResponse,
    "ListAwsVpcsResponse": ListAwsVpcsResponse,
    "ListAwsVpcsResponseVpcsInner": ListAwsVpcsResponseVpcsInner,
    "ListAzureAppRegistrationsResponse": ListAzureAppRegistrationsResponse,
    "ListAzureCmkEligibleAppsResponse": ListAzureCmkEligibleAppsResponse,
    "ListAzureDiskEncryptionSetsRequest": ListAzureDiskEncryptionSetsRequest,
    "ListAzureDiskEncryptionSetsResponse": ListAzureDiskEncryptionSetsResponse,
    "ListAzureFileShares200Response": ListAzureFileShares200Response,
    "ListAzureFileShares200ResponseFileSharesInner": ListAzureFileShares200ResponseFileSharesInner,
    "ListAzureFileSharesRequest": ListAzureFileSharesRequest,
    "ListAzureKeyVaultKeysRequest": ListAzureKeyVaultKeysRequest,
    "ListAzureKeyVaultKeysResponse": ListAzureKeyVaultKeysResponse,
    "ListAzureRegions200Response": ListAzureRegions200Response,
    "ListAzureSKUs200Response": ListAzureSKUs200Response,
    "ListAzureSKUs200ResponseSkusInner": ListAzureSKUs200ResponseSkusInner,
    "ListAzureSKUsRequest": ListAzureSKUsRequest,
    "ListAzureStorageAccountContainers200Response": ListAzureStorageAccountContainers200Response,
    "ListAzureStorageAccountContainersRequest": ListAzureStorageAccountContainersRequest,
    "ListAzureSubnets200Response": ListAzureSubnets200Response,
    "ListAzureSubnets200ResponseSubnetsInner": ListAzureSubnets200ResponseSubnetsInner,
    "ListAzureSubnetsRequest": ListAzureSubnetsRequest,
    "ListAzureUnassignedNetworkInterfaces200Response": ListAzureUnassignedNetworkInterfaces200Response,
    "ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner": ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner,
    "ListAzureUnassignedNetworkInterfacesRequest": ListAzureUnassignedNetworkInterfacesRequest,
    "ListAzureVirtualNetworks200Response": ListAzureVirtualNetworks200Response,
    "ListAzureVirtualNetworks200ResponseVirtualNetworksInner": ListAzureVirtualNetworks200ResponseVirtualNetworksInner,
    "ListAzureVirtualNetworksRequest": ListAzureVirtualNetworksRequest,
    "ListBackupJobTypesResponse": ListBackupJobTypesResponse,
    "ListBackupJobsInternal200Response": ListBackupJobsInternal200Response,
    "ListBackupJobsRequest": ListBackupJobsRequest,
    "ListBackupJobsResponse": ListBackupJobsResponse,
    "ListBackupPoliciesResponse": ListBackupPoliciesResponse,
    "ListBackupPolicyResponse": ListBackupPolicyResponse,
    "ListBackupPostureControlsRequest": ListBackupPostureControlsRequest,
    "ListBackupPostureControlsResponse": ListBackupPostureControlsResponse,
    "ListBackupVaultResponse": ListBackupVaultResponse,
    "ListBackupZeroEtlPoliciesResponse": ListBackupZeroEtlPoliciesResponse,
    "ListBillingTransactionHistoryRequest": ListBillingTransactionHistoryRequest,
    "ListBillingTransactionHistoryResponse": ListBillingTransactionHistoryResponse,
    "ListCatalogDatabasesResponse": ListCatalogDatabasesResponse,
    "ListCatalogTablesResponse": ListCatalogTablesResponse,
    "ListCatalogsResponse": ListCatalogsResponse,
    "ListClassificationCategoriesResponse": ListClassificationCategoriesResponse,
    "ListClassificationPoliciesResponse": ListClassificationPoliciesResponse,
    "ListCloudSnapshotsResponse": ListCloudSnapshotsResponse,
    "ListComplianceResourcesResponse": ListComplianceResourcesResponse,
    "ListControlViolationsResponse": ListControlViolationsResponse,
    "ListCredentialFindingsResponse": ListCredentialFindingsResponse,
    "ListDailySnapshotsResponse": ListDailySnapshotsResponse,
    "ListDataCatalogChildrenRequest": ListDataCatalogChildrenRequest,
    "ListDataCatalogChildrenResponse": ListDataCatalogChildrenResponse,
    "ListDataCatalogDatasetEventsRequest": ListDataCatalogDatasetEventsRequest,
    "ListDataCatalogDatasetEventsResponse": ListDataCatalogDatasetEventsResponse,
    "ListDataCatalogDatasetsFlatRequest": ListDataCatalogDatasetsFlatRequest,
    "ListDataCatalogDatasetsFlatResponse": ListDataCatalogDatasetsFlatResponse,
    "ListDataCatalogDatasetsRequest": ListDataCatalogDatasetsRequest,
    "ListDataCatalogDatasetsResponse": ListDataCatalogDatasetsResponse,
    "ListDataCatalogJoinabilityRequest": ListDataCatalogJoinabilityRequest,
    "ListDataCatalogJoinabilityResponse": ListDataCatalogJoinabilityResponse,
    "ListDataCatalogNamespacesRequest": ListDataCatalogNamespacesRequest,
    "ListDataCatalogNamespacesResponse": ListDataCatalogNamespacesResponse,
    "ListDataCatalogPipelineVersionsResponse": ListDataCatalogPipelineVersionsResponse,
    "ListDataCatalogPipelinesRequest": ListDataCatalogPipelinesRequest,
    "ListDataCatalogPipelinesResponse": ListDataCatalogPipelinesResponse,
    "ListDataCatalogSemanticLayerRunsResponse": ListDataCatalogSemanticLayerRunsResponse,
    "ListDataClassificationEntitiesResponse": ListDataClassificationEntitiesResponse,
    "ListDatabaseSnapshotsResponse": ListDatabaseSnapshotsResponse,
    "ListDirectoryEdgesRequest": ListDirectoryEdgesRequest,
    "ListDirectoryEdgesResponse": ListDirectoryEdgesResponse,
    "ListDlsgPoliciesResponse": ListDlsgPoliciesResponse,
    "ListDynamoDbBackupConfigsResponse": ListDynamoDbBackupConfigsResponse,
    "ListEffectivePoliciesRequest": ListEffectivePoliciesRequest,
    "ListEffectivePoliciesResponse": ListEffectivePoliciesResponse,
    "ListEffectiveTagsRequest": ListEffectiveTagsRequest,
    "ListEffectiveTagsResponse": ListEffectiveTagsResponse,
    "ListEksClustersResponse": ListEksClustersResponse,
    "ListExclusionPatternResourcesResponse": ListExclusionPatternResourcesResponse,
    "ListFindingExclusionsRequest": ListFindingExclusionsRequest,
    "ListFindingExclusionsResponse": ListFindingExclusionsResponse,
    "ListFindingsResponse": ListFindingsResponse,
    "ListGcpFoldersResponse": ListGcpFoldersResponse,
    "ListGcpNetworksResponse": ListGcpNetworksResponse,
    "ListGcpNetworksResponseNetworksInner": ListGcpNetworksResponseNetworksInner,
    "ListGcpOrganizationsResponse": ListGcpOrganizationsResponse,
    "ListGcpSubnetsResponse": ListGcpSubnetsResponse,
    "ListGdsgEnvironmentsResponse": ListGdsgEnvironmentsResponse,
    "ListGdsgInventoryReportConfigurationsResponse": ListGdsgInventoryReportConfigurationsResponse,
    "ListGdsgInventoryReportRunsResponse": ListGdsgInventoryReportRunsResponse,
    "ListGdsgObjectsResponse": ListGdsgObjectsResponse,
    "ListGoogleWorkspaceGroups200Response": ListGoogleWorkspaceGroups200Response,
    "ListGoogleWorkspaceGroupsRequest": ListGoogleWorkspaceGroupsRequest,
    "ListGoogleWorkspaceOrgUnits200Response": ListGoogleWorkspaceOrgUnits200Response,
    "ListGoogleWorkspaceOrgUnitsRequest": ListGoogleWorkspaceOrgUnitsRequest,
    "ListGoogleWorkspacesWithPolicyStatusResponse": ListGoogleWorkspacesWithPolicyStatusResponse,
    "ListGrantedOrganizationGroupAccessResponse": ListGrantedOrganizationGroupAccessResponse,
    "ListGroupConversationsRequest": ListGroupConversationsRequest,
    "ListIdpGroupsResponse": ListIdpGroupsResponse,
    "ListIdpsResponse": ListIdpsResponse,
    "ListInfectedSnapshotsResponse": ListInfectedSnapshotsResponse,
    "ListInitiatorsResponse": ListInitiatorsResponse,
    "ListInstanceProfilesResponse": ListInstanceProfilesResponse,
    "ListInstanceTypesResponse": ListInstanceTypesResponse,
    "ListIntegrationsResponse": ListIntegrationsResponse,
    "ListInventoryAppsResponse": ListInventoryAppsResponse,
    "ListInventoryBackupRegionsResponse": ListInventoryBackupRegionsResponse,
    "ListInventoryClassificationEntitiesResponse": ListInventoryClassificationEntitiesResponse,
    "ListInventoryEnvironmentsResponse": ListInventoryEnvironmentsResponse,
    "ListInventoryGlobalDatabasesResponse": ListInventoryGlobalDatabasesResponse,
    "ListInventoryItemSnapshotsResponse": ListInventoryItemSnapshotsResponse,
    "ListInventoryNetworksResponse": ListInventoryNetworksResponse,
    "ListInventoryRequest": ListInventoryRequest,
    "ListInventoryResourceGroupsResponse": ListInventoryResourceGroupsResponse,
    "ListInventoryResourceIdentifiersResponse": ListInventoryResourceIdentifiersResponse,
    "ListInventoryResourceTypesResponse": ListInventoryResourceTypesResponse,
    "ListInventoryResourcesResponse": ListInventoryResourcesResponse,
    "ListInventorySensitivityAnnotationValuesResponse": ListInventorySensitivityAnnotationValuesResponse,
    "ListInventorySnapshotsRequest": ListInventorySnapshotsRequest,
    "ListInventorySnapshotsResponse": ListInventorySnapshotsResponse,
    "ListInventorySourceRegionsResponse": ListInventorySourceRegionsResponse,
    "ListInventorySubnetsResponse": ListInventorySubnetsResponse,
    "ListInventoryTagsResponse": ListInventoryTagsResponse,
    "ListJobErrorCodesResponse": ListJobErrorCodesResponse,
    "ListKeyspacesBackupConfigsResponse": ListKeyspacesBackupConfigsResponse,
    "ListKnownAppsResponse": ListKnownAppsResponse,
    "ListLogSourcesPoliciesResponse": ListLogSourcesPoliciesResponse,
    "ListLogSourcesResponse": ListLogSourcesResponse,
    "ListMPAOperationsResponse": ListMPAOperationsResponse,
    "ListMPARequestsRequest": ListMPARequestsRequest,
    "ListMPARequestsRequestFilters": ListMPARequestsRequestFilters,
    "ListMPARequestsResponse": ListMPARequestsResponse,
    "ListMPARequestsSort": ListMPARequestsSort,
    "ListMappableRolesRequest": ListMappableRolesRequest,
    "ListMappableRolesResponse": ListMappableRolesResponse,
    "ListMicrosoft365GroupMembers200Response": ListMicrosoft365GroupMembers200Response,
    "ListMicrosoft365GroupMembersRequest": ListMicrosoft365GroupMembersRequest,
    "ListMicrosoft365GroupMembersSort": ListMicrosoft365GroupMembersSort,
    "ListMicrosoft365Groups200Response": ListMicrosoft365Groups200Response,
    "ListMicrosoft365GroupsRequest": ListMicrosoft365GroupsRequest,
    "ListMicrosoft365SharePointSites200Response": ListMicrosoft365SharePointSites200Response,
    "ListMicrosoft365SharePointSitesRequest": ListMicrosoft365SharePointSitesRequest,
    "ListMicrosoft365Users200Response": ListMicrosoft365Users200Response,
    "ListMicrosoft365UsersRequest": ListMicrosoft365UsersRequest,
    "ListMongoAtlasPrivateLinks200Response": ListMongoAtlasPrivateLinks200Response,
    "ListMongoDbBackupConfigsResponse": ListMongoDbBackupConfigsResponse,
    "ListMyMPARequestsRequest": ListMyMPARequestsRequest,
    "ListMyMPARequestsRequestFilters": ListMyMPARequestsRequestFilters,
    "ListMyMPARequestsResponse": ListMyMPARequestsResponse,
    "ListNotificationPoliciesResponse": ListNotificationPoliciesResponse,
    "ListNotificationsResponse": ListNotificationsResponse,
    "ListOAuthAppsResponse": ListOAuthAppsResponse,
    "ListObjectStoreExclusionRulesResponse": ListObjectStoreExclusionRulesResponse,
    "ListOrganizationAccountsResponse": ListOrganizationAccountsResponse,
    "ListOrganizationIdpGroupsRequest": ListOrganizationIdpGroupsRequest,
    "ListOrganizationIdpGroupsResponse": ListOrganizationIdpGroupsResponse,
    "ListOrganizationIdpsResponse": ListOrganizationIdpsResponse,
    "ListOrganizationUsersResponse": ListOrganizationUsersResponse,
    "ListPermissionsResponse": ListPermissionsResponse,
    "ListProjectsResponse": ListProjectsResponse,
    "ListQueryExecutionsRequest": ListQueryExecutionsRequest,
    "ListQueryExecutionsRequestFilters": ListQueryExecutionsRequestFilters,
    "ListQueryExecutionsRequestFiltersCreatedAt": ListQueryExecutionsRequestFiltersCreatedAt,
    "ListQueryExecutionsRequestFiltersId": ListQueryExecutionsRequestFiltersId,
    "ListQueryExecutionsRequestFiltersStatus": ListQueryExecutionsRequestFiltersStatus,
    "ListQueryExecutionsRequestSortsInner": ListQueryExecutionsRequestSortsInner,
    "ListQueryExecutionsResponse": ListQueryExecutionsResponse,
    "ListResourceAttachmentEventsResponse": ListResourceAttachmentEventsResponse,
    "ListResourcesResponse": ListResourcesResponse,
    "ListRestoreAccountsRequest": ListRestoreAccountsRequest,
    "ListRestoreAccountsResponse": ListRestoreAccountsResponse,
    "ListRestoreAwsOrganizationalUnitsResponse": ListRestoreAwsOrganizationalUnitsResponse,
    "ListRestoreJobTypesResponse": ListRestoreJobTypesResponse,
    "ListRestoreJobsInternal200Response": ListRestoreJobsInternal200Response,
    "ListRestoreJobsRequest": ListRestoreJobsRequest,
    "ListRestoreJobsResponse": ListRestoreJobsResponse,
    "ListRestoreTemplatesRequest": ListRestoreTemplatesRequest,
    "ListRestoreTemplatesResponse": ListRestoreTemplatesResponse,
    "ListRestoreTemplatesResponsePagination": ListRestoreTemplatesResponsePagination,
    "ListRolesResponse": ListRolesResponse,
    "ListSaasEntitiesRequest": ListSaasEntitiesRequest,
    "ListSaasEntitiesRequestFilters": ListSaasEntitiesRequestFilters,
    "ListSaasEntitiesResponse": ListSaasEntitiesResponse,
    "ListSaasEntitySnapshotsResponse": ListSaasEntitySnapshotsResponse,
    "ListScanJobTypesResponse": ListScanJobTypesResponse,
    "ListScanJobsInternal200Response": ListScanJobsInternal200Response,
    "ListScanJobsRequest": ListScanJobsRequest,
    "ListScanJobsResponse": ListScanJobsResponse,
    "ListSecurityFindingsRequest": ListSecurityFindingsRequest,
    "ListSensitivityAnnotationsResponse": ListSensitivityAnnotationsResponse,
    "ListSnapshotRecipeEntriesRequest": ListSnapshotRecipeEntriesRequest,
    "ListSnapshotRecipeEntriesResponse": ListSnapshotRecipeEntriesResponse,
    "ListSnapshotRecipesResponse": ListSnapshotRecipesResponse,
    "ListSourceAccountsRequest": ListSourceAccountsRequest,
    "ListSourceAccountsResponse": ListSourceAccountsResponse,
    "ListSourceAwsOrganizationalUnitsResponse": ListSourceAwsOrganizationalUnitsResponse,
    "ListStagingBucketsResponse": ListStagingBucketsResponse,
    "ListStorageGatewaysResponse": ListStorageGatewaysResponse,
    "ListSubnetsResponse": ListSubnetsResponse,
    "ListSubnetsResponseV2": ListSubnetsResponseV2,
    "ListSubnetsResponseV2SubnetsInner": ListSubnetsResponseV2SubnetsInner,
    "ListTagDefinitionsResponse": ListTagDefinitionsResponse,
    "ListTestResourceSnapshots200Response": ListTestResourceSnapshots200Response,
    "ListTestResourceSnapshots200ResponseSnapshotsInner": ListTestResourceSnapshots200ResponseSnapshotsInner,
    "ListThreatHuntingResultsRequest": ListThreatHuntingResultsRequest,
    "ListThreatHuntingResultsResponse": ListThreatHuntingResultsResponse,
    "ListThreatHuntingScanRequestsRequest": ListThreatHuntingScanRequestsRequest,
    "ListThreatHuntingScanRequestsResponse": ListThreatHuntingScanRequestsResponse,
    "ListUsersResponse": ListUsersResponse,
    "ListVaultBlockedRegionsResponse": ListVaultBlockedRegionsResponse,
    "ListVaultsRequest": ListVaultsRequest,
    "ListZeroEtlJobSyncsRequest": ListZeroEtlJobSyncsRequest,
    "ListZeroEtlJobSyncsResponse": ListZeroEtlJobSyncsResponse,
    "ListZeroEtlJobsRequest": ListZeroEtlJobsRequest,
    "ListZeroEtlJobsResponse": ListZeroEtlJobsResponse,
    "ListZeroEtlTargetTablesRequest": ListZeroEtlTargetTablesRequest,
    "ListZeroEtlTargetTablesResponse": ListZeroEtlTargetTablesResponse,
    "LlgLocationResource": LlgLocationResource,
    "LlgLocationWithResources": LlgLocationWithResources,
    "LlgResourcePolicy": LlgResourcePolicy,
    "LogRecord": LogRecord,
    "LogSource": LogSource,
    "LogSourceLocation": LogSourceLocation,
    "LogSourceLocationCloudTrail": LogSourceLocationCloudTrail,
    "LogSourceLocationCloudWatchLogs": LogSourceLocationCloudWatchLogs,
    "LogSourceLocationDatadog": LogSourceLocationDatadog,
    "LogSourceLocationGcpCloudLogging": LogSourceLocationGcpCloudLogging,
    "LogSourceLocationSplunkDdss": LogSourceLocationSplunkDdss,
    "LogSourceWithPolicy": LogSourceWithPolicy,
    "LogsHistogramDataPoint": LogsHistogramDataPoint,
    "LogsSchema": LogsSchema,
    "LogsSchemaColumn": LogsSchemaColumn,
    "LogsSchemaEntry": LogsSchemaEntry,
    "LogsSchemasResponse": LogsSchemasResponse,
    "LuceneQueryInput": LuceneQueryInput,
    "MPAInterceptedResponse": MPAInterceptedResponse,
    "MPAOperationInfo": MPAOperationInfo,
    "MPAPoliciesInfo": MPAPoliciesInfo,
    "MPAPrincipal": MPAPrincipal,
    "MPARequest": MPARequest,
    "MPARequestDetail": MPARequestDetail,
    "MPARequestNotificationArguments": MPARequestNotificationArguments,
    "MPARequestPolicyDetail": MPARequestPolicyDetail,
    "MPAReview": MPAReview,
    "MPAReviewNotificationArguments": MPAReviewNotificationArguments,
    "MaxRetentionDaysLimit": MaxRetentionDaysLimit,
    "MaxRetentionRule": MaxRetentionRule,
    "Message": Message,
    "Microsoft365BackupScope": Microsoft365BackupScope,
    "Microsoft365ConnectionInfo": Microsoft365ConnectionInfo,
    "Microsoft365EntityFilters": Microsoft365EntityFilters,
    "Microsoft365EntitySelection": Microsoft365EntitySelection,
    "Microsoft365FilterSelectionRef": Microsoft365FilterSelectionRef,
    "Microsoft365Group": Microsoft365Group,
    "Microsoft365Permission": Microsoft365Permission,
    "Microsoft365PolicyConfig": Microsoft365PolicyConfig,
    "Microsoft365Resource": Microsoft365Resource,
    "Microsoft365RestoreAccountAttributes": Microsoft365RestoreAccountAttributes,
    "Microsoft365RestoreAccountAttributesInput": Microsoft365RestoreAccountAttributesInput,
    "Microsoft365SharePointSite": Microsoft365SharePointSite,
    "Microsoft365SharePointSiteSelectedItemsOptions": Microsoft365SharePointSiteSelectedItemsOptions,
    "Microsoft365SourceAccountAttributesInput": Microsoft365SourceAccountAttributesInput,
    "Microsoft365TeamSelectedItemsOptions": Microsoft365TeamSelectedItemsOptions,
    "Microsoft365TeamsRestoreDestination": Microsoft365TeamsRestoreDestination,
    "Microsoft365User": Microsoft365User,
    "Microsoft365UserChatsSelectedItemsOptions": Microsoft365UserChatsSelectedItemsOptions,
    "Microsoft365UserDriveSelectedItemsOptions": Microsoft365UserDriveSelectedItemsOptions,
    "Microsoft365UserExclusions": Microsoft365UserExclusions,
    "Microsoft365UserMailSelectedItemsOptions": Microsoft365UserMailSelectedItemsOptions,
    "Microsoft365UserRestoreData": Microsoft365UserRestoreData,
    "Microsoft365UserRestoreSelection": Microsoft365UserRestoreSelection,
    "Microsoft365UserRestoreWorkload": Microsoft365UserRestoreWorkload,
    "Microsoft365WholeUserRestore": Microsoft365WholeUserRestore,
    "MicrosoftFabricIntegrationConfig": MicrosoftFabricIntegrationConfig,
    "MinRetentionRule": MinRetentionRule,
    "ModelError": ModelError,
    "MongoAtlasClusterResource": MongoAtlasClusterResource,
    "MongoAtlasOidc": MongoAtlasOidc,
    "MongoAtlasPrivateLinkEntry": MongoAtlasPrivateLinkEntry,
    "MongoAtlasRegionPlacement": MongoAtlasRegionPlacement,
    "MongoAtlasRequiredPrivateLink": MongoAtlasRequiredPrivateLink,
    "MongoAtlasRestoreAccountAttributes": MongoAtlasRestoreAccountAttributes,
    "MongoAtlasRestoreAccountAttributesInput": MongoAtlasRestoreAccountAttributesInput,
    "MongoAtlasRestoreDestination": MongoAtlasRestoreDestination,
    "MongoAtlasSourceAccountAttributes": MongoAtlasSourceAccountAttributes,
    "MongoAtlasSourceAccountAttributesInput": MongoAtlasSourceAccountAttributesInput,
    "MongoDbBackupConfig": MongoDbBackupConfig,
    "MonthlyConfig": MonthlyConfig,
    "MonthlySnapshotData": MonthlySnapshotData,
    "MsaAcceptanceResponse": MsaAcceptanceResponse,
    "MultiResourceBackupZeroEtlConfiguration": MultiResourceBackupZeroEtlConfiguration,
    "NativePasswordAccounts": NativePasswordAccounts,
    "NativeStandardConfig": NativeStandardConfig,
    "NeptuneClusterParameterGroup": NeptuneClusterParameterGroup,
    "NeptuneClusterParameterGroups": NeptuneClusterParameterGroups,
    "NeptuneRestoreDestination": NeptuneRestoreDestination,
    "NeptuneSnapshotProperties": NeptuneSnapshotProperties,
    "NetworkClassificationCondition": NetworkClassificationCondition,
    "NetworkClassificationDetails": NetworkClassificationDetails,
    "NetworkClassificationFilters": NetworkClassificationFilters,
    "NetworkInterfaceConfig": NetworkInterfaceConfig,
    "Notification": Notification,
    "NotificationArguments": NotificationArguments,
    "NotificationPolicy": NotificationPolicy,
    "NotificationPolicyConfig": NotificationPolicyConfig,
    "NotificationPolicyConfigDatadog": NotificationPolicyConfigDatadog,
    "NotificationPolicyConfigEmail": NotificationPolicyConfigEmail,
    "NotificationPolicyConfigServiceNow": NotificationPolicyConfigServiceNow,
    "NotificationPolicyConfigSlack": NotificationPolicyConfigSlack,
    "NotificationPolicyConfigSns": NotificationPolicyConfigSns,
    "NotificationPolicyConfigSplunk": NotificationPolicyConfigSplunk,
    "NotificationPolicyConfigWebhook": NotificationPolicyConfigWebhook,
    "NumberOfCopiesRule": NumberOfCopiesRule,
    "OAuthApp": OAuthApp,
    "Oauth2TokenResponse": Oauth2TokenResponse,
    "ObjectStorageDestination": ObjectStorageDestination,
    "ObjectStoreCoverageBreakdown": ObjectStoreCoverageBreakdown,
    "ObjectStoreCoverageReasonEntry": ObjectStoreCoverageReasonEntry,
    "ObjectStoreExclusionRule": ObjectStoreExclusionRule,
    "ObjectStoreScanMethod": ObjectStoreScanMethod,
    "ObjectStoreScanMethodSetting": ObjectStoreScanMethodSetting,
    "ObjectStoreTierClass": ObjectStoreTierClass,
    "OnboardAdditionalAzureApps200Response": OnboardAdditionalAzureApps200Response,
    "OnboardAdditionalAzureAppsRequest": OnboardAdditionalAzureAppsRequest,
    "OnboardRdsCdcRequest": OnboardRdsCdcRequest,
    "OnboardRdsCdcResponse": OnboardRdsCdcResponse,
    "OnboardingAzureResourceGroup": OnboardingAzureResourceGroup,
    "OperatingSystem": OperatingSystem,
    "OperationIdFilters": OperationIdFilters,
    "OrgCostDataFilters": OrgCostDataFilters,
    "OrgSaasAccountCost": OrgSaasAccountCost,
    "OrganizationAccount": OrganizationAccount,
    "OrganizationGroupAccess": OrganizationGroupAccess,
    "OrganizationIdp": OrganizationIdp,
    "OrganizationIdpGroup": OrganizationIdpGroup,
    "OrganizationRoleGrant": OrganizationRoleGrant,
    "OrganizationSamlServiceProviderDetails": OrganizationSamlServiceProviderDetails,
    "OrganizationUser": OrganizationUser,
    "OrganizationUserRole": OrganizationUserRole,
    "OverrideDataClassificationsRequest": OverrideDataClassificationsRequest,
    "OverrideDataClassificationsResponse": OverrideDataClassificationsResponse,
    "OverrideEnvironmentRequest": OverrideEnvironmentRequest,
    "OverrideEnvironmentResponse": OverrideEnvironmentResponse,
    "OverrideNetworkClassificationRequest": OverrideNetworkClassificationRequest,
    "OverrideNetworkClassificationResponse": OverrideNetworkClassificationResponse,
    "OverrideSensitivityAnnotationsRequest": OverrideSensitivityAnnotationsRequest,
    "Pagination": Pagination,
    "ParameterCheckResult": ParameterCheckResult,
    "ParentIdFilters": ParentIdFilters,
    "PartialRestoreData": PartialRestoreData,
    "Path": Path,
    "PathSnapshotsRequest": PathSnapshotsRequest,
    "PathSnapshotsResponse": PathSnapshotsResponse,
    "Permission": Permission,
    "PermissionGrant": PermissionGrant,
    "PermissionGrantInput": PermissionGrantInput,
    "PersistentVolumeClaimProperties": PersistentVolumeClaimProperties,
    "PitrBackupPolicyPlan": PitrBackupPolicyPlan,
    "PitrBackupResourceType": PitrBackupResourceType,
    "PitrBackupSchedules": PitrBackupSchedules,
    "PitrIntervalConfig": PitrIntervalConfig,
    "PitrRestoreVaultWindows": PitrRestoreVaultWindows,
    "PitrRestoreWindow": PitrRestoreWindow,
    "PitrRestoreWindowsResponse": PitrRestoreWindowsResponse,
    "Preferences": Preferences,
    "PreviewBackupPolicyResourcesRequest": PreviewBackupPolicyResourcesRequest,
    "PreviewBackupPolicyResourcesResponse": PreviewBackupPolicyResourcesResponse,
    "PrivateLinkCheckResult": PrivateLinkCheckResult,
    "PrivateLinkFormatInstructions": PrivateLinkFormatInstructions,
    "PrivateLinkInstructionStep": PrivateLinkInstructionStep,
    "Project": Project,
    "ProjectIdFilters": ProjectIdFilters,
    "ProviderAccountIdFilters": ProviderAccountIdFilters,
    "ProviderCategoryFilters": ProviderCategoryFilters,
    "ProviderParentIdFilters": ProviderParentIdFilters,
    "ProviderRestoreAccountConnectivityConfig": ProviderRestoreAccountConnectivityConfig,
    "PulumiConfiguration": PulumiConfiguration,
    "PulumiConfigurations": PulumiConfigurations,
    "PulumiConfigurationsFilterConditions": PulumiConfigurationsFilterConditions,
    "PulumiConfigurationsRequest": PulumiConfigurationsRequest,
    "PutDashboardRequest": PutDashboardRequest,
    "PutDataCatalogExternalContextDocumentRequest": PutDataCatalogExternalContextDocumentRequest,
    "PutDataCatalogExternalContextDocumentResponse": PutDataCatalogExternalContextDocumentResponse,
    "QueryCostDataRequest": QueryCostDataRequest,
    "QueryCostDataResponse": QueryCostDataResponse,
    "QueryDBRequest": QueryDBRequest,
    "QueryDBResponse": QueryDBResponse,
    "QueryDBRestoreDestination": QueryDBRestoreDestination,
    "QueryDBResultResponse": QueryDBResultResponse,
    "QueryDBStatusResponse": QueryDBStatusResponse,
    "QueryExecution": QueryExecution,
    "QueryExecutionResultColumn": QueryExecutionResultColumn,
    "QueryOrganizationCostData400Response": QueryOrganizationCostData400Response,
    "QueryOrganizationCostDataRequest": QueryOrganizationCostDataRequest,
    "QueryOrganizationCostDataResponse": QueryOrganizationCostDataResponse,
    "QuotaStatusFilters": QuotaStatusFilters,
    "RamShareCheckResult": RamShareCheckResult,
    "RansomwareResourceNotificationArguments": RansomwareResourceNotificationArguments,
    "RdsNativePitrAdvancedConfig": RdsNativePitrAdvancedConfig,
    "RdsNativePitrClusterAdvancedConfig": RdsNativePitrClusterAdvancedConfig,
    "RdsNativePitrNetworkConfig": RdsNativePitrNetworkConfig,
    "RdsNativePitrWindow": RdsNativePitrWindow,
    "RdsPasswordConfig": RdsPasswordConfig,
    "RdsSecurityGroup": RdsSecurityGroup,
    "ReactivateAccountRequest": ReactivateAccountRequest,
    "ReassessActionRequiredRequest": ReassessActionRequiredRequest,
    "ReassessActionRequiredResponse": ReassessActionRequiredResponse,
    "ReconnectCustomerVaultAccountResponse": ReconnectCustomerVaultAccountResponse,
    "ReconnectRestoreAccountResponse": ReconnectRestoreAccountResponse,
    "ReconnectRestoreAwsOrganizationalUnitResponse": ReconnectRestoreAwsOrganizationalUnitResponse,
    "ReconnectSourceAccountResponse": ReconnectSourceAccountResponse,
    "ReconnectSourceAwsOrganizationalUnitResponse": ReconnectSourceAwsOrganizationalUnitResponse,
    "RecordRestoreResult": RecordRestoreResult,
    "RecoveryPointData": RecoveryPointData,
    "RegionCondition": RegionCondition,
    "RegisterInput": RegisterInput,
    "RegisterInputBillingToken": RegisterInputBillingToken,
    "RegisterResponse": RegisterResponse,
    "RelatedGlobalDbCluster": RelatedGlobalDbCluster,
    "RequestDetails": RequestDetails,
    "ResourceBackupSettings": ResourceBackupSettings,
    "ResourceBlockerDetail": ResourceBlockerDetail,
    "ResourceComplianceRow": ResourceComplianceRow,
    "ResourceDetails": ResourceDetails,
    "ResourceGroupNameCondition": ResourceGroupNameCondition,
    "ResourceGroupNameFilters": ResourceGroupNameFilters,
    "ResourceIdCondition": ResourceIdCondition,
    "ResourceIdFilters": ResourceIdFilters,
    "ResourceIdentifiers": ResourceIdentifiers,
    "ResourceNameCondition": ResourceNameCondition,
    "ResourceNameFilters": ResourceNameFilters,
    "ResourceProperties": ResourceProperties,
    "ResourceQuota": ResourceQuota,
    "ResourceReference": ResourceReference,
    "ResourceSnapshot": ResourceSnapshot,
    "ResourceSnapshotProperties": ResourceSnapshotProperties,
    "ResourceTag": ResourceTag,
    "ResourceTypeCondition": ResourceTypeCondition,
    "ResourceTypeFilters": ResourceTypeFilters,
    "ResourceTypeToSecurityGroup": ResourceTypeToSecurityGroup,
    "ResourceValidationError": ResourceValidationError,
    "RestoreAccount": RestoreAccount,
    "RestoreAccountAttributesInput": RestoreAccountAttributesInput,
    "RestoreAccountCloudAttributes": RestoreAccountCloudAttributes,
    "RestoreAccountConnectivityConfig": RestoreAccountConnectivityConfig,
    "RestoreAccountMetricsConfig": RestoreAccountMetricsConfig,
    "RestoreAccountRegions": RestoreAccountRegions,
    "RestoreAccountsFilterConditions": RestoreAccountsFilterConditions,
    "RestoreAtlasClusterInput": RestoreAtlasClusterInput,
    "RestoreAvailabilityZones": RestoreAvailabilityZones,
    "RestoreAwsCassandraClusterRequest": RestoreAwsCassandraClusterRequest,
    "RestoreAwsEc2InstanceRequest": RestoreAwsEc2InstanceRequest,
    "RestoreAwsOpenSearchDomainRequest": RestoreAwsOpenSearchDomainRequest,
    "RestoreAwsOrganizationalUnit": RestoreAwsOrganizationalUnit,
    "RestoreAzureDiskConfig": RestoreAzureDiskConfig,
    "RestoreAzureDiskRequest": RestoreAzureDiskRequest,
    "RestoreAzureEntraIdRequest": RestoreAzureEntraIdRequest,
    "RestoreAzureFileShareRequest": RestoreAzureFileShareRequest,
    "RestoreAzureInstanceDiskInput": RestoreAzureInstanceDiskInput,
    "RestoreAzurePostgresDatabaseRequest": RestoreAzurePostgresDatabaseRequest,
    "RestoreAzureSqlDatabaseNativePitrRequest": RestoreAzureSqlDatabaseNativePitrRequest,
    "RestoreAzureSqlDatabaseRequest": RestoreAzureSqlDatabaseRequest,
    "RestoreAzureSqlVmPitrRequest": RestoreAzureSqlVmPitrRequest,
    "RestoreAzureVMInstanceConfig": RestoreAzureVMInstanceConfig,
    "RestoreAzureVmInstanceRequest": RestoreAzureVmInstanceRequest,
    "RestoreAzureVmNativeRequest": RestoreAzureVmNativeRequest,
    "RestoreBigQueryDatasetRequest": RestoreBigQueryDatasetRequest,
    "RestoreBigQueryNativePitrRequest": RestoreBigQueryNativePitrRequest,
    "RestoreBucketRequest": RestoreBucketRequest,
    "RestoreDbToRdsInstanceRequest": RestoreDbToRdsInstanceRequest,
    "RestoreDbToRdsSnapshotRequest": RestoreDbToRdsSnapshotRequest,
    "RestoreDestinationLimits": RestoreDestinationLimits,
    "RestoreDestinationTagLimits": RestoreDestinationTagLimits,
    "RestoreDocumentDBRequest": RestoreDocumentDBRequest,
    "RestoreDynamoDBTableRequest": RestoreDynamoDBTableRequest,
    "RestoreDynamoDBToExistingTableRequest": RestoreDynamoDBToExistingTableRequest,
    "RestoreDynamoDBToS3Request": RestoreDynamoDBToS3Request,
    "RestoreDynamoDbTableConfig": RestoreDynamoDbTableConfig,
    "RestoreEFSRequest": RestoreEFSRequest,
    "RestoreEbsVolumeConfig": RestoreEbsVolumeConfig,
    "RestoreEc2InstanceConfig": RestoreEc2InstanceConfig,
    "RestoreEksClusterRequest": RestoreEksClusterRequest,
    "RestoreEksNamespaceConfig": RestoreEksNamespaceConfig,
    "RestoreEksNamespaceInput": RestoreEksNamespaceInput,
    "RestoreEksNamespaceVolumeInput": RestoreEksNamespaceVolumeInput,
    "RestoreEntraIdWithMicrosoft365Request": RestoreEntraIdWithMicrosoft365Request,
    "RestoreFSxRequest": RestoreFSxRequest,
    "RestoreFilesRequest": RestoreFilesRequest,
    "RestoreGceDiskConfig": RestoreGceDiskConfig,
    "RestoreGceInstanceConfig": RestoreGceInstanceConfig,
    "RestoreGcpCloudSqlDatabaseConfig": RestoreGcpCloudSqlDatabaseConfig,
    "RestoreGcpCloudSqlRequest": RestoreGcpCloudSqlRequest,
    "RestoreGcpDiskRequest": RestoreGcpDiskRequest,
    "RestoreGcpInstanceDiskInput": RestoreGcpInstanceDiskInput,
    "RestoreGcpVmInstanceRequest": RestoreGcpVmInstanceRequest,
    "RestoreGoogleWorkspaceGroupMessagesRequest": RestoreGoogleWorkspaceGroupMessagesRequest,
    "RestoreGoogleWorkspaceGroupRequest": RestoreGoogleWorkspaceGroupRequest,
    "RestoreGoogleWorkspaceSharedDriveRequest": RestoreGoogleWorkspaceSharedDriveRequest,
    "RestoreGoogleWorkspaceUserDriveRequest": RestoreGoogleWorkspaceUserDriveRequest,
    "RestoreGoogleWorkspaceUserMailRequest": RestoreGoogleWorkspaceUserMailRequest,
    "RestoreGoogleWorkspaceUserRequest": RestoreGoogleWorkspaceUserRequest,
    "RestoreImageImageDeviceInput": RestoreImageImageDeviceInput,
    "RestoreImageImageInput": RestoreImageImageInput,
    "RestoreImageInput": RestoreImageInput,
    "RestoreImageVolumeInput": RestoreImageVolumeInput,
    "RestoreInstanceImageDeviceInput": RestoreInstanceImageDeviceInput,
    "RestoreInstanceImageInput": RestoreInstanceImageInput,
    "RestoreInstanceVolumeInput": RestoreInstanceVolumeInput,
    "RestoreJob": RestoreJob,
    "RestoreJobConfiguration": RestoreJobConfiguration,
    "RestoreJobInitiationResponse": RestoreJobInitiationResponse,
    "RestoreJobTypeFilters": RestoreJobTypeFilters,
    "RestoreJobsFilterConditions": RestoreJobsFilterConditions,
    "RestoreKeyspacesTableRequest": RestoreKeyspacesTableRequest,
    "RestoreMicrosoft365ItemsRequest": RestoreMicrosoft365ItemsRequest,
    "RestoreMicrosoft365Request": RestoreMicrosoft365Request,
    "RestoreMicrosoft365SharePointSiteByEntityRequest": RestoreMicrosoft365SharePointSiteByEntityRequest,
    "RestoreMicrosoft365TeamByEntityRequest": RestoreMicrosoft365TeamByEntityRequest,
    "RestoreMicrosoft365UserByEntityRequest": RestoreMicrosoft365UserByEntityRequest,
    "RestoreMicrosoft365UserChatsByEntityRequest": RestoreMicrosoft365UserChatsByEntityRequest,
    "RestoreMicrosoft365UserDriveByEntityRequest": RestoreMicrosoft365UserDriveByEntityRequest,
    "RestoreMicrosoft365UserMailByEntityRequest": RestoreMicrosoft365UserMailByEntityRequest,
    "RestoreMicrosoft365UserRequest": RestoreMicrosoft365UserRequest,
    "RestoreNeptuneRequest": RestoreNeptuneRequest,
    "RestoreObfuscationConfig": RestoreObfuscationConfig,
    "RestoreRdsInstanceClasses": RestoreRdsInstanceClasses,
    "RestoreRdsInstanceConfig": RestoreRdsInstanceConfig,
    "RestoreRdsNativePitrRequest": RestoreRdsNativePitrRequest,
    "RestoreRdsSubnetGroups": RestoreRdsSubnetGroups,
    "RestoreRdsSubnetGroupsRdsSubnetGroupsInner": RestoreRdsSubnetGroupsRdsSubnetGroupsInner,
    "RestoreRecipeRef": RestoreRecipeRef,
    "RestoreResult": RestoreResult,
    "RestoreSecurityGroups": RestoreSecurityGroups,
    "RestoreSecurityGroupsSecurityGroupsInner": RestoreSecurityGroupsSecurityGroupsInner,
    "RestoreTemplate": RestoreTemplate,
    "RestoreTemplateFilterConditions": RestoreTemplateFilterConditions,
    "RestoreTemplateIdFilters": RestoreTemplateIdFilters,
    "RestoreTemplateResourceTypeFilters": RestoreTemplateResourceTypeFilters,
    "RestoreVolumeToEbsRequest": RestoreVolumeToEbsRequest,
    "RestoreVolumeToEbsSnapshotRequest": RestoreVolumeToEbsSnapshotRequest,
    "RevalidateRestoreTemplateRequest": RevalidateRestoreTemplateRequest,
    "RevalidateRestoreTemplateResponse": RevalidateRestoreTemplateResponse,
    "RevalidationReport": RevalidationReport,
    "RiskLevelFilters": RiskLevelFilters,
    "Role": Role,
    "RoleAccessGroupCondition": RoleAccessGroupCondition,
    "RoleSummary": RoleSummary,
    "RoleUsage": RoleUsage,
    "RuleOutcome": RuleOutcome,
    "RuleOutcomeList": RuleOutcomeList,
    "RunAgentRequest": RunAgentRequest,
    "S3Bucket": S3Bucket,
    "S3Buckets": S3Buckets,
    "S3RestoreDestination": S3RestoreDestination,
    "S3RestoreTarget": S3RestoreTarget,
    "S3TemplateParams": S3TemplateParams,
    "SAMLCallback400Response": SAMLCallback400Response,
    "SAMLCallback401Response": SAMLCallback401Response,
    "SAMLCallback500Response": SAMLCallback500Response,
    "SaasAppCost": SaasAppCost,
    "SaasCommitmentWindowCost": SaasCommitmentWindowCost,
    "SaasEmailSearchFilter": SaasEmailSearchFilter,
    "SaasEntity": SaasEntity,
    "SaasEntityExternalIdFilters": SaasEntityExternalIdFilters,
    "SaasEntityProperties": SaasEntityProperties,
    "SaasEntitySnapshot": SaasEntitySnapshot,
    "SaasEntityTypeFilters": SaasEntityTypeFilters,
    "SaasGoogleWorkspaceUserProperties": SaasGoogleWorkspaceUserProperties,
    "SaasGroupProperties": SaasGroupProperties,
    "SaasItemSearchRequest": SaasItemSearchRequest,
    "SaasItemSearchResponse": SaasItemSearchResponse,
    "SaasMailDetails": SaasMailDetails,
    "SaasMicrosoft365UserProperties": SaasMicrosoft365UserProperties,
    "SaasProtectionStatusFilters": SaasProtectionStatusFilters,
    "SaasRestoreItem": SaasRestoreItem,
    "SaasSharePointSiteProperties": SaasSharePointSiteProperties,
    "SaasSnapshotItem": SaasSnapshotItem,
    "SaasTeamProperties": SaasTeamProperties,
    "SaasWorkloadStatus": SaasWorkloadStatus,
    "SameSourceAccountRestoreLimits": SameSourceAccountRestoreLimits,
    "SamlIdentityProvider": SamlIdentityProvider,
    "SamlIdentityProviderConfigsResponse": SamlIdentityProviderConfigsResponse,
    "SapHanaInstance": SapHanaInstance,
    "SapHanaRestoreProperties": SapHanaRestoreProperties,
    "SaveCloudResourceSecurityPropertiesRequest": SaveCloudResourceSecurityPropertiesRequest,
    "ScanJob": ScanJob,
    "SchemaRecord": SchemaRecord,
    "SearchAllEvent": SearchAllEvent,
    "SearchAllPlan": SearchAllPlan,
    "SearchAllRequest": SearchAllRequest,
    "SearchAllSection": SearchAllSection,
    "SearchAllSectionQuery": SearchAllSectionQuery,
    "SearchAllSectionRef": SearchAllSectionRef,
    "SearchAllSectionResult": SearchAllSectionResult,
    "SearchDBResponse": SearchDBResponse,
    "SearchDirectoryEntitiesRequest": SearchDirectoryEntitiesRequest,
    "SearchDirectoryEntitiesResponse": SearchDirectoryEntitiesResponse,
    "SearchFilesResponse": SearchFilesResponse,
    "SearchInput": SearchInput,
    "SearchLogsHistogramInput": SearchLogsHistogramInput,
    "SearchLogsHistogramResponse": SearchLogsHistogramResponse,
    "SearchLogsInput": SearchLogsInput,
    "SearchLogsResponse": SearchLogsResponse,
    "SearchWorkspaceDirectoryRequest": SearchWorkspaceDirectoryRequest,
    "SearchWorkspaceFilesRequest": SearchWorkspaceFilesRequest,
    "SearchWorkspaceMailRequest": SearchWorkspaceMailRequest,
    "SecurityFindingsFilterConditions": SecurityFindingsFilterConditions,
    "SecurityInformation": SecurityInformation,
    "SecurityPlan": SecurityPlan,
    "SecurityPlanEnabledResponse": SecurityPlanEnabledResponse,
    "SecurityResourceNotificationArguments": SecurityResourceNotificationArguments,
    "SecurityScan": SecurityScan,
    "SecurityScanConclusionCondition": SecurityScanConclusionCondition,
    "SecurityScanConclusionFilters": SecurityScanConclusionFilters,
    "SecurityScanNotificationData": SecurityScanNotificationData,
    "SecurityScanResult": SecurityScanResult,
    "SecurityScansSummaryResponse": SecurityScansSummaryResponse,
    "SecuritySnapshotNotificationArguments": SecuritySnapshotNotificationArguments,
    "SecuritySummary": SecuritySummary,
    "SendA2AMessageRequest": SendA2AMessageRequest,
    "SensitivityAnnotation": SensitivityAnnotation,
    "SensitivityAnnotationsCondition": SensitivityAnnotationsCondition,
    "SensitivityLabelsDetails": SensitivityLabelsDetails,
    "SensitivityLabelsFilters": SensitivityLabelsFilters,
    "ServiceProviderDetails": ServiceProviderDetails,
    "Session": Session,
    "SetDataCatalogDatasetAccessControlModeRequest": SetDataCatalogDatasetAccessControlModeRequest,
    "SetDataCatalogDatasetAccessControlModeResponse": SetDataCatalogDatasetAccessControlModeResponse,
    "SetResourceTagRequest": SetResourceTagRequest,
    "SetupAwsPrivateLinkRequest": SetupAwsPrivateLinkRequest,
    "SetupAwsPrivateLinkResponse": SetupAwsPrivateLinkResponse,
    "SetupMongoAtlasPrivateLinkRequest": SetupMongoAtlasPrivateLinkRequest,
    "SetupMongoAtlasPrivateLinkResponse": SetupMongoAtlasPrivateLinkResponse,
    "SeverityFilters": SeverityFilters,
    "ShovalAgentInstallCommand": ShovalAgentInstallCommand,
    "SingleResourceBackupZeroEtlConfiguration": SingleResourceBackupZeroEtlConfiguration,
    "Snapshot": Snapshot,
    "SnapshotAccessDeniedNotificationArguments": SnapshotAccessDeniedNotificationArguments,
    "SnapshotCoverage": SnapshotCoverage,
    "SnapshotDateFilters": SnapshotDateFilters,
    "SnapshotFilterConditions": SnapshotFilterConditions,
    "SnapshotFindingCountsResponse": SnapshotFindingCountsResponse,
    "SnapshotHistogramBucket": SnapshotHistogramBucket,
    "SnapshotIdFilters": SnapshotIdFilters,
    "SnapshotLocation": SnapshotLocation,
    "SnapshotRecipe": SnapshotRecipe,
    "SnapshotRecipeDirectorySummary": SnapshotRecipeDirectorySummary,
    "SnapshotRecipeEntry": SnapshotRecipeEntry,
    "SnapshotRecipeInvalidSnapshot": SnapshotRecipeInvalidSnapshot,
    "SnapshotRecipeProposal": SnapshotRecipeProposal,
    "SnapshotRecipeRule": SnapshotRecipeRule,
    "SnapshotRecipeRuleError": SnapshotRecipeRuleError,
    "SnapshotRecipeSourceSummary": SnapshotRecipeSourceSummary,
    "SnapshotRecipeSummary": SnapshotRecipeSummary,
    "SnapshotRecipeValidity": SnapshotRecipeValidity,
    "SnapshotReference": SnapshotReference,
    "SnapshotStorage": SnapshotStorage,
    "SnapshotTimeFilters": SnapshotTimeFilters,
    "SnapshotsSummaryResponse": SnapshotsSummaryResponse,
    "SnowflakeIntegrationConfig": SnowflakeIntegrationConfig,
    "SortBackupJobBy": SortBackupJobBy,
    "SortLogsBy": SortLogsBy,
    "SortResourceBy": SortResourceBy,
    "SortRestoreAccountsBy": SortRestoreAccountsBy,
    "SortRestoreJobBy": SortRestoreJobBy,
    "SortSnapshotsBy": SortSnapshotsBy,
    "SortSourceAccountsBy": SortSourceAccountsBy,
    "SourceAccount": SourceAccount,
    "SourceAccountAttributesInput": SourceAccountAttributesInput,
    "SourceAccountCloudAttributes": SourceAccountCloudAttributes,
    "SourceAccountMetricsConfig": SourceAccountMetricsConfig,
    "SourceAccountProviderIdFilters": SourceAccountProviderIdFilters,
    "SourceAccountTagKeyValuesCondition": SourceAccountTagKeyValuesCondition,
    "SourceAccountTagKeysCondition": SourceAccountTagKeysCondition,
    "SourceAccountsFilterConditions": SourceAccountsFilterConditions,
    "SourceAwsOrganizationalUnit": SourceAwsOrganizationalUnit,
    "SourceRegionFilters": SourceRegionFilters,
    "SourceSizeCheckResult": SourceSizeCheckResult,
    "SourceStorage": SourceStorage,
    "SourceStorageBackupStatus": SourceStorageBackupStatus,
    "SourceStorageSizeCondition": SourceStorageSizeCondition,
    "SqlInstructions": SqlInstructions,
    "SqlSetupCheckResult": SqlSetupCheckResult,
    "SqlVmNetworkInfo": SqlVmNetworkInfo,
    "SqlVmPitrRestoreProperties": SqlVmPitrRestoreProperties,
    "SsoIntegrationSettings": SsoIntegrationSettings,
    "StackNameFilters": StackNameFilters,
    "StagingAccount": StagingAccount,
    "StagingAccountConfig": StagingAccountConfig,
    "StagingBucket": StagingBucket,
    "StagingBucketConfig": StagingBucketConfig,
    "StandardBackupPolicyPlan": StandardBackupPolicyPlan,
    "StandardBackupScheduleConfig": StandardBackupScheduleConfig,
    "StandardBackupSchedules": StandardBackupSchedules,
    "StandardIntervalConfig": StandardIntervalConfig,
    "StartQueryExecutionRequest": StartQueryExecutionRequest,
    "StartTimeDateFilters": StartTimeDateFilters,
    "StatusCodeFilters": StatusCodeFilters,
    "StatusProperties": StatusProperties,
    "StepProgressMetric": StepProgressMetric,
    "StepProgressView": StepProgressView,
    "StorageAccountContainerRestoreDestination": StorageAccountContainerRestoreDestination,
    "StorageAccountRestoreTarget": StorageAccountRestoreTarget,
    "StorageGateway": StorageGateway,
    "StorageGatewayDetails": StorageGatewayDetails,
    "SubmitMyMPARequestRequest": SubmitMyMPARequestRequest,
    "SubmitMyMPARequestResponse": SubmitMyMPARequestResponse,
    "SubnetConfig": SubnetConfig,
    "SubnetFilters": SubnetFilters,
    "SubnetPerAvailabilityZone": SubnetPerAvailabilityZone,
    "SubnetsCondition": SubnetsCondition,
    "SupportedProviders": SupportedProviders,
    "Table": Table,
    "TableRecord": TableRecord,
    "TagKeyValue": TagKeyValue,
    "TagKeyValuesCondition": TagKeyValuesCondition,
    "TagKeyValuesFilters": TagKeyValuesFilters,
    "TagKeysCondition": TagKeysCondition,
    "TagKeysFilters": TagKeysFilters,
    "TakeNativeSnapshotRequest": TakeNativeSnapshotRequest,
    "TakeSnapshotRequest": TakeSnapshotRequest,
    "TakeSnapshotResponse": TakeSnapshotResponse,
    "TeardownAwsPrivateLinkResponse": TeardownAwsPrivateLinkResponse,
    "TeardownMongoAtlasPrivateLinkResponse": TeardownMongoAtlasPrivateLinkResponse,
    "ThreatDetectionFilters": ThreatDetectionFilters,
    "ThreatHuntingResult": ThreatHuntingResult,
    "ThreatHuntingScanRequest": ThreatHuntingScanRequest,
    "TimeFrame": TimeFrame,
    "TimeOfDay": TimeOfDay,
    "TimeOfYear": TimeOfYear,
    "TokenResponse": TokenResponse,
    "TotalSourceStorageSizeRequest": TotalSourceStorageSizeRequest,
    "TotalSourceStorageSizeResponse": TotalSourceStorageSizeResponse,
    "TrendPoint": TrendPoint,
    "TriggerKeyspacesScheduledDump200Response": TriggerKeyspacesScheduledDump200Response,
    "UnifiedDBRecord": UnifiedDBRecord,
    "UnifiedDBServerRecord": UnifiedDBServerRecord,
    "UnifiedDatabaseRecord": UnifiedDatabaseRecord,
    "UnifiedRestoreEntity": UnifiedRestoreEntity,
    "UnifiedRestoreEntityMicrosoft365": UnifiedRestoreEntityMicrosoft365,
    "UnifiedRestoreEntityRelationships": UnifiedRestoreEntityRelationships,
    "UnifiedRestoreMicrosoft365Request": UnifiedRestoreMicrosoft365Request,
    "UnifiedRestoreMicrosoft365Snapshot": UnifiedRestoreMicrosoft365Snapshot,
    "UnifiedRestoreMicrosoft365User": UnifiedRestoreMicrosoft365User,
    "UnifiedRestorePlan": UnifiedRestorePlan,
    "UnifiedRestoreWorkload": UnifiedRestoreWorkload,
    "UnifiedSchemaRecord": UnifiedSchemaRecord,
    "UnifiedTableRecord": UnifiedTableRecord,
    "UpPulumiStacksResponse": UpPulumiStacksResponse,
    "UpdateAccessGrantRequest": UpdateAccessGrantRequest,
    "UpdateAccessPolicyRequest": UpdateAccessPolicyRequest,
    "UpdateAccountCompanyContactsRequest": UpdateAccountCompanyContactsRequest,
    "UpdateAccountLabelsRequest": UpdateAccountLabelsRequest,
    "UpdateAccountProfileResponse": UpdateAccountProfileResponse,
    "UpdateActionApprovalRuleRequest": UpdateActionApprovalRuleRequest,
    "UpdateActionApprovalRuleResponse": UpdateActionApprovalRuleResponse,
    "UpdateApiCredentialsRequest": UpdateApiCredentialsRequest,
    "UpdateAwsRestoreAccountAttributes": UpdateAwsRestoreAccountAttributes,
    "UpdateAwsSourceAccountAttributes": UpdateAwsSourceAccountAttributes,
    "UpdateAzureSourceAccountAttributes": UpdateAzureSourceAccountAttributes,
    "UpdateBackupPolicyRequest": UpdateBackupPolicyRequest,
    "UpdateBackupPolicyResponse": UpdateBackupPolicyResponse,
    "UpdateBackupPostureControlRequest": UpdateBackupPostureControlRequest,
    "UpdateBackupZeroEtlPolicyInput": UpdateBackupZeroEtlPolicyInput,
    "UpdateClassificationPolicyRequest": UpdateClassificationPolicyRequest,
    "UpdateClassificationPolicyResponse": UpdateClassificationPolicyResponse,
    "UpdateCloudResourceConfigurationRequest": UpdateCloudResourceConfigurationRequest,
    "UpdateCloudResourceConfigurationRequestCdcBackup": UpdateCloudResourceConfigurationRequestCdcBackup,
    "UpdateCloudResourceConfigurationRequestInventoryBackup": UpdateCloudResourceConfigurationRequestInventoryBackup,
    "UpdateControlViolationInput": UpdateControlViolationInput,
    "UpdateDataCatalogPipelineRequest": UpdateDataCatalogPipelineRequest,
    "UpdateDlsgPolicyRequest": UpdateDlsgPolicyRequest,
    "UpdateDlsgPolicyResponse": UpdateDlsgPolicyResponse,
    "UpdateFindingExclusionRequest": UpdateFindingExclusionRequest,
    "UpdateFindingExclusionResponse": UpdateFindingExclusionResponse,
    "UpdateGcpRestoreAccountAttributes": UpdateGcpRestoreAccountAttributes,
    "UpdateGcpSourceAccountAttributes": UpdateGcpSourceAccountAttributes,
    "UpdateGdsgInventoryReportConfigurationRequest": UpdateGdsgInventoryReportConfigurationRequest,
    "UpdateGdsgInventoryReportConfigurationResponse": UpdateGdsgInventoryReportConfigurationResponse,
    "UpdateGwsBackupFilterRequest": UpdateGwsBackupFilterRequest,
    "UpdateIdpGroupRequest": UpdateIdpGroupRequest,
    "UpdateIdpGroupResponse": UpdateIdpGroupResponse,
    "UpdateIntegrationRequest": UpdateIntegrationRequest,
    "UpdateIntegrationResponse": UpdateIntegrationResponse,
    "UpdateObjectStoreScanMethodRequest": UpdateObjectStoreScanMethodRequest,
    "UpdateObjectStoreScanMethodResponse": UpdateObjectStoreScanMethodResponse,
    "UpdateObjectStoreScanMethodSetting": UpdateObjectStoreScanMethodSetting,
    "UpdateOrganizationIdpGroupRequest": UpdateOrganizationIdpGroupRequest,
    "UpdateOrganizationIdpGroupResponse": UpdateOrganizationIdpGroupResponse,
    "UpdateOrganizationIdpRequest": UpdateOrganizationIdpRequest,
    "UpdateOrganizationIdpResponse": UpdateOrganizationIdpResponse,
    "UpdateOrganizationUserRequest": UpdateOrganizationUserRequest,
    "UpdateOrganizationUserResponse": UpdateOrganizationUserResponse,
    "UpdateProjectConfigurationKeyRequest": UpdateProjectConfigurationKeyRequest,
    "UpdatePulumiConfigurationRequest": UpdatePulumiConfigurationRequest,
    "UpdateResourceSecurityScansExclusionRequest": UpdateResourceSecurityScansExclusionRequest,
    "UpdateRestoreAccountAttributesInput": UpdateRestoreAccountAttributesInput,
    "UpdateRestoreAccountConnectivityConfigRequest": UpdateRestoreAccountConnectivityConfigRequest,
    "UpdateRestoreAccountConnectivityConfigResponse": UpdateRestoreAccountConnectivityConfigResponse,
    "UpdateRestoreAccountRequest": UpdateRestoreAccountRequest,
    "UpdateRestoreAccountResponse": UpdateRestoreAccountResponse,
    "UpdateRestoreTemplateRequest": UpdateRestoreTemplateRequest,
    "UpdateRestoreTemplateResponse": UpdateRestoreTemplateResponse,
    "UpdateRoleRequest": UpdateRoleRequest,
    "UpdateRoleResponse": UpdateRoleResponse,
    "UpdateSamlIdentityProviderInput": UpdateSamlIdentityProviderInput,
    "UpdateSessionRequest": UpdateSessionRequest,
    "UpdateShouldFullBackupResourceRequest": UpdateShouldFullBackupResourceRequest,
    "UpdateSnapshotRecipeRequest": UpdateSnapshotRecipeRequest,
    "UpdateSnapshotRecipeResponse": UpdateSnapshotRecipeResponse,
    "UpdateSourceAccountAttributesInput": UpdateSourceAccountAttributesInput,
    "UpdateSourceAccountRequest": UpdateSourceAccountRequest,
    "UpdateSourceAccountResponse": UpdateSourceAccountResponse,
    "UpdateTagDefinitionRequest": UpdateTagDefinitionRequest,
    "UpdateThreatHuntingScanRequestRequest": UpdateThreatHuntingScanRequestRequest,
    "UpdateUserInput": UpdateUserInput,
    "UpdateVaultRequest": UpdateVaultRequest,
    "UpdateVaultResponse": UpdateVaultResponse,
    "UpdateViewerRoleRequest": UpdateViewerRoleRequest,
    "Usage": Usage,
    "UsageTypeFilters": UsageTypeFilters,
    "User": User,
    "UserIdFilters": UserIdFilters,
    "VNetConfig": VNetConfig,
    "ValidateAccessGrantRequest": ValidateAccessGrantRequest,
    "ValidateAccessGrantResponse": ValidateAccessGrantResponse,
    "ValidateAccessPolicyRequest": ValidateAccessPolicyRequest,
    "ValidateAccessPolicyResponse": ValidateAccessPolicyResponse,
    "ValidateDataCatalogPipelineRequest": ValidateDataCatalogPipelineRequest,
    "ValidateDataCatalogPipelineResponse": ValidateDataCatalogPipelineResponse,
    "ValidateResourceConfigurationRequest": ValidateResourceConfigurationRequest,
    "ValidateResourceConfigurationResponse": ValidateResourceConfigurationResponse,
    "VaultEncryptionTypeFilters": VaultEncryptionTypeFilters,
    "VaultFilters": VaultFilters,
    "VaultMetadataReplicationConfig": VaultMetadataReplicationConfig,
    "VaultNotificationArguments": VaultNotificationArguments,
    "VaultProviderAttributes": VaultProviderAttributes,
    "VaultProviderAttributesInput": VaultProviderAttributesInput,
    "VaultRegionFilters": VaultRegionFilters,
    "VaultSnapshotCount": VaultSnapshotCount,
    "VaultStatusFilters": VaultStatusFilters,
    "VaultTagFilters": VaultTagFilters,
    "VaultTieringPolicy": VaultTieringPolicy,
    "VaultTypeFilters": VaultTypeFilters,
    "VaultsFilterConditions": VaultsFilterConditions,
    "VerifyMongoAtlasPrivateLinkResponse": VerifyMongoAtlasPrivateLinkResponse,
    "VerifyRdsCdcSqlSetupResponse": VerifyRdsCdcSqlSetupResponse,
    "Viewer": Viewer,
    "ViolationsDetectionNotificationArguments": ViolationsDetectionNotificationArguments,
    "VirtualMachineRestoreDestination": VirtualMachineRestoreDestination,
    "VisualizationHistogramSeries": VisualizationHistogramSeries,
    "VisualizationHistogramTimePoint": VisualizationHistogramTimePoint,
    "VisualizationLabel": VisualizationLabel,
    "VolumeSettings": VolumeSettings,
    "VpcCondition": VpcCondition,
    "VpcPropertyFilters": VpcPropertyFilters,
    "WebhookV1AnomalyDataPoint": WebhookV1AnomalyDataPoint,
    "WebhookV1AnomalyGraphData": WebhookV1AnomalyGraphData,
    "WebhookV1AuditEvent": WebhookV1AuditEvent,
    "WebhookV1AuditPayload": WebhookV1AuditPayload,
    "WebhookV1BackupJobDetails": WebhookV1BackupJobDetails,
    "WebhookV1BackupJobFailedArguments": WebhookV1BackupJobFailedArguments,
    "WebhookV1BackupJobPartialArguments": WebhookV1BackupJobPartialArguments,
    "WebhookV1BackupJobRejectedArguments": WebhookV1BackupJobRejectedArguments,
    "WebhookV1BackupJobSkippedArguments": WebhookV1BackupJobSkippedArguments,
    "WebhookV1BackupJobSucceededArguments": WebhookV1BackupJobSucceededArguments,
    "WebhookV1BackupPolicyNotificationArguments": WebhookV1BackupPolicyNotificationArguments,
    "WebhookV1ClassificationJobFailedArguments": WebhookV1ClassificationJobFailedArguments,
    "WebhookV1ClassificationJobRejectedArguments": WebhookV1ClassificationJobRejectedArguments,
    "WebhookV1ClassificationJobSkippedArguments": WebhookV1ClassificationJobSkippedArguments,
    "WebhookV1CloudAccountArguments": WebhookV1CloudAccountArguments,
    "WebhookV1CreditsMonthlyUsageNotificationArguments": WebhookV1CreditsMonthlyUsageNotificationArguments,
    "WebhookV1CreditsNotificationArguments": WebhookV1CreditsNotificationArguments,
    "WebhookV1GdsgOperationalNotificationArguments": WebhookV1GdsgOperationalNotificationArguments,
    "WebhookV1InitiatorArguments": WebhookV1InitiatorArguments,
    "WebhookV1IssueMutedNotificationArguments": WebhookV1IssueMutedNotificationArguments,
    "WebhookV1JobMetricsReportFailedArguments": WebhookV1JobMetricsReportFailedArguments,
    "WebhookV1MPARequestNotificationArguments": WebhookV1MPARequestNotificationArguments,
    "WebhookV1MPAReviewNotificationArguments": WebhookV1MPAReviewNotificationArguments,
    "WebhookV1NotificationTargetChangeArguments": WebhookV1NotificationTargetChangeArguments,
    "WebhookV1OnboardingPayload": WebhookV1OnboardingPayload,
    "WebhookV1Payload": WebhookV1Payload,
    "WebhookV1PolicyArguments": WebhookV1PolicyArguments,
    "WebhookV1ProtobufDuration": WebhookV1ProtobufDuration,
    "WebhookV1ProtobufTimestamp": WebhookV1ProtobufTimestamp,
    "WebhookV1ResourceArguments": WebhookV1ResourceArguments,
    "WebhookV1RestoreJobFailedArguments": WebhookV1RestoreJobFailedArguments,
    "WebhookV1RestoreJobRejectedArguments": WebhookV1RestoreJobRejectedArguments,
    "WebhookV1RestoreJobSucceededArguments": WebhookV1RestoreJobSucceededArguments,
    "WebhookV1SecurityEvidence": WebhookV1SecurityEvidence,
    "WebhookV1SecurityScan": WebhookV1SecurityScan,
    "WebhookV1SecurityScanResult": WebhookV1SecurityScanResult,
    "WebhookV1SnapshotAccessDeniedArguments": WebhookV1SnapshotAccessDeniedArguments,
    "WebhookV1SnapshotArguments": WebhookV1SnapshotArguments,
    "WebhookV1StandardPayload": WebhookV1StandardPayload,
    "WebhookV1StandardPayloadBackupJobFailed": WebhookV1StandardPayloadBackupJobFailed,
    "WebhookV1StandardPayloadBackupJobFailedArguments": WebhookV1StandardPayloadBackupJobFailedArguments,
    "WebhookV1StandardPayloadBackupJobPartial": WebhookV1StandardPayloadBackupJobPartial,
    "WebhookV1StandardPayloadBackupJobPartialArguments": WebhookV1StandardPayloadBackupJobPartialArguments,
    "WebhookV1StandardPayloadBackupJobRejected": WebhookV1StandardPayloadBackupJobRejected,
    "WebhookV1StandardPayloadBackupJobRejectedArguments": WebhookV1StandardPayloadBackupJobRejectedArguments,
    "WebhookV1StandardPayloadBackupJobSkipped": WebhookV1StandardPayloadBackupJobSkipped,
    "WebhookV1StandardPayloadBackupJobSkippedArguments": WebhookV1StandardPayloadBackupJobSkippedArguments,
    "WebhookV1StandardPayloadBackupJobSucceeded": WebhookV1StandardPayloadBackupJobSucceeded,
    "WebhookV1StandardPayloadBackupJobSucceededArguments": WebhookV1StandardPayloadBackupJobSucceededArguments,
    "WebhookV1StandardPayloadBackupVault": WebhookV1StandardPayloadBackupVault,
    "WebhookV1StandardPayloadBackupVaultArguments": WebhookV1StandardPayloadBackupVaultArguments,
    "WebhookV1StandardPayloadClassificationJobFailed": WebhookV1StandardPayloadClassificationJobFailed,
    "WebhookV1StandardPayloadClassificationJobFailedArguments": WebhookV1StandardPayloadClassificationJobFailedArguments,
    "WebhookV1StandardPayloadClassificationJobRejected": WebhookV1StandardPayloadClassificationJobRejected,
    "WebhookV1StandardPayloadClassificationJobRejectedArguments": WebhookV1StandardPayloadClassificationJobRejectedArguments,
    "WebhookV1StandardPayloadClassificationJobSkipped": WebhookV1StandardPayloadClassificationJobSkipped,
    "WebhookV1StandardPayloadClassificationJobSkippedArguments": WebhookV1StandardPayloadClassificationJobSkippedArguments,
    "WebhookV1StandardPayloadCloudAccount": WebhookV1StandardPayloadCloudAccount,
    "WebhookV1StandardPayloadCloudAccountArguments": WebhookV1StandardPayloadCloudAccountArguments,
    "WebhookV1StandardPayloadCreditsMonthlyUsage": WebhookV1StandardPayloadCreditsMonthlyUsage,
    "WebhookV1StandardPayloadCreditsMonthlyUsageArguments": WebhookV1StandardPayloadCreditsMonthlyUsageArguments,
    "WebhookV1StandardPayloadCreditsUsage": WebhookV1StandardPayloadCreditsUsage,
    "WebhookV1StandardPayloadCreditsUsageArguments": WebhookV1StandardPayloadCreditsUsageArguments,
    "WebhookV1StandardPayloadGdsgOperational": WebhookV1StandardPayloadGdsgOperational,
    "WebhookV1StandardPayloadGdsgOperationalArguments": WebhookV1StandardPayloadGdsgOperationalArguments,
    "WebhookV1StandardPayloadIssueMuted": WebhookV1StandardPayloadIssueMuted,
    "WebhookV1StandardPayloadIssueMutedArguments": WebhookV1StandardPayloadIssueMutedArguments,
    "WebhookV1StandardPayloadJobMetricsReportFailed": WebhookV1StandardPayloadJobMetricsReportFailed,
    "WebhookV1StandardPayloadJobMetricsReportFailedArguments": WebhookV1StandardPayloadJobMetricsReportFailedArguments,
    "WebhookV1StandardPayloadMpaRequest": WebhookV1StandardPayloadMpaRequest,
    "WebhookV1StandardPayloadMpaRequestArguments": WebhookV1StandardPayloadMpaRequestArguments,
    "WebhookV1StandardPayloadMpaReview": WebhookV1StandardPayloadMpaReview,
    "WebhookV1StandardPayloadMpaReviewArguments": WebhookV1StandardPayloadMpaReviewArguments,
    "WebhookV1StandardPayloadNotificationTargetChange": WebhookV1StandardPayloadNotificationTargetChange,
    "WebhookV1StandardPayloadNotificationTargetChangeArguments": WebhookV1StandardPayloadNotificationTargetChangeArguments,
    "WebhookV1StandardPayloadPolicyAssignment": WebhookV1StandardPayloadPolicyAssignment,
    "WebhookV1StandardPayloadPolicyAssignmentArguments": WebhookV1StandardPayloadPolicyAssignmentArguments,
    "WebhookV1StandardPayloadPolicyChange": WebhookV1StandardPayloadPolicyChange,
    "WebhookV1StandardPayloadPolicyChangeArguments": WebhookV1StandardPayloadPolicyChangeArguments,
    "WebhookV1StandardPayloadResource": WebhookV1StandardPayloadResource,
    "WebhookV1StandardPayloadResourceArguments": WebhookV1StandardPayloadResourceArguments,
    "WebhookV1StandardPayloadRestoreJobFailed": WebhookV1StandardPayloadRestoreJobFailed,
    "WebhookV1StandardPayloadRestoreJobFailedArguments": WebhookV1StandardPayloadRestoreJobFailedArguments,
    "WebhookV1StandardPayloadRestoreJobRejected": WebhookV1StandardPayloadRestoreJobRejected,
    "WebhookV1StandardPayloadRestoreJobRejectedArguments": WebhookV1StandardPayloadRestoreJobRejectedArguments,
    "WebhookV1StandardPayloadRestoreJobSucceeded": WebhookV1StandardPayloadRestoreJobSucceeded,
    "WebhookV1StandardPayloadRestoreJobSucceededArguments": WebhookV1StandardPayloadRestoreJobSucceededArguments,
    "WebhookV1StandardPayloadSnapshot": WebhookV1StandardPayloadSnapshot,
    "WebhookV1StandardPayloadSnapshotAccessDenied": WebhookV1StandardPayloadSnapshotAccessDenied,
    "WebhookV1StandardPayloadSnapshotAccessDeniedArguments": WebhookV1StandardPayloadSnapshotAccessDeniedArguments,
    "WebhookV1StandardPayloadSnapshotArguments": WebhookV1StandardPayloadSnapshotArguments,
    "WebhookV1StandardPayloadSnapshotUserProtection": WebhookV1StandardPayloadSnapshotUserProtection,
    "WebhookV1StandardPayloadSnapshotUserProtectionArguments": WebhookV1StandardPayloadSnapshotUserProtectionArguments,
    "WebhookV1StandardPayloadViolations": WebhookV1StandardPayloadViolations,
    "WebhookV1StandardPayloadViolationsArguments": WebhookV1StandardPayloadViolationsArguments,
    "WebhookV1VaultArguments": WebhookV1VaultArguments,
    "WebhookV1ViolationsDetectionNotificationArguments": WebhookV1ViolationsDetectionNotificationArguments,
    "WeeklyConfig": WeeklyConfig,
    "YearlySnapshotDistribution": YearlySnapshotDistribution,
    "ZeroEtlJob": ZeroEtlJob,
    "ZeroEtlJobSync": ZeroEtlJobSync,
    "ZeroEtlJobSyncsFilters": ZeroEtlJobSyncsFilters,
    "ZeroEtlJobTableCounts": ZeroEtlJobTableCounts,
    "ZeroEtlJobsFilters": ZeroEtlJobsFilters,
    "ZeroEtlJobsSort": ZeroEtlJobsSort,
    "ZeroEtlTargetTable": ZeroEtlTargetTable,
    "ZeroEtlTargetTablesFilters": ZeroEtlTargetTablesFilters,
    "ZeroEtlTargetTablesSort": ZeroEtlTargetTablesSort,
};
export class ObjectSerializer {
    static findCorrectType(data, expectedType) {
        if (data == undefined) {
            return expectedType;
        }
        else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        }
        else if (expectedType === "Date") {
            return expectedType;
        }
        else {
            if (enumsMap.has(expectedType)) {
                return expectedType;
            }
            if (!typeMap[expectedType]) {
                return expectedType;
            }
            let discriminatorProperty = typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType;
            }
            else {
                if (data[discriminatorProperty]) {
                    var discriminatorType = data[discriminatorProperty];
                    if (typeMap[discriminatorType]) {
                        return discriminatorType;
                    }
                    else {
                        return expectedType;
                    }
                }
                else {
                    return expectedType;
                }
            }
        }
    }
    static serialize(data, type, format) {
        if (data === undefined || data === null || primitives.includes(type.toLowerCase())) {
            return data;
        }
        else if (type.startsWith("Array<", 0)) {
            let subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.serialize(date, subType, format));
            }
            return transformedData;
        }
        else if (type.startsWith("Set<", 0)) {
            let subType = type.replace("Set<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let item of data) {
                transformedData.push(ObjectSerializer.serialize(item, subType, format));
            }
            return transformedData;
        }
        else if (type === "Date") {
            if (format == "date") {
                let month = data.getMonth() + 1;
                month = month < 10 ? "0" + month.toString() : month.toString();
                let day = data.getDate();
                day = day < 10 ? "0" + day.toString() : day.toString();
                return data.getFullYear() + "-" + month + "-" + day;
            }
            else {
                return data.toISOString();
            }
        }
        else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            type = this.findCorrectType(data, type);
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            let instance = {};
            for (let attributeType of attributeTypes) {
                instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type, attributeType.format);
            }
            return instance;
        }
    }
    static deserialize(data, type, format) {
        type = ObjectSerializer.findCorrectType(data, type);
        if (data == undefined) {
            return data;
        }
        else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        }
        else if (type.lastIndexOf("Array<", 0) === 0) {
            let subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.deserialize(date, subType, format));
            }
            return transformedData;
        }
        else if (type.lastIndexOf("Set<", 0) === 0) {
            let subType = type.replace("Set<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let item of data) {
                transformedData.push(ObjectSerializer.deserialize(item, subType, format));
            }
            return new Set(transformedData);
        }
        else if (type === "Date") {
            return new Date(data);
        }
        else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            let instance = new typeMap[type]();
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            for (let attributeType of attributeTypes) {
                let value = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type, attributeType.format);
                if (value !== undefined) {
                    instance[attributeType.name] = value;
                }
            }
            return instance;
        }
    }
    static getPreferredMediaType(mediaTypes) {
        return "application/json";
    }
}
